var Bu = Object.defineProperty;
var $u = (i, t, e) => t in i ? Bu(i, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : i[t] = e;
var xo = (i, t, e) => ($u(i, typeof t != "symbol" ? t + "" : t, e), e), wo = (i, t, e) => {
  if (!t.has(i))
    throw TypeError("Cannot " + e);
};
var Mt = (i, t, e) => (wo(i, t, "read from private field"), e ? e.call(i) : t.get(i)), At = (i, t, e) => {
  if (t.has(i))
    throw TypeError("Cannot add the same private member more than once");
  t instanceof WeakSet ? t.add(i) : t.set(i, e);
}, dt = (i, t, e, n) => (wo(i, t, "write to private field"), n ? n.call(i, e) : t.set(i, e), e);
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const an = window, Os = an.ShadowRoot && (an.ShadyCSS === void 0 || an.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, Ds = Symbol(), So = /* @__PURE__ */ new WeakMap();
class $c {
  constructor(t, e, n) {
    if (this._$cssResult$ = !0, n !== Ds)
      throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
    this.cssText = t, this.t = e;
  }
  get styleSheet() {
    let t = this.o;
    const e = this.t;
    if (Os && t === void 0) {
      const n = e !== void 0 && e.length === 1;
      n && (t = So.get(e)), t === void 0 && ((this.o = t = new CSSStyleSheet()).replaceSync(this.cssText), n && So.set(e, t));
    }
    return t;
  }
  toString() {
    return this.cssText;
  }
}
const zu = (i) => new $c(typeof i == "string" ? i : i + "", void 0, Ds), qu = (i, ...t) => {
  const e = i.length === 1 ? i[0] : t.reduce((n, r, s) => n + ((o) => {
    if (o._$cssResult$ === !0)
      return o.cssText;
    if (typeof o == "number")
      return o;
    throw Error("Value passed to 'css' function must be a 'css' function result: " + o + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
  })(r) + i[s + 1], i[0]);
  return new $c(e, i, Ds);
}, Qu = (i, t) => {
  Os ? i.adoptedStyleSheets = t.map((e) => e instanceof CSSStyleSheet ? e : e.styleSheet) : t.forEach((e) => {
    const n = document.createElement("style"), r = an.litNonce;
    r !== void 0 && n.setAttribute("nonce", r), n.textContent = e.cssText, i.appendChild(n);
  });
}, Eo = Os ? (i) => i : (i) => i instanceof CSSStyleSheet ? ((t) => {
  let e = "";
  for (const n of t.cssRules)
    e += n.cssText;
  return zu(e);
})(i) : i;
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var sr;
const yn = window, ko = yn.trustedTypes, Uu = ko ? ko.emptyScript : "", Oo = yn.reactiveElementPolyfillSupport, jr = { toAttribute(i, t) {
  switch (t) {
    case Boolean:
      i = i ? Uu : null;
      break;
    case Object:
    case Array:
      i = i == null ? i : JSON.stringify(i);
  }
  return i;
}, fromAttribute(i, t) {
  let e = i;
  switch (t) {
    case Boolean:
      e = i !== null;
      break;
    case Number:
      e = i === null ? null : Number(i);
      break;
    case Object:
    case Array:
      try {
        e = JSON.parse(i);
      } catch {
        e = null;
      }
  }
  return e;
} }, zc = (i, t) => t !== i && (t == t || i == i), or = { attribute: !0, type: String, converter: jr, reflect: !1, hasChanged: zc };
class Oe extends HTMLElement {
  constructor() {
    super(), this._$Ei = /* @__PURE__ */ new Map(), this.isUpdatePending = !1, this.hasUpdated = !1, this._$El = null, this.u();
  }
  static addInitializer(t) {
    var e;
    this.finalize(), ((e = this.h) !== null && e !== void 0 ? e : this.h = []).push(t);
  }
  static get observedAttributes() {
    this.finalize();
    const t = [];
    return this.elementProperties.forEach((e, n) => {
      const r = this._$Ep(n, e);
      r !== void 0 && (this._$Ev.set(r, n), t.push(r));
    }), t;
  }
  static createProperty(t, e = or) {
    if (e.state && (e.attribute = !1), this.finalize(), this.elementProperties.set(t, e), !e.noAccessor && !this.prototype.hasOwnProperty(t)) {
      const n = typeof t == "symbol" ? Symbol() : "__" + t, r = this.getPropertyDescriptor(t, n, e);
      r !== void 0 && Object.defineProperty(this.prototype, t, r);
    }
  }
  static getPropertyDescriptor(t, e, n) {
    return { get() {
      return this[e];
    }, set(r) {
      const s = this[t];
      this[e] = r, this.requestUpdate(t, s, n);
    }, configurable: !0, enumerable: !0 };
  }
  static getPropertyOptions(t) {
    return this.elementProperties.get(t) || or;
  }
  static finalize() {
    if (this.hasOwnProperty("finalized"))
      return !1;
    this.finalized = !0;
    const t = Object.getPrototypeOf(this);
    if (t.finalize(), t.h !== void 0 && (this.h = [...t.h]), this.elementProperties = new Map(t.elementProperties), this._$Ev = /* @__PURE__ */ new Map(), this.hasOwnProperty("properties")) {
      const e = this.properties, n = [...Object.getOwnPropertyNames(e), ...Object.getOwnPropertySymbols(e)];
      for (const r of n)
        this.createProperty(r, e[r]);
    }
    return this.elementStyles = this.finalizeStyles(this.styles), !0;
  }
  static finalizeStyles(t) {
    const e = [];
    if (Array.isArray(t)) {
      const n = new Set(t.flat(1 / 0).reverse());
      for (const r of n)
        e.unshift(Eo(r));
    } else
      t !== void 0 && e.push(Eo(t));
    return e;
  }
  static _$Ep(t, e) {
    const n = e.attribute;
    return n === !1 ? void 0 : typeof n == "string" ? n : typeof t == "string" ? t.toLowerCase() : void 0;
  }
  u() {
    var t;
    this._$E_ = new Promise((e) => this.enableUpdating = e), this._$AL = /* @__PURE__ */ new Map(), this._$Eg(), this.requestUpdate(), (t = this.constructor.h) === null || t === void 0 || t.forEach((e) => e(this));
  }
  addController(t) {
    var e, n;
    ((e = this._$ES) !== null && e !== void 0 ? e : this._$ES = []).push(t), this.renderRoot !== void 0 && this.isConnected && ((n = t.hostConnected) === null || n === void 0 || n.call(t));
  }
  removeController(t) {
    var e;
    (e = this._$ES) === null || e === void 0 || e.splice(this._$ES.indexOf(t) >>> 0, 1);
  }
  _$Eg() {
    this.constructor.elementProperties.forEach((t, e) => {
      this.hasOwnProperty(e) && (this._$Ei.set(e, this[e]), delete this[e]);
    });
  }
  createRenderRoot() {
    var t;
    const e = (t = this.shadowRoot) !== null && t !== void 0 ? t : this.attachShadow(this.constructor.shadowRootOptions);
    return Qu(e, this.constructor.elementStyles), e;
  }
  connectedCallback() {
    var t;
    this.renderRoot === void 0 && (this.renderRoot = this.createRenderRoot()), this.enableUpdating(!0), (t = this._$ES) === null || t === void 0 || t.forEach((e) => {
      var n;
      return (n = e.hostConnected) === null || n === void 0 ? void 0 : n.call(e);
    });
  }
  enableUpdating(t) {
  }
  disconnectedCallback() {
    var t;
    (t = this._$ES) === null || t === void 0 || t.forEach((e) => {
      var n;
      return (n = e.hostDisconnected) === null || n === void 0 ? void 0 : n.call(e);
    });
  }
  attributeChangedCallback(t, e, n) {
    this._$AK(t, n);
  }
  _$EO(t, e, n = or) {
    var r;
    const s = this.constructor._$Ep(t, n);
    if (s !== void 0 && n.reflect === !0) {
      const o = (((r = n.converter) === null || r === void 0 ? void 0 : r.toAttribute) !== void 0 ? n.converter : jr).toAttribute(e, n.type);
      this._$El = t, o == null ? this.removeAttribute(s) : this.setAttribute(s, o), this._$El = null;
    }
  }
  _$AK(t, e) {
    var n;
    const r = this.constructor, s = r._$Ev.get(t);
    if (s !== void 0 && this._$El !== s) {
      const o = r.getPropertyOptions(s), a = typeof o.converter == "function" ? { fromAttribute: o.converter } : ((n = o.converter) === null || n === void 0 ? void 0 : n.fromAttribute) !== void 0 ? o.converter : jr;
      this._$El = s, this[s] = a.fromAttribute(e, o.type), this._$El = null;
    }
  }
  requestUpdate(t, e, n) {
    let r = !0;
    t !== void 0 && (((n = n || this.constructor.getPropertyOptions(t)).hasChanged || zc)(this[t], e) ? (this._$AL.has(t) || this._$AL.set(t, e), n.reflect === !0 && this._$El !== t && (this._$EC === void 0 && (this._$EC = /* @__PURE__ */ new Map()), this._$EC.set(t, n))) : r = !1), !this.isUpdatePending && r && (this._$E_ = this._$Ej());
  }
  async _$Ej() {
    this.isUpdatePending = !0;
    try {
      await this._$E_;
    } catch (e) {
      Promise.reject(e);
    }
    const t = this.scheduleUpdate();
    return t != null && await t, !this.isUpdatePending;
  }
  scheduleUpdate() {
    return this.performUpdate();
  }
  performUpdate() {
    var t;
    if (!this.isUpdatePending)
      return;
    this.hasUpdated, this._$Ei && (this._$Ei.forEach((r, s) => this[s] = r), this._$Ei = void 0);
    let e = !1;
    const n = this._$AL;
    try {
      e = this.shouldUpdate(n), e ? (this.willUpdate(n), (t = this._$ES) === null || t === void 0 || t.forEach((r) => {
        var s;
        return (s = r.hostUpdate) === null || s === void 0 ? void 0 : s.call(r);
      }), this.update(n)) : this._$Ek();
    } catch (r) {
      throw e = !1, this._$Ek(), r;
    }
    e && this._$AE(n);
  }
  willUpdate(t) {
  }
  _$AE(t) {
    var e;
    (e = this._$ES) === null || e === void 0 || e.forEach((n) => {
      var r;
      return (r = n.hostUpdated) === null || r === void 0 ? void 0 : r.call(n);
    }), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
  }
  _$Ek() {
    this._$AL = /* @__PURE__ */ new Map(), this.isUpdatePending = !1;
  }
  get updateComplete() {
    return this.getUpdateComplete();
  }
  getUpdateComplete() {
    return this._$E_;
  }
  shouldUpdate(t) {
    return !0;
  }
  update(t) {
    this._$EC !== void 0 && (this._$EC.forEach((e, n) => this._$EO(n, this[n], e)), this._$EC = void 0), this._$Ek();
  }
  updated(t) {
  }
  firstUpdated(t) {
  }
}
Oe.finalized = !0, Oe.elementProperties = /* @__PURE__ */ new Map(), Oe.elementStyles = [], Oe.shadowRootOptions = { mode: "open" }, Oo == null || Oo({ ReactiveElement: Oe }), ((sr = yn.reactiveElementVersions) !== null && sr !== void 0 ? sr : yn.reactiveElementVersions = []).push("1.4.2");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var ar;
const vn = window, Ne = vn.trustedTypes, Do = Ne ? Ne.createPolicy("lit-html", { createHTML: (i) => i }) : void 0, Gt = `lit$${(Math.random() + "").slice(9)}$`, qc = "?" + Gt, Wu = `<${qc}>`, Ve = document, Si = (i = "") => Ve.createComment(i), Ei = (i) => i === null || typeof i != "object" && typeof i != "function", Qc = Array.isArray, Hu = (i) => Qc(i) || typeof (i == null ? void 0 : i[Symbol.iterator]) == "function", Je = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, To = /-->/g, Mo = />/g, se = RegExp(`>|[ 	
\f\r](?:([^\\s"'>=/]+)([ 	
\f\r]*=[ 	
\f\r]*(?:[^ 	
\f\r"'\`<>=]|("|')|))|$)`, "g"), Ao = /'/g, Co = /"/g, Uc = /^(?:script|style|textarea|title)$/i, Yu = (i) => (t, ...e) => ({ _$litType$: i, strings: t, values: e }), Gu = Yu(1), je = Symbol.for("lit-noChange"), at = Symbol.for("lit-nothing"), Po = /* @__PURE__ */ new WeakMap(), Ce = Ve.createTreeWalker(Ve, 129, null, !1), Xu = (i, t) => {
  const e = i.length - 1, n = [];
  let r, s = t === 2 ? "<svg>" : "", o = Je;
  for (let c = 0; c < e; c++) {
    const l = i[c];
    let u, h, f = -1, d = 0;
    for (; d < l.length && (o.lastIndex = d, h = o.exec(l), h !== null); )
      d = o.lastIndex, o === Je ? h[1] === "!--" ? o = To : h[1] !== void 0 ? o = Mo : h[2] !== void 0 ? (Uc.test(h[2]) && (r = RegExp("</" + h[2], "g")), o = se) : h[3] !== void 0 && (o = se) : o === se ? h[0] === ">" ? (o = r != null ? r : Je, f = -1) : h[1] === void 0 ? f = -2 : (f = o.lastIndex - h[2].length, u = h[1], o = h[3] === void 0 ? se : h[3] === '"' ? Co : Ao) : o === Co || o === Ao ? o = se : o === To || o === Mo ? o = Je : (o = se, r = void 0);
    const p = o === se && i[c + 1].startsWith("/>") ? " " : "";
    s += o === Je ? l + Wu : f >= 0 ? (n.push(u), l.slice(0, f) + "$lit$" + l.slice(f) + Gt + p) : l + Gt + (f === -2 ? (n.push(void 0), c) : p);
  }
  const a = s + (i[e] || "<?>") + (t === 2 ? "</svg>" : "");
  if (!Array.isArray(i) || !i.hasOwnProperty("raw"))
    throw Error("invalid template strings array");
  return [Do !== void 0 ? Do.createHTML(a) : a, n];
};
class ki {
  constructor({ strings: t, _$litType$: e }, n) {
    let r;
    this.parts = [];
    let s = 0, o = 0;
    const a = t.length - 1, c = this.parts, [l, u] = Xu(t, e);
    if (this.el = ki.createElement(l, n), Ce.currentNode = this.el.content, e === 2) {
      const h = this.el.content, f = h.firstChild;
      f.remove(), h.append(...f.childNodes);
    }
    for (; (r = Ce.nextNode()) !== null && c.length < a; ) {
      if (r.nodeType === 1) {
        if (r.hasAttributes()) {
          const h = [];
          for (const f of r.getAttributeNames())
            if (f.endsWith("$lit$") || f.startsWith(Gt)) {
              const d = u[o++];
              if (h.push(f), d !== void 0) {
                const p = r.getAttribute(d.toLowerCase() + "$lit$").split(Gt), g = /([.?@])?(.*)/.exec(d);
                c.push({ type: 1, index: s, name: g[2], strings: p, ctor: g[1] === "." ? Ju : g[1] === "?" ? th : g[1] === "@" ? eh : Bn });
              } else
                c.push({ type: 6, index: s });
            }
          for (const f of h)
            r.removeAttribute(f);
        }
        if (Uc.test(r.tagName)) {
          const h = r.textContent.split(Gt), f = h.length - 1;
          if (f > 0) {
            r.textContent = Ne ? Ne.emptyScript : "";
            for (let d = 0; d < f; d++)
              r.append(h[d], Si()), Ce.nextNode(), c.push({ type: 2, index: ++s });
            r.append(h[f], Si());
          }
        }
      } else if (r.nodeType === 8)
        if (r.data === qc)
          c.push({ type: 2, index: s });
        else {
          let h = -1;
          for (; (h = r.data.indexOf(Gt, h + 1)) !== -1; )
            c.push({ type: 7, index: s }), h += Gt.length - 1;
        }
      s++;
    }
  }
  static createElement(t, e) {
    const n = Ve.createElement("template");
    return n.innerHTML = t, n;
  }
}
function Be(i, t, e = i, n) {
  var r, s, o, a;
  if (t === je)
    return t;
  let c = n !== void 0 ? (r = e._$Co) === null || r === void 0 ? void 0 : r[n] : e._$Cl;
  const l = Ei(t) ? void 0 : t._$litDirective$;
  return (c == null ? void 0 : c.constructor) !== l && ((s = c == null ? void 0 : c._$AO) === null || s === void 0 || s.call(c, !1), l === void 0 ? c = void 0 : (c = new l(i), c._$AT(i, e, n)), n !== void 0 ? ((o = (a = e)._$Co) !== null && o !== void 0 ? o : a._$Co = [])[n] = c : e._$Cl = c), c !== void 0 && (t = Be(i, c._$AS(i, t.values), c, n)), t;
}
class Ku {
  constructor(t, e) {
    this.u = [], this._$AN = void 0, this._$AD = t, this._$AM = e;
  }
  get parentNode() {
    return this._$AM.parentNode;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  v(t) {
    var e;
    const { el: { content: n }, parts: r } = this._$AD, s = ((e = t == null ? void 0 : t.creationScope) !== null && e !== void 0 ? e : Ve).importNode(n, !0);
    Ce.currentNode = s;
    let o = Ce.nextNode(), a = 0, c = 0, l = r[0];
    for (; l !== void 0; ) {
      if (a === l.index) {
        let u;
        l.type === 2 ? u = new Ni(o, o.nextSibling, this, t) : l.type === 1 ? u = new l.ctor(o, l.name, l.strings, this, t) : l.type === 6 && (u = new ih(o, this, t)), this.u.push(u), l = r[++c];
      }
      a !== (l == null ? void 0 : l.index) && (o = Ce.nextNode(), a++);
    }
    return s;
  }
  p(t) {
    let e = 0;
    for (const n of this.u)
      n !== void 0 && (n.strings !== void 0 ? (n._$AI(t, n, e), e += n.strings.length - 2) : n._$AI(t[e])), e++;
  }
}
class Ni {
  constructor(t, e, n, r) {
    var s;
    this.type = 2, this._$AH = at, this._$AN = void 0, this._$AA = t, this._$AB = e, this._$AM = n, this.options = r, this._$Cm = (s = r == null ? void 0 : r.isConnected) === null || s === void 0 || s;
  }
  get _$AU() {
    var t, e;
    return (e = (t = this._$AM) === null || t === void 0 ? void 0 : t._$AU) !== null && e !== void 0 ? e : this._$Cm;
  }
  get parentNode() {
    let t = this._$AA.parentNode;
    const e = this._$AM;
    return e !== void 0 && t.nodeType === 11 && (t = e.parentNode), t;
  }
  get startNode() {
    return this._$AA;
  }
  get endNode() {
    return this._$AB;
  }
  _$AI(t, e = this) {
    t = Be(this, t, e), Ei(t) ? t === at || t == null || t === "" ? (this._$AH !== at && this._$AR(), this._$AH = at) : t !== this._$AH && t !== je && this.g(t) : t._$litType$ !== void 0 ? this.$(t) : t.nodeType !== void 0 ? this.T(t) : Hu(t) ? this.k(t) : this.g(t);
  }
  O(t, e = this._$AB) {
    return this._$AA.parentNode.insertBefore(t, e);
  }
  T(t) {
    this._$AH !== t && (this._$AR(), this._$AH = this.O(t));
  }
  g(t) {
    this._$AH !== at && Ei(this._$AH) ? this._$AA.nextSibling.data = t : this.T(Ve.createTextNode(t)), this._$AH = t;
  }
  $(t) {
    var e;
    const { values: n, _$litType$: r } = t, s = typeof r == "number" ? this._$AC(t) : (r.el === void 0 && (r.el = ki.createElement(r.h, this.options)), r);
    if (((e = this._$AH) === null || e === void 0 ? void 0 : e._$AD) === s)
      this._$AH.p(n);
    else {
      const o = new Ku(s, this), a = o.v(this.options);
      o.p(n), this.T(a), this._$AH = o;
    }
  }
  _$AC(t) {
    let e = Po.get(t.strings);
    return e === void 0 && Po.set(t.strings, e = new ki(t)), e;
  }
  k(t) {
    Qc(this._$AH) || (this._$AH = [], this._$AR());
    const e = this._$AH;
    let n, r = 0;
    for (const s of t)
      r === e.length ? e.push(n = new Ni(this.O(Si()), this.O(Si()), this, this.options)) : n = e[r], n._$AI(s), r++;
    r < e.length && (this._$AR(n && n._$AB.nextSibling, r), e.length = r);
  }
  _$AR(t = this._$AA.nextSibling, e) {
    var n;
    for ((n = this._$AP) === null || n === void 0 || n.call(this, !1, !0, e); t && t !== this._$AB; ) {
      const r = t.nextSibling;
      t.remove(), t = r;
    }
  }
  setConnected(t) {
    var e;
    this._$AM === void 0 && (this._$Cm = t, (e = this._$AP) === null || e === void 0 || e.call(this, t));
  }
}
class Bn {
  constructor(t, e, n, r, s) {
    this.type = 1, this._$AH = at, this._$AN = void 0, this.element = t, this.name = e, this._$AM = r, this.options = s, n.length > 2 || n[0] !== "" || n[1] !== "" ? (this._$AH = Array(n.length - 1).fill(new String()), this.strings = n) : this._$AH = at;
  }
  get tagName() {
    return this.element.tagName;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AI(t, e = this, n, r) {
    const s = this.strings;
    let o = !1;
    if (s === void 0)
      t = Be(this, t, e, 0), o = !Ei(t) || t !== this._$AH && t !== je, o && (this._$AH = t);
    else {
      const a = t;
      let c, l;
      for (t = s[0], c = 0; c < s.length - 1; c++)
        l = Be(this, a[n + c], e, c), l === je && (l = this._$AH[c]), o || (o = !Ei(l) || l !== this._$AH[c]), l === at ? t = at : t !== at && (t += (l != null ? l : "") + s[c + 1]), this._$AH[c] = l;
    }
    o && !r && this.j(t);
  }
  j(t) {
    t === at ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t != null ? t : "");
  }
}
class Ju extends Bn {
  constructor() {
    super(...arguments), this.type = 3;
  }
  j(t) {
    this.element[this.name] = t === at ? void 0 : t;
  }
}
const Zu = Ne ? Ne.emptyScript : "";
class th extends Bn {
  constructor() {
    super(...arguments), this.type = 4;
  }
  j(t) {
    t && t !== at ? this.element.setAttribute(this.name, Zu) : this.element.removeAttribute(this.name);
  }
}
class eh extends Bn {
  constructor(t, e, n, r, s) {
    super(t, e, n, r, s), this.type = 5;
  }
  _$AI(t, e = this) {
    var n;
    if ((t = (n = Be(this, t, e, 0)) !== null && n !== void 0 ? n : at) === je)
      return;
    const r = this._$AH, s = t === at && r !== at || t.capture !== r.capture || t.once !== r.once || t.passive !== r.passive, o = t !== at && (r === at || s);
    s && this.element.removeEventListener(this.name, this, r), o && this.element.addEventListener(this.name, this, t), this._$AH = t;
  }
  handleEvent(t) {
    var e, n;
    typeof this._$AH == "function" ? this._$AH.call((n = (e = this.options) === null || e === void 0 ? void 0 : e.host) !== null && n !== void 0 ? n : this.element, t) : this._$AH.handleEvent(t);
  }
}
class ih {
  constructor(t, e, n) {
    this.element = t, this.type = 6, this._$AN = void 0, this._$AM = e, this.options = n;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AI(t) {
    Be(this, t);
  }
}
const Ro = vn.litHtmlPolyfillSupport;
Ro == null || Ro(ki, Ni), ((ar = vn.litHtmlVersions) !== null && ar !== void 0 ? ar : vn.litHtmlVersions = []).push("2.4.0");
const nh = (i, t, e) => {
  var n, r;
  const s = (n = e == null ? void 0 : e.renderBefore) !== null && n !== void 0 ? n : t;
  let o = s._$litPart$;
  if (o === void 0) {
    const a = (r = e == null ? void 0 : e.renderBefore) !== null && r !== void 0 ? r : null;
    s._$litPart$ = o = new Ni(t.insertBefore(Si(), a), a, void 0, e != null ? e : {});
  }
  return o._$AI(i), o;
};
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var cr, lr;
class pi extends Oe {
  constructor() {
    super(...arguments), this.renderOptions = { host: this }, this._$Do = void 0;
  }
  createRenderRoot() {
    var t, e;
    const n = super.createRenderRoot();
    return (t = (e = this.renderOptions).renderBefore) !== null && t !== void 0 || (e.renderBefore = n.firstChild), n;
  }
  update(t) {
    const e = this.render();
    this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = nh(e, this.renderRoot, this.renderOptions);
  }
  connectedCallback() {
    var t;
    super.connectedCallback(), (t = this._$Do) === null || t === void 0 || t.setConnected(!0);
  }
  disconnectedCallback() {
    var t;
    super.disconnectedCallback(), (t = this._$Do) === null || t === void 0 || t.setConnected(!1);
  }
  render() {
    return je;
  }
}
pi.finalized = !0, pi._$litElement$ = !0, (cr = globalThis.litElementHydrateSupport) === null || cr === void 0 || cr.call(globalThis, { LitElement: pi });
const Io = globalThis.litElementPolyfillSupport;
Io == null || Io({ LitElement: pi });
((lr = globalThis.litElementVersions) !== null && lr !== void 0 ? lr : globalThis.litElementVersions = []).push("3.2.2");
/*!
 * Chart.js v3.9.1
 * https://www.chartjs.org
 * (c) 2022 Chart.js Contributors
 * Released under the MIT License
 */
const rh = function() {
  let i = 0;
  return function() {
    return i++;
  };
}();
function $(i) {
  return i === null || typeof i > "u";
}
function H(i) {
  if (Array.isArray && Array.isArray(i))
    return !0;
  const t = Object.prototype.toString.call(i);
  return t.slice(0, 7) === "[object" && t.slice(-6) === "Array]";
}
function L(i) {
  return i !== null && Object.prototype.toString.call(i) === "[object Object]";
}
const ut = (i) => (typeof i == "number" || i instanceof Number) && isFinite(+i);
function yt(i, t) {
  return ut(i) ? i : t;
}
function F(i, t) {
  return typeof i > "u" ? t : i;
}
const sh = (i, t) => typeof i == "string" && i.endsWith("%") ? parseFloat(i) / 100 : i / t, Wc = (i, t) => typeof i == "string" && i.endsWith("%") ? parseFloat(i) / 100 * t : +i;
function X(i, t, e) {
  if (i && typeof i.call == "function")
    return i.apply(e, t);
}
function j(i, t, e, n) {
  let r, s, o;
  if (H(i))
    if (s = i.length, n)
      for (r = s - 1; r >= 0; r--)
        t.call(e, i[r], r);
    else
      for (r = 0; r < s; r++)
        t.call(e, i[r], r);
  else if (L(i))
    for (o = Object.keys(i), s = o.length, r = 0; r < s; r++)
      t.call(e, i[o[r]], o[r]);
}
function bn(i, t) {
  let e, n, r, s;
  if (!i || !t || i.length !== t.length)
    return !1;
  for (e = 0, n = i.length; e < n; ++e)
    if (r = i[e], s = t[e], r.datasetIndex !== s.datasetIndex || r.index !== s.index)
      return !1;
  return !0;
}
function _n(i) {
  if (H(i))
    return i.map(_n);
  if (L(i)) {
    const t = /* @__PURE__ */ Object.create(null), e = Object.keys(i), n = e.length;
    let r = 0;
    for (; r < n; ++r)
      t[e[r]] = _n(i[e[r]]);
    return t;
  }
  return i;
}
function Hc(i) {
  return ["__proto__", "prototype", "constructor"].indexOf(i) === -1;
}
function oh(i, t, e, n) {
  if (!Hc(i))
    return;
  const r = t[i], s = e[i];
  L(r) && L(s) ? Oi(r, s, n) : t[i] = _n(s);
}
function Oi(i, t, e) {
  const n = H(t) ? t : [t], r = n.length;
  if (!L(i))
    return i;
  e = e || {};
  const s = e.merger || oh;
  for (let o = 0; o < r; ++o) {
    if (t = n[o], !L(t))
      continue;
    const a = Object.keys(t);
    for (let c = 0, l = a.length; c < l; ++c)
      s(a[c], i, t, e);
  }
  return i;
}
function gi(i, t) {
  return Oi(i, t, { merger: ah });
}
function ah(i, t, e) {
  if (!Hc(i))
    return;
  const n = t[i], r = e[i];
  L(n) && L(r) ? gi(n, r) : Object.prototype.hasOwnProperty.call(t, i) || (t[i] = _n(r));
}
const Fo = {
  "": (i) => i,
  x: (i) => i.x,
  y: (i) => i.y
};
function te(i, t) {
  return (Fo[t] || (Fo[t] = ch(t)))(i);
}
function ch(i) {
  const t = lh(i);
  return (e) => {
    for (const n of t) {
      if (n === "")
        break;
      e = e && e[n];
    }
    return e;
  };
}
function lh(i) {
  const t = i.split("."), e = [];
  let n = "";
  for (const r of t)
    n += r, n.endsWith("\\") ? n = n.slice(0, -1) + "." : (e.push(n), n = "");
  return e;
}
function Ts(i) {
  return i.charAt(0).toUpperCase() + i.slice(1);
}
const _t = (i) => typeof i < "u", ee = (i) => typeof i == "function", Lo = (i, t) => {
  if (i.size !== t.size)
    return !1;
  for (const e of i)
    if (!t.has(e))
      return !1;
  return !0;
};
function uh(i) {
  return i.type === "mouseup" || i.type === "click" || i.type === "contextmenu";
}
const Z = Math.PI, Q = 2 * Z, hh = Q + Z, xn = Number.POSITIVE_INFINITY, fh = Z / 180, K = Z / 2, Ze = Z / 4, No = Z * 2 / 3, bt = Math.log10, Rt = Math.sign;
function Vo(i) {
  const t = Math.round(i);
  i = mi(i, t, i / 1e3) ? t : i;
  const e = Math.pow(10, Math.floor(bt(i))), n = i / e;
  return (n <= 1 ? 1 : n <= 2 ? 2 : n <= 5 ? 5 : 10) * e;
}
function dh(i) {
  const t = [], e = Math.sqrt(i);
  let n;
  for (n = 1; n < e; n++)
    i % n === 0 && (t.push(n), t.push(i / n));
  return e === (e | 0) && t.push(e), t.sort((r, s) => r - s).pop(), t;
}
function $e(i) {
  return !isNaN(parseFloat(i)) && isFinite(i);
}
function mi(i, t, e) {
  return Math.abs(i - t) < e;
}
function ph(i, t) {
  const e = Math.round(i);
  return e - t <= i && e + t >= i;
}
function Yc(i, t, e) {
  let n, r, s;
  for (n = 0, r = i.length; n < r; n++)
    s = i[n][e], isNaN(s) || (t.min = Math.min(t.min, s), t.max = Math.max(t.max, s));
}
function kt(i) {
  return i * (Z / 180);
}
function Ms(i) {
  return i * (180 / Z);
}
function jo(i) {
  if (!ut(i))
    return;
  let t = 1, e = 0;
  for (; Math.round(i * t) / t !== i; )
    t *= 10, e++;
  return e;
}
function Gc(i, t) {
  const e = t.x - i.x, n = t.y - i.y, r = Math.sqrt(e * e + n * n);
  let s = Math.atan2(n, e);
  return s < -0.5 * Z && (s += Q), {
    angle: s,
    distance: r
  };
}
function Br(i, t) {
  return Math.sqrt(Math.pow(t.x - i.x, 2) + Math.pow(t.y - i.y, 2));
}
function gh(i, t) {
  return (i - t + hh) % Q - Z;
}
function Et(i) {
  return (i % Q + Q) % Q;
}
function Di(i, t, e, n) {
  const r = Et(i), s = Et(t), o = Et(e), a = Et(s - r), c = Et(o - r), l = Et(r - s), u = Et(r - o);
  return r === s || r === o || n && s === o || a > c && l < u;
}
function ft(i, t, e) {
  return Math.max(t, Math.min(e, i));
}
function mh(i) {
  return ft(i, -32768, 32767);
}
function wn(i, t, e, n = 1e-6) {
  return i >= Math.min(t, e) - n && i <= Math.max(t, e) + n;
}
function As(i, t, e) {
  e = e || ((o) => i[o] < t);
  let n = i.length - 1, r = 0, s;
  for (; n - r > 1; )
    s = r + n >> 1, e(s) ? r = s : n = s;
  return { lo: r, hi: n };
}
const ue = (i, t, e, n) => As(i, e, n ? (r) => i[r][t] <= e : (r) => i[r][t] < e), yh = (i, t, e) => As(i, e, (n) => i[n][t] >= e);
function vh(i, t, e) {
  let n = 0, r = i.length;
  for (; n < r && i[n] < t; )
    n++;
  for (; r > n && i[r - 1] > e; )
    r--;
  return n > 0 || r < i.length ? i.slice(n, r) : i;
}
const Xc = ["push", "pop", "shift", "splice", "unshift"];
function bh(i, t) {
  if (i._chartjs) {
    i._chartjs.listeners.push(t);
    return;
  }
  Object.defineProperty(i, "_chartjs", {
    configurable: !0,
    enumerable: !1,
    value: {
      listeners: [t]
    }
  }), Xc.forEach((e) => {
    const n = "_onData" + Ts(e), r = i[e];
    Object.defineProperty(i, e, {
      configurable: !0,
      enumerable: !1,
      value(...s) {
        const o = r.apply(this, s);
        return i._chartjs.listeners.forEach((a) => {
          typeof a[n] == "function" && a[n](...s);
        }), o;
      }
    });
  });
}
function Bo(i, t) {
  const e = i._chartjs;
  if (!e)
    return;
  const n = e.listeners, r = n.indexOf(t);
  r !== -1 && n.splice(r, 1), !(n.length > 0) && (Xc.forEach((s) => {
    delete i[s];
  }), delete i._chartjs);
}
function Kc(i) {
  const t = /* @__PURE__ */ new Set();
  let e, n;
  for (e = 0, n = i.length; e < n; ++e)
    t.add(i[e]);
  return t.size === n ? i : Array.from(t);
}
const Jc = function() {
  return typeof window > "u" ? function(i) {
    return i();
  } : window.requestAnimationFrame;
}();
function Zc(i, t, e) {
  const n = e || ((o) => Array.prototype.slice.call(o));
  let r = !1, s = [];
  return function(...o) {
    s = n(o), r || (r = !0, Jc.call(window, () => {
      r = !1, i.apply(t, s);
    }));
  };
}
function _h(i, t) {
  let e;
  return function(...n) {
    return t ? (clearTimeout(e), e = setTimeout(i, t, n)) : i.apply(this, n), t;
  };
}
const xh = (i) => i === "start" ? "left" : i === "end" ? "right" : "center", $o = (i, t, e) => i === "start" ? t : i === "end" ? e : (t + e) / 2;
function tl(i, t, e) {
  const n = t.length;
  let r = 0, s = n;
  if (i._sorted) {
    const { iScale: o, _parsed: a } = i, c = o.axis, { min: l, max: u, minDefined: h, maxDefined: f } = o.getUserBounds();
    h && (r = ft(
      Math.min(
        ue(a, o.axis, l).lo,
        e ? n : ue(t, c, o.getPixelForValue(l)).lo
      ),
      0,
      n - 1
    )), f ? s = ft(
      Math.max(
        ue(a, o.axis, u, !0).hi + 1,
        e ? 0 : ue(t, c, o.getPixelForValue(u), !0).hi + 1
      ),
      r,
      n
    ) - r : s = n - r;
  }
  return { start: r, count: s };
}
function el(i) {
  const { xScale: t, yScale: e, _scaleRanges: n } = i, r = {
    xmin: t.min,
    xmax: t.max,
    ymin: e.min,
    ymax: e.max
  };
  if (!n)
    return i._scaleRanges = r, !0;
  const s = n.xmin !== t.min || n.xmax !== t.max || n.ymin !== e.min || n.ymax !== e.max;
  return Object.assign(n, r), s;
}
const Qi = (i) => i === 0 || i === 1, zo = (i, t, e) => -(Math.pow(2, 10 * (i -= 1)) * Math.sin((i - t) * Q / e)), qo = (i, t, e) => Math.pow(2, -10 * i) * Math.sin((i - t) * Q / e) + 1, yi = {
  linear: (i) => i,
  easeInQuad: (i) => i * i,
  easeOutQuad: (i) => -i * (i - 2),
  easeInOutQuad: (i) => (i /= 0.5) < 1 ? 0.5 * i * i : -0.5 * (--i * (i - 2) - 1),
  easeInCubic: (i) => i * i * i,
  easeOutCubic: (i) => (i -= 1) * i * i + 1,
  easeInOutCubic: (i) => (i /= 0.5) < 1 ? 0.5 * i * i * i : 0.5 * ((i -= 2) * i * i + 2),
  easeInQuart: (i) => i * i * i * i,
  easeOutQuart: (i) => -((i -= 1) * i * i * i - 1),
  easeInOutQuart: (i) => (i /= 0.5) < 1 ? 0.5 * i * i * i * i : -0.5 * ((i -= 2) * i * i * i - 2),
  easeInQuint: (i) => i * i * i * i * i,
  easeOutQuint: (i) => (i -= 1) * i * i * i * i + 1,
  easeInOutQuint: (i) => (i /= 0.5) < 1 ? 0.5 * i * i * i * i * i : 0.5 * ((i -= 2) * i * i * i * i + 2),
  easeInSine: (i) => -Math.cos(i * K) + 1,
  easeOutSine: (i) => Math.sin(i * K),
  easeInOutSine: (i) => -0.5 * (Math.cos(Z * i) - 1),
  easeInExpo: (i) => i === 0 ? 0 : Math.pow(2, 10 * (i - 1)),
  easeOutExpo: (i) => i === 1 ? 1 : -Math.pow(2, -10 * i) + 1,
  easeInOutExpo: (i) => Qi(i) ? i : i < 0.5 ? 0.5 * Math.pow(2, 10 * (i * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (i * 2 - 1)) + 2),
  easeInCirc: (i) => i >= 1 ? i : -(Math.sqrt(1 - i * i) - 1),
  easeOutCirc: (i) => Math.sqrt(1 - (i -= 1) * i),
  easeInOutCirc: (i) => (i /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - i * i) - 1) : 0.5 * (Math.sqrt(1 - (i -= 2) * i) + 1),
  easeInElastic: (i) => Qi(i) ? i : zo(i, 0.075, 0.3),
  easeOutElastic: (i) => Qi(i) ? i : qo(i, 0.075, 0.3),
  easeInOutElastic(i) {
    return Qi(i) ? i : i < 0.5 ? 0.5 * zo(i * 2, 0.1125, 0.45) : 0.5 + 0.5 * qo(i * 2 - 1, 0.1125, 0.45);
  },
  easeInBack(i) {
    return i * i * ((1.70158 + 1) * i - 1.70158);
  },
  easeOutBack(i) {
    return (i -= 1) * i * ((1.70158 + 1) * i + 1.70158) + 1;
  },
  easeInOutBack(i) {
    let t = 1.70158;
    return (i /= 0.5) < 1 ? 0.5 * (i * i * (((t *= 1.525) + 1) * i - t)) : 0.5 * ((i -= 2) * i * (((t *= 1.525) + 1) * i + t) + 2);
  },
  easeInBounce: (i) => 1 - yi.easeOutBounce(1 - i),
  easeOutBounce(i) {
    return i < 1 / 2.75 ? 7.5625 * i * i : i < 2 / 2.75 ? 7.5625 * (i -= 1.5 / 2.75) * i + 0.75 : i < 2.5 / 2.75 ? 7.5625 * (i -= 2.25 / 2.75) * i + 0.9375 : 7.5625 * (i -= 2.625 / 2.75) * i + 0.984375;
  },
  easeInOutBounce: (i) => i < 0.5 ? yi.easeInBounce(i * 2) * 0.5 : yi.easeOutBounce(i * 2 - 1) * 0.5 + 0.5
};
/*!
 * @kurkle/color v0.2.1
 * https://github.com/kurkle/color#readme
 * (c) 2022 Jukka Kurkela
 * Released under the MIT License
 */
function Vi(i) {
  return i + 0.5 | 0;
}
const Kt = (i, t, e) => Math.max(Math.min(i, e), t);
function ui(i) {
  return Kt(Vi(i * 2.55), 0, 255);
}
function Zt(i) {
  return Kt(Vi(i * 255), 0, 255);
}
function jt(i) {
  return Kt(Vi(i / 2.55) / 100, 0, 1);
}
function Qo(i) {
  return Kt(Vi(i * 100), 0, 100);
}
const mt = { 0: 0, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9, A: 10, B: 11, C: 12, D: 13, E: 14, F: 15, a: 10, b: 11, c: 12, d: 13, e: 14, f: 15 }, $r = [..."0123456789ABCDEF"], wh = (i) => $r[i & 15], Sh = (i) => $r[(i & 240) >> 4] + $r[i & 15], Ui = (i) => (i & 240) >> 4 === (i & 15), Eh = (i) => Ui(i.r) && Ui(i.g) && Ui(i.b) && Ui(i.a);
function kh(i) {
  var t = i.length, e;
  return i[0] === "#" && (t === 4 || t === 5 ? e = {
    r: 255 & mt[i[1]] * 17,
    g: 255 & mt[i[2]] * 17,
    b: 255 & mt[i[3]] * 17,
    a: t === 5 ? mt[i[4]] * 17 : 255
  } : (t === 7 || t === 9) && (e = {
    r: mt[i[1]] << 4 | mt[i[2]],
    g: mt[i[3]] << 4 | mt[i[4]],
    b: mt[i[5]] << 4 | mt[i[6]],
    a: t === 9 ? mt[i[7]] << 4 | mt[i[8]] : 255
  })), e;
}
const Oh = (i, t) => i < 255 ? t(i) : "";
function Dh(i) {
  var t = Eh(i) ? wh : Sh;
  return i ? "#" + t(i.r) + t(i.g) + t(i.b) + Oh(i.a, t) : void 0;
}
const Th = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function il(i, t, e) {
  const n = t * Math.min(e, 1 - e), r = (s, o = (s + i / 30) % 12) => e - n * Math.max(Math.min(o - 3, 9 - o, 1), -1);
  return [r(0), r(8), r(4)];
}
function Mh(i, t, e) {
  const n = (r, s = (r + i / 60) % 6) => e - e * t * Math.max(Math.min(s, 4 - s, 1), 0);
  return [n(5), n(3), n(1)];
}
function Ah(i, t, e) {
  const n = il(i, 1, 0.5);
  let r;
  for (t + e > 1 && (r = 1 / (t + e), t *= r, e *= r), r = 0; r < 3; r++)
    n[r] *= 1 - t - e, n[r] += t;
  return n;
}
function Ch(i, t, e, n, r) {
  return i === r ? (t - e) / n + (t < e ? 6 : 0) : t === r ? (e - i) / n + 2 : (i - t) / n + 4;
}
function Cs(i) {
  const e = i.r / 255, n = i.g / 255, r = i.b / 255, s = Math.max(e, n, r), o = Math.min(e, n, r), a = (s + o) / 2;
  let c, l, u;
  return s !== o && (u = s - o, l = a > 0.5 ? u / (2 - s - o) : u / (s + o), c = Ch(e, n, r, u, s), c = c * 60 + 0.5), [c | 0, l || 0, a];
}
function Ps(i, t, e, n) {
  return (Array.isArray(t) ? i(t[0], t[1], t[2]) : i(t, e, n)).map(Zt);
}
function Rs(i, t, e) {
  return Ps(il, i, t, e);
}
function Ph(i, t, e) {
  return Ps(Ah, i, t, e);
}
function Rh(i, t, e) {
  return Ps(Mh, i, t, e);
}
function nl(i) {
  return (i % 360 + 360) % 360;
}
function Ih(i) {
  const t = Th.exec(i);
  let e = 255, n;
  if (!t)
    return;
  t[5] !== n && (e = t[6] ? ui(+t[5]) : Zt(+t[5]));
  const r = nl(+t[2]), s = +t[3] / 100, o = +t[4] / 100;
  return t[1] === "hwb" ? n = Ph(r, s, o) : t[1] === "hsv" ? n = Rh(r, s, o) : n = Rs(r, s, o), {
    r: n[0],
    g: n[1],
    b: n[2],
    a: e
  };
}
function Fh(i, t) {
  var e = Cs(i);
  e[0] = nl(e[0] + t), e = Rs(e), i.r = e[0], i.g = e[1], i.b = e[2];
}
function Lh(i) {
  if (!i)
    return;
  const t = Cs(i), e = t[0], n = Qo(t[1]), r = Qo(t[2]);
  return i.a < 255 ? `hsla(${e}, ${n}%, ${r}%, ${jt(i.a)})` : `hsl(${e}, ${n}%, ${r}%)`;
}
const Uo = {
  x: "dark",
  Z: "light",
  Y: "re",
  X: "blu",
  W: "gr",
  V: "medium",
  U: "slate",
  A: "ee",
  T: "ol",
  S: "or",
  B: "ra",
  C: "lateg",
  D: "ights",
  R: "in",
  Q: "turquois",
  E: "hi",
  P: "ro",
  O: "al",
  N: "le",
  M: "de",
  L: "yello",
  F: "en",
  K: "ch",
  G: "arks",
  H: "ea",
  I: "ightg",
  J: "wh"
}, Wo = {
  OiceXe: "f0f8ff",
  antiquewEte: "faebd7",
  aqua: "ffff",
  aquamarRe: "7fffd4",
  azuY: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "0",
  blanKedOmond: "ffebcd",
  Xe: "ff",
  XeviTet: "8a2be2",
  bPwn: "a52a2a",
  burlywood: "deb887",
  caMtXe: "5f9ea0",
  KartYuse: "7fff00",
  KocTate: "d2691e",
  cSO: "ff7f50",
  cSnflowerXe: "6495ed",
  cSnsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "ffff",
  xXe: "8b",
  xcyan: "8b8b",
  xgTMnPd: "b8860b",
  xWay: "a9a9a9",
  xgYF: "6400",
  xgYy: "a9a9a9",
  xkhaki: "bdb76b",
  xmagFta: "8b008b",
  xTivegYF: "556b2f",
  xSange: "ff8c00",
  xScEd: "9932cc",
  xYd: "8b0000",
  xsOmon: "e9967a",
  xsHgYF: "8fbc8f",
  xUXe: "483d8b",
  xUWay: "2f4f4f",
  xUgYy: "2f4f4f",
  xQe: "ced1",
  xviTet: "9400d3",
  dAppRk: "ff1493",
  dApskyXe: "bfff",
  dimWay: "696969",
  dimgYy: "696969",
  dodgerXe: "1e90ff",
  fiYbrick: "b22222",
  flSOwEte: "fffaf0",
  foYstWAn: "228b22",
  fuKsia: "ff00ff",
  gaRsbSo: "dcdcdc",
  ghostwEte: "f8f8ff",
  gTd: "ffd700",
  gTMnPd: "daa520",
  Way: "808080",
  gYF: "8000",
  gYFLw: "adff2f",
  gYy: "808080",
  honeyMw: "f0fff0",
  hotpRk: "ff69b4",
  RdianYd: "cd5c5c",
  Rdigo: "4b0082",
  ivSy: "fffff0",
  khaki: "f0e68c",
  lavFMr: "e6e6fa",
  lavFMrXsh: "fff0f5",
  lawngYF: "7cfc00",
  NmoncEffon: "fffacd",
  ZXe: "add8e6",
  ZcSO: "f08080",
  Zcyan: "e0ffff",
  ZgTMnPdLw: "fafad2",
  ZWay: "d3d3d3",
  ZgYF: "90ee90",
  ZgYy: "d3d3d3",
  ZpRk: "ffb6c1",
  ZsOmon: "ffa07a",
  ZsHgYF: "20b2aa",
  ZskyXe: "87cefa",
  ZUWay: "778899",
  ZUgYy: "778899",
  ZstAlXe: "b0c4de",
  ZLw: "ffffe0",
  lime: "ff00",
  limegYF: "32cd32",
  lRF: "faf0e6",
  magFta: "ff00ff",
  maPon: "800000",
  VaquamarRe: "66cdaa",
  VXe: "cd",
  VScEd: "ba55d3",
  VpurpN: "9370db",
  VsHgYF: "3cb371",
  VUXe: "7b68ee",
  VsprRggYF: "fa9a",
  VQe: "48d1cc",
  VviTetYd: "c71585",
  midnightXe: "191970",
  mRtcYam: "f5fffa",
  mistyPse: "ffe4e1",
  moccasR: "ffe4b5",
  navajowEte: "ffdead",
  navy: "80",
  Tdlace: "fdf5e6",
  Tive: "808000",
  TivedBb: "6b8e23",
  Sange: "ffa500",
  SangeYd: "ff4500",
  ScEd: "da70d6",
  pOegTMnPd: "eee8aa",
  pOegYF: "98fb98",
  pOeQe: "afeeee",
  pOeviTetYd: "db7093",
  papayawEp: "ffefd5",
  pHKpuff: "ffdab9",
  peru: "cd853f",
  pRk: "ffc0cb",
  plum: "dda0dd",
  powMrXe: "b0e0e6",
  purpN: "800080",
  YbeccapurpN: "663399",
  Yd: "ff0000",
  Psybrown: "bc8f8f",
  PyOXe: "4169e1",
  saddNbPwn: "8b4513",
  sOmon: "fa8072",
  sandybPwn: "f4a460",
  sHgYF: "2e8b57",
  sHshell: "fff5ee",
  siFna: "a0522d",
  silver: "c0c0c0",
  skyXe: "87ceeb",
  UXe: "6a5acd",
  UWay: "708090",
  UgYy: "708090",
  snow: "fffafa",
  sprRggYF: "ff7f",
  stAlXe: "4682b4",
  tan: "d2b48c",
  teO: "8080",
  tEstN: "d8bfd8",
  tomato: "ff6347",
  Qe: "40e0d0",
  viTet: "ee82ee",
  JHt: "f5deb3",
  wEte: "ffffff",
  wEtesmoke: "f5f5f5",
  Lw: "ffff00",
  LwgYF: "9acd32"
};
function Nh() {
  const i = {}, t = Object.keys(Wo), e = Object.keys(Uo);
  let n, r, s, o, a;
  for (n = 0; n < t.length; n++) {
    for (o = a = t[n], r = 0; r < e.length; r++)
      s = e[r], a = a.replace(s, Uo[s]);
    s = parseInt(Wo[o], 16), i[a] = [s >> 16 & 255, s >> 8 & 255, s & 255];
  }
  return i;
}
let Wi;
function Vh(i) {
  Wi || (Wi = Nh(), Wi.transparent = [0, 0, 0, 0]);
  const t = Wi[i.toLowerCase()];
  return t && {
    r: t[0],
    g: t[1],
    b: t[2],
    a: t.length === 4 ? t[3] : 255
  };
}
const jh = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function Bh(i) {
  const t = jh.exec(i);
  let e = 255, n, r, s;
  if (!!t) {
    if (t[7] !== n) {
      const o = +t[7];
      e = t[8] ? ui(o) : Kt(o * 255, 0, 255);
    }
    return n = +t[1], r = +t[3], s = +t[5], n = 255 & (t[2] ? ui(n) : Kt(n, 0, 255)), r = 255 & (t[4] ? ui(r) : Kt(r, 0, 255)), s = 255 & (t[6] ? ui(s) : Kt(s, 0, 255)), {
      r: n,
      g: r,
      b: s,
      a: e
    };
  }
}
function $h(i) {
  return i && (i.a < 255 ? `rgba(${i.r}, ${i.g}, ${i.b}, ${jt(i.a)})` : `rgb(${i.r}, ${i.g}, ${i.b})`);
}
const ur = (i) => i <= 31308e-7 ? i * 12.92 : Math.pow(i, 1 / 2.4) * 1.055 - 0.055, Se = (i) => i <= 0.04045 ? i / 12.92 : Math.pow((i + 0.055) / 1.055, 2.4);
function zh(i, t, e) {
  const n = Se(jt(i.r)), r = Se(jt(i.g)), s = Se(jt(i.b));
  return {
    r: Zt(ur(n + e * (Se(jt(t.r)) - n))),
    g: Zt(ur(r + e * (Se(jt(t.g)) - r))),
    b: Zt(ur(s + e * (Se(jt(t.b)) - s))),
    a: i.a + e * (t.a - i.a)
  };
}
function Hi(i, t, e) {
  if (i) {
    let n = Cs(i);
    n[t] = Math.max(0, Math.min(n[t] + n[t] * e, t === 0 ? 360 : 1)), n = Rs(n), i.r = n[0], i.g = n[1], i.b = n[2];
  }
}
function rl(i, t) {
  return i && Object.assign(t || {}, i);
}
function Ho(i) {
  var t = { r: 0, g: 0, b: 0, a: 255 };
  return Array.isArray(i) ? i.length >= 3 && (t = { r: i[0], g: i[1], b: i[2], a: 255 }, i.length > 3 && (t.a = Zt(i[3]))) : (t = rl(i, { r: 0, g: 0, b: 0, a: 1 }), t.a = Zt(t.a)), t;
}
function qh(i) {
  return i.charAt(0) === "r" ? Bh(i) : Ih(i);
}
class Sn {
  constructor(t) {
    if (t instanceof Sn)
      return t;
    const e = typeof t;
    let n;
    e === "object" ? n = Ho(t) : e === "string" && (n = kh(t) || Vh(t) || qh(t)), this._rgb = n, this._valid = !!n;
  }
  get valid() {
    return this._valid;
  }
  get rgb() {
    var t = rl(this._rgb);
    return t && (t.a = jt(t.a)), t;
  }
  set rgb(t) {
    this._rgb = Ho(t);
  }
  rgbString() {
    return this._valid ? $h(this._rgb) : void 0;
  }
  hexString() {
    return this._valid ? Dh(this._rgb) : void 0;
  }
  hslString() {
    return this._valid ? Lh(this._rgb) : void 0;
  }
  mix(t, e) {
    if (t) {
      const n = this.rgb, r = t.rgb;
      let s;
      const o = e === s ? 0.5 : e, a = 2 * o - 1, c = n.a - r.a, l = ((a * c === -1 ? a : (a + c) / (1 + a * c)) + 1) / 2;
      s = 1 - l, n.r = 255 & l * n.r + s * r.r + 0.5, n.g = 255 & l * n.g + s * r.g + 0.5, n.b = 255 & l * n.b + s * r.b + 0.5, n.a = o * n.a + (1 - o) * r.a, this.rgb = n;
    }
    return this;
  }
  interpolate(t, e) {
    return t && (this._rgb = zh(this._rgb, t._rgb, e)), this;
  }
  clone() {
    return new Sn(this.rgb);
  }
  alpha(t) {
    return this._rgb.a = Zt(t), this;
  }
  clearer(t) {
    const e = this._rgb;
    return e.a *= 1 - t, this;
  }
  greyscale() {
    const t = this._rgb, e = Vi(t.r * 0.3 + t.g * 0.59 + t.b * 0.11);
    return t.r = t.g = t.b = e, this;
  }
  opaquer(t) {
    const e = this._rgb;
    return e.a *= 1 + t, this;
  }
  negate() {
    const t = this._rgb;
    return t.r = 255 - t.r, t.g = 255 - t.g, t.b = 255 - t.b, this;
  }
  lighten(t) {
    return Hi(this._rgb, 2, t), this;
  }
  darken(t) {
    return Hi(this._rgb, 2, -t), this;
  }
  saturate(t) {
    return Hi(this._rgb, 1, t), this;
  }
  desaturate(t) {
    return Hi(this._rgb, 1, -t), this;
  }
  rotate(t) {
    return Fh(this._rgb, t), this;
  }
}
function sl(i) {
  return new Sn(i);
}
function ol(i) {
  if (i && typeof i == "object") {
    const t = i.toString();
    return t === "[object CanvasPattern]" || t === "[object CanvasGradient]";
  }
  return !1;
}
function Yo(i) {
  return ol(i) ? i : sl(i);
}
function hr(i) {
  return ol(i) ? i : sl(i).saturate(0.5).darken(0.1).hexString();
}
const ge = /* @__PURE__ */ Object.create(null), zr = /* @__PURE__ */ Object.create(null);
function vi(i, t) {
  if (!t)
    return i;
  const e = t.split(".");
  for (let n = 0, r = e.length; n < r; ++n) {
    const s = e[n];
    i = i[s] || (i[s] = /* @__PURE__ */ Object.create(null));
  }
  return i;
}
function fr(i, t, e) {
  return typeof t == "string" ? Oi(vi(i, t), e) : Oi(vi(i, ""), t);
}
class Qh {
  constructor(t) {
    this.animation = void 0, this.backgroundColor = "rgba(0,0,0,0.1)", this.borderColor = "rgba(0,0,0,0.1)", this.color = "#666", this.datasets = {}, this.devicePixelRatio = (e) => e.chart.platform.getDevicePixelRatio(), this.elements = {}, this.events = [
      "mousemove",
      "mouseout",
      "click",
      "touchstart",
      "touchmove"
    ], this.font = {
      family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
      size: 12,
      style: "normal",
      lineHeight: 1.2,
      weight: null
    }, this.hover = {}, this.hoverBackgroundColor = (e, n) => hr(n.backgroundColor), this.hoverBorderColor = (e, n) => hr(n.borderColor), this.hoverColor = (e, n) => hr(n.color), this.indexAxis = "x", this.interaction = {
      mode: "nearest",
      intersect: !0,
      includeInvisible: !1
    }, this.maintainAspectRatio = !0, this.onHover = null, this.onClick = null, this.parsing = !0, this.plugins = {}, this.responsive = !0, this.scale = void 0, this.scales = {}, this.showLine = !0, this.drawActiveElementsOnTop = !0, this.describe(t);
  }
  set(t, e) {
    return fr(this, t, e);
  }
  get(t) {
    return vi(this, t);
  }
  describe(t, e) {
    return fr(zr, t, e);
  }
  override(t, e) {
    return fr(ge, t, e);
  }
  route(t, e, n, r) {
    const s = vi(this, t), o = vi(this, n), a = "_" + e;
    Object.defineProperties(s, {
      [a]: {
        value: s[e],
        writable: !0
      },
      [e]: {
        enumerable: !0,
        get() {
          const c = this[a], l = o[r];
          return L(c) ? Object.assign({}, l, c) : F(c, l);
        },
        set(c) {
          this[a] = c;
        }
      }
    });
  }
}
var I = new Qh({
  _scriptable: (i) => !i.startsWith("on"),
  _indexable: (i) => i !== "events",
  hover: {
    _fallback: "interaction"
  },
  interaction: {
    _scriptable: !1,
    _indexable: !1
  }
});
function Uh(i) {
  return !i || $(i.size) || $(i.family) ? null : (i.style ? i.style + " " : "") + (i.weight ? i.weight + " " : "") + i.size + "px " + i.family;
}
function En(i, t, e, n, r) {
  let s = t[r];
  return s || (s = t[r] = i.measureText(r).width, e.push(r)), s > n && (n = s), n;
}
function Wh(i, t, e, n) {
  n = n || {};
  let r = n.data = n.data || {}, s = n.garbageCollect = n.garbageCollect || [];
  n.font !== t && (r = n.data = {}, s = n.garbageCollect = [], n.font = t), i.save(), i.font = t;
  let o = 0;
  const a = e.length;
  let c, l, u, h, f;
  for (c = 0; c < a; c++)
    if (h = e[c], h != null && H(h) !== !0)
      o = En(i, r, s, o, h);
    else if (H(h))
      for (l = 0, u = h.length; l < u; l++)
        f = h[l], f != null && !H(f) && (o = En(i, r, s, o, f));
  i.restore();
  const d = s.length / 2;
  if (d > e.length) {
    for (c = 0; c < d; c++)
      delete r[s[c]];
    s.splice(0, d);
  }
  return o;
}
function oe(i, t, e) {
  const n = i.currentDevicePixelRatio, r = e !== 0 ? Math.max(e / 2, 0.5) : 0;
  return Math.round((t - r) * n) / n + r;
}
function Go(i, t) {
  t = t || i.getContext("2d"), t.save(), t.resetTransform(), t.clearRect(0, 0, i.width, i.height), t.restore();
}
function qr(i, t, e, n) {
  Hh(i, t, e, n, null);
}
function Hh(i, t, e, n, r) {
  let s, o, a, c, l, u;
  const h = t.pointStyle, f = t.rotation, d = t.radius;
  let p = (f || 0) * fh;
  if (h && typeof h == "object" && (s = h.toString(), s === "[object HTMLImageElement]" || s === "[object HTMLCanvasElement]")) {
    i.save(), i.translate(e, n), i.rotate(p), i.drawImage(h, -h.width / 2, -h.height / 2, h.width, h.height), i.restore();
    return;
  }
  if (!(isNaN(d) || d <= 0)) {
    switch (i.beginPath(), h) {
      default:
        r ? i.ellipse(e, n, r / 2, d, 0, 0, Q) : i.arc(e, n, d, 0, Q), i.closePath();
        break;
      case "triangle":
        i.moveTo(e + Math.sin(p) * d, n - Math.cos(p) * d), p += No, i.lineTo(e + Math.sin(p) * d, n - Math.cos(p) * d), p += No, i.lineTo(e + Math.sin(p) * d, n - Math.cos(p) * d), i.closePath();
        break;
      case "rectRounded":
        l = d * 0.516, c = d - l, o = Math.cos(p + Ze) * c, a = Math.sin(p + Ze) * c, i.arc(e - o, n - a, l, p - Z, p - K), i.arc(e + a, n - o, l, p - K, p), i.arc(e + o, n + a, l, p, p + K), i.arc(e - a, n + o, l, p + K, p + Z), i.closePath();
        break;
      case "rect":
        if (!f) {
          c = Math.SQRT1_2 * d, u = r ? r / 2 : c, i.rect(e - u, n - c, 2 * u, 2 * c);
          break;
        }
        p += Ze;
      case "rectRot":
        o = Math.cos(p) * d, a = Math.sin(p) * d, i.moveTo(e - o, n - a), i.lineTo(e + a, n - o), i.lineTo(e + o, n + a), i.lineTo(e - a, n + o), i.closePath();
        break;
      case "crossRot":
        p += Ze;
      case "cross":
        o = Math.cos(p) * d, a = Math.sin(p) * d, i.moveTo(e - o, n - a), i.lineTo(e + o, n + a), i.moveTo(e + a, n - o), i.lineTo(e - a, n + o);
        break;
      case "star":
        o = Math.cos(p) * d, a = Math.sin(p) * d, i.moveTo(e - o, n - a), i.lineTo(e + o, n + a), i.moveTo(e + a, n - o), i.lineTo(e - a, n + o), p += Ze, o = Math.cos(p) * d, a = Math.sin(p) * d, i.moveTo(e - o, n - a), i.lineTo(e + o, n + a), i.moveTo(e + a, n - o), i.lineTo(e - a, n + o);
        break;
      case "line":
        o = r ? r / 2 : Math.cos(p) * d, a = Math.sin(p) * d, i.moveTo(e - o, n - a), i.lineTo(e + o, n + a);
        break;
      case "dash":
        i.moveTo(e, n), i.lineTo(e + Math.cos(p) * d, n + Math.sin(p) * d);
        break;
    }
    i.fill(), t.borderWidth > 0 && i.stroke();
  }
}
function Ti(i, t, e) {
  return e = e || 0.5, !t || i && i.x > t.left - e && i.x < t.right + e && i.y > t.top - e && i.y < t.bottom + e;
}
function al(i, t) {
  i.save(), i.beginPath(), i.rect(t.left, t.top, t.right - t.left, t.bottom - t.top), i.clip();
}
function cl(i) {
  i.restore();
}
function Yh(i, t, e, n, r) {
  if (!t)
    return i.lineTo(e.x, e.y);
  if (r === "middle") {
    const s = (t.x + e.x) / 2;
    i.lineTo(s, t.y), i.lineTo(s, e.y);
  } else
    r === "after" != !!n ? i.lineTo(t.x, e.y) : i.lineTo(e.x, t.y);
  i.lineTo(e.x, e.y);
}
function Gh(i, t, e, n) {
  if (!t)
    return i.lineTo(e.x, e.y);
  i.bezierCurveTo(
    n ? t.cp1x : t.cp2x,
    n ? t.cp1y : t.cp2y,
    n ? e.cp2x : e.cp1x,
    n ? e.cp2y : e.cp1y,
    e.x,
    e.y
  );
}
function kn(i, t, e, n, r, s = {}) {
  const o = H(t) ? t : [t], a = s.strokeWidth > 0 && s.strokeColor !== "";
  let c, l;
  for (i.save(), i.font = r.string, Xh(i, s), c = 0; c < o.length; ++c)
    l = o[c], a && (s.strokeColor && (i.strokeStyle = s.strokeColor), $(s.strokeWidth) || (i.lineWidth = s.strokeWidth), i.strokeText(l, e, n, s.maxWidth)), i.fillText(l, e, n, s.maxWidth), Kh(i, e, n, l, s), n += r.lineHeight;
  i.restore();
}
function Xh(i, t) {
  t.translation && i.translate(t.translation[0], t.translation[1]), $(t.rotation) || i.rotate(t.rotation), t.color && (i.fillStyle = t.color), t.textAlign && (i.textAlign = t.textAlign), t.textBaseline && (i.textBaseline = t.textBaseline);
}
function Kh(i, t, e, n, r) {
  if (r.strikethrough || r.underline) {
    const s = i.measureText(n), o = t - s.actualBoundingBoxLeft, a = t + s.actualBoundingBoxRight, c = e - s.actualBoundingBoxAscent, l = e + s.actualBoundingBoxDescent, u = r.strikethrough ? (c + l) / 2 : l;
    i.strokeStyle = i.fillStyle, i.beginPath(), i.lineWidth = r.decorationWidth || 2, i.moveTo(o, u), i.lineTo(a, u), i.stroke();
  }
}
function On(i, t) {
  const { x: e, y: n, w: r, h: s, radius: o } = t;
  i.arc(e + o.topLeft, n + o.topLeft, o.topLeft, -K, Z, !0), i.lineTo(e, n + s - o.bottomLeft), i.arc(e + o.bottomLeft, n + s - o.bottomLeft, o.bottomLeft, Z, K, !0), i.lineTo(e + r - o.bottomRight, n + s), i.arc(e + r - o.bottomRight, n + s - o.bottomRight, o.bottomRight, K, 0, !0), i.lineTo(e + r, n + o.topRight), i.arc(e + r - o.topRight, n + o.topRight, o.topRight, 0, -K, !0), i.lineTo(e + o.topLeft, n);
}
const Jh = new RegExp(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/), Zh = new RegExp(/^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/);
function tf(i, t) {
  const e = ("" + i).match(Jh);
  if (!e || e[1] === "normal")
    return t * 1.2;
  switch (i = +e[2], e[3]) {
    case "px":
      return i;
    case "%":
      i /= 100;
      break;
  }
  return t * i;
}
const ef = (i) => +i || 0;
function Is(i, t) {
  const e = {}, n = L(t), r = n ? Object.keys(t) : t, s = L(i) ? n ? (o) => F(i[o], i[t[o]]) : (o) => i[o] : () => i;
  for (const o of r)
    e[o] = ef(s(o));
  return e;
}
function ll(i) {
  return Is(i, { top: "y", right: "x", bottom: "y", left: "x" });
}
function Pe(i) {
  return Is(i, ["topLeft", "topRight", "bottomLeft", "bottomRight"]);
}
function xt(i) {
  const t = ll(i);
  return t.width = t.left + t.right, t.height = t.top + t.bottom, t;
}
function gt(i, t) {
  i = i || {}, t = t || I.font;
  let e = F(i.size, t.size);
  typeof e == "string" && (e = parseInt(e, 10));
  let n = F(i.style, t.style);
  n && !("" + n).match(Zh) && (console.warn('Invalid font style specified: "' + n + '"'), n = "");
  const r = {
    family: F(i.family, t.family),
    lineHeight: tf(F(i.lineHeight, t.lineHeight), e),
    size: e,
    style: n,
    weight: F(i.weight, t.weight),
    string: ""
  };
  return r.string = Uh(r), r;
}
function Yi(i, t, e, n) {
  let r = !0, s, o, a;
  for (s = 0, o = i.length; s < o; ++s)
    if (a = i[s], a !== void 0 && (t !== void 0 && typeof a == "function" && (a = a(t), r = !1), e !== void 0 && H(a) && (a = a[e % a.length], r = !1), a !== void 0))
      return n && !r && (n.cacheable = !1), a;
}
function nf(i, t, e) {
  const { min: n, max: r } = i, s = Wc(t, (r - n) / 2), o = (a, c) => e && a === 0 ? 0 : a + c;
  return {
    min: o(n, -Math.abs(s)),
    max: o(r, s)
  };
}
function re(i, t) {
  return Object.assign(Object.create(i), t);
}
function Fs(i, t = [""], e = i, n, r = () => i[0]) {
  _t(n) || (n = dl("_fallback", i));
  const s = {
    [Symbol.toStringTag]: "Object",
    _cacheable: !0,
    _scopes: i,
    _rootScopes: e,
    _fallback: n,
    _getTarget: r,
    override: (o) => Fs([o, ...i], t, e, n)
  };
  return new Proxy(s, {
    deleteProperty(o, a) {
      return delete o[a], delete o._keys, delete i[0][a], !0;
    },
    get(o, a) {
      return hl(
        o,
        a,
        () => hf(a, t, i, o)
      );
    },
    getOwnPropertyDescriptor(o, a) {
      return Reflect.getOwnPropertyDescriptor(o._scopes[0], a);
    },
    getPrototypeOf() {
      return Reflect.getPrototypeOf(i[0]);
    },
    has(o, a) {
      return Ko(o).includes(a);
    },
    ownKeys(o) {
      return Ko(o);
    },
    set(o, a, c) {
      const l = o._storage || (o._storage = r());
      return o[a] = l[a] = c, delete o._keys, !0;
    }
  });
}
function ze(i, t, e, n) {
  const r = {
    _cacheable: !1,
    _proxy: i,
    _context: t,
    _subProxy: e,
    _stack: /* @__PURE__ */ new Set(),
    _descriptors: ul(i, n),
    setContext: (s) => ze(i, s, e, n),
    override: (s) => ze(i.override(s), t, e, n)
  };
  return new Proxy(r, {
    deleteProperty(s, o) {
      return delete s[o], delete i[o], !0;
    },
    get(s, o, a) {
      return hl(
        s,
        o,
        () => sf(s, o, a)
      );
    },
    getOwnPropertyDescriptor(s, o) {
      return s._descriptors.allKeys ? Reflect.has(i, o) ? { enumerable: !0, configurable: !0 } : void 0 : Reflect.getOwnPropertyDescriptor(i, o);
    },
    getPrototypeOf() {
      return Reflect.getPrototypeOf(i);
    },
    has(s, o) {
      return Reflect.has(i, o);
    },
    ownKeys() {
      return Reflect.ownKeys(i);
    },
    set(s, o, a) {
      return i[o] = a, delete s[o], !0;
    }
  });
}
function ul(i, t = { scriptable: !0, indexable: !0 }) {
  const { _scriptable: e = t.scriptable, _indexable: n = t.indexable, _allKeys: r = t.allKeys } = i;
  return {
    allKeys: r,
    scriptable: e,
    indexable: n,
    isScriptable: ee(e) ? e : () => e,
    isIndexable: ee(n) ? n : () => n
  };
}
const rf = (i, t) => i ? i + Ts(t) : t, Ls = (i, t) => L(t) && i !== "adapters" && (Object.getPrototypeOf(t) === null || t.constructor === Object);
function hl(i, t, e) {
  if (Object.prototype.hasOwnProperty.call(i, t))
    return i[t];
  const n = e();
  return i[t] = n, n;
}
function sf(i, t, e) {
  const { _proxy: n, _context: r, _subProxy: s, _descriptors: o } = i;
  let a = n[t];
  return ee(a) && o.isScriptable(t) && (a = of(t, a, i, e)), H(a) && a.length && (a = af(t, a, i, o.isIndexable)), Ls(t, a) && (a = ze(a, r, s && s[t], o)), a;
}
function of(i, t, e, n) {
  const { _proxy: r, _context: s, _subProxy: o, _stack: a } = e;
  if (a.has(i))
    throw new Error("Recursion detected: " + Array.from(a).join("->") + "->" + i);
  return a.add(i), t = t(s, o || n), a.delete(i), Ls(i, t) && (t = Ns(r._scopes, r, i, t)), t;
}
function af(i, t, e, n) {
  const { _proxy: r, _context: s, _subProxy: o, _descriptors: a } = e;
  if (_t(s.index) && n(i))
    t = t[s.index % t.length];
  else if (L(t[0])) {
    const c = t, l = r._scopes.filter((u) => u !== c);
    t = [];
    for (const u of c) {
      const h = Ns(l, r, i, u);
      t.push(ze(h, s, o && o[i], a));
    }
  }
  return t;
}
function fl(i, t, e) {
  return ee(i) ? i(t, e) : i;
}
const cf = (i, t) => i === !0 ? t : typeof i == "string" ? te(t, i) : void 0;
function lf(i, t, e, n, r) {
  for (const s of t) {
    const o = cf(e, s);
    if (o) {
      i.add(o);
      const a = fl(o._fallback, e, r);
      if (_t(a) && a !== e && a !== n)
        return a;
    } else if (o === !1 && _t(n) && e !== n)
      return null;
  }
  return !1;
}
function Ns(i, t, e, n) {
  const r = t._rootScopes, s = fl(t._fallback, e, n), o = [...i, ...r], a = /* @__PURE__ */ new Set();
  a.add(n);
  let c = Xo(a, o, e, s || e, n);
  return c === null || _t(s) && s !== e && (c = Xo(a, o, s, c, n), c === null) ? !1 : Fs(
    Array.from(a),
    [""],
    r,
    s,
    () => uf(t, e, n)
  );
}
function Xo(i, t, e, n, r) {
  for (; e; )
    e = lf(i, t, e, n, r);
  return e;
}
function uf(i, t, e) {
  const n = i._getTarget();
  t in n || (n[t] = {});
  const r = n[t];
  return H(r) && L(e) ? e : r;
}
function hf(i, t, e, n) {
  let r;
  for (const s of t)
    if (r = dl(rf(s, i), e), _t(r))
      return Ls(i, r) ? Ns(e, n, i, r) : r;
}
function dl(i, t) {
  for (const e of t) {
    if (!e)
      continue;
    const n = e[i];
    if (_t(n))
      return n;
  }
}
function Ko(i) {
  let t = i._keys;
  return t || (t = i._keys = ff(i._scopes)), t;
}
function ff(i) {
  const t = /* @__PURE__ */ new Set();
  for (const e of i)
    for (const n of Object.keys(e).filter((r) => !r.startsWith("_")))
      t.add(n);
  return Array.from(t);
}
function pl(i, t, e, n) {
  const { iScale: r } = i, { key: s = "r" } = this._parsing, o = new Array(n);
  let a, c, l, u;
  for (a = 0, c = n; a < c; ++a)
    l = a + e, u = t[l], o[a] = {
      r: r.parse(te(u, s), l)
    };
  return o;
}
const df = Number.EPSILON || 1e-14, qe = (i, t) => t < i.length && !i[t].skip && i[t], gl = (i) => i === "x" ? "y" : "x";
function pf(i, t, e, n) {
  const r = i.skip ? t : i, s = t, o = e.skip ? t : e, a = Br(s, r), c = Br(o, s);
  let l = a / (a + c), u = c / (a + c);
  l = isNaN(l) ? 0 : l, u = isNaN(u) ? 0 : u;
  const h = n * l, f = n * u;
  return {
    previous: {
      x: s.x - h * (o.x - r.x),
      y: s.y - h * (o.y - r.y)
    },
    next: {
      x: s.x + f * (o.x - r.x),
      y: s.y + f * (o.y - r.y)
    }
  };
}
function gf(i, t, e) {
  const n = i.length;
  let r, s, o, a, c, l = qe(i, 0);
  for (let u = 0; u < n - 1; ++u)
    if (c = l, l = qe(i, u + 1), !(!c || !l)) {
      if (mi(t[u], 0, df)) {
        e[u] = e[u + 1] = 0;
        continue;
      }
      r = e[u] / t[u], s = e[u + 1] / t[u], a = Math.pow(r, 2) + Math.pow(s, 2), !(a <= 9) && (o = 3 / Math.sqrt(a), e[u] = r * o * t[u], e[u + 1] = s * o * t[u]);
    }
}
function mf(i, t, e = "x") {
  const n = gl(e), r = i.length;
  let s, o, a, c = qe(i, 0);
  for (let l = 0; l < r; ++l) {
    if (o = a, a = c, c = qe(i, l + 1), !a)
      continue;
    const u = a[e], h = a[n];
    o && (s = (u - o[e]) / 3, a[`cp1${e}`] = u - s, a[`cp1${n}`] = h - s * t[l]), c && (s = (c[e] - u) / 3, a[`cp2${e}`] = u + s, a[`cp2${n}`] = h + s * t[l]);
  }
}
function yf(i, t = "x") {
  const e = gl(t), n = i.length, r = Array(n).fill(0), s = Array(n);
  let o, a, c, l = qe(i, 0);
  for (o = 0; o < n; ++o)
    if (a = c, c = l, l = qe(i, o + 1), !!c) {
      if (l) {
        const u = l[t] - c[t];
        r[o] = u !== 0 ? (l[e] - c[e]) / u : 0;
      }
      s[o] = a ? l ? Rt(r[o - 1]) !== Rt(r[o]) ? 0 : (r[o - 1] + r[o]) / 2 : r[o - 1] : r[o];
    }
  gf(i, r, s), mf(i, s, t);
}
function Gi(i, t, e) {
  return Math.max(Math.min(i, e), t);
}
function vf(i, t) {
  let e, n, r, s, o, a = Ti(i[0], t);
  for (e = 0, n = i.length; e < n; ++e)
    o = s, s = a, a = e < n - 1 && Ti(i[e + 1], t), s && (r = i[e], o && (r.cp1x = Gi(r.cp1x, t.left, t.right), r.cp1y = Gi(r.cp1y, t.top, t.bottom)), a && (r.cp2x = Gi(r.cp2x, t.left, t.right), r.cp2y = Gi(r.cp2y, t.top, t.bottom)));
}
function bf(i, t, e, n, r) {
  let s, o, a, c;
  if (t.spanGaps && (i = i.filter((l) => !l.skip)), t.cubicInterpolationMode === "monotone")
    yf(i, r);
  else {
    let l = n ? i[i.length - 1] : i[0];
    for (s = 0, o = i.length; s < o; ++s)
      a = i[s], c = pf(
        l,
        a,
        i[Math.min(s + 1, o - (n ? 0 : 1)) % o],
        t.tension
      ), a.cp1x = c.previous.x, a.cp1y = c.previous.y, a.cp2x = c.next.x, a.cp2y = c.next.y, l = a;
  }
  t.capBezierPoints && vf(i, e);
}
function ml() {
  return typeof window < "u" && typeof document < "u";
}
function Vs(i) {
  let t = i.parentNode;
  return t && t.toString() === "[object ShadowRoot]" && (t = t.host), t;
}
function Dn(i, t, e) {
  let n;
  return typeof i == "string" ? (n = parseInt(i, 10), i.indexOf("%") !== -1 && (n = n / 100 * t.parentNode[e])) : n = i, n;
}
const $n = (i) => window.getComputedStyle(i, null);
function _f(i, t) {
  return $n(i).getPropertyValue(t);
}
const xf = ["top", "right", "bottom", "left"];
function de(i, t, e) {
  const n = {};
  e = e ? "-" + e : "";
  for (let r = 0; r < 4; r++) {
    const s = xf[r];
    n[s] = parseFloat(i[t + "-" + s + e]) || 0;
  }
  return n.width = n.left + n.right, n.height = n.top + n.bottom, n;
}
const wf = (i, t, e) => (i > 0 || t > 0) && (!e || !e.shadowRoot);
function Sf(i, t) {
  const e = i.touches, n = e && e.length ? e[0] : i, { offsetX: r, offsetY: s } = n;
  let o = !1, a, c;
  if (wf(r, s, i.target))
    a = r, c = s;
  else {
    const l = t.getBoundingClientRect();
    a = n.clientX - l.left, c = n.clientY - l.top, o = !0;
  }
  return { x: a, y: c, box: o };
}
function ce(i, t) {
  if ("native" in i)
    return i;
  const { canvas: e, currentDevicePixelRatio: n } = t, r = $n(e), s = r.boxSizing === "border-box", o = de(r, "padding"), a = de(r, "border", "width"), { x: c, y: l, box: u } = Sf(i, e), h = o.left + (u && a.left), f = o.top + (u && a.top);
  let { width: d, height: p } = t;
  return s && (d -= o.width + a.width, p -= o.height + a.height), {
    x: Math.round((c - h) / d * e.width / n),
    y: Math.round((l - f) / p * e.height / n)
  };
}
function Ef(i, t, e) {
  let n, r;
  if (t === void 0 || e === void 0) {
    const s = Vs(i);
    if (!s)
      t = i.clientWidth, e = i.clientHeight;
    else {
      const o = s.getBoundingClientRect(), a = $n(s), c = de(a, "border", "width"), l = de(a, "padding");
      t = o.width - l.width - c.width, e = o.height - l.height - c.height, n = Dn(a.maxWidth, s, "clientWidth"), r = Dn(a.maxHeight, s, "clientHeight");
    }
  }
  return {
    width: t,
    height: e,
    maxWidth: n || xn,
    maxHeight: r || xn
  };
}
const dr = (i) => Math.round(i * 10) / 10;
function kf(i, t, e, n) {
  const r = $n(i), s = de(r, "margin"), o = Dn(r.maxWidth, i, "clientWidth") || xn, a = Dn(r.maxHeight, i, "clientHeight") || xn, c = Ef(i, t, e);
  let { width: l, height: u } = c;
  if (r.boxSizing === "content-box") {
    const h = de(r, "border", "width"), f = de(r, "padding");
    l -= f.width + h.width, u -= f.height + h.height;
  }
  return l = Math.max(0, l - s.width), u = Math.max(0, n ? Math.floor(l / n) : u - s.height), l = dr(Math.min(l, o, c.maxWidth)), u = dr(Math.min(u, a, c.maxHeight)), l && !u && (u = dr(l / 2)), {
    width: l,
    height: u
  };
}
function Jo(i, t, e) {
  const n = t || 1, r = Math.floor(i.height * n), s = Math.floor(i.width * n);
  i.height = r / n, i.width = s / n;
  const o = i.canvas;
  return o.style && (e || !o.style.height && !o.style.width) && (o.style.height = `${i.height}px`, o.style.width = `${i.width}px`), i.currentDevicePixelRatio !== n || o.height !== r || o.width !== s ? (i.currentDevicePixelRatio = n, o.height = r, o.width = s, i.ctx.setTransform(n, 0, 0, n, 0, 0), !0) : !1;
}
const Of = function() {
  let i = !1;
  try {
    const t = {
      get passive() {
        return i = !0, !1;
      }
    };
    window.addEventListener("test", null, t), window.removeEventListener("test", null, t);
  } catch {
  }
  return i;
}();
function Zo(i, t) {
  const e = _f(i, t), n = e && e.match(/^(\d+)(\.\d+)?px$/);
  return n ? +n[1] : void 0;
}
function le(i, t, e, n) {
  return {
    x: i.x + e * (t.x - i.x),
    y: i.y + e * (t.y - i.y)
  };
}
function Df(i, t, e, n) {
  return {
    x: i.x + e * (t.x - i.x),
    y: n === "middle" ? e < 0.5 ? i.y : t.y : n === "after" ? e < 1 ? i.y : t.y : e > 0 ? t.y : i.y
  };
}
function Tf(i, t, e, n) {
  const r = { x: i.cp2x, y: i.cp2y }, s = { x: t.cp1x, y: t.cp1y }, o = le(i, r, e), a = le(r, s, e), c = le(s, t, e), l = le(o, a, e), u = le(a, c, e);
  return le(l, u, e);
}
const ta = /* @__PURE__ */ new Map();
function Mf(i, t) {
  t = t || {};
  const e = i + JSON.stringify(t);
  let n = ta.get(e);
  return n || (n = new Intl.NumberFormat(i, t), ta.set(e, n)), n;
}
function ji(i, t, e) {
  return Mf(t, e).format(i);
}
const Af = function(i, t) {
  return {
    x(e) {
      return i + i + t - e;
    },
    setWidth(e) {
      t = e;
    },
    textAlign(e) {
      return e === "center" ? e : e === "right" ? "left" : "right";
    },
    xPlus(e, n) {
      return e - n;
    },
    leftForLtr(e, n) {
      return e - n;
    }
  };
}, Cf = function() {
  return {
    x(i) {
      return i;
    },
    setWidth(i) {
    },
    textAlign(i) {
      return i;
    },
    xPlus(i, t) {
      return i + t;
    },
    leftForLtr(i, t) {
      return i;
    }
  };
};
function pr(i, t, e) {
  return i ? Af(t, e) : Cf();
}
function Pf(i, t) {
  let e, n;
  (t === "ltr" || t === "rtl") && (e = i.canvas.style, n = [
    e.getPropertyValue("direction"),
    e.getPropertyPriority("direction")
  ], e.setProperty("direction", t, "important"), i.prevTextDirection = n);
}
function Rf(i, t) {
  t !== void 0 && (delete i.prevTextDirection, i.canvas.style.setProperty("direction", t[0], t[1]));
}
function yl(i) {
  return i === "angle" ? {
    between: Di,
    compare: gh,
    normalize: Et
  } : {
    between: wn,
    compare: (t, e) => t - e,
    normalize: (t) => t
  };
}
function ea({ start: i, end: t, count: e, loop: n, style: r }) {
  return {
    start: i % e,
    end: t % e,
    loop: n && (t - i + 1) % e === 0,
    style: r
  };
}
function If(i, t, e) {
  const { property: n, start: r, end: s } = e, { between: o, normalize: a } = yl(n), c = t.length;
  let { start: l, end: u, loop: h } = i, f, d;
  if (h) {
    for (l += c, u += c, f = 0, d = c; f < d && o(a(t[l % c][n]), r, s); ++f)
      l--, u--;
    l %= c, u %= c;
  }
  return u < l && (u += c), { start: l, end: u, loop: h, style: i.style };
}
function Ff(i, t, e) {
  if (!e)
    return [i];
  const { property: n, start: r, end: s } = e, o = t.length, { compare: a, between: c, normalize: l } = yl(n), { start: u, end: h, loop: f, style: d } = If(i, t, e), p = [];
  let g = !1, m = null, y, b, v;
  const _ = () => c(r, v, y) && a(r, v) !== 0, x = () => a(s, y) === 0 || c(s, v, y), k = () => g || _(), E = () => !g || x();
  for (let O = u, M = u; O <= h; ++O)
    b = t[O % o], !b.skip && (y = l(b[n]), y !== v && (g = c(y, r, s), m === null && k() && (m = a(y, r) === 0 ? O : M), m !== null && E() && (p.push(ea({ start: m, end: O, loop: f, count: o, style: d })), m = null), M = O, v = y));
  return m !== null && p.push(ea({ start: m, end: h, loop: f, count: o, style: d })), p;
}
function Lf(i, t) {
  const e = [], n = i.segments;
  for (let r = 0; r < n.length; r++) {
    const s = Ff(n[r], i.points, t);
    s.length && e.push(...s);
  }
  return e;
}
function Nf(i, t, e, n) {
  let r = 0, s = t - 1;
  if (e && !n)
    for (; r < t && !i[r].skip; )
      r++;
  for (; r < t && i[r].skip; )
    r++;
  for (r %= t, e && (s += r); s > r && i[s % t].skip; )
    s--;
  return s %= t, { start: r, end: s };
}
function Vf(i, t, e, n) {
  const r = i.length, s = [];
  let o = t, a = i[t], c;
  for (c = t + 1; c <= e; ++c) {
    const l = i[c % r];
    l.skip || l.stop ? a.skip || (n = !1, s.push({ start: t % r, end: (c - 1) % r, loop: n }), t = o = l.stop ? c : null) : (o = c, a.skip && (t = c)), a = l;
  }
  return o !== null && s.push({ start: t % r, end: o % r, loop: n }), s;
}
function jf(i, t) {
  const e = i.points, n = i.options.spanGaps, r = e.length;
  if (!r)
    return [];
  const s = !!i._loop, { start: o, end: a } = Nf(e, r, s, n);
  if (n === !0)
    return ia(i, [{ start: o, end: a, loop: s }], e, t);
  const c = a < o ? a + r : a, l = !!i._fullLoop && o === 0 && a === r - 1;
  return ia(i, Vf(e, o, c, l), e, t);
}
function ia(i, t, e, n) {
  return !n || !n.setContext || !e ? t : Bf(i, t, e, n);
}
function Bf(i, t, e, n) {
  const r = i._chart.getContext(), s = na(i.options), { _datasetIndex: o, options: { spanGaps: a } } = i, c = e.length, l = [];
  let u = s, h = t[0].start, f = h;
  function d(p, g, m, y) {
    const b = a ? -1 : 1;
    if (p !== g) {
      for (p += c; e[p % c].skip; )
        p -= b;
      for (; e[g % c].skip; )
        g += b;
      p % c !== g % c && (l.push({ start: p % c, end: g % c, loop: m, style: y }), u = y, h = g % c);
    }
  }
  for (const p of t) {
    h = a ? h : p.start;
    let g = e[h % c], m;
    for (f = h + 1; f <= p.end; f++) {
      const y = e[f % c];
      m = na(n.setContext(re(r, {
        type: "segment",
        p0: g,
        p1: y,
        p0DataIndex: (f - 1) % c,
        p1DataIndex: f % c,
        datasetIndex: o
      }))), $f(m, u) && d(h, f - 1, p.loop, u), g = y, u = m;
    }
    h < f - 1 && d(h, f - 1, p.loop, u);
  }
  return l;
}
function na(i) {
  return {
    backgroundColor: i.backgroundColor,
    borderCapStyle: i.borderCapStyle,
    borderDash: i.borderDash,
    borderDashOffset: i.borderDashOffset,
    borderJoinStyle: i.borderJoinStyle,
    borderWidth: i.borderWidth,
    borderColor: i.borderColor
  };
}
function $f(i, t) {
  return t && JSON.stringify(i) !== JSON.stringify(t);
}
/*!
 * Chart.js v3.9.1
 * https://www.chartjs.org
 * (c) 2022 Chart.js Contributors
 * Released under the MIT License
 */
class zf {
  constructor() {
    this._request = null, this._charts = /* @__PURE__ */ new Map(), this._running = !1, this._lastDate = void 0;
  }
  _notify(t, e, n, r) {
    const s = e.listeners[r], o = e.duration;
    s.forEach((a) => a({
      chart: t,
      initial: e.initial,
      numSteps: o,
      currentStep: Math.min(n - e.start, o)
    }));
  }
  _refresh() {
    this._request || (this._running = !0, this._request = Jc.call(window, () => {
      this._update(), this._request = null, this._running && this._refresh();
    }));
  }
  _update(t = Date.now()) {
    let e = 0;
    this._charts.forEach((n, r) => {
      if (!n.running || !n.items.length)
        return;
      const s = n.items;
      let o = s.length - 1, a = !1, c;
      for (; o >= 0; --o)
        c = s[o], c._active ? (c._total > n.duration && (n.duration = c._total), c.tick(t), a = !0) : (s[o] = s[s.length - 1], s.pop());
      a && (r.draw(), this._notify(r, n, t, "progress")), s.length || (n.running = !1, this._notify(r, n, t, "complete"), n.initial = !1), e += s.length;
    }), this._lastDate = t, e === 0 && (this._running = !1);
  }
  _getAnims(t) {
    const e = this._charts;
    let n = e.get(t);
    return n || (n = {
      running: !1,
      initial: !0,
      items: [],
      listeners: {
        complete: [],
        progress: []
      }
    }, e.set(t, n)), n;
  }
  listen(t, e, n) {
    this._getAnims(t).listeners[e].push(n);
  }
  add(t, e) {
    !e || !e.length || this._getAnims(t).items.push(...e);
  }
  has(t) {
    return this._getAnims(t).items.length > 0;
  }
  start(t) {
    const e = this._charts.get(t);
    !e || (e.running = !0, e.start = Date.now(), e.duration = e.items.reduce((n, r) => Math.max(n, r._duration), 0), this._refresh());
  }
  running(t) {
    if (!this._running)
      return !1;
    const e = this._charts.get(t);
    return !(!e || !e.running || !e.items.length);
  }
  stop(t) {
    const e = this._charts.get(t);
    if (!e || !e.items.length)
      return;
    const n = e.items;
    let r = n.length - 1;
    for (; r >= 0; --r)
      n[r].cancel();
    e.items = [], this._notify(t, e, Date.now(), "complete");
  }
  remove(t) {
    return this._charts.delete(t);
  }
}
var Nt = new zf();
const ra = "transparent", qf = {
  boolean(i, t, e) {
    return e > 0.5 ? t : i;
  },
  color(i, t, e) {
    const n = Yo(i || ra), r = n.valid && Yo(t || ra);
    return r && r.valid ? r.mix(n, e).hexString() : t;
  },
  number(i, t, e) {
    return i + (t - i) * e;
  }
};
class Qf {
  constructor(t, e, n, r) {
    const s = e[n];
    r = Yi([t.to, r, s, t.from]);
    const o = Yi([t.from, s, r]);
    this._active = !0, this._fn = t.fn || qf[t.type || typeof o], this._easing = yi[t.easing] || yi.linear, this._start = Math.floor(Date.now() + (t.delay || 0)), this._duration = this._total = Math.floor(t.duration), this._loop = !!t.loop, this._target = e, this._prop = n, this._from = o, this._to = r, this._promises = void 0;
  }
  active() {
    return this._active;
  }
  update(t, e, n) {
    if (this._active) {
      this._notify(!1);
      const r = this._target[this._prop], s = n - this._start, o = this._duration - s;
      this._start = n, this._duration = Math.floor(Math.max(o, t.duration)), this._total += s, this._loop = !!t.loop, this._to = Yi([t.to, e, r, t.from]), this._from = Yi([t.from, r, e]);
    }
  }
  cancel() {
    this._active && (this.tick(Date.now()), this._active = !1, this._notify(!1));
  }
  tick(t) {
    const e = t - this._start, n = this._duration, r = this._prop, s = this._from, o = this._loop, a = this._to;
    let c;
    if (this._active = s !== a && (o || e < n), !this._active) {
      this._target[r] = a, this._notify(!0);
      return;
    }
    if (e < 0) {
      this._target[r] = s;
      return;
    }
    c = e / n % 2, c = o && c > 1 ? 2 - c : c, c = this._easing(Math.min(1, Math.max(0, c))), this._target[r] = this._fn(s, a, c);
  }
  wait() {
    const t = this._promises || (this._promises = []);
    return new Promise((e, n) => {
      t.push({ res: e, rej: n });
    });
  }
  _notify(t) {
    const e = t ? "res" : "rej", n = this._promises || [];
    for (let r = 0; r < n.length; r++)
      n[r][e]();
  }
}
const Uf = ["x", "y", "borderWidth", "radius", "tension"], Wf = ["color", "borderColor", "backgroundColor"];
I.set("animation", {
  delay: void 0,
  duration: 1e3,
  easing: "easeOutQuart",
  fn: void 0,
  from: void 0,
  loop: void 0,
  to: void 0,
  type: void 0
});
const Hf = Object.keys(I.animation);
I.describe("animation", {
  _fallback: !1,
  _indexable: !1,
  _scriptable: (i) => i !== "onProgress" && i !== "onComplete" && i !== "fn"
});
I.set("animations", {
  colors: {
    type: "color",
    properties: Wf
  },
  numbers: {
    type: "number",
    properties: Uf
  }
});
I.describe("animations", {
  _fallback: "animation"
});
I.set("transitions", {
  active: {
    animation: {
      duration: 400
    }
  },
  resize: {
    animation: {
      duration: 0
    }
  },
  show: {
    animations: {
      colors: {
        from: "transparent"
      },
      visible: {
        type: "boolean",
        duration: 0
      }
    }
  },
  hide: {
    animations: {
      colors: {
        to: "transparent"
      },
      visible: {
        type: "boolean",
        easing: "linear",
        fn: (i) => i | 0
      }
    }
  }
});
class vl {
  constructor(t, e) {
    this._chart = t, this._properties = /* @__PURE__ */ new Map(), this.configure(e);
  }
  configure(t) {
    if (!L(t))
      return;
    const e = this._properties;
    Object.getOwnPropertyNames(t).forEach((n) => {
      const r = t[n];
      if (!L(r))
        return;
      const s = {};
      for (const o of Hf)
        s[o] = r[o];
      (H(r.properties) && r.properties || [n]).forEach((o) => {
        (o === n || !e.has(o)) && e.set(o, s);
      });
    });
  }
  _animateOptions(t, e) {
    const n = e.options, r = Gf(t, n);
    if (!r)
      return [];
    const s = this._createAnimations(r, n);
    return n.$shared && Yf(t.options.$animations, n).then(() => {
      t.options = n;
    }, () => {
    }), s;
  }
  _createAnimations(t, e) {
    const n = this._properties, r = [], s = t.$animations || (t.$animations = {}), o = Object.keys(e), a = Date.now();
    let c;
    for (c = o.length - 1; c >= 0; --c) {
      const l = o[c];
      if (l.charAt(0) === "$")
        continue;
      if (l === "options") {
        r.push(...this._animateOptions(t, e));
        continue;
      }
      const u = e[l];
      let h = s[l];
      const f = n.get(l);
      if (h)
        if (f && h.active()) {
          h.update(f, u, a);
          continue;
        } else
          h.cancel();
      if (!f || !f.duration) {
        t[l] = u;
        continue;
      }
      s[l] = h = new Qf(f, t, l, u), r.push(h);
    }
    return r;
  }
  update(t, e) {
    if (this._properties.size === 0) {
      Object.assign(t, e);
      return;
    }
    const n = this._createAnimations(t, e);
    if (n.length)
      return Nt.add(this._chart, n), !0;
  }
}
function Yf(i, t) {
  const e = [], n = Object.keys(t);
  for (let r = 0; r < n.length; r++) {
    const s = i[n[r]];
    s && s.active() && e.push(s.wait());
  }
  return Promise.all(e);
}
function Gf(i, t) {
  if (!t)
    return;
  let e = i.options;
  if (!e) {
    i.options = t;
    return;
  }
  return e.$shared && (i.options = e = Object.assign({}, e, { $shared: !1, $animations: {} })), e;
}
function sa(i, t) {
  const e = i && i.options || {}, n = e.reverse, r = e.min === void 0 ? t : 0, s = e.max === void 0 ? t : 0;
  return {
    start: n ? s : r,
    end: n ? r : s
  };
}
function Xf(i, t, e) {
  if (e === !1)
    return !1;
  const n = sa(i, e), r = sa(t, e);
  return {
    top: r.end,
    right: n.end,
    bottom: r.start,
    left: n.start
  };
}
function Kf(i) {
  let t, e, n, r;
  return L(i) ? (t = i.top, e = i.right, n = i.bottom, r = i.left) : t = e = n = r = i, {
    top: t,
    right: e,
    bottom: n,
    left: r,
    disabled: i === !1
  };
}
function bl(i, t) {
  const e = [], n = i._getSortedDatasetMetas(t);
  let r, s;
  for (r = 0, s = n.length; r < s; ++r)
    e.push(n[r].index);
  return e;
}
function oa(i, t, e, n = {}) {
  const r = i.keys, s = n.mode === "single";
  let o, a, c, l;
  if (t !== null) {
    for (o = 0, a = r.length; o < a; ++o) {
      if (c = +r[o], c === e) {
        if (n.all)
          continue;
        break;
      }
      l = i.values[c], ut(l) && (s || t === 0 || Rt(t) === Rt(l)) && (t += l);
    }
    return t;
  }
}
function Jf(i) {
  const t = Object.keys(i), e = new Array(t.length);
  let n, r, s;
  for (n = 0, r = t.length; n < r; ++n)
    s = t[n], e[n] = {
      x: s,
      y: i[s]
    };
  return e;
}
function aa(i, t) {
  const e = i && i.options.stacked;
  return e || e === void 0 && t.stack !== void 0;
}
function Zf(i, t, e) {
  return `${i.id}.${t.id}.${e.stack || e.type}`;
}
function td(i) {
  const { min: t, max: e, minDefined: n, maxDefined: r } = i.getUserBounds();
  return {
    min: n ? t : Number.NEGATIVE_INFINITY,
    max: r ? e : Number.POSITIVE_INFINITY
  };
}
function ed(i, t, e) {
  const n = i[t] || (i[t] = {});
  return n[e] || (n[e] = {});
}
function ca(i, t, e, n) {
  for (const r of t.getMatchingVisibleMetas(n).reverse()) {
    const s = i[r.index];
    if (e && s > 0 || !e && s < 0)
      return r.index;
  }
  return null;
}
function la(i, t) {
  const { chart: e, _cachedMeta: n } = i, r = e._stacks || (e._stacks = {}), { iScale: s, vScale: o, index: a } = n, c = s.axis, l = o.axis, u = Zf(s, o, n), h = t.length;
  let f;
  for (let d = 0; d < h; ++d) {
    const p = t[d], { [c]: g, [l]: m } = p, y = p._stacks || (p._stacks = {});
    f = y[l] = ed(r, u, g), f[a] = m, f._top = ca(f, o, !0, n.type), f._bottom = ca(f, o, !1, n.type);
  }
}
function gr(i, t) {
  const e = i.scales;
  return Object.keys(e).filter((n) => e[n].axis === t).shift();
}
function id(i, t) {
  return re(
    i,
    {
      active: !1,
      dataset: void 0,
      datasetIndex: t,
      index: t,
      mode: "default",
      type: "dataset"
    }
  );
}
function nd(i, t, e) {
  return re(i, {
    active: !1,
    dataIndex: t,
    parsed: void 0,
    raw: void 0,
    element: e,
    index: t,
    mode: "default",
    type: "data"
  });
}
function ti(i, t) {
  const e = i.controller.index, n = i.vScale && i.vScale.axis;
  if (!!n) {
    t = t || i._parsed;
    for (const r of t) {
      const s = r._stacks;
      if (!s || s[n] === void 0 || s[n][e] === void 0)
        return;
      delete s[n][e];
    }
  }
}
const mr = (i) => i === "reset" || i === "none", ua = (i, t) => t ? i : Object.assign({}, i), rd = (i, t, e) => i && !t.hidden && t._stacked && { keys: bl(e, !0), values: null };
class Ot {
  constructor(t, e) {
    this.chart = t, this._ctx = t.ctx, this.index = e, this._cachedDataOpts = {}, this._cachedMeta = this.getMeta(), this._type = this._cachedMeta.type, this.options = void 0, this._parsing = !1, this._data = void 0, this._objectData = void 0, this._sharedOptions = void 0, this._drawStart = void 0, this._drawCount = void 0, this.enableOptionSharing = !1, this.supportsDecimation = !1, this.$context = void 0, this._syncList = [], this.initialize();
  }
  initialize() {
    const t = this._cachedMeta;
    this.configure(), this.linkScales(), t._stacked = aa(t.vScale, t), this.addElements();
  }
  updateIndex(t) {
    this.index !== t && ti(this._cachedMeta), this.index = t;
  }
  linkScales() {
    const t = this.chart, e = this._cachedMeta, n = this.getDataset(), r = (h, f, d, p) => h === "x" ? f : h === "r" ? p : d, s = e.xAxisID = F(n.xAxisID, gr(t, "x")), o = e.yAxisID = F(n.yAxisID, gr(t, "y")), a = e.rAxisID = F(n.rAxisID, gr(t, "r")), c = e.indexAxis, l = e.iAxisID = r(c, s, o, a), u = e.vAxisID = r(c, o, s, a);
    e.xScale = this.getScaleForId(s), e.yScale = this.getScaleForId(o), e.rScale = this.getScaleForId(a), e.iScale = this.getScaleForId(l), e.vScale = this.getScaleForId(u);
  }
  getDataset() {
    return this.chart.data.datasets[this.index];
  }
  getMeta() {
    return this.chart.getDatasetMeta(this.index);
  }
  getScaleForId(t) {
    return this.chart.scales[t];
  }
  _getOtherScale(t) {
    const e = this._cachedMeta;
    return t === e.iScale ? e.vScale : e.iScale;
  }
  reset() {
    this._update("reset");
  }
  _destroy() {
    const t = this._cachedMeta;
    this._data && Bo(this._data, this), t._stacked && ti(t);
  }
  _dataCheck() {
    const t = this.getDataset(), e = t.data || (t.data = []), n = this._data;
    if (L(e))
      this._data = Jf(e);
    else if (n !== e) {
      if (n) {
        Bo(n, this);
        const r = this._cachedMeta;
        ti(r), r._parsed = [];
      }
      e && Object.isExtensible(e) && bh(e, this), this._syncList = [], this._data = e;
    }
  }
  addElements() {
    const t = this._cachedMeta;
    this._dataCheck(), this.datasetElementType && (t.dataset = new this.datasetElementType());
  }
  buildOrUpdateElements(t) {
    const e = this._cachedMeta, n = this.getDataset();
    let r = !1;
    this._dataCheck();
    const s = e._stacked;
    e._stacked = aa(e.vScale, e), e.stack !== n.stack && (r = !0, ti(e), e.stack = n.stack), this._resyncElements(t), (r || s !== e._stacked) && la(this, e._parsed);
  }
  configure() {
    const t = this.chart.config, e = t.datasetScopeKeys(this._type), n = t.getOptionScopes(this.getDataset(), e, !0);
    this.options = t.createResolver(n, this.getContext()), this._parsing = this.options.parsing, this._cachedDataOpts = {};
  }
  parse(t, e) {
    const { _cachedMeta: n, _data: r } = this, { iScale: s, _stacked: o } = n, a = s.axis;
    let c = t === 0 && e === r.length ? !0 : n._sorted, l = t > 0 && n._parsed[t - 1], u, h, f;
    if (this._parsing === !1)
      n._parsed = r, n._sorted = !0, f = r;
    else {
      H(r[t]) ? f = this.parseArrayData(n, r, t, e) : L(r[t]) ? f = this.parseObjectData(n, r, t, e) : f = this.parsePrimitiveData(n, r, t, e);
      const d = () => h[a] === null || l && h[a] < l[a];
      for (u = 0; u < e; ++u)
        n._parsed[u + t] = h = f[u], c && (d() && (c = !1), l = h);
      n._sorted = c;
    }
    o && la(this, f);
  }
  parsePrimitiveData(t, e, n, r) {
    const { iScale: s, vScale: o } = t, a = s.axis, c = o.axis, l = s.getLabels(), u = s === o, h = new Array(r);
    let f, d, p;
    for (f = 0, d = r; f < d; ++f)
      p = f + n, h[f] = {
        [a]: u || s.parse(l[p], p),
        [c]: o.parse(e[p], p)
      };
    return h;
  }
  parseArrayData(t, e, n, r) {
    const { xScale: s, yScale: o } = t, a = new Array(r);
    let c, l, u, h;
    for (c = 0, l = r; c < l; ++c)
      u = c + n, h = e[u], a[c] = {
        x: s.parse(h[0], u),
        y: o.parse(h[1], u)
      };
    return a;
  }
  parseObjectData(t, e, n, r) {
    const { xScale: s, yScale: o } = t, { xAxisKey: a = "x", yAxisKey: c = "y" } = this._parsing, l = new Array(r);
    let u, h, f, d;
    for (u = 0, h = r; u < h; ++u)
      f = u + n, d = e[f], l[u] = {
        x: s.parse(te(d, a), f),
        y: o.parse(te(d, c), f)
      };
    return l;
  }
  getParsed(t) {
    return this._cachedMeta._parsed[t];
  }
  getDataElement(t) {
    return this._cachedMeta.data[t];
  }
  applyStack(t, e, n) {
    const r = this.chart, s = this._cachedMeta, o = e[t.axis], a = {
      keys: bl(r, !0),
      values: e._stacks[t.axis]
    };
    return oa(a, o, s.index, { mode: n });
  }
  updateRangeFromParsed(t, e, n, r) {
    const s = n[e.axis];
    let o = s === null ? NaN : s;
    const a = r && n._stacks[e.axis];
    r && a && (r.values = a, o = oa(r, s, this._cachedMeta.index)), t.min = Math.min(t.min, o), t.max = Math.max(t.max, o);
  }
  getMinMax(t, e) {
    const n = this._cachedMeta, r = n._parsed, s = n._sorted && t === n.iScale, o = r.length, a = this._getOtherScale(t), c = rd(e, n, this.chart), l = { min: Number.POSITIVE_INFINITY, max: Number.NEGATIVE_INFINITY }, { min: u, max: h } = td(a);
    let f, d;
    function p() {
      d = r[f];
      const g = d[a.axis];
      return !ut(d[t.axis]) || u > g || h < g;
    }
    for (f = 0; f < o && !(!p() && (this.updateRangeFromParsed(l, t, d, c), s)); ++f)
      ;
    if (s) {
      for (f = o - 1; f >= 0; --f)
        if (!p()) {
          this.updateRangeFromParsed(l, t, d, c);
          break;
        }
    }
    return l;
  }
  getAllParsedValues(t) {
    const e = this._cachedMeta._parsed, n = [];
    let r, s, o;
    for (r = 0, s = e.length; r < s; ++r)
      o = e[r][t.axis], ut(o) && n.push(o);
    return n;
  }
  getMaxOverflow() {
    return !1;
  }
  getLabelAndValue(t) {
    const e = this._cachedMeta, n = e.iScale, r = e.vScale, s = this.getParsed(t);
    return {
      label: n ? "" + n.getLabelForValue(s[n.axis]) : "",
      value: r ? "" + r.getLabelForValue(s[r.axis]) : ""
    };
  }
  _update(t) {
    const e = this._cachedMeta;
    this.update(t || "default"), e._clip = Kf(F(this.options.clip, Xf(e.xScale, e.yScale, this.getMaxOverflow())));
  }
  update(t) {
  }
  draw() {
    const t = this._ctx, e = this.chart, n = this._cachedMeta, r = n.data || [], s = e.chartArea, o = [], a = this._drawStart || 0, c = this._drawCount || r.length - a, l = this.options.drawActiveElementsOnTop;
    let u;
    for (n.dataset && n.dataset.draw(t, s, a, c), u = a; u < a + c; ++u) {
      const h = r[u];
      h.hidden || (h.active && l ? o.push(h) : h.draw(t, s));
    }
    for (u = 0; u < o.length; ++u)
      o[u].draw(t, s);
  }
  getStyle(t, e) {
    const n = e ? "active" : "default";
    return t === void 0 && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(n) : this.resolveDataElementOptions(t || 0, n);
  }
  getContext(t, e, n) {
    const r = this.getDataset();
    let s;
    if (t >= 0 && t < this._cachedMeta.data.length) {
      const o = this._cachedMeta.data[t];
      s = o.$context || (o.$context = nd(this.getContext(), t, o)), s.parsed = this.getParsed(t), s.raw = r.data[t], s.index = s.dataIndex = t;
    } else
      s = this.$context || (this.$context = id(this.chart.getContext(), this.index)), s.dataset = r, s.index = s.datasetIndex = this.index;
    return s.active = !!e, s.mode = n, s;
  }
  resolveDatasetElementOptions(t) {
    return this._resolveElementOptions(this.datasetElementType.id, t);
  }
  resolveDataElementOptions(t, e) {
    return this._resolveElementOptions(this.dataElementType.id, e, t);
  }
  _resolveElementOptions(t, e = "default", n) {
    const r = e === "active", s = this._cachedDataOpts, o = t + "-" + e, a = s[o], c = this.enableOptionSharing && _t(n);
    if (a)
      return ua(a, c);
    const l = this.chart.config, u = l.datasetElementScopeKeys(this._type, t), h = r ? [`${t}Hover`, "hover", t, ""] : [t, ""], f = l.getOptionScopes(this.getDataset(), u), d = Object.keys(I.elements[t]), p = () => this.getContext(n, r), g = l.resolveNamedOptions(f, d, p, h);
    return g.$shared && (g.$shared = c, s[o] = Object.freeze(ua(g, c))), g;
  }
  _resolveAnimations(t, e, n) {
    const r = this.chart, s = this._cachedDataOpts, o = `animation-${e}`, a = s[o];
    if (a)
      return a;
    let c;
    if (r.options.animation !== !1) {
      const u = this.chart.config, h = u.datasetAnimationScopeKeys(this._type, e), f = u.getOptionScopes(this.getDataset(), h);
      c = u.createResolver(f, this.getContext(t, n, e));
    }
    const l = new vl(r, c && c.animations);
    return c && c._cacheable && (s[o] = Object.freeze(l)), l;
  }
  getSharedOptions(t) {
    if (!!t.$shared)
      return this._sharedOptions || (this._sharedOptions = Object.assign({}, t));
  }
  includeOptions(t, e) {
    return !e || mr(t) || this.chart._animationsDisabled;
  }
  _getSharedOptions(t, e) {
    const n = this.resolveDataElementOptions(t, e), r = this._sharedOptions, s = this.getSharedOptions(n), o = this.includeOptions(e, s) || s !== r;
    return this.updateSharedOptions(s, e, n), { sharedOptions: s, includeOptions: o };
  }
  updateElement(t, e, n, r) {
    mr(r) ? Object.assign(t, n) : this._resolveAnimations(e, r).update(t, n);
  }
  updateSharedOptions(t, e, n) {
    t && !mr(e) && this._resolveAnimations(void 0, e).update(t, n);
  }
  _setStyle(t, e, n, r) {
    t.active = r;
    const s = this.getStyle(e, r);
    this._resolveAnimations(e, n, r).update(t, {
      options: !r && this.getSharedOptions(s) || s
    });
  }
  removeHoverStyle(t, e, n) {
    this._setStyle(t, n, "active", !1);
  }
  setHoverStyle(t, e, n) {
    this._setStyle(t, n, "active", !0);
  }
  _removeDatasetHoverStyle() {
    const t = this._cachedMeta.dataset;
    t && this._setStyle(t, void 0, "active", !1);
  }
  _setDatasetHoverStyle() {
    const t = this._cachedMeta.dataset;
    t && this._setStyle(t, void 0, "active", !0);
  }
  _resyncElements(t) {
    const e = this._data, n = this._cachedMeta.data;
    for (const [a, c, l] of this._syncList)
      this[a](c, l);
    this._syncList = [];
    const r = n.length, s = e.length, o = Math.min(s, r);
    o && this.parse(0, o), s > r ? this._insertElements(r, s - r, t) : s < r && this._removeElements(s, r - s);
  }
  _insertElements(t, e, n = !0) {
    const r = this._cachedMeta, s = r.data, o = t + e;
    let a;
    const c = (l) => {
      for (l.length += e, a = l.length - 1; a >= o; a--)
        l[a] = l[a - e];
    };
    for (c(s), a = t; a < o; ++a)
      s[a] = new this.dataElementType();
    this._parsing && c(r._parsed), this.parse(t, e), n && this.updateElements(s, t, e, "reset");
  }
  updateElements(t, e, n, r) {
  }
  _removeElements(t, e) {
    const n = this._cachedMeta;
    if (this._parsing) {
      const r = n._parsed.splice(t, e);
      n._stacked && ti(n, r);
    }
    n.data.splice(t, e);
  }
  _sync(t) {
    if (this._parsing)
      this._syncList.push(t);
    else {
      const [e, n, r] = t;
      this[e](n, r);
    }
    this.chart._dataChanges.push([this.index, ...t]);
  }
  _onDataPush() {
    const t = arguments.length;
    this._sync(["_insertElements", this.getDataset().data.length - t, t]);
  }
  _onDataPop() {
    this._sync(["_removeElements", this._cachedMeta.data.length - 1, 1]);
  }
  _onDataShift() {
    this._sync(["_removeElements", 0, 1]);
  }
  _onDataSplice(t, e) {
    e && this._sync(["_removeElements", t, e]);
    const n = arguments.length - 2;
    n && this._sync(["_insertElements", t, n]);
  }
  _onDataUnshift() {
    this._sync(["_insertElements", 0, arguments.length]);
  }
}
Ot.defaults = {};
Ot.prototype.datasetElementType = null;
Ot.prototype.dataElementType = null;
function sd(i, t) {
  if (!i._cache.$bar) {
    const e = i.getMatchingVisibleMetas(t);
    let n = [];
    for (let r = 0, s = e.length; r < s; r++)
      n = n.concat(e[r].controller.getAllParsedValues(i));
    i._cache.$bar = Kc(n.sort((r, s) => r - s));
  }
  return i._cache.$bar;
}
function od(i) {
  const t = i.iScale, e = sd(t, i.type);
  let n = t._length, r, s, o, a;
  const c = () => {
    o === 32767 || o === -32768 || (_t(a) && (n = Math.min(n, Math.abs(o - a) || n)), a = o);
  };
  for (r = 0, s = e.length; r < s; ++r)
    o = t.getPixelForValue(e[r]), c();
  for (a = void 0, r = 0, s = t.ticks.length; r < s; ++r)
    o = t.getPixelForTick(r), c();
  return n;
}
function ad(i, t, e, n) {
  const r = e.barThickness;
  let s, o;
  return $(r) ? (s = t.min * e.categoryPercentage, o = e.barPercentage) : (s = r * n, o = 1), {
    chunk: s / n,
    ratio: o,
    start: t.pixels[i] - s / 2
  };
}
function cd(i, t, e, n) {
  const r = t.pixels, s = r[i];
  let o = i > 0 ? r[i - 1] : null, a = i < r.length - 1 ? r[i + 1] : null;
  const c = e.categoryPercentage;
  o === null && (o = s - (a === null ? t.end - t.start : a - s)), a === null && (a = s + s - o);
  const l = s - (s - Math.min(o, a)) / 2 * c;
  return {
    chunk: Math.abs(a - o) / 2 * c / n,
    ratio: e.barPercentage,
    start: l
  };
}
function ld(i, t, e, n) {
  const r = e.parse(i[0], n), s = e.parse(i[1], n), o = Math.min(r, s), a = Math.max(r, s);
  let c = o, l = a;
  Math.abs(o) > Math.abs(a) && (c = a, l = o), t[e.axis] = l, t._custom = {
    barStart: c,
    barEnd: l,
    start: r,
    end: s,
    min: o,
    max: a
  };
}
function _l(i, t, e, n) {
  return H(i) ? ld(i, t, e, n) : t[e.axis] = e.parse(i, n), t;
}
function ha(i, t, e, n) {
  const r = i.iScale, s = i.vScale, o = r.getLabels(), a = r === s, c = [];
  let l, u, h, f;
  for (l = e, u = e + n; l < u; ++l)
    f = t[l], h = {}, h[r.axis] = a || r.parse(o[l], l), c.push(_l(f, h, s, l));
  return c;
}
function yr(i) {
  return i && i.barStart !== void 0 && i.barEnd !== void 0;
}
function ud(i, t, e) {
  return i !== 0 ? Rt(i) : (t.isHorizontal() ? 1 : -1) * (t.min >= e ? 1 : -1);
}
function hd(i) {
  let t, e, n, r, s;
  return i.horizontal ? (t = i.base > i.x, e = "left", n = "right") : (t = i.base < i.y, e = "bottom", n = "top"), t ? (r = "end", s = "start") : (r = "start", s = "end"), { start: e, end: n, reverse: t, top: r, bottom: s };
}
function fd(i, t, e, n) {
  let r = t.borderSkipped;
  const s = {};
  if (!r) {
    i.borderSkipped = s;
    return;
  }
  if (r === !0) {
    i.borderSkipped = { top: !0, right: !0, bottom: !0, left: !0 };
    return;
  }
  const { start: o, end: a, reverse: c, top: l, bottom: u } = hd(i);
  r === "middle" && e && (i.enableBorderRadius = !0, (e._top || 0) === n ? r = l : (e._bottom || 0) === n ? r = u : (s[fa(u, o, a, c)] = !0, r = l)), s[fa(r, o, a, c)] = !0, i.borderSkipped = s;
}
function fa(i, t, e, n) {
  return n ? (i = dd(i, t, e), i = da(i, e, t)) : i = da(i, t, e), i;
}
function dd(i, t, e) {
  return i === t ? e : i === e ? t : i;
}
function da(i, t, e) {
  return i === "start" ? t : i === "end" ? e : i;
}
function pd(i, { inflateAmount: t }, e) {
  i.inflateAmount = t === "auto" ? e === 1 ? 0.33 : 0 : t;
}
class js extends Ot {
  parsePrimitiveData(t, e, n, r) {
    return ha(t, e, n, r);
  }
  parseArrayData(t, e, n, r) {
    return ha(t, e, n, r);
  }
  parseObjectData(t, e, n, r) {
    const { iScale: s, vScale: o } = t, { xAxisKey: a = "x", yAxisKey: c = "y" } = this._parsing, l = s.axis === "x" ? a : c, u = o.axis === "x" ? a : c, h = [];
    let f, d, p, g;
    for (f = n, d = n + r; f < d; ++f)
      g = e[f], p = {}, p[s.axis] = s.parse(te(g, l), f), h.push(_l(te(g, u), p, o, f));
    return h;
  }
  updateRangeFromParsed(t, e, n, r) {
    super.updateRangeFromParsed(t, e, n, r);
    const s = n._custom;
    s && e === this._cachedMeta.vScale && (t.min = Math.min(t.min, s.min), t.max = Math.max(t.max, s.max));
  }
  getMaxOverflow() {
    return 0;
  }
  getLabelAndValue(t) {
    const e = this._cachedMeta, { iScale: n, vScale: r } = e, s = this.getParsed(t), o = s._custom, a = yr(o) ? "[" + o.start + ", " + o.end + "]" : "" + r.getLabelForValue(s[r.axis]);
    return {
      label: "" + n.getLabelForValue(s[n.axis]),
      value: a
    };
  }
  initialize() {
    this.enableOptionSharing = !0, super.initialize();
    const t = this._cachedMeta;
    t.stack = this.getDataset().stack;
  }
  update(t) {
    const e = this._cachedMeta;
    this.updateElements(e.data, 0, e.data.length, t);
  }
  updateElements(t, e, n, r) {
    const s = r === "reset", { index: o, _cachedMeta: { vScale: a } } = this, c = a.getBasePixel(), l = a.isHorizontal(), u = this._getRuler(), { sharedOptions: h, includeOptions: f } = this._getSharedOptions(e, r);
    for (let d = e; d < e + n; d++) {
      const p = this.getParsed(d), g = s || $(p[a.axis]) ? { base: c, head: c } : this._calculateBarValuePixels(d), m = this._calculateBarIndexPixels(d, u), y = (p._stacks || {})[a.axis], b = {
        horizontal: l,
        base: g.base,
        enableBorderRadius: !y || yr(p._custom) || o === y._top || o === y._bottom,
        x: l ? g.head : m.center,
        y: l ? m.center : g.head,
        height: l ? m.size : Math.abs(g.size),
        width: l ? Math.abs(g.size) : m.size
      };
      f && (b.options = h || this.resolveDataElementOptions(d, t[d].active ? "active" : r));
      const v = b.options || t[d].options;
      fd(b, v, y, o), pd(b, v, u.ratio), this.updateElement(t[d], d, b, r);
    }
  }
  _getStacks(t, e) {
    const { iScale: n } = this._cachedMeta, r = n.getMatchingVisibleMetas(this._type).filter((c) => c.controller.options.grouped), s = n.options.stacked, o = [], a = (c) => {
      const l = c.controller.getParsed(e), u = l && l[c.vScale.axis];
      if ($(u) || isNaN(u))
        return !0;
    };
    for (const c of r)
      if (!(e !== void 0 && a(c)) && ((s === !1 || o.indexOf(c.stack) === -1 || s === void 0 && c.stack === void 0) && o.push(c.stack), c.index === t))
        break;
    return o.length || o.push(void 0), o;
  }
  _getStackCount(t) {
    return this._getStacks(void 0, t).length;
  }
  _getStackIndex(t, e, n) {
    const r = this._getStacks(t, n), s = e !== void 0 ? r.indexOf(e) : -1;
    return s === -1 ? r.length - 1 : s;
  }
  _getRuler() {
    const t = this.options, e = this._cachedMeta, n = e.iScale, r = [];
    let s, o;
    for (s = 0, o = e.data.length; s < o; ++s)
      r.push(n.getPixelForValue(this.getParsed(s)[n.axis], s));
    const a = t.barThickness;
    return {
      min: a || od(e),
      pixels: r,
      start: n._startPixel,
      end: n._endPixel,
      stackCount: this._getStackCount(),
      scale: n,
      grouped: t.grouped,
      ratio: a ? 1 : t.categoryPercentage * t.barPercentage
    };
  }
  _calculateBarValuePixels(t) {
    const { _cachedMeta: { vScale: e, _stacked: n }, options: { base: r, minBarLength: s } } = this, o = r || 0, a = this.getParsed(t), c = a._custom, l = yr(c);
    let u = a[e.axis], h = 0, f = n ? this.applyStack(e, a, n) : u, d, p;
    f !== u && (h = f - u, f = u), l && (u = c.barStart, f = c.barEnd - c.barStart, u !== 0 && Rt(u) !== Rt(c.barEnd) && (h = 0), h += u);
    const g = !$(r) && !l ? r : h;
    let m = e.getPixelForValue(g);
    if (this.chart.getDataVisibility(t) ? d = e.getPixelForValue(h + f) : d = m, p = d - m, Math.abs(p) < s) {
      p = ud(p, e, o) * s, u === o && (m -= p / 2);
      const y = e.getPixelForDecimal(0), b = e.getPixelForDecimal(1), v = Math.min(y, b), _ = Math.max(y, b);
      m = Math.max(Math.min(m, _), v), d = m + p;
    }
    if (m === e.getPixelForValue(o)) {
      const y = Rt(p) * e.getLineWidthForValue(o) / 2;
      m += y, p -= y;
    }
    return {
      size: p,
      base: m,
      head: d,
      center: d + p / 2
    };
  }
  _calculateBarIndexPixels(t, e) {
    const n = e.scale, r = this.options, s = r.skipNull, o = F(r.maxBarThickness, 1 / 0);
    let a, c;
    if (e.grouped) {
      const l = s ? this._getStackCount(t) : e.stackCount, u = r.barThickness === "flex" ? cd(t, e, r, l) : ad(t, e, r, l), h = this._getStackIndex(this.index, this._cachedMeta.stack, s ? t : void 0);
      a = u.start + u.chunk * h + u.chunk / 2, c = Math.min(o, u.chunk * u.ratio);
    } else
      a = n.getPixelForValue(this.getParsed(t)[n.axis], t), c = Math.min(o, e.min * e.ratio);
    return {
      base: a - c / 2,
      head: a + c / 2,
      center: a,
      size: c
    };
  }
  draw() {
    const t = this._cachedMeta, e = t.vScale, n = t.data, r = n.length;
    let s = 0;
    for (; s < r; ++s)
      this.getParsed(s)[e.axis] !== null && n[s].draw(this._ctx);
  }
}
js.id = "bar";
js.defaults = {
  datasetElementType: !1,
  dataElementType: "bar",
  categoryPercentage: 0.8,
  barPercentage: 0.9,
  grouped: !0,
  animations: {
    numbers: {
      type: "number",
      properties: ["x", "y", "base", "width", "height"]
    }
  }
};
js.overrides = {
  scales: {
    _index_: {
      type: "category",
      offset: !0,
      grid: {
        offset: !0
      }
    },
    _value_: {
      type: "linear",
      beginAtZero: !0
    }
  }
};
class zn extends Ot {
  initialize() {
    this.enableOptionSharing = !0, super.initialize();
  }
  parsePrimitiveData(t, e, n, r) {
    const s = super.parsePrimitiveData(t, e, n, r);
    for (let o = 0; o < s.length; o++)
      s[o]._custom = this.resolveDataElementOptions(o + n).radius;
    return s;
  }
  parseArrayData(t, e, n, r) {
    const s = super.parseArrayData(t, e, n, r);
    for (let o = 0; o < s.length; o++) {
      const a = e[n + o];
      s[o]._custom = F(a[2], this.resolveDataElementOptions(o + n).radius);
    }
    return s;
  }
  parseObjectData(t, e, n, r) {
    const s = super.parseObjectData(t, e, n, r);
    for (let o = 0; o < s.length; o++) {
      const a = e[n + o];
      s[o]._custom = F(a && a.r && +a.r, this.resolveDataElementOptions(o + n).radius);
    }
    return s;
  }
  getMaxOverflow() {
    const t = this._cachedMeta.data;
    let e = 0;
    for (let n = t.length - 1; n >= 0; --n)
      e = Math.max(e, t[n].size(this.resolveDataElementOptions(n)) / 2);
    return e > 0 && e;
  }
  getLabelAndValue(t) {
    const e = this._cachedMeta, { xScale: n, yScale: r } = e, s = this.getParsed(t), o = n.getLabelForValue(s.x), a = r.getLabelForValue(s.y), c = s._custom;
    return {
      label: e.label,
      value: "(" + o + ", " + a + (c ? ", " + c : "") + ")"
    };
  }
  update(t) {
    const e = this._cachedMeta.data;
    this.updateElements(e, 0, e.length, t);
  }
  updateElements(t, e, n, r) {
    const s = r === "reset", { iScale: o, vScale: a } = this._cachedMeta, { sharedOptions: c, includeOptions: l } = this._getSharedOptions(e, r), u = o.axis, h = a.axis;
    for (let f = e; f < e + n; f++) {
      const d = t[f], p = !s && this.getParsed(f), g = {}, m = g[u] = s ? o.getPixelForDecimal(0.5) : o.getPixelForValue(p[u]), y = g[h] = s ? a.getBasePixel() : a.getPixelForValue(p[h]);
      g.skip = isNaN(m) || isNaN(y), l && (g.options = c || this.resolveDataElementOptions(f, d.active ? "active" : r), s && (g.options.radius = 0)), this.updateElement(d, f, g, r);
    }
  }
  resolveDataElementOptions(t, e) {
    const n = this.getParsed(t);
    let r = super.resolveDataElementOptions(t, e);
    r.$shared && (r = Object.assign({}, r, { $shared: !1 }));
    const s = r.radius;
    return e !== "active" && (r.radius = 0), r.radius += F(n && n._custom, s), r;
  }
}
zn.id = "bubble";
zn.defaults = {
  datasetElementType: !1,
  dataElementType: "point",
  animations: {
    numbers: {
      type: "number",
      properties: ["x", "y", "borderWidth", "radius"]
    }
  }
};
zn.overrides = {
  scales: {
    x: {
      type: "linear"
    },
    y: {
      type: "linear"
    }
  },
  plugins: {
    tooltip: {
      callbacks: {
        title() {
          return "";
        }
      }
    }
  }
};
function gd(i, t, e) {
  let n = 1, r = 1, s = 0, o = 0;
  if (t < Q) {
    const a = i, c = a + t, l = Math.cos(a), u = Math.sin(a), h = Math.cos(c), f = Math.sin(c), d = (v, _, x) => Di(v, a, c, !0) ? 1 : Math.max(_, _ * e, x, x * e), p = (v, _, x) => Di(v, a, c, !0) ? -1 : Math.min(_, _ * e, x, x * e), g = d(0, l, h), m = d(K, u, f), y = p(Z, l, h), b = p(Z + K, u, f);
    n = (g - y) / 2, r = (m - b) / 2, s = -(g + y) / 2, o = -(m + b) / 2;
  }
  return { ratioX: n, ratioY: r, offsetX: s, offsetY: o };
}
class Ge extends Ot {
  constructor(t, e) {
    super(t, e), this.enableOptionSharing = !0, this.innerRadius = void 0, this.outerRadius = void 0, this.offsetX = void 0, this.offsetY = void 0;
  }
  linkScales() {
  }
  parse(t, e) {
    const n = this.getDataset().data, r = this._cachedMeta;
    if (this._parsing === !1)
      r._parsed = n;
    else {
      let s = (c) => +n[c];
      if (L(n[t])) {
        const { key: c = "value" } = this._parsing;
        s = (l) => +te(n[l], c);
      }
      let o, a;
      for (o = t, a = t + e; o < a; ++o)
        r._parsed[o] = s(o);
    }
  }
  _getRotation() {
    return kt(this.options.rotation - 90);
  }
  _getCircumference() {
    return kt(this.options.circumference);
  }
  _getRotationExtents() {
    let t = Q, e = -Q;
    for (let n = 0; n < this.chart.data.datasets.length; ++n)
      if (this.chart.isDatasetVisible(n)) {
        const r = this.chart.getDatasetMeta(n).controller, s = r._getRotation(), o = r._getCircumference();
        t = Math.min(t, s), e = Math.max(e, s + o);
      }
    return {
      rotation: t,
      circumference: e - t
    };
  }
  update(t) {
    const e = this.chart, { chartArea: n } = e, r = this._cachedMeta, s = r.data, o = this.getMaxBorderWidth() + this.getMaxOffset(s) + this.options.spacing, a = Math.max((Math.min(n.width, n.height) - o) / 2, 0), c = Math.min(sh(this.options.cutout, a), 1), l = this._getRingWeight(this.index), { circumference: u, rotation: h } = this._getRotationExtents(), { ratioX: f, ratioY: d, offsetX: p, offsetY: g } = gd(h, u, c), m = (n.width - o) / f, y = (n.height - o) / d, b = Math.max(Math.min(m, y) / 2, 0), v = Wc(this.options.radius, b), _ = Math.max(v * c, 0), x = (v - _) / this._getVisibleDatasetWeightTotal();
    this.offsetX = p * v, this.offsetY = g * v, r.total = this.calculateTotal(), this.outerRadius = v - x * this._getRingWeightOffset(this.index), this.innerRadius = Math.max(this.outerRadius - x * l, 0), this.updateElements(s, 0, s.length, t);
  }
  _circumference(t, e) {
    const n = this.options, r = this._cachedMeta, s = this._getCircumference();
    return e && n.animation.animateRotate || !this.chart.getDataVisibility(t) || r._parsed[t] === null || r.data[t].hidden ? 0 : this.calculateCircumference(r._parsed[t] * s / Q);
  }
  updateElements(t, e, n, r) {
    const s = r === "reset", o = this.chart, a = o.chartArea, l = o.options.animation, u = (a.left + a.right) / 2, h = (a.top + a.bottom) / 2, f = s && l.animateScale, d = f ? 0 : this.innerRadius, p = f ? 0 : this.outerRadius, { sharedOptions: g, includeOptions: m } = this._getSharedOptions(e, r);
    let y = this._getRotation(), b;
    for (b = 0; b < e; ++b)
      y += this._circumference(b, s);
    for (b = e; b < e + n; ++b) {
      const v = this._circumference(b, s), _ = t[b], x = {
        x: u + this.offsetX,
        y: h + this.offsetY,
        startAngle: y,
        endAngle: y + v,
        circumference: v,
        outerRadius: p,
        innerRadius: d
      };
      m && (x.options = g || this.resolveDataElementOptions(b, _.active ? "active" : r)), y += v, this.updateElement(_, b, x, r);
    }
  }
  calculateTotal() {
    const t = this._cachedMeta, e = t.data;
    let n = 0, r;
    for (r = 0; r < e.length; r++) {
      const s = t._parsed[r];
      s !== null && !isNaN(s) && this.chart.getDataVisibility(r) && !e[r].hidden && (n += Math.abs(s));
    }
    return n;
  }
  calculateCircumference(t) {
    const e = this._cachedMeta.total;
    return e > 0 && !isNaN(t) ? Q * (Math.abs(t) / e) : 0;
  }
  getLabelAndValue(t) {
    const e = this._cachedMeta, n = this.chart, r = n.data.labels || [], s = ji(e._parsed[t], n.options.locale);
    return {
      label: r[t] || "",
      value: s
    };
  }
  getMaxBorderWidth(t) {
    let e = 0;
    const n = this.chart;
    let r, s, o, a, c;
    if (!t) {
      for (r = 0, s = n.data.datasets.length; r < s; ++r)
        if (n.isDatasetVisible(r)) {
          o = n.getDatasetMeta(r), t = o.data, a = o.controller;
          break;
        }
    }
    if (!t)
      return 0;
    for (r = 0, s = t.length; r < s; ++r)
      c = a.resolveDataElementOptions(r), c.borderAlign !== "inner" && (e = Math.max(e, c.borderWidth || 0, c.hoverBorderWidth || 0));
    return e;
  }
  getMaxOffset(t) {
    let e = 0;
    for (let n = 0, r = t.length; n < r; ++n) {
      const s = this.resolveDataElementOptions(n);
      e = Math.max(e, s.offset || 0, s.hoverOffset || 0);
    }
    return e;
  }
  _getRingWeightOffset(t) {
    let e = 0;
    for (let n = 0; n < t; ++n)
      this.chart.isDatasetVisible(n) && (e += this._getRingWeight(n));
    return e;
  }
  _getRingWeight(t) {
    return Math.max(F(this.chart.data.datasets[t].weight, 1), 0);
  }
  _getVisibleDatasetWeightTotal() {
    return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
  }
}
Ge.id = "doughnut";
Ge.defaults = {
  datasetElementType: !1,
  dataElementType: "arc",
  animation: {
    animateRotate: !0,
    animateScale: !1
  },
  animations: {
    numbers: {
      type: "number",
      properties: ["circumference", "endAngle", "innerRadius", "outerRadius", "startAngle", "x", "y", "offset", "borderWidth", "spacing"]
    }
  },
  cutout: "50%",
  rotation: 0,
  circumference: 360,
  radius: "100%",
  spacing: 0,
  indexAxis: "r"
};
Ge.descriptors = {
  _scriptable: (i) => i !== "spacing",
  _indexable: (i) => i !== "spacing"
};
Ge.overrides = {
  aspectRatio: 1,
  plugins: {
    legend: {
      labels: {
        generateLabels(i) {
          const t = i.data;
          if (t.labels.length && t.datasets.length) {
            const { labels: { pointStyle: e } } = i.legend.options;
            return t.labels.map((n, r) => {
              const o = i.getDatasetMeta(0).controller.getStyle(r);
              return {
                text: n,
                fillStyle: o.backgroundColor,
                strokeStyle: o.borderColor,
                lineWidth: o.borderWidth,
                pointStyle: e,
                hidden: !i.getDataVisibility(r),
                index: r
              };
            });
          }
          return [];
        }
      },
      onClick(i, t, e) {
        e.chart.toggleDataVisibility(t.index), e.chart.update();
      }
    },
    tooltip: {
      callbacks: {
        title() {
          return "";
        },
        label(i) {
          let t = i.label;
          const e = ": " + i.formattedValue;
          return H(t) ? (t = t.slice(), t[0] += e) : t += e, t;
        }
      }
    }
  }
};
class Bs extends Ot {
  initialize() {
    this.enableOptionSharing = !0, this.supportsDecimation = !0, super.initialize();
  }
  update(t) {
    const e = this._cachedMeta, { dataset: n, data: r = [], _dataset: s } = e, o = this.chart._animationsDisabled;
    let { start: a, count: c } = tl(e, r, o);
    this._drawStart = a, this._drawCount = c, el(e) && (a = 0, c = r.length), n._chart = this.chart, n._datasetIndex = this.index, n._decimated = !!s._decimated, n.points = r;
    const l = this.resolveDatasetElementOptions(t);
    this.options.showLine || (l.borderWidth = 0), l.segment = this.options.segment, this.updateElement(n, void 0, {
      animated: !o,
      options: l
    }, t), this.updateElements(r, a, c, t);
  }
  updateElements(t, e, n, r) {
    const s = r === "reset", { iScale: o, vScale: a, _stacked: c, _dataset: l } = this._cachedMeta, { sharedOptions: u, includeOptions: h } = this._getSharedOptions(e, r), f = o.axis, d = a.axis, { spanGaps: p, segment: g } = this.options, m = $e(p) ? p : Number.POSITIVE_INFINITY, y = this.chart._animationsDisabled || s || r === "none";
    let b = e > 0 && this.getParsed(e - 1);
    for (let v = e; v < e + n; ++v) {
      const _ = t[v], x = this.getParsed(v), k = y ? _ : {}, E = $(x[d]), O = k[f] = o.getPixelForValue(x[f], v), M = k[d] = s || E ? a.getBasePixel() : a.getPixelForValue(c ? this.applyStack(a, x, c) : x[d], v);
      k.skip = isNaN(O) || isNaN(M) || E, k.stop = v > 0 && Math.abs(x[f] - b[f]) > m, g && (k.parsed = x, k.raw = l.data[v]), h && (k.options = u || this.resolveDataElementOptions(v, _.active ? "active" : r)), y || this.updateElement(_, v, k, r), b = x;
    }
  }
  getMaxOverflow() {
    const t = this._cachedMeta, e = t.dataset, n = e.options && e.options.borderWidth || 0, r = t.data || [];
    if (!r.length)
      return n;
    const s = r[0].size(this.resolveDataElementOptions(0)), o = r[r.length - 1].size(this.resolveDataElementOptions(r.length - 1));
    return Math.max(n, s, o) / 2;
  }
  draw() {
    const t = this._cachedMeta;
    t.dataset.updateControlPoints(this.chart.chartArea, t.iScale.axis), super.draw();
  }
}
Bs.id = "line";
Bs.defaults = {
  datasetElementType: "line",
  dataElementType: "point",
  showLine: !0,
  spanGaps: !1
};
Bs.overrides = {
  scales: {
    _index_: {
      type: "category"
    },
    _value_: {
      type: "linear"
    }
  }
};
class $s extends Ot {
  constructor(t, e) {
    super(t, e), this.innerRadius = void 0, this.outerRadius = void 0;
  }
  getLabelAndValue(t) {
    const e = this._cachedMeta, n = this.chart, r = n.data.labels || [], s = ji(e._parsed[t].r, n.options.locale);
    return {
      label: r[t] || "",
      value: s
    };
  }
  parseObjectData(t, e, n, r) {
    return pl.bind(this)(t, e, n, r);
  }
  update(t) {
    const e = this._cachedMeta.data;
    this._updateRadius(), this.updateElements(e, 0, e.length, t);
  }
  getMinMax() {
    const t = this._cachedMeta, e = { min: Number.POSITIVE_INFINITY, max: Number.NEGATIVE_INFINITY };
    return t.data.forEach((n, r) => {
      const s = this.getParsed(r).r;
      !isNaN(s) && this.chart.getDataVisibility(r) && (s < e.min && (e.min = s), s > e.max && (e.max = s));
    }), e;
  }
  _updateRadius() {
    const t = this.chart, e = t.chartArea, n = t.options, r = Math.min(e.right - e.left, e.bottom - e.top), s = Math.max(r / 2, 0), o = Math.max(n.cutoutPercentage ? s / 100 * n.cutoutPercentage : 1, 0), a = (s - o) / t.getVisibleDatasetCount();
    this.outerRadius = s - a * this.index, this.innerRadius = this.outerRadius - a;
  }
  updateElements(t, e, n, r) {
    const s = r === "reset", o = this.chart, c = o.options.animation, l = this._cachedMeta.rScale, u = l.xCenter, h = l.yCenter, f = l.getIndexAngle(0) - 0.5 * Z;
    let d = f, p;
    const g = 360 / this.countVisibleElements();
    for (p = 0; p < e; ++p)
      d += this._computeAngle(p, r, g);
    for (p = e; p < e + n; p++) {
      const m = t[p];
      let y = d, b = d + this._computeAngle(p, r, g), v = o.getDataVisibility(p) ? l.getDistanceFromCenterForValue(this.getParsed(p).r) : 0;
      d = b, s && (c.animateScale && (v = 0), c.animateRotate && (y = b = f));
      const _ = {
        x: u,
        y: h,
        innerRadius: 0,
        outerRadius: v,
        startAngle: y,
        endAngle: b,
        options: this.resolveDataElementOptions(p, m.active ? "active" : r)
      };
      this.updateElement(m, p, _, r);
    }
  }
  countVisibleElements() {
    const t = this._cachedMeta;
    let e = 0;
    return t.data.forEach((n, r) => {
      !isNaN(this.getParsed(r).r) && this.chart.getDataVisibility(r) && e++;
    }), e;
  }
  _computeAngle(t, e, n) {
    return this.chart.getDataVisibility(t) ? kt(this.resolveDataElementOptions(t, e).angle || n) : 0;
  }
}
$s.id = "polarArea";
$s.defaults = {
  dataElementType: "arc",
  animation: {
    animateRotate: !0,
    animateScale: !0
  },
  animations: {
    numbers: {
      type: "number",
      properties: ["x", "y", "startAngle", "endAngle", "innerRadius", "outerRadius"]
    }
  },
  indexAxis: "r",
  startAngle: 0
};
$s.overrides = {
  aspectRatio: 1,
  plugins: {
    legend: {
      labels: {
        generateLabels(i) {
          const t = i.data;
          if (t.labels.length && t.datasets.length) {
            const { labels: { pointStyle: e } } = i.legend.options;
            return t.labels.map((n, r) => {
              const o = i.getDatasetMeta(0).controller.getStyle(r);
              return {
                text: n,
                fillStyle: o.backgroundColor,
                strokeStyle: o.borderColor,
                lineWidth: o.borderWidth,
                pointStyle: e,
                hidden: !i.getDataVisibility(r),
                index: r
              };
            });
          }
          return [];
        }
      },
      onClick(i, t, e) {
        e.chart.toggleDataVisibility(t.index), e.chart.update();
      }
    },
    tooltip: {
      callbacks: {
        title() {
          return "";
        },
        label(i) {
          return i.chart.data.labels[i.dataIndex] + ": " + i.formattedValue;
        }
      }
    }
  },
  scales: {
    r: {
      type: "radialLinear",
      angleLines: {
        display: !1
      },
      beginAtZero: !0,
      grid: {
        circular: !0
      },
      pointLabels: {
        display: !1
      },
      startAngle: 0
    }
  }
};
class xl extends Ge {
}
xl.id = "pie";
xl.defaults = {
  cutout: 0,
  rotation: 0,
  circumference: 360,
  radius: "100%"
};
class zs extends Ot {
  getLabelAndValue(t) {
    const e = this._cachedMeta.vScale, n = this.getParsed(t);
    return {
      label: e.getLabels()[t],
      value: "" + e.getLabelForValue(n[e.axis])
    };
  }
  parseObjectData(t, e, n, r) {
    return pl.bind(this)(t, e, n, r);
  }
  update(t) {
    const e = this._cachedMeta, n = e.dataset, r = e.data || [], s = e.iScale.getLabels();
    if (n.points = r, t !== "resize") {
      const o = this.resolveDatasetElementOptions(t);
      this.options.showLine || (o.borderWidth = 0);
      const a = {
        _loop: !0,
        _fullLoop: s.length === r.length,
        options: o
      };
      this.updateElement(n, void 0, a, t);
    }
    this.updateElements(r, 0, r.length, t);
  }
  updateElements(t, e, n, r) {
    const s = this._cachedMeta.rScale, o = r === "reset";
    for (let a = e; a < e + n; a++) {
      const c = t[a], l = this.resolveDataElementOptions(a, c.active ? "active" : r), u = s.getPointPositionForValue(a, this.getParsed(a).r), h = o ? s.xCenter : u.x, f = o ? s.yCenter : u.y, d = {
        x: h,
        y: f,
        angle: u.angle,
        skip: isNaN(h) || isNaN(f),
        options: l
      };
      this.updateElement(c, a, d, r);
    }
  }
}
zs.id = "radar";
zs.defaults = {
  datasetElementType: "line",
  dataElementType: "point",
  indexAxis: "r",
  showLine: !0,
  elements: {
    line: {
      fill: "start"
    }
  }
};
zs.overrides = {
  aspectRatio: 1,
  scales: {
    r: {
      type: "radialLinear"
    }
  }
};
class $t {
  constructor() {
    this.x = void 0, this.y = void 0, this.active = !1, this.options = void 0, this.$animations = void 0;
  }
  tooltipPosition(t) {
    const { x: e, y: n } = this.getProps(["x", "y"], t);
    return { x: e, y: n };
  }
  hasValue() {
    return $e(this.x) && $e(this.y);
  }
  getProps(t, e) {
    const n = this.$animations;
    if (!e || !n)
      return this;
    const r = {};
    return t.forEach((s) => {
      r[s] = n[s] && n[s].active() ? n[s]._to : this[s];
    }), r;
  }
}
$t.defaults = {};
$t.defaultRoutes = void 0;
const wl = {
  values(i) {
    return H(i) ? i : "" + i;
  },
  numeric(i, t, e) {
    if (i === 0)
      return "0";
    const n = this.chart.options.locale;
    let r, s = i;
    if (e.length > 1) {
      const l = Math.max(Math.abs(e[0].value), Math.abs(e[e.length - 1].value));
      (l < 1e-4 || l > 1e15) && (r = "scientific"), s = md(i, e);
    }
    const o = bt(Math.abs(s)), a = Math.max(Math.min(-1 * Math.floor(o), 20), 0), c = { notation: r, minimumFractionDigits: a, maximumFractionDigits: a };
    return Object.assign(c, this.options.ticks.format), ji(i, n, c);
  },
  logarithmic(i, t, e) {
    if (i === 0)
      return "0";
    const n = i / Math.pow(10, Math.floor(bt(i)));
    return n === 1 || n === 2 || n === 5 ? wl.numeric.call(this, i, t, e) : "";
  }
};
function md(i, t) {
  let e = t.length > 3 ? t[2].value - t[1].value : t[1].value - t[0].value;
  return Math.abs(e) >= 1 && i !== Math.floor(i) && (e = i - Math.floor(i)), e;
}
var qn = { formatters: wl };
I.set("scale", {
  display: !0,
  offset: !1,
  reverse: !1,
  beginAtZero: !1,
  bounds: "ticks",
  grace: 0,
  grid: {
    display: !0,
    lineWidth: 1,
    drawBorder: !0,
    drawOnChartArea: !0,
    drawTicks: !0,
    tickLength: 8,
    tickWidth: (i, t) => t.lineWidth,
    tickColor: (i, t) => t.color,
    offset: !1,
    borderDash: [],
    borderDashOffset: 0,
    borderWidth: 1
  },
  title: {
    display: !1,
    text: "",
    padding: {
      top: 4,
      bottom: 4
    }
  },
  ticks: {
    minRotation: 0,
    maxRotation: 50,
    mirror: !1,
    textStrokeWidth: 0,
    textStrokeColor: "",
    padding: 3,
    display: !0,
    autoSkip: !0,
    autoSkipPadding: 3,
    labelOffset: 0,
    callback: qn.formatters.values,
    minor: {},
    major: {},
    align: "center",
    crossAlign: "near",
    showLabelBackdrop: !1,
    backdropColor: "rgba(255, 255, 255, 0.75)",
    backdropPadding: 2
  }
});
I.route("scale.ticks", "color", "", "color");
I.route("scale.grid", "color", "", "borderColor");
I.route("scale.grid", "borderColor", "", "borderColor");
I.route("scale.title", "color", "", "color");
I.describe("scale", {
  _fallback: !1,
  _scriptable: (i) => !i.startsWith("before") && !i.startsWith("after") && i !== "callback" && i !== "parser",
  _indexable: (i) => i !== "borderDash" && i !== "tickBorderDash"
});
I.describe("scales", {
  _fallback: "scale"
});
I.describe("scale.ticks", {
  _scriptable: (i) => i !== "backdropPadding" && i !== "callback",
  _indexable: (i) => i !== "backdropPadding"
});
function yd(i, t) {
  const e = i.options.ticks, n = e.maxTicksLimit || vd(i), r = e.major.enabled ? _d(t) : [], s = r.length, o = r[0], a = r[s - 1], c = [];
  if (s > n)
    return xd(t, c, r, s / n), c;
  const l = bd(r, t, n);
  if (s > 0) {
    let u, h;
    const f = s > 1 ? Math.round((a - o) / (s - 1)) : null;
    for (Xi(t, c, l, $(f) ? 0 : o - f, o), u = 0, h = s - 1; u < h; u++)
      Xi(t, c, l, r[u], r[u + 1]);
    return Xi(t, c, l, a, $(f) ? t.length : a + f), c;
  }
  return Xi(t, c, l), c;
}
function vd(i) {
  const t = i.options.offset, e = i._tickSize(), n = i._length / e + (t ? 0 : 1), r = i._maxLength / e;
  return Math.floor(Math.min(n, r));
}
function bd(i, t, e) {
  const n = wd(i), r = t.length / e;
  if (!n)
    return Math.max(r, 1);
  const s = dh(n);
  for (let o = 0, a = s.length - 1; o < a; o++) {
    const c = s[o];
    if (c > r)
      return c;
  }
  return Math.max(r, 1);
}
function _d(i) {
  const t = [];
  let e, n;
  for (e = 0, n = i.length; e < n; e++)
    i[e].major && t.push(e);
  return t;
}
function xd(i, t, e, n) {
  let r = 0, s = e[0], o;
  for (n = Math.ceil(n), o = 0; o < i.length; o++)
    o === s && (t.push(i[o]), r++, s = e[r * n]);
}
function Xi(i, t, e, n, r) {
  const s = F(n, 0), o = Math.min(F(r, i.length), i.length);
  let a = 0, c, l, u;
  for (e = Math.ceil(e), r && (c = r - n, e = c / Math.floor(c / e)), u = s; u < 0; )
    a++, u = Math.round(s + a * e);
  for (l = Math.max(s, 0); l < o; l++)
    l === u && (t.push(i[l]), a++, u = Math.round(s + a * e));
}
function wd(i) {
  const t = i.length;
  let e, n;
  if (t < 2)
    return !1;
  for (n = i[0], e = 1; e < t; ++e)
    if (i[e] - i[e - 1] !== n)
      return !1;
  return n;
}
const Sd = (i) => i === "left" ? "right" : i === "right" ? "left" : i, pa = (i, t, e) => t === "top" || t === "left" ? i[t] + e : i[t] - e;
function ga(i, t) {
  const e = [], n = i.length / t, r = i.length;
  let s = 0;
  for (; s < r; s += n)
    e.push(i[Math.floor(s)]);
  return e;
}
function Ed(i, t, e) {
  const n = i.ticks.length, r = Math.min(t, n - 1), s = i._startPixel, o = i._endPixel, a = 1e-6;
  let c = i.getPixelForTick(r), l;
  if (!(e && (n === 1 ? l = Math.max(c - s, o - c) : t === 0 ? l = (i.getPixelForTick(1) - c) / 2 : l = (c - i.getPixelForTick(r - 1)) / 2, c += r < t ? l : -l, c < s - a || c > o + a)))
    return c;
}
function kd(i, t) {
  j(i, (e) => {
    const n = e.gc, r = n.length / 2;
    let s;
    if (r > t) {
      for (s = 0; s < r; ++s)
        delete e.data[n[s]];
      n.splice(0, r);
    }
  });
}
function ei(i) {
  return i.drawTicks ? i.tickLength : 0;
}
function ma(i, t) {
  if (!i.display)
    return 0;
  const e = gt(i.font, t), n = xt(i.padding);
  return (H(i.text) ? i.text.length : 1) * e.lineHeight + n.height;
}
function Od(i, t) {
  return re(i, {
    scale: t,
    type: "scale"
  });
}
function Dd(i, t, e) {
  return re(i, {
    tick: e,
    index: t,
    type: "tick"
  });
}
function Td(i, t, e) {
  let n = xh(i);
  return (e && t !== "right" || !e && t === "right") && (n = Sd(n)), n;
}
function Md(i, t, e, n) {
  const { top: r, left: s, bottom: o, right: a, chart: c } = i, { chartArea: l, scales: u } = c;
  let h = 0, f, d, p;
  const g = o - r, m = a - s;
  if (i.isHorizontal()) {
    if (d = $o(n, s, a), L(e)) {
      const y = Object.keys(e)[0], b = e[y];
      p = u[y].getPixelForValue(b) + g - t;
    } else
      e === "center" ? p = (l.bottom + l.top) / 2 + g - t : p = pa(i, e, t);
    f = a - s;
  } else {
    if (L(e)) {
      const y = Object.keys(e)[0], b = e[y];
      d = u[y].getPixelForValue(b) - m + t;
    } else
      e === "center" ? d = (l.left + l.right) / 2 - m + t : d = pa(i, e, t);
    p = $o(n, o, r), h = e === "left" ? -K : K;
  }
  return { titleX: d, titleY: p, maxWidth: f, rotation: h };
}
class be extends $t {
  constructor(t) {
    super(), this.id = t.id, this.type = t.type, this.options = void 0, this.ctx = t.ctx, this.chart = t.chart, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this._margins = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, this.maxWidth = void 0, this.maxHeight = void 0, this.paddingTop = void 0, this.paddingBottom = void 0, this.paddingLeft = void 0, this.paddingRight = void 0, this.axis = void 0, this.labelRotation = void 0, this.min = void 0, this.max = void 0, this._range = void 0, this.ticks = [], this._gridLineItems = null, this._labelItems = null, this._labelSizes = null, this._length = 0, this._maxLength = 0, this._longestTextCache = {}, this._startPixel = void 0, this._endPixel = void 0, this._reversePixels = !1, this._userMax = void 0, this._userMin = void 0, this._suggestedMax = void 0, this._suggestedMin = void 0, this._ticksLength = 0, this._borderValue = 0, this._cache = {}, this._dataLimitsCached = !1, this.$context = void 0;
  }
  init(t) {
    this.options = t.setContext(this.getContext()), this.axis = t.axis, this._userMin = this.parse(t.min), this._userMax = this.parse(t.max), this._suggestedMin = this.parse(t.suggestedMin), this._suggestedMax = this.parse(t.suggestedMax);
  }
  parse(t, e) {
    return t;
  }
  getUserBounds() {
    let { _userMin: t, _userMax: e, _suggestedMin: n, _suggestedMax: r } = this;
    return t = yt(t, Number.POSITIVE_INFINITY), e = yt(e, Number.NEGATIVE_INFINITY), n = yt(n, Number.POSITIVE_INFINITY), r = yt(r, Number.NEGATIVE_INFINITY), {
      min: yt(t, n),
      max: yt(e, r),
      minDefined: ut(t),
      maxDefined: ut(e)
    };
  }
  getMinMax(t) {
    let { min: e, max: n, minDefined: r, maxDefined: s } = this.getUserBounds(), o;
    if (r && s)
      return { min: e, max: n };
    const a = this.getMatchingVisibleMetas();
    for (let c = 0, l = a.length; c < l; ++c)
      o = a[c].controller.getMinMax(this, t), r || (e = Math.min(e, o.min)), s || (n = Math.max(n, o.max));
    return e = s && e > n ? n : e, n = r && e > n ? e : n, {
      min: yt(e, yt(n, e)),
      max: yt(n, yt(e, n))
    };
  }
  getPadding() {
    return {
      left: this.paddingLeft || 0,
      top: this.paddingTop || 0,
      right: this.paddingRight || 0,
      bottom: this.paddingBottom || 0
    };
  }
  getTicks() {
    return this.ticks;
  }
  getLabels() {
    const t = this.chart.data;
    return this.options.labels || (this.isHorizontal() ? t.xLabels : t.yLabels) || t.labels || [];
  }
  beforeLayout() {
    this._cache = {}, this._dataLimitsCached = !1;
  }
  beforeUpdate() {
    X(this.options.beforeUpdate, [this]);
  }
  update(t, e, n) {
    const { beginAtZero: r, grace: s, ticks: o } = this.options, a = o.sampleSize;
    this.beforeUpdate(), this.maxWidth = t, this.maxHeight = e, this._margins = n = Object.assign({
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, n), this.ticks = null, this._labelSizes = null, this._gridLineItems = null, this._labelItems = null, this.beforeSetDimensions(), this.setDimensions(), this.afterSetDimensions(), this._maxLength = this.isHorizontal() ? this.width + n.left + n.right : this.height + n.top + n.bottom, this._dataLimitsCached || (this.beforeDataLimits(), this.determineDataLimits(), this.afterDataLimits(), this._range = nf(this, s, r), this._dataLimitsCached = !0), this.beforeBuildTicks(), this.ticks = this.buildTicks() || [], this.afterBuildTicks();
    const c = a < this.ticks.length;
    this._convertTicksToLabels(c ? ga(this.ticks, a) : this.ticks), this.configure(), this.beforeCalculateLabelRotation(), this.calculateLabelRotation(), this.afterCalculateLabelRotation(), o.display && (o.autoSkip || o.source === "auto") && (this.ticks = yd(this, this.ticks), this._labelSizes = null, this.afterAutoSkip()), c && this._convertTicksToLabels(this.ticks), this.beforeFit(), this.fit(), this.afterFit(), this.afterUpdate();
  }
  configure() {
    let t = this.options.reverse, e, n;
    this.isHorizontal() ? (e = this.left, n = this.right) : (e = this.top, n = this.bottom, t = !t), this._startPixel = e, this._endPixel = n, this._reversePixels = t, this._length = n - e, this._alignToPixels = this.options.alignToPixels;
  }
  afterUpdate() {
    X(this.options.afterUpdate, [this]);
  }
  beforeSetDimensions() {
    X(this.options.beforeSetDimensions, [this]);
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = 0, this.right = this.width) : (this.height = this.maxHeight, this.top = 0, this.bottom = this.height), this.paddingLeft = 0, this.paddingTop = 0, this.paddingRight = 0, this.paddingBottom = 0;
  }
  afterSetDimensions() {
    X(this.options.afterSetDimensions, [this]);
  }
  _callHooks(t) {
    this.chart.notifyPlugins(t, this.getContext()), X(this.options[t], [this]);
  }
  beforeDataLimits() {
    this._callHooks("beforeDataLimits");
  }
  determineDataLimits() {
  }
  afterDataLimits() {
    this._callHooks("afterDataLimits");
  }
  beforeBuildTicks() {
    this._callHooks("beforeBuildTicks");
  }
  buildTicks() {
    return [];
  }
  afterBuildTicks() {
    this._callHooks("afterBuildTicks");
  }
  beforeTickToLabelConversion() {
    X(this.options.beforeTickToLabelConversion, [this]);
  }
  generateTickLabels(t) {
    const e = this.options.ticks;
    let n, r, s;
    for (n = 0, r = t.length; n < r; n++)
      s = t[n], s.label = X(e.callback, [s.value, n, t], this);
  }
  afterTickToLabelConversion() {
    X(this.options.afterTickToLabelConversion, [this]);
  }
  beforeCalculateLabelRotation() {
    X(this.options.beforeCalculateLabelRotation, [this]);
  }
  calculateLabelRotation() {
    const t = this.options, e = t.ticks, n = this.ticks.length, r = e.minRotation || 0, s = e.maxRotation;
    let o = r, a, c, l;
    if (!this._isVisible() || !e.display || r >= s || n <= 1 || !this.isHorizontal()) {
      this.labelRotation = r;
      return;
    }
    const u = this._getLabelSizes(), h = u.widest.width, f = u.highest.height, d = ft(this.chart.width - h, 0, this.maxWidth);
    a = t.offset ? this.maxWidth / n : d / (n - 1), h + 6 > a && (a = d / (n - (t.offset ? 0.5 : 1)), c = this.maxHeight - ei(t.grid) - e.padding - ma(t.title, this.chart.options.font), l = Math.sqrt(h * h + f * f), o = Ms(Math.min(
      Math.asin(ft((u.highest.height + 6) / a, -1, 1)),
      Math.asin(ft(c / l, -1, 1)) - Math.asin(ft(f / l, -1, 1))
    )), o = Math.max(r, Math.min(s, o))), this.labelRotation = o;
  }
  afterCalculateLabelRotation() {
    X(this.options.afterCalculateLabelRotation, [this]);
  }
  afterAutoSkip() {
  }
  beforeFit() {
    X(this.options.beforeFit, [this]);
  }
  fit() {
    const t = {
      width: 0,
      height: 0
    }, { chart: e, options: { ticks: n, title: r, grid: s } } = this, o = this._isVisible(), a = this.isHorizontal();
    if (o) {
      const c = ma(r, e.options.font);
      if (a ? (t.width = this.maxWidth, t.height = ei(s) + c) : (t.height = this.maxHeight, t.width = ei(s) + c), n.display && this.ticks.length) {
        const { first: l, last: u, widest: h, highest: f } = this._getLabelSizes(), d = n.padding * 2, p = kt(this.labelRotation), g = Math.cos(p), m = Math.sin(p);
        if (a) {
          const y = n.mirror ? 0 : m * h.width + g * f.height;
          t.height = Math.min(this.maxHeight, t.height + y + d);
        } else {
          const y = n.mirror ? 0 : g * h.width + m * f.height;
          t.width = Math.min(this.maxWidth, t.width + y + d);
        }
        this._calculatePadding(l, u, m, g);
      }
    }
    this._handleMargins(), a ? (this.width = this._length = e.width - this._margins.left - this._margins.right, this.height = t.height) : (this.width = t.width, this.height = this._length = e.height - this._margins.top - this._margins.bottom);
  }
  _calculatePadding(t, e, n, r) {
    const { ticks: { align: s, padding: o }, position: a } = this.options, c = this.labelRotation !== 0, l = a !== "top" && this.axis === "x";
    if (this.isHorizontal()) {
      const u = this.getPixelForTick(0) - this.left, h = this.right - this.getPixelForTick(this.ticks.length - 1);
      let f = 0, d = 0;
      c ? l ? (f = r * t.width, d = n * e.height) : (f = n * t.height, d = r * e.width) : s === "start" ? d = e.width : s === "end" ? f = t.width : s !== "inner" && (f = t.width / 2, d = e.width / 2), this.paddingLeft = Math.max((f - u + o) * this.width / (this.width - u), 0), this.paddingRight = Math.max((d - h + o) * this.width / (this.width - h), 0);
    } else {
      let u = e.height / 2, h = t.height / 2;
      s === "start" ? (u = 0, h = t.height) : s === "end" && (u = e.height, h = 0), this.paddingTop = u + o, this.paddingBottom = h + o;
    }
  }
  _handleMargins() {
    this._margins && (this._margins.left = Math.max(this.paddingLeft, this._margins.left), this._margins.top = Math.max(this.paddingTop, this._margins.top), this._margins.right = Math.max(this.paddingRight, this._margins.right), this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom));
  }
  afterFit() {
    X(this.options.afterFit, [this]);
  }
  isHorizontal() {
    const { axis: t, position: e } = this.options;
    return e === "top" || e === "bottom" || t === "x";
  }
  isFullSize() {
    return this.options.fullSize;
  }
  _convertTicksToLabels(t) {
    this.beforeTickToLabelConversion(), this.generateTickLabels(t);
    let e, n;
    for (e = 0, n = t.length; e < n; e++)
      $(t[e].label) && (t.splice(e, 1), n--, e--);
    this.afterTickToLabelConversion();
  }
  _getLabelSizes() {
    let t = this._labelSizes;
    if (!t) {
      const e = this.options.ticks.sampleSize;
      let n = this.ticks;
      e < n.length && (n = ga(n, e)), this._labelSizes = t = this._computeLabelSizes(n, n.length);
    }
    return t;
  }
  _computeLabelSizes(t, e) {
    const { ctx: n, _longestTextCache: r } = this, s = [], o = [];
    let a = 0, c = 0, l, u, h, f, d, p, g, m, y, b, v;
    for (l = 0; l < e; ++l) {
      if (f = t[l].label, d = this._resolveTickFontOptions(l), n.font = p = d.string, g = r[p] = r[p] || { data: {}, gc: [] }, m = d.lineHeight, y = b = 0, !$(f) && !H(f))
        y = En(n, g.data, g.gc, y, f), b = m;
      else if (H(f))
        for (u = 0, h = f.length; u < h; ++u)
          v = f[u], !$(v) && !H(v) && (y = En(n, g.data, g.gc, y, v), b += m);
      s.push(y), o.push(b), a = Math.max(y, a), c = Math.max(b, c);
    }
    kd(r, e);
    const _ = s.indexOf(a), x = o.indexOf(c), k = (E) => ({ width: s[E] || 0, height: o[E] || 0 });
    return {
      first: k(0),
      last: k(e - 1),
      widest: k(_),
      highest: k(x),
      widths: s,
      heights: o
    };
  }
  getLabelForValue(t) {
    return t;
  }
  getPixelForValue(t, e) {
    return NaN;
  }
  getValueForPixel(t) {
  }
  getPixelForTick(t) {
    const e = this.ticks;
    return t < 0 || t > e.length - 1 ? null : this.getPixelForValue(e[t].value);
  }
  getPixelForDecimal(t) {
    this._reversePixels && (t = 1 - t);
    const e = this._startPixel + t * this._length;
    return mh(this._alignToPixels ? oe(this.chart, e, 0) : e);
  }
  getDecimalForPixel(t) {
    const e = (t - this._startPixel) / this._length;
    return this._reversePixels ? 1 - e : e;
  }
  getBasePixel() {
    return this.getPixelForValue(this.getBaseValue());
  }
  getBaseValue() {
    const { min: t, max: e } = this;
    return t < 0 && e < 0 ? e : t > 0 && e > 0 ? t : 0;
  }
  getContext(t) {
    const e = this.ticks || [];
    if (t >= 0 && t < e.length) {
      const n = e[t];
      return n.$context || (n.$context = Dd(this.getContext(), t, n));
    }
    return this.$context || (this.$context = Od(this.chart.getContext(), this));
  }
  _tickSize() {
    const t = this.options.ticks, e = kt(this.labelRotation), n = Math.abs(Math.cos(e)), r = Math.abs(Math.sin(e)), s = this._getLabelSizes(), o = t.autoSkipPadding || 0, a = s ? s.widest.width + o : 0, c = s ? s.highest.height + o : 0;
    return this.isHorizontal() ? c * n > a * r ? a / n : c / r : c * r < a * n ? c / n : a / r;
  }
  _isVisible() {
    const t = this.options.display;
    return t !== "auto" ? !!t : this.getMatchingVisibleMetas().length > 0;
  }
  _computeGridLineItems(t) {
    const e = this.axis, n = this.chart, r = this.options, { grid: s, position: o } = r, a = s.offset, c = this.isHorizontal(), u = this.ticks.length + (a ? 1 : 0), h = ei(s), f = [], d = s.setContext(this.getContext()), p = d.drawBorder ? d.borderWidth : 0, g = p / 2, m = function(P) {
      return oe(n, P, p);
    };
    let y, b, v, _, x, k, E, O, M, C, V, q;
    if (o === "top")
      y = m(this.bottom), k = this.bottom - h, O = y - g, C = m(t.top) + g, q = t.bottom;
    else if (o === "bottom")
      y = m(this.top), C = t.top, q = m(t.bottom) - g, k = y + g, O = this.top + h;
    else if (o === "left")
      y = m(this.right), x = this.right - h, E = y - g, M = m(t.left) + g, V = t.right;
    else if (o === "right")
      y = m(this.left), M = t.left, V = m(t.right) - g, x = y + g, E = this.left + h;
    else if (e === "x") {
      if (o === "center")
        y = m((t.top + t.bottom) / 2 + 0.5);
      else if (L(o)) {
        const P = Object.keys(o)[0], G = o[P];
        y = m(this.chart.scales[P].getPixelForValue(G));
      }
      C = t.top, q = t.bottom, k = y + g, O = k + h;
    } else if (e === "y") {
      if (o === "center")
        y = m((t.left + t.right) / 2);
      else if (L(o)) {
        const P = Object.keys(o)[0], G = o[P];
        y = m(this.chart.scales[P].getPixelForValue(G));
      }
      x = y - g, E = x - h, M = t.left, V = t.right;
    }
    const Y = F(r.ticks.maxTicksLimit, u), rt = Math.max(1, Math.ceil(u / Y));
    for (b = 0; b < u; b += rt) {
      const P = s.setContext(this.getContext(b)), G = P.lineWidth, W = P.color, et = P.borderDash || [], we = P.borderDashOffset, ht = P.tickWidth, qt = P.tickColor, Lt = P.tickBorderDash || [], Ke = P.tickBorderDashOffset;
      v = Ed(this, b, a), v !== void 0 && (_ = oe(n, v, G), c ? x = E = M = V = _ : k = O = C = q = _, f.push({
        tx1: x,
        ty1: k,
        tx2: E,
        ty2: O,
        x1: M,
        y1: C,
        x2: V,
        y2: q,
        width: G,
        color: W,
        borderDash: et,
        borderDashOffset: we,
        tickWidth: ht,
        tickColor: qt,
        tickBorderDash: Lt,
        tickBorderDashOffset: Ke
      }));
    }
    return this._ticksLength = u, this._borderValue = y, f;
  }
  _computeLabelItems(t) {
    const e = this.axis, n = this.options, { position: r, ticks: s } = n, o = this.isHorizontal(), a = this.ticks, { align: c, crossAlign: l, padding: u, mirror: h } = s, f = ei(n.grid), d = f + u, p = h ? -u : d, g = -kt(this.labelRotation), m = [];
    let y, b, v, _, x, k, E, O, M, C, V, q, Y = "middle";
    if (r === "top")
      k = this.bottom - p, E = this._getXAxisLabelAlignment();
    else if (r === "bottom")
      k = this.top + p, E = this._getXAxisLabelAlignment();
    else if (r === "left") {
      const P = this._getYAxisLabelAlignment(f);
      E = P.textAlign, x = P.x;
    } else if (r === "right") {
      const P = this._getYAxisLabelAlignment(f);
      E = P.textAlign, x = P.x;
    } else if (e === "x") {
      if (r === "center")
        k = (t.top + t.bottom) / 2 + d;
      else if (L(r)) {
        const P = Object.keys(r)[0], G = r[P];
        k = this.chart.scales[P].getPixelForValue(G) + d;
      }
      E = this._getXAxisLabelAlignment();
    } else if (e === "y") {
      if (r === "center")
        x = (t.left + t.right) / 2 - d;
      else if (L(r)) {
        const P = Object.keys(r)[0], G = r[P];
        x = this.chart.scales[P].getPixelForValue(G);
      }
      E = this._getYAxisLabelAlignment(f).textAlign;
    }
    e === "y" && (c === "start" ? Y = "top" : c === "end" && (Y = "bottom"));
    const rt = this._getLabelSizes();
    for (y = 0, b = a.length; y < b; ++y) {
      v = a[y], _ = v.label;
      const P = s.setContext(this.getContext(y));
      O = this.getPixelForTick(y) + s.labelOffset, M = this._resolveTickFontOptions(y), C = M.lineHeight, V = H(_) ? _.length : 1;
      const G = V / 2, W = P.color, et = P.textStrokeColor, we = P.textStrokeWidth;
      let ht = E;
      o ? (x = O, E === "inner" && (y === b - 1 ? ht = this.options.reverse ? "left" : "right" : y === 0 ? ht = this.options.reverse ? "right" : "left" : ht = "center"), r === "top" ? l === "near" || g !== 0 ? q = -V * C + C / 2 : l === "center" ? q = -rt.highest.height / 2 - G * C + C : q = -rt.highest.height + C / 2 : l === "near" || g !== 0 ? q = C / 2 : l === "center" ? q = rt.highest.height / 2 - G * C : q = rt.highest.height - V * C, h && (q *= -1)) : (k = O, q = (1 - V) * C / 2);
      let qt;
      if (P.showLabelBackdrop) {
        const Lt = xt(P.backdropPadding), Ke = rt.heights[y], ir = rt.widths[y];
        let nr = k + q - Lt.top, rr = x - Lt.left;
        switch (Y) {
          case "middle":
            nr -= Ke / 2;
            break;
          case "bottom":
            nr -= Ke;
            break;
        }
        switch (E) {
          case "center":
            rr -= ir / 2;
            break;
          case "right":
            rr -= ir;
            break;
        }
        qt = {
          left: rr,
          top: nr,
          width: ir + Lt.width,
          height: Ke + Lt.height,
          color: P.backdropColor
        };
      }
      m.push({
        rotation: g,
        label: _,
        font: M,
        color: W,
        strokeColor: et,
        strokeWidth: we,
        textOffset: q,
        textAlign: ht,
        textBaseline: Y,
        translation: [x, k],
        backdrop: qt
      });
    }
    return m;
  }
  _getXAxisLabelAlignment() {
    const { position: t, ticks: e } = this.options;
    if (-kt(this.labelRotation))
      return t === "top" ? "left" : "right";
    let r = "center";
    return e.align === "start" ? r = "left" : e.align === "end" ? r = "right" : e.align === "inner" && (r = "inner"), r;
  }
  _getYAxisLabelAlignment(t) {
    const { position: e, ticks: { crossAlign: n, mirror: r, padding: s } } = this.options, o = this._getLabelSizes(), a = t + s, c = o.widest.width;
    let l, u;
    return e === "left" ? r ? (u = this.right + s, n === "near" ? l = "left" : n === "center" ? (l = "center", u += c / 2) : (l = "right", u += c)) : (u = this.right - a, n === "near" ? l = "right" : n === "center" ? (l = "center", u -= c / 2) : (l = "left", u = this.left)) : e === "right" ? r ? (u = this.left + s, n === "near" ? l = "right" : n === "center" ? (l = "center", u -= c / 2) : (l = "left", u -= c)) : (u = this.left + a, n === "near" ? l = "left" : n === "center" ? (l = "center", u += c / 2) : (l = "right", u = this.right)) : l = "right", { textAlign: l, x: u };
  }
  _computeLabelArea() {
    if (this.options.ticks.mirror)
      return;
    const t = this.chart, e = this.options.position;
    if (e === "left" || e === "right")
      return { top: 0, left: this.left, bottom: t.height, right: this.right };
    if (e === "top" || e === "bottom")
      return { top: this.top, left: 0, bottom: this.bottom, right: t.width };
  }
  drawBackground() {
    const { ctx: t, options: { backgroundColor: e }, left: n, top: r, width: s, height: o } = this;
    e && (t.save(), t.fillStyle = e, t.fillRect(n, r, s, o), t.restore());
  }
  getLineWidthForValue(t) {
    const e = this.options.grid;
    if (!this._isVisible() || !e.display)
      return 0;
    const r = this.ticks.findIndex((s) => s.value === t);
    return r >= 0 ? e.setContext(this.getContext(r)).lineWidth : 0;
  }
  drawGrid(t) {
    const e = this.options.grid, n = this.ctx, r = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(t));
    let s, o;
    const a = (c, l, u) => {
      !u.width || !u.color || (n.save(), n.lineWidth = u.width, n.strokeStyle = u.color, n.setLineDash(u.borderDash || []), n.lineDashOffset = u.borderDashOffset, n.beginPath(), n.moveTo(c.x, c.y), n.lineTo(l.x, l.y), n.stroke(), n.restore());
    };
    if (e.display)
      for (s = 0, o = r.length; s < o; ++s) {
        const c = r[s];
        e.drawOnChartArea && a(
          { x: c.x1, y: c.y1 },
          { x: c.x2, y: c.y2 },
          c
        ), e.drawTicks && a(
          { x: c.tx1, y: c.ty1 },
          { x: c.tx2, y: c.ty2 },
          {
            color: c.tickColor,
            width: c.tickWidth,
            borderDash: c.tickBorderDash,
            borderDashOffset: c.tickBorderDashOffset
          }
        );
      }
  }
  drawBorder() {
    const { chart: t, ctx: e, options: { grid: n } } = this, r = n.setContext(this.getContext()), s = n.drawBorder ? r.borderWidth : 0;
    if (!s)
      return;
    const o = n.setContext(this.getContext(0)).lineWidth, a = this._borderValue;
    let c, l, u, h;
    this.isHorizontal() ? (c = oe(t, this.left, s) - s / 2, l = oe(t, this.right, o) + o / 2, u = h = a) : (u = oe(t, this.top, s) - s / 2, h = oe(t, this.bottom, o) + o / 2, c = l = a), e.save(), e.lineWidth = r.borderWidth, e.strokeStyle = r.borderColor, e.beginPath(), e.moveTo(c, u), e.lineTo(l, h), e.stroke(), e.restore();
  }
  drawLabels(t) {
    if (!this.options.ticks.display)
      return;
    const n = this.ctx, r = this._computeLabelArea();
    r && al(n, r);
    const s = this._labelItems || (this._labelItems = this._computeLabelItems(t));
    let o, a;
    for (o = 0, a = s.length; o < a; ++o) {
      const c = s[o], l = c.font, u = c.label;
      c.backdrop && (n.fillStyle = c.backdrop.color, n.fillRect(c.backdrop.left, c.backdrop.top, c.backdrop.width, c.backdrop.height));
      let h = c.textOffset;
      kn(n, u, 0, h, l, c);
    }
    r && cl(n);
  }
  drawTitle() {
    const { ctx: t, options: { position: e, title: n, reverse: r } } = this;
    if (!n.display)
      return;
    const s = gt(n.font), o = xt(n.padding), a = n.align;
    let c = s.lineHeight / 2;
    e === "bottom" || e === "center" || L(e) ? (c += o.bottom, H(n.text) && (c += s.lineHeight * (n.text.length - 1))) : c += o.top;
    const { titleX: l, titleY: u, maxWidth: h, rotation: f } = Md(this, c, e, a);
    kn(t, n.text, 0, 0, s, {
      color: n.color,
      maxWidth: h,
      rotation: f,
      textAlign: Td(a, e, r),
      textBaseline: "middle",
      translation: [l, u]
    });
  }
  draw(t) {
    !this._isVisible() || (this.drawBackground(), this.drawGrid(t), this.drawBorder(), this.drawTitle(), this.drawLabels(t));
  }
  _layers() {
    const t = this.options, e = t.ticks && t.ticks.z || 0, n = F(t.grid && t.grid.z, -1);
    return !this._isVisible() || this.draw !== be.prototype.draw ? [{
      z: e,
      draw: (r) => {
        this.draw(r);
      }
    }] : [{
      z: n,
      draw: (r) => {
        this.drawBackground(), this.drawGrid(r), this.drawTitle();
      }
    }, {
      z: n + 1,
      draw: () => {
        this.drawBorder();
      }
    }, {
      z: e,
      draw: (r) => {
        this.drawLabels(r);
      }
    }];
  }
  getMatchingVisibleMetas(t) {
    const e = this.chart.getSortedVisibleDatasetMetas(), n = this.axis + "AxisID", r = [];
    let s, o;
    for (s = 0, o = e.length; s < o; ++s) {
      const a = e[s];
      a[n] === this.id && (!t || a.type === t) && r.push(a);
    }
    return r;
  }
  _resolveTickFontOptions(t) {
    const e = this.options.ticks.setContext(this.getContext(t));
    return gt(e.font);
  }
  _maxDigits() {
    const t = this._resolveTickFontOptions(0).lineHeight;
    return (this.isHorizontal() ? this.width : this.height) / t;
  }
}
class Ki {
  constructor(t, e, n) {
    this.type = t, this.scope = e, this.override = n, this.items = /* @__PURE__ */ Object.create(null);
  }
  isForType(t) {
    return Object.prototype.isPrototypeOf.call(this.type.prototype, t.prototype);
  }
  register(t) {
    const e = Object.getPrototypeOf(t);
    let n;
    Pd(e) && (n = this.register(e));
    const r = this.items, s = t.id, o = this.scope + "." + s;
    if (!s)
      throw new Error("class does not have id: " + t);
    return s in r || (r[s] = t, Ad(t, o, n), this.override && I.override(t.id, t.overrides)), o;
  }
  get(t) {
    return this.items[t];
  }
  unregister(t) {
    const e = this.items, n = t.id, r = this.scope;
    n in e && delete e[n], r && n in I[r] && (delete I[r][n], this.override && delete ge[n]);
  }
}
function Ad(i, t, e) {
  const n = Oi(/* @__PURE__ */ Object.create(null), [
    e ? I.get(e) : {},
    I.get(t),
    i.defaults
  ]);
  I.set(t, n), i.defaultRoutes && Cd(t, i.defaultRoutes), i.descriptors && I.describe(t, i.descriptors);
}
function Cd(i, t) {
  Object.keys(t).forEach((e) => {
    const n = e.split("."), r = n.pop(), s = [i].concat(n).join("."), o = t[e].split("."), a = o.pop(), c = o.join(".");
    I.route(s, r, c, a);
  });
}
function Pd(i) {
  return "id" in i && "defaults" in i;
}
class Rd {
  constructor() {
    this.controllers = new Ki(Ot, "datasets", !0), this.elements = new Ki($t, "elements"), this.plugins = new Ki(Object, "plugins"), this.scales = new Ki(be, "scales"), this._typedRegistries = [this.controllers, this.scales, this.elements];
  }
  add(...t) {
    this._each("register", t);
  }
  remove(...t) {
    this._each("unregister", t);
  }
  addControllers(...t) {
    this._each("register", t, this.controllers);
  }
  addElements(...t) {
    this._each("register", t, this.elements);
  }
  addPlugins(...t) {
    this._each("register", t, this.plugins);
  }
  addScales(...t) {
    this._each("register", t, this.scales);
  }
  getController(t) {
    return this._get(t, this.controllers, "controller");
  }
  getElement(t) {
    return this._get(t, this.elements, "element");
  }
  getPlugin(t) {
    return this._get(t, this.plugins, "plugin");
  }
  getScale(t) {
    return this._get(t, this.scales, "scale");
  }
  removeControllers(...t) {
    this._each("unregister", t, this.controllers);
  }
  removeElements(...t) {
    this._each("unregister", t, this.elements);
  }
  removePlugins(...t) {
    this._each("unregister", t, this.plugins);
  }
  removeScales(...t) {
    this._each("unregister", t, this.scales);
  }
  _each(t, e, n) {
    [...e].forEach((r) => {
      const s = n || this._getRegistryForType(r);
      n || s.isForType(r) || s === this.plugins && r.id ? this._exec(t, s, r) : j(r, (o) => {
        const a = n || this._getRegistryForType(o);
        this._exec(t, a, o);
      });
    });
  }
  _exec(t, e, n) {
    const r = Ts(t);
    X(n["before" + r], [], n), e[t](n), X(n["after" + r], [], n);
  }
  _getRegistryForType(t) {
    for (let e = 0; e < this._typedRegistries.length; e++) {
      const n = this._typedRegistries[e];
      if (n.isForType(t))
        return n;
    }
    return this.plugins;
  }
  _get(t, e, n) {
    const r = e.get(t);
    if (r === void 0)
      throw new Error('"' + t + '" is not a registered ' + n + ".");
    return r;
  }
}
var Pt = new Rd();
class qs extends Ot {
  update(t) {
    const e = this._cachedMeta, { data: n = [] } = e, r = this.chart._animationsDisabled;
    let { start: s, count: o } = tl(e, n, r);
    if (this._drawStart = s, this._drawCount = o, el(e) && (s = 0, o = n.length), this.options.showLine) {
      const { dataset: a, _dataset: c } = e;
      a._chart = this.chart, a._datasetIndex = this.index, a._decimated = !!c._decimated, a.points = n;
      const l = this.resolveDatasetElementOptions(t);
      l.segment = this.options.segment, this.updateElement(a, void 0, {
        animated: !r,
        options: l
      }, t);
    }
    this.updateElements(n, s, o, t);
  }
  addElements() {
    const { showLine: t } = this.options;
    !this.datasetElementType && t && (this.datasetElementType = Pt.getElement("line")), super.addElements();
  }
  updateElements(t, e, n, r) {
    const s = r === "reset", { iScale: o, vScale: a, _stacked: c, _dataset: l } = this._cachedMeta, u = this.resolveDataElementOptions(e, r), h = this.getSharedOptions(u), f = this.includeOptions(r, h), d = o.axis, p = a.axis, { spanGaps: g, segment: m } = this.options, y = $e(g) ? g : Number.POSITIVE_INFINITY, b = this.chart._animationsDisabled || s || r === "none";
    let v = e > 0 && this.getParsed(e - 1);
    for (let _ = e; _ < e + n; ++_) {
      const x = t[_], k = this.getParsed(_), E = b ? x : {}, O = $(k[p]), M = E[d] = o.getPixelForValue(k[d], _), C = E[p] = s || O ? a.getBasePixel() : a.getPixelForValue(c ? this.applyStack(a, k, c) : k[p], _);
      E.skip = isNaN(M) || isNaN(C) || O, E.stop = _ > 0 && Math.abs(k[d] - v[d]) > y, m && (E.parsed = k, E.raw = l.data[_]), f && (E.options = h || this.resolveDataElementOptions(_, x.active ? "active" : r)), b || this.updateElement(x, _, E, r), v = k;
    }
    this.updateSharedOptions(h, r, u);
  }
  getMaxOverflow() {
    const t = this._cachedMeta, e = t.data || [];
    if (!this.options.showLine) {
      let a = 0;
      for (let c = e.length - 1; c >= 0; --c)
        a = Math.max(a, e[c].size(this.resolveDataElementOptions(c)) / 2);
      return a > 0 && a;
    }
    const n = t.dataset, r = n.options && n.options.borderWidth || 0;
    if (!e.length)
      return r;
    const s = e[0].size(this.resolveDataElementOptions(0)), o = e[e.length - 1].size(this.resolveDataElementOptions(e.length - 1));
    return Math.max(r, s, o) / 2;
  }
}
qs.id = "scatter";
qs.defaults = {
  datasetElementType: !1,
  dataElementType: "point",
  showLine: !1,
  fill: !1
};
qs.overrides = {
  interaction: {
    mode: "point"
  },
  plugins: {
    tooltip: {
      callbacks: {
        title() {
          return "";
        },
        label(i) {
          return "(" + i.label + ", " + i.formattedValue + ")";
        }
      }
    }
  },
  scales: {
    x: {
      type: "linear"
    },
    y: {
      type: "linear"
    }
  }
};
function ae() {
  throw new Error("This method is not implemented: Check that a complete date adapter is provided.");
}
class Qr {
  constructor(t) {
    this.options = t || {};
  }
  init(t) {
  }
  formats() {
    return ae();
  }
  parse(t, e) {
    return ae();
  }
  format(t, e) {
    return ae();
  }
  add(t, e, n) {
    return ae();
  }
  diff(t, e, n) {
    return ae();
  }
  startOf(t, e, n) {
    return ae();
  }
  endOf(t, e) {
    return ae();
  }
}
Qr.override = function(i) {
  Object.assign(Qr.prototype, i);
};
var Id = {
  _date: Qr
};
function Fd(i, t, e, n) {
  const { controller: r, data: s, _sorted: o } = i, a = r._cachedMeta.iScale;
  if (a && t === a.axis && t !== "r" && o && s.length) {
    const c = a._reversePixels ? yh : ue;
    if (n) {
      if (r._sharedOptions) {
        const l = s[0], u = typeof l.getRange == "function" && l.getRange(t);
        if (u) {
          const h = c(s, t, e - u), f = c(s, t, e + u);
          return { lo: h.lo, hi: f.hi };
        }
      }
    } else
      return c(s, t, e);
  }
  return { lo: 0, hi: s.length - 1 };
}
function Bi(i, t, e, n, r) {
  const s = i.getSortedVisibleDatasetMetas(), o = e[t];
  for (let a = 0, c = s.length; a < c; ++a) {
    const { index: l, data: u } = s[a], { lo: h, hi: f } = Fd(s[a], t, o, r);
    for (let d = h; d <= f; ++d) {
      const p = u[d];
      p.skip || n(p, l, d);
    }
  }
}
function Ld(i) {
  const t = i.indexOf("x") !== -1, e = i.indexOf("y") !== -1;
  return function(n, r) {
    const s = t ? Math.abs(n.x - r.x) : 0, o = e ? Math.abs(n.y - r.y) : 0;
    return Math.sqrt(Math.pow(s, 2) + Math.pow(o, 2));
  };
}
function vr(i, t, e, n, r) {
  const s = [];
  return !r && !i.isPointInArea(t) || Bi(i, e, t, function(a, c, l) {
    !r && !Ti(a, i.chartArea, 0) || a.inRange(t.x, t.y, n) && s.push({ element: a, datasetIndex: c, index: l });
  }, !0), s;
}
function Nd(i, t, e, n) {
  let r = [];
  function s(o, a, c) {
    const { startAngle: l, endAngle: u } = o.getProps(["startAngle", "endAngle"], n), { angle: h } = Gc(o, { x: t.x, y: t.y });
    Di(h, l, u) && r.push({ element: o, datasetIndex: a, index: c });
  }
  return Bi(i, e, t, s), r;
}
function Vd(i, t, e, n, r, s) {
  let o = [];
  const a = Ld(e);
  let c = Number.POSITIVE_INFINITY;
  function l(u, h, f) {
    const d = u.inRange(t.x, t.y, r);
    if (n && !d)
      return;
    const p = u.getCenterPoint(r);
    if (!(!!s || i.isPointInArea(p)) && !d)
      return;
    const m = a(t, p);
    m < c ? (o = [{ element: u, datasetIndex: h, index: f }], c = m) : m === c && o.push({ element: u, datasetIndex: h, index: f });
  }
  return Bi(i, e, t, l), o;
}
function br(i, t, e, n, r, s) {
  return !s && !i.isPointInArea(t) ? [] : e === "r" && !n ? Nd(i, t, e, r) : Vd(i, t, e, n, r, s);
}
function ya(i, t, e, n, r) {
  const s = [], o = e === "x" ? "inXRange" : "inYRange";
  let a = !1;
  return Bi(i, e, t, (c, l, u) => {
    c[o](t[e], r) && (s.push({ element: c, datasetIndex: l, index: u }), a = a || c.inRange(t.x, t.y, r));
  }), n && !a ? [] : s;
}
var jd = {
  evaluateInteractionItems: Bi,
  modes: {
    index(i, t, e, n) {
      const r = ce(t, i), s = e.axis || "x", o = e.includeInvisible || !1, a = e.intersect ? vr(i, r, s, n, o) : br(i, r, s, !1, n, o), c = [];
      return a.length ? (i.getSortedVisibleDatasetMetas().forEach((l) => {
        const u = a[0].index, h = l.data[u];
        h && !h.skip && c.push({ element: h, datasetIndex: l.index, index: u });
      }), c) : [];
    },
    dataset(i, t, e, n) {
      const r = ce(t, i), s = e.axis || "xy", o = e.includeInvisible || !1;
      let a = e.intersect ? vr(i, r, s, n, o) : br(i, r, s, !1, n, o);
      if (a.length > 0) {
        const c = a[0].datasetIndex, l = i.getDatasetMeta(c).data;
        a = [];
        for (let u = 0; u < l.length; ++u)
          a.push({ element: l[u], datasetIndex: c, index: u });
      }
      return a;
    },
    point(i, t, e, n) {
      const r = ce(t, i), s = e.axis || "xy", o = e.includeInvisible || !1;
      return vr(i, r, s, n, o);
    },
    nearest(i, t, e, n) {
      const r = ce(t, i), s = e.axis || "xy", o = e.includeInvisible || !1;
      return br(i, r, s, e.intersect, n, o);
    },
    x(i, t, e, n) {
      const r = ce(t, i);
      return ya(i, r, "x", e.intersect, n);
    },
    y(i, t, e, n) {
      const r = ce(t, i);
      return ya(i, r, "y", e.intersect, n);
    }
  }
};
const Sl = ["left", "top", "right", "bottom"];
function ii(i, t) {
  return i.filter((e) => e.pos === t);
}
function va(i, t) {
  return i.filter((e) => Sl.indexOf(e.pos) === -1 && e.box.axis === t);
}
function ni(i, t) {
  return i.sort((e, n) => {
    const r = t ? n : e, s = t ? e : n;
    return r.weight === s.weight ? r.index - s.index : r.weight - s.weight;
  });
}
function Bd(i) {
  const t = [];
  let e, n, r, s, o, a;
  for (e = 0, n = (i || []).length; e < n; ++e)
    r = i[e], { position: s, options: { stack: o, stackWeight: a = 1 } } = r, t.push({
      index: e,
      box: r,
      pos: s,
      horizontal: r.isHorizontal(),
      weight: r.weight,
      stack: o && s + o,
      stackWeight: a
    });
  return t;
}
function $d(i) {
  const t = {};
  for (const e of i) {
    const { stack: n, pos: r, stackWeight: s } = e;
    if (!n || !Sl.includes(r))
      continue;
    const o = t[n] || (t[n] = { count: 0, placed: 0, weight: 0, size: 0 });
    o.count++, o.weight += s;
  }
  return t;
}
function zd(i, t) {
  const e = $d(i), { vBoxMaxWidth: n, hBoxMaxHeight: r } = t;
  let s, o, a;
  for (s = 0, o = i.length; s < o; ++s) {
    a = i[s];
    const { fullSize: c } = a.box, l = e[a.stack], u = l && a.stackWeight / l.weight;
    a.horizontal ? (a.width = u ? u * n : c && t.availableWidth, a.height = r) : (a.width = n, a.height = u ? u * r : c && t.availableHeight);
  }
  return e;
}
function qd(i) {
  const t = Bd(i), e = ni(t.filter((l) => l.box.fullSize), !0), n = ni(ii(t, "left"), !0), r = ni(ii(t, "right")), s = ni(ii(t, "top"), !0), o = ni(ii(t, "bottom")), a = va(t, "x"), c = va(t, "y");
  return {
    fullSize: e,
    leftAndTop: n.concat(s),
    rightAndBottom: r.concat(c).concat(o).concat(a),
    chartArea: ii(t, "chartArea"),
    vertical: n.concat(r).concat(c),
    horizontal: s.concat(o).concat(a)
  };
}
function ba(i, t, e, n) {
  return Math.max(i[e], t[e]) + Math.max(i[n], t[n]);
}
function El(i, t) {
  i.top = Math.max(i.top, t.top), i.left = Math.max(i.left, t.left), i.bottom = Math.max(i.bottom, t.bottom), i.right = Math.max(i.right, t.right);
}
function Qd(i, t, e, n) {
  const { pos: r, box: s } = e, o = i.maxPadding;
  if (!L(r)) {
    e.size && (i[r] -= e.size);
    const h = n[e.stack] || { size: 0, count: 1 };
    h.size = Math.max(h.size, e.horizontal ? s.height : s.width), e.size = h.size / h.count, i[r] += e.size;
  }
  s.getPadding && El(o, s.getPadding());
  const a = Math.max(0, t.outerWidth - ba(o, i, "left", "right")), c = Math.max(0, t.outerHeight - ba(o, i, "top", "bottom")), l = a !== i.w, u = c !== i.h;
  return i.w = a, i.h = c, e.horizontal ? { same: l, other: u } : { same: u, other: l };
}
function Ud(i) {
  const t = i.maxPadding;
  function e(n) {
    const r = Math.max(t[n] - i[n], 0);
    return i[n] += r, r;
  }
  i.y += e("top"), i.x += e("left"), e("right"), e("bottom");
}
function Wd(i, t) {
  const e = t.maxPadding;
  function n(r) {
    const s = { left: 0, top: 0, right: 0, bottom: 0 };
    return r.forEach((o) => {
      s[o] = Math.max(t[o], e[o]);
    }), s;
  }
  return n(i ? ["left", "right"] : ["top", "bottom"]);
}
function hi(i, t, e, n) {
  const r = [];
  let s, o, a, c, l, u;
  for (s = 0, o = i.length, l = 0; s < o; ++s) {
    a = i[s], c = a.box, c.update(
      a.width || t.w,
      a.height || t.h,
      Wd(a.horizontal, t)
    );
    const { same: h, other: f } = Qd(t, e, a, n);
    l |= h && r.length, u = u || f, c.fullSize || r.push(a);
  }
  return l && hi(r, t, e, n) || u;
}
function Ji(i, t, e, n, r) {
  i.top = e, i.left = t, i.right = t + n, i.bottom = e + r, i.width = n, i.height = r;
}
function _a(i, t, e, n) {
  const r = e.padding;
  let { x: s, y: o } = t;
  for (const a of i) {
    const c = a.box, l = n[a.stack] || { count: 1, placed: 0, weight: 1 }, u = a.stackWeight / l.weight || 1;
    if (a.horizontal) {
      const h = t.w * u, f = l.size || c.height;
      _t(l.start) && (o = l.start), c.fullSize ? Ji(c, r.left, o, e.outerWidth - r.right - r.left, f) : Ji(c, t.left + l.placed, o, h, f), l.start = o, l.placed += h, o = c.bottom;
    } else {
      const h = t.h * u, f = l.size || c.width;
      _t(l.start) && (s = l.start), c.fullSize ? Ji(c, s, r.top, f, e.outerHeight - r.bottom - r.top) : Ji(c, s, t.top + l.placed, f, h), l.start = s, l.placed += h, s = c.right;
    }
  }
  t.x = s, t.y = o;
}
I.set("layout", {
  autoPadding: !0,
  padding: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  }
});
var Zi = {
  addBox(i, t) {
    i.boxes || (i.boxes = []), t.fullSize = t.fullSize || !1, t.position = t.position || "top", t.weight = t.weight || 0, t._layers = t._layers || function() {
      return [{
        z: 0,
        draw(e) {
          t.draw(e);
        }
      }];
    }, i.boxes.push(t);
  },
  removeBox(i, t) {
    const e = i.boxes ? i.boxes.indexOf(t) : -1;
    e !== -1 && i.boxes.splice(e, 1);
  },
  configure(i, t, e) {
    t.fullSize = e.fullSize, t.position = e.position, t.weight = e.weight;
  },
  update(i, t, e, n) {
    if (!i)
      return;
    const r = xt(i.options.layout.padding), s = Math.max(t - r.width, 0), o = Math.max(e - r.height, 0), a = qd(i.boxes), c = a.vertical, l = a.horizontal;
    j(i.boxes, (g) => {
      typeof g.beforeLayout == "function" && g.beforeLayout();
    });
    const u = c.reduce((g, m) => m.box.options && m.box.options.display === !1 ? g : g + 1, 0) || 1, h = Object.freeze({
      outerWidth: t,
      outerHeight: e,
      padding: r,
      availableWidth: s,
      availableHeight: o,
      vBoxMaxWidth: s / 2 / u,
      hBoxMaxHeight: o / 2
    }), f = Object.assign({}, r);
    El(f, xt(n));
    const d = Object.assign({
      maxPadding: f,
      w: s,
      h: o,
      x: r.left,
      y: r.top
    }, r), p = zd(c.concat(l), h);
    hi(a.fullSize, d, h, p), hi(c, d, h, p), hi(l, d, h, p) && hi(c, d, h, p), Ud(d), _a(a.leftAndTop, d, h, p), d.x += d.w, d.y += d.h, _a(a.rightAndBottom, d, h, p), i.chartArea = {
      left: d.left,
      top: d.top,
      right: d.left + d.w,
      bottom: d.top + d.h,
      height: d.h,
      width: d.w
    }, j(a.chartArea, (g) => {
      const m = g.box;
      Object.assign(m, i.chartArea), m.update(d.w, d.h, { left: 0, top: 0, right: 0, bottom: 0 });
    });
  }
};
class kl {
  acquireContext(t, e) {
  }
  releaseContext(t) {
    return !1;
  }
  addEventListener(t, e, n) {
  }
  removeEventListener(t, e, n) {
  }
  getDevicePixelRatio() {
    return 1;
  }
  getMaximumSize(t, e, n, r) {
    return e = Math.max(0, e || t.width), n = n || t.height, {
      width: e,
      height: Math.max(0, r ? Math.floor(e / r) : n)
    };
  }
  isAttached(t) {
    return !0;
  }
  updateConfig(t) {
  }
}
class Hd extends kl {
  acquireContext(t) {
    return t && t.getContext && t.getContext("2d") || null;
  }
  updateConfig(t) {
    t.options.animation = !1;
  }
}
const cn = "$chartjs", Yd = {
  touchstart: "mousedown",
  touchmove: "mousemove",
  touchend: "mouseup",
  pointerenter: "mouseenter",
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointerleave: "mouseout",
  pointerout: "mouseout"
}, xa = (i) => i === null || i === "";
function Gd(i, t) {
  const e = i.style, n = i.getAttribute("height"), r = i.getAttribute("width");
  if (i[cn] = {
    initial: {
      height: n,
      width: r,
      style: {
        display: e.display,
        height: e.height,
        width: e.width
      }
    }
  }, e.display = e.display || "block", e.boxSizing = e.boxSizing || "border-box", xa(r)) {
    const s = Zo(i, "width");
    s !== void 0 && (i.width = s);
  }
  if (xa(n))
    if (i.style.height === "")
      i.height = i.width / (t || 2);
    else {
      const s = Zo(i, "height");
      s !== void 0 && (i.height = s);
    }
  return i;
}
const Ol = Of ? { passive: !0 } : !1;
function Xd(i, t, e) {
  i.addEventListener(t, e, Ol);
}
function Kd(i, t, e) {
  i.canvas.removeEventListener(t, e, Ol);
}
function Jd(i, t) {
  const e = Yd[i.type] || i.type, { x: n, y: r } = ce(i, t);
  return {
    type: e,
    chart: t,
    native: i,
    x: n !== void 0 ? n : null,
    y: r !== void 0 ? r : null
  };
}
function Tn(i, t) {
  for (const e of i)
    if (e === t || e.contains(t))
      return !0;
}
function Zd(i, t, e) {
  const n = i.canvas, r = new MutationObserver((s) => {
    let o = !1;
    for (const a of s)
      o = o || Tn(a.addedNodes, n), o = o && !Tn(a.removedNodes, n);
    o && e();
  });
  return r.observe(document, { childList: !0, subtree: !0 }), r;
}
function tp(i, t, e) {
  const n = i.canvas, r = new MutationObserver((s) => {
    let o = !1;
    for (const a of s)
      o = o || Tn(a.removedNodes, n), o = o && !Tn(a.addedNodes, n);
    o && e();
  });
  return r.observe(document, { childList: !0, subtree: !0 }), r;
}
const Mi = /* @__PURE__ */ new Map();
let wa = 0;
function Dl() {
  const i = window.devicePixelRatio;
  i !== wa && (wa = i, Mi.forEach((t, e) => {
    e.currentDevicePixelRatio !== i && t();
  }));
}
function ep(i, t) {
  Mi.size || window.addEventListener("resize", Dl), Mi.set(i, t);
}
function ip(i) {
  Mi.delete(i), Mi.size || window.removeEventListener("resize", Dl);
}
function np(i, t, e) {
  const n = i.canvas, r = n && Vs(n);
  if (!r)
    return;
  const s = Zc((a, c) => {
    const l = r.clientWidth;
    e(a, c), l < r.clientWidth && e();
  }, window), o = new ResizeObserver((a) => {
    const c = a[0], l = c.contentRect.width, u = c.contentRect.height;
    l === 0 && u === 0 || s(l, u);
  });
  return o.observe(r), ep(i, s), o;
}
function _r(i, t, e) {
  e && e.disconnect(), t === "resize" && ip(i);
}
function rp(i, t, e) {
  const n = i.canvas, r = Zc((s) => {
    i.ctx !== null && e(Jd(s, i));
  }, i, (s) => {
    const o = s[0];
    return [o, o.offsetX, o.offsetY];
  });
  return Xd(n, t, r), r;
}
class sp extends kl {
  acquireContext(t, e) {
    const n = t && t.getContext && t.getContext("2d");
    return n && n.canvas === t ? (Gd(t, e), n) : null;
  }
  releaseContext(t) {
    const e = t.canvas;
    if (!e[cn])
      return !1;
    const n = e[cn].initial;
    ["height", "width"].forEach((s) => {
      const o = n[s];
      $(o) ? e.removeAttribute(s) : e.setAttribute(s, o);
    });
    const r = n.style || {};
    return Object.keys(r).forEach((s) => {
      e.style[s] = r[s];
    }), e.width = e.width, delete e[cn], !0;
  }
  addEventListener(t, e, n) {
    this.removeEventListener(t, e);
    const r = t.$proxies || (t.$proxies = {}), o = {
      attach: Zd,
      detach: tp,
      resize: np
    }[e] || rp;
    r[e] = o(t, e, n);
  }
  removeEventListener(t, e) {
    const n = t.$proxies || (t.$proxies = {}), r = n[e];
    if (!r)
      return;
    ({
      attach: _r,
      detach: _r,
      resize: _r
    }[e] || Kd)(t, e, r), n[e] = void 0;
  }
  getDevicePixelRatio() {
    return window.devicePixelRatio;
  }
  getMaximumSize(t, e, n, r) {
    return kf(t, e, n, r);
  }
  isAttached(t) {
    const e = Vs(t);
    return !!(e && e.isConnected);
  }
}
function op(i) {
  return !ml() || typeof OffscreenCanvas < "u" && i instanceof OffscreenCanvas ? Hd : sp;
}
class ap {
  constructor() {
    this._init = [];
  }
  notify(t, e, n, r) {
    e === "beforeInit" && (this._init = this._createDescriptors(t, !0), this._notify(this._init, t, "install"));
    const s = r ? this._descriptors(t).filter(r) : this._descriptors(t), o = this._notify(s, t, e, n);
    return e === "afterDestroy" && (this._notify(s, t, "stop"), this._notify(this._init, t, "uninstall")), o;
  }
  _notify(t, e, n, r) {
    r = r || {};
    for (const s of t) {
      const o = s.plugin, a = o[n], c = [e, r, s.options];
      if (X(a, c, o) === !1 && r.cancelable)
        return !1;
    }
    return !0;
  }
  invalidate() {
    $(this._cache) || (this._oldCache = this._cache, this._cache = void 0);
  }
  _descriptors(t) {
    if (this._cache)
      return this._cache;
    const e = this._cache = this._createDescriptors(t);
    return this._notifyStateChanges(t), e;
  }
  _createDescriptors(t, e) {
    const n = t && t.config, r = F(n.options && n.options.plugins, {}), s = cp(n);
    return r === !1 && !e ? [] : up(t, s, r, e);
  }
  _notifyStateChanges(t) {
    const e = this._oldCache || [], n = this._cache, r = (s, o) => s.filter((a) => !o.some((c) => a.plugin.id === c.plugin.id));
    this._notify(r(e, n), t, "stop"), this._notify(r(n, e), t, "start");
  }
}
function cp(i) {
  const t = {}, e = [], n = Object.keys(Pt.plugins.items);
  for (let s = 0; s < n.length; s++)
    e.push(Pt.getPlugin(n[s]));
  const r = i.plugins || [];
  for (let s = 0; s < r.length; s++) {
    const o = r[s];
    e.indexOf(o) === -1 && (e.push(o), t[o.id] = !0);
  }
  return { plugins: e, localIds: t };
}
function lp(i, t) {
  return !t && i === !1 ? null : i === !0 ? {} : i;
}
function up(i, { plugins: t, localIds: e }, n, r) {
  const s = [], o = i.getContext();
  for (const a of t) {
    const c = a.id, l = lp(n[c], r);
    l !== null && s.push({
      plugin: a,
      options: hp(i.config, { plugin: a, local: e[c] }, l, o)
    });
  }
  return s;
}
function hp(i, { plugin: t, local: e }, n, r) {
  const s = i.pluginScopeKeys(t), o = i.getOptionScopes(n, s);
  return e && t.defaults && o.push(t.defaults), i.createResolver(o, r, [""], {
    scriptable: !1,
    indexable: !1,
    allKeys: !0
  });
}
function Ur(i, t) {
  const e = I.datasets[i] || {};
  return ((t.datasets || {})[i] || {}).indexAxis || t.indexAxis || e.indexAxis || "x";
}
function fp(i, t) {
  let e = i;
  return i === "_index_" ? e = t : i === "_value_" && (e = t === "x" ? "y" : "x"), e;
}
function dp(i, t) {
  return i === t ? "_index_" : "_value_";
}
function pp(i) {
  if (i === "top" || i === "bottom")
    return "x";
  if (i === "left" || i === "right")
    return "y";
}
function Wr(i, t) {
  return i === "x" || i === "y" ? i : t.axis || pp(t.position) || i.charAt(0).toLowerCase();
}
function gp(i, t) {
  const e = ge[i.type] || { scales: {} }, n = t.scales || {}, r = Ur(i.type, t), s = /* @__PURE__ */ Object.create(null), o = /* @__PURE__ */ Object.create(null);
  return Object.keys(n).forEach((a) => {
    const c = n[a];
    if (!L(c))
      return console.error(`Invalid scale configuration for scale: ${a}`);
    if (c._proxy)
      return console.warn(`Ignoring resolver passed as options for scale: ${a}`);
    const l = Wr(a, c), u = dp(l, r), h = e.scales || {};
    s[l] = s[l] || a, o[a] = gi(/* @__PURE__ */ Object.create(null), [{ axis: l }, c, h[l], h[u]]);
  }), i.data.datasets.forEach((a) => {
    const c = a.type || i.type, l = a.indexAxis || Ur(c, t), h = (ge[c] || {}).scales || {};
    Object.keys(h).forEach((f) => {
      const d = fp(f, l), p = a[d + "AxisID"] || s[d] || d;
      o[p] = o[p] || /* @__PURE__ */ Object.create(null), gi(o[p], [{ axis: d }, n[p], h[f]]);
    });
  }), Object.keys(o).forEach((a) => {
    const c = o[a];
    gi(c, [I.scales[c.type], I.scale]);
  }), o;
}
function Tl(i) {
  const t = i.options || (i.options = {});
  t.plugins = F(t.plugins, {}), t.scales = gp(i, t);
}
function Ml(i) {
  return i = i || {}, i.datasets = i.datasets || [], i.labels = i.labels || [], i;
}
function mp(i) {
  return i = i || {}, i.data = Ml(i.data), Tl(i), i;
}
const Sa = /* @__PURE__ */ new Map(), Al = /* @__PURE__ */ new Set();
function tn(i, t) {
  let e = Sa.get(i);
  return e || (e = t(), Sa.set(i, e), Al.add(e)), e;
}
const ri = (i, t, e) => {
  const n = te(t, e);
  n !== void 0 && i.add(n);
};
class yp {
  constructor(t) {
    this._config = mp(t), this._scopeCache = /* @__PURE__ */ new Map(), this._resolverCache = /* @__PURE__ */ new Map();
  }
  get platform() {
    return this._config.platform;
  }
  get type() {
    return this._config.type;
  }
  set type(t) {
    this._config.type = t;
  }
  get data() {
    return this._config.data;
  }
  set data(t) {
    this._config.data = Ml(t);
  }
  get options() {
    return this._config.options;
  }
  set options(t) {
    this._config.options = t;
  }
  get plugins() {
    return this._config.plugins;
  }
  update() {
    const t = this._config;
    this.clearCache(), Tl(t);
  }
  clearCache() {
    this._scopeCache.clear(), this._resolverCache.clear();
  }
  datasetScopeKeys(t) {
    return tn(
      t,
      () => [[
        `datasets.${t}`,
        ""
      ]]
    );
  }
  datasetAnimationScopeKeys(t, e) {
    return tn(
      `${t}.transition.${e}`,
      () => [
        [
          `datasets.${t}.transitions.${e}`,
          `transitions.${e}`
        ],
        [
          `datasets.${t}`,
          ""
        ]
      ]
    );
  }
  datasetElementScopeKeys(t, e) {
    return tn(
      `${t}-${e}`,
      () => [[
        `datasets.${t}.elements.${e}`,
        `datasets.${t}`,
        `elements.${e}`,
        ""
      ]]
    );
  }
  pluginScopeKeys(t) {
    const e = t.id, n = this.type;
    return tn(
      `${n}-plugin-${e}`,
      () => [[
        `plugins.${e}`,
        ...t.additionalOptionScopes || []
      ]]
    );
  }
  _cachedScopes(t, e) {
    const n = this._scopeCache;
    let r = n.get(t);
    return (!r || e) && (r = /* @__PURE__ */ new Map(), n.set(t, r)), r;
  }
  getOptionScopes(t, e, n) {
    const { options: r, type: s } = this, o = this._cachedScopes(t, n), a = o.get(e);
    if (a)
      return a;
    const c = /* @__PURE__ */ new Set();
    e.forEach((u) => {
      t && (c.add(t), u.forEach((h) => ri(c, t, h))), u.forEach((h) => ri(c, r, h)), u.forEach((h) => ri(c, ge[s] || {}, h)), u.forEach((h) => ri(c, I, h)), u.forEach((h) => ri(c, zr, h));
    });
    const l = Array.from(c);
    return l.length === 0 && l.push(/* @__PURE__ */ Object.create(null)), Al.has(e) && o.set(e, l), l;
  }
  chartOptionScopes() {
    const { options: t, type: e } = this;
    return [
      t,
      ge[e] || {},
      I.datasets[e] || {},
      { type: e },
      I,
      zr
    ];
  }
  resolveNamedOptions(t, e, n, r = [""]) {
    const s = { $shared: !0 }, { resolver: o, subPrefixes: a } = Ea(this._resolverCache, t, r);
    let c = o;
    if (bp(o, e)) {
      s.$shared = !1, n = ee(n) ? n() : n;
      const l = this.createResolver(t, n, a);
      c = ze(o, n, l);
    }
    for (const l of e)
      s[l] = c[l];
    return s;
  }
  createResolver(t, e, n = [""], r) {
    const { resolver: s } = Ea(this._resolverCache, t, n);
    return L(e) ? ze(s, e, void 0, r) : s;
  }
}
function Ea(i, t, e) {
  let n = i.get(t);
  n || (n = /* @__PURE__ */ new Map(), i.set(t, n));
  const r = e.join();
  let s = n.get(r);
  return s || (s = {
    resolver: Fs(t, e),
    subPrefixes: e.filter((a) => !a.toLowerCase().includes("hover"))
  }, n.set(r, s)), s;
}
const vp = (i) => L(i) && Object.getOwnPropertyNames(i).reduce((t, e) => t || ee(i[e]), !1);
function bp(i, t) {
  const { isScriptable: e, isIndexable: n } = ul(i);
  for (const r of t) {
    const s = e(r), o = n(r), a = (o || s) && i[r];
    if (s && (ee(a) || vp(a)) || o && H(a))
      return !0;
  }
  return !1;
}
var _p = "3.9.1";
const xp = ["top", "bottom", "left", "right", "chartArea"];
function ka(i, t) {
  return i === "top" || i === "bottom" || xp.indexOf(i) === -1 && t === "x";
}
function Oa(i, t) {
  return function(e, n) {
    return e[i] === n[i] ? e[t] - n[t] : e[i] - n[i];
  };
}
function Da(i) {
  const t = i.chart, e = t.options.animation;
  t.notifyPlugins("afterRender"), X(e && e.onComplete, [i], t);
}
function wp(i) {
  const t = i.chart, e = t.options.animation;
  X(e && e.onProgress, [i], t);
}
function Cl(i) {
  return ml() && typeof i == "string" ? i = document.getElementById(i) : i && i.length && (i = i[0]), i && i.canvas && (i = i.canvas), i;
}
const Mn = {}, Pl = (i) => {
  const t = Cl(i);
  return Object.values(Mn).filter((e) => e.canvas === t).pop();
};
function Sp(i, t, e) {
  const n = Object.keys(i);
  for (const r of n) {
    const s = +r;
    if (s >= t) {
      const o = i[r];
      delete i[r], (e > 0 || s > t) && (i[s + e] = o);
    }
  }
}
function Ep(i, t, e, n) {
  return !e || i.type === "mouseout" ? null : n ? t : i;
}
class An {
  constructor(t, e) {
    const n = this.config = new yp(e), r = Cl(t), s = Pl(r);
    if (s)
      throw new Error(
        "Canvas is already in use. Chart with ID '" + s.id + "' must be destroyed before the canvas with ID '" + s.canvas.id + "' can be reused."
      );
    const o = n.createResolver(n.chartOptionScopes(), this.getContext());
    this.platform = new (n.platform || op(r))(), this.platform.updateConfig(n);
    const a = this.platform.acquireContext(r, o.aspectRatio), c = a && a.canvas, l = c && c.height, u = c && c.width;
    if (this.id = rh(), this.ctx = a, this.canvas = c, this.width = u, this.height = l, this._options = o, this._aspectRatio = this.aspectRatio, this._layers = [], this._metasets = [], this._stacks = void 0, this.boxes = [], this.currentDevicePixelRatio = void 0, this.chartArea = void 0, this._active = [], this._lastEvent = void 0, this._listeners = {}, this._responsiveListeners = void 0, this._sortedMetasets = [], this.scales = {}, this._plugins = new ap(), this.$proxies = {}, this._hiddenIndices = {}, this.attached = !1, this._animationsDisabled = void 0, this.$context = void 0, this._doResize = _h((h) => this.update(h), o.resizeDelay || 0), this._dataChanges = [], Mn[this.id] = this, !a || !c) {
      console.error("Failed to create chart: can't acquire context from the given item");
      return;
    }
    Nt.listen(this, "complete", Da), Nt.listen(this, "progress", wp), this._initialize(), this.attached && this.update();
  }
  get aspectRatio() {
    const { options: { aspectRatio: t, maintainAspectRatio: e }, width: n, height: r, _aspectRatio: s } = this;
    return $(t) ? e && s ? s : r ? n / r : null : t;
  }
  get data() {
    return this.config.data;
  }
  set data(t) {
    this.config.data = t;
  }
  get options() {
    return this._options;
  }
  set options(t) {
    this.config.options = t;
  }
  _initialize() {
    return this.notifyPlugins("beforeInit"), this.options.responsive ? this.resize() : Jo(this, this.options.devicePixelRatio), this.bindEvents(), this.notifyPlugins("afterInit"), this;
  }
  clear() {
    return Go(this.canvas, this.ctx), this;
  }
  stop() {
    return Nt.stop(this), this;
  }
  resize(t, e) {
    Nt.running(this) ? this._resizeBeforeDraw = { width: t, height: e } : this._resize(t, e);
  }
  _resize(t, e) {
    const n = this.options, r = this.canvas, s = n.maintainAspectRatio && this.aspectRatio, o = this.platform.getMaximumSize(r, t, e, s), a = n.devicePixelRatio || this.platform.getDevicePixelRatio(), c = this.width ? "resize" : "attach";
    this.width = o.width, this.height = o.height, this._aspectRatio = this.aspectRatio, Jo(this, a, !0) && (this.notifyPlugins("resize", { size: o }), X(n.onResize, [this, o], this), this.attached && this._doResize(c) && this.render());
  }
  ensureScalesHaveIDs() {
    const e = this.options.scales || {};
    j(e, (n, r) => {
      n.id = r;
    });
  }
  buildOrUpdateScales() {
    const t = this.options, e = t.scales, n = this.scales, r = Object.keys(n).reduce((o, a) => (o[a] = !1, o), {});
    let s = [];
    e && (s = s.concat(
      Object.keys(e).map((o) => {
        const a = e[o], c = Wr(o, a), l = c === "r", u = c === "x";
        return {
          options: a,
          dposition: l ? "chartArea" : u ? "bottom" : "left",
          dtype: l ? "radialLinear" : u ? "category" : "linear"
        };
      })
    )), j(s, (o) => {
      const a = o.options, c = a.id, l = Wr(c, a), u = F(a.type, o.dtype);
      (a.position === void 0 || ka(a.position, l) !== ka(o.dposition)) && (a.position = o.dposition), r[c] = !0;
      let h = null;
      if (c in n && n[c].type === u)
        h = n[c];
      else {
        const f = Pt.getScale(u);
        h = new f({
          id: c,
          type: u,
          ctx: this.ctx,
          chart: this
        }), n[h.id] = h;
      }
      h.init(a, t);
    }), j(r, (o, a) => {
      o || delete n[a];
    }), j(n, (o) => {
      Zi.configure(this, o, o.options), Zi.addBox(this, o);
    });
  }
  _updateMetasets() {
    const t = this._metasets, e = this.data.datasets.length, n = t.length;
    if (t.sort((r, s) => r.index - s.index), n > e) {
      for (let r = e; r < n; ++r)
        this._destroyDatasetMeta(r);
      t.splice(e, n - e);
    }
    this._sortedMetasets = t.slice(0).sort(Oa("order", "index"));
  }
  _removeUnreferencedMetasets() {
    const { _metasets: t, data: { datasets: e } } = this;
    t.length > e.length && delete this._stacks, t.forEach((n, r) => {
      e.filter((s) => s === n._dataset).length === 0 && this._destroyDatasetMeta(r);
    });
  }
  buildOrUpdateControllers() {
    const t = [], e = this.data.datasets;
    let n, r;
    for (this._removeUnreferencedMetasets(), n = 0, r = e.length; n < r; n++) {
      const s = e[n];
      let o = this.getDatasetMeta(n);
      const a = s.type || this.config.type;
      if (o.type && o.type !== a && (this._destroyDatasetMeta(n), o = this.getDatasetMeta(n)), o.type = a, o.indexAxis = s.indexAxis || Ur(a, this.options), o.order = s.order || 0, o.index = n, o.label = "" + s.label, o.visible = this.isDatasetVisible(n), o.controller)
        o.controller.updateIndex(n), o.controller.linkScales();
      else {
        const c = Pt.getController(a), { datasetElementType: l, dataElementType: u } = I.datasets[a];
        Object.assign(c.prototype, {
          dataElementType: Pt.getElement(u),
          datasetElementType: l && Pt.getElement(l)
        }), o.controller = new c(this, n), t.push(o.controller);
      }
    }
    return this._updateMetasets(), t;
  }
  _resetElements() {
    j(this.data.datasets, (t, e) => {
      this.getDatasetMeta(e).controller.reset();
    }, this);
  }
  reset() {
    this._resetElements(), this.notifyPlugins("reset");
  }
  update(t) {
    const e = this.config;
    e.update();
    const n = this._options = e.createResolver(e.chartOptionScopes(), this.getContext()), r = this._animationsDisabled = !n.animation;
    if (this._updateScales(), this._checkEventBindings(), this._updateHiddenIndices(), this._plugins.invalidate(), this.notifyPlugins("beforeUpdate", { mode: t, cancelable: !0 }) === !1)
      return;
    const s = this.buildOrUpdateControllers();
    this.notifyPlugins("beforeElementsUpdate");
    let o = 0;
    for (let l = 0, u = this.data.datasets.length; l < u; l++) {
      const { controller: h } = this.getDatasetMeta(l), f = !r && s.indexOf(h) === -1;
      h.buildOrUpdateElements(f), o = Math.max(+h.getMaxOverflow(), o);
    }
    o = this._minPadding = n.layout.autoPadding ? o : 0, this._updateLayout(o), r || j(s, (l) => {
      l.reset();
    }), this._updateDatasets(t), this.notifyPlugins("afterUpdate", { mode: t }), this._layers.sort(Oa("z", "_idx"));
    const { _active: a, _lastEvent: c } = this;
    c ? this._eventHandler(c, !0) : a.length && this._updateHoverStyles(a, a, !0), this.render();
  }
  _updateScales() {
    j(this.scales, (t) => {
      Zi.removeBox(this, t);
    }), this.ensureScalesHaveIDs(), this.buildOrUpdateScales();
  }
  _checkEventBindings() {
    const t = this.options, e = new Set(Object.keys(this._listeners)), n = new Set(t.events);
    (!Lo(e, n) || !!this._responsiveListeners !== t.responsive) && (this.unbindEvents(), this.bindEvents());
  }
  _updateHiddenIndices() {
    const { _hiddenIndices: t } = this, e = this._getUniformDataChanges() || [];
    for (const { method: n, start: r, count: s } of e) {
      const o = n === "_removeElements" ? -s : s;
      Sp(t, r, o);
    }
  }
  _getUniformDataChanges() {
    const t = this._dataChanges;
    if (!t || !t.length)
      return;
    this._dataChanges = [];
    const e = this.data.datasets.length, n = (s) => new Set(
      t.filter((o) => o[0] === s).map((o, a) => a + "," + o.splice(1).join(","))
    ), r = n(0);
    for (let s = 1; s < e; s++)
      if (!Lo(r, n(s)))
        return;
    return Array.from(r).map((s) => s.split(",")).map((s) => ({ method: s[1], start: +s[2], count: +s[3] }));
  }
  _updateLayout(t) {
    if (this.notifyPlugins("beforeLayout", { cancelable: !0 }) === !1)
      return;
    Zi.update(this, this.width, this.height, t);
    const e = this.chartArea, n = e.width <= 0 || e.height <= 0;
    this._layers = [], j(this.boxes, (r) => {
      n && r.position === "chartArea" || (r.configure && r.configure(), this._layers.push(...r._layers()));
    }, this), this._layers.forEach((r, s) => {
      r._idx = s;
    }), this.notifyPlugins("afterLayout");
  }
  _updateDatasets(t) {
    if (this.notifyPlugins("beforeDatasetsUpdate", { mode: t, cancelable: !0 }) !== !1) {
      for (let e = 0, n = this.data.datasets.length; e < n; ++e)
        this.getDatasetMeta(e).controller.configure();
      for (let e = 0, n = this.data.datasets.length; e < n; ++e)
        this._updateDataset(e, ee(t) ? t({ datasetIndex: e }) : t);
      this.notifyPlugins("afterDatasetsUpdate", { mode: t });
    }
  }
  _updateDataset(t, e) {
    const n = this.getDatasetMeta(t), r = { meta: n, index: t, mode: e, cancelable: !0 };
    this.notifyPlugins("beforeDatasetUpdate", r) !== !1 && (n.controller._update(e), r.cancelable = !1, this.notifyPlugins("afterDatasetUpdate", r));
  }
  render() {
    this.notifyPlugins("beforeRender", { cancelable: !0 }) !== !1 && (Nt.has(this) ? this.attached && !Nt.running(this) && Nt.start(this) : (this.draw(), Da({ chart: this })));
  }
  draw() {
    let t;
    if (this._resizeBeforeDraw) {
      const { width: n, height: r } = this._resizeBeforeDraw;
      this._resize(n, r), this._resizeBeforeDraw = null;
    }
    if (this.clear(), this.width <= 0 || this.height <= 0 || this.notifyPlugins("beforeDraw", { cancelable: !0 }) === !1)
      return;
    const e = this._layers;
    for (t = 0; t < e.length && e[t].z <= 0; ++t)
      e[t].draw(this.chartArea);
    for (this._drawDatasets(); t < e.length; ++t)
      e[t].draw(this.chartArea);
    this.notifyPlugins("afterDraw");
  }
  _getSortedDatasetMetas(t) {
    const e = this._sortedMetasets, n = [];
    let r, s;
    for (r = 0, s = e.length; r < s; ++r) {
      const o = e[r];
      (!t || o.visible) && n.push(o);
    }
    return n;
  }
  getSortedVisibleDatasetMetas() {
    return this._getSortedDatasetMetas(!0);
  }
  _drawDatasets() {
    if (this.notifyPlugins("beforeDatasetsDraw", { cancelable: !0 }) === !1)
      return;
    const t = this.getSortedVisibleDatasetMetas();
    for (let e = t.length - 1; e >= 0; --e)
      this._drawDataset(t[e]);
    this.notifyPlugins("afterDatasetsDraw");
  }
  _drawDataset(t) {
    const e = this.ctx, n = t._clip, r = !n.disabled, s = this.chartArea, o = {
      meta: t,
      index: t.index,
      cancelable: !0
    };
    this.notifyPlugins("beforeDatasetDraw", o) !== !1 && (r && al(e, {
      left: n.left === !1 ? 0 : s.left - n.left,
      right: n.right === !1 ? this.width : s.right + n.right,
      top: n.top === !1 ? 0 : s.top - n.top,
      bottom: n.bottom === !1 ? this.height : s.bottom + n.bottom
    }), t.controller.draw(), r && cl(e), o.cancelable = !1, this.notifyPlugins("afterDatasetDraw", o));
  }
  isPointInArea(t) {
    return Ti(t, this.chartArea, this._minPadding);
  }
  getElementsAtEventForMode(t, e, n, r) {
    const s = jd.modes[e];
    return typeof s == "function" ? s(this, t, n, r) : [];
  }
  getDatasetMeta(t) {
    const e = this.data.datasets[t], n = this._metasets;
    let r = n.filter((s) => s && s._dataset === e).pop();
    return r || (r = {
      type: null,
      data: [],
      dataset: null,
      controller: null,
      hidden: null,
      xAxisID: null,
      yAxisID: null,
      order: e && e.order || 0,
      index: t,
      _dataset: e,
      _parsed: [],
      _sorted: !1
    }, n.push(r)), r;
  }
  getContext() {
    return this.$context || (this.$context = re(null, { chart: this, type: "chart" }));
  }
  getVisibleDatasetCount() {
    return this.getSortedVisibleDatasetMetas().length;
  }
  isDatasetVisible(t) {
    const e = this.data.datasets[t];
    if (!e)
      return !1;
    const n = this.getDatasetMeta(t);
    return typeof n.hidden == "boolean" ? !n.hidden : !e.hidden;
  }
  setDatasetVisibility(t, e) {
    const n = this.getDatasetMeta(t);
    n.hidden = !e;
  }
  toggleDataVisibility(t) {
    this._hiddenIndices[t] = !this._hiddenIndices[t];
  }
  getDataVisibility(t) {
    return !this._hiddenIndices[t];
  }
  _updateVisibility(t, e, n) {
    const r = n ? "show" : "hide", s = this.getDatasetMeta(t), o = s.controller._resolveAnimations(void 0, r);
    _t(e) ? (s.data[e].hidden = !n, this.update()) : (this.setDatasetVisibility(t, n), o.update(s, { visible: n }), this.update((a) => a.datasetIndex === t ? r : void 0));
  }
  hide(t, e) {
    this._updateVisibility(t, e, !1);
  }
  show(t, e) {
    this._updateVisibility(t, e, !0);
  }
  _destroyDatasetMeta(t) {
    const e = this._metasets[t];
    e && e.controller && e.controller._destroy(), delete this._metasets[t];
  }
  _stop() {
    let t, e;
    for (this.stop(), Nt.remove(this), t = 0, e = this.data.datasets.length; t < e; ++t)
      this._destroyDatasetMeta(t);
  }
  destroy() {
    this.notifyPlugins("beforeDestroy");
    const { canvas: t, ctx: e } = this;
    this._stop(), this.config.clearCache(), t && (this.unbindEvents(), Go(t, e), this.platform.releaseContext(e), this.canvas = null, this.ctx = null), this.notifyPlugins("destroy"), delete Mn[this.id], this.notifyPlugins("afterDestroy");
  }
  toBase64Image(...t) {
    return this.canvas.toDataURL(...t);
  }
  bindEvents() {
    this.bindUserEvents(), this.options.responsive ? this.bindResponsiveEvents() : this.attached = !0;
  }
  bindUserEvents() {
    const t = this._listeners, e = this.platform, n = (s, o) => {
      e.addEventListener(this, s, o), t[s] = o;
    }, r = (s, o, a) => {
      s.offsetX = o, s.offsetY = a, this._eventHandler(s);
    };
    j(this.options.events, (s) => n(s, r));
  }
  bindResponsiveEvents() {
    this._responsiveListeners || (this._responsiveListeners = {});
    const t = this._responsiveListeners, e = this.platform, n = (c, l) => {
      e.addEventListener(this, c, l), t[c] = l;
    }, r = (c, l) => {
      t[c] && (e.removeEventListener(this, c, l), delete t[c]);
    }, s = (c, l) => {
      this.canvas && this.resize(c, l);
    };
    let o;
    const a = () => {
      r("attach", a), this.attached = !0, this.resize(), n("resize", s), n("detach", o);
    };
    o = () => {
      this.attached = !1, r("resize", s), this._stop(), this._resize(0, 0), n("attach", a);
    }, e.isAttached(this.canvas) ? a() : o();
  }
  unbindEvents() {
    j(this._listeners, (t, e) => {
      this.platform.removeEventListener(this, e, t);
    }), this._listeners = {}, j(this._responsiveListeners, (t, e) => {
      this.platform.removeEventListener(this, e, t);
    }), this._responsiveListeners = void 0;
  }
  updateHoverStyle(t, e, n) {
    const r = n ? "set" : "remove";
    let s, o, a, c;
    for (e === "dataset" && (s = this.getDatasetMeta(t[0].datasetIndex), s.controller["_" + r + "DatasetHoverStyle"]()), a = 0, c = t.length; a < c; ++a) {
      o = t[a];
      const l = o && this.getDatasetMeta(o.datasetIndex).controller;
      l && l[r + "HoverStyle"](o.element, o.datasetIndex, o.index);
    }
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(t) {
    const e = this._active || [], n = t.map(({ datasetIndex: s, index: o }) => {
      const a = this.getDatasetMeta(s);
      if (!a)
        throw new Error("No dataset found at index " + s);
      return {
        datasetIndex: s,
        element: a.data[o],
        index: o
      };
    });
    !bn(n, e) && (this._active = n, this._lastEvent = null, this._updateHoverStyles(n, e));
  }
  notifyPlugins(t, e, n) {
    return this._plugins.notify(this, t, e, n);
  }
  _updateHoverStyles(t, e, n) {
    const r = this.options.hover, s = (c, l) => c.filter((u) => !l.some((h) => u.datasetIndex === h.datasetIndex && u.index === h.index)), o = s(e, t), a = n ? t : s(t, e);
    o.length && this.updateHoverStyle(o, r.mode, !1), a.length && r.mode && this.updateHoverStyle(a, r.mode, !0);
  }
  _eventHandler(t, e) {
    const n = {
      event: t,
      replay: e,
      cancelable: !0,
      inChartArea: this.isPointInArea(t)
    }, r = (o) => (o.options.events || this.options.events).includes(t.native.type);
    if (this.notifyPlugins("beforeEvent", n, r) === !1)
      return;
    const s = this._handleEvent(t, e, n.inChartArea);
    return n.cancelable = !1, this.notifyPlugins("afterEvent", n, r), (s || n.changed) && this.render(), this;
  }
  _handleEvent(t, e, n) {
    const { _active: r = [], options: s } = this, o = e, a = this._getActiveElements(t, r, n, o), c = uh(t), l = Ep(t, this._lastEvent, n, c);
    n && (this._lastEvent = null, X(s.onHover, [t, a, this], this), c && X(s.onClick, [t, a, this], this));
    const u = !bn(a, r);
    return (u || e) && (this._active = a, this._updateHoverStyles(a, r, e)), this._lastEvent = l, u;
  }
  _getActiveElements(t, e, n, r) {
    if (t.type === "mouseout")
      return [];
    if (!n)
      return e;
    const s = this.options.hover;
    return this.getElementsAtEventForMode(t, s.mode, s, r);
  }
}
const Ta = () => j(An.instances, (i) => i._plugins.invalidate()), Qt = !0;
Object.defineProperties(An, {
  defaults: {
    enumerable: Qt,
    value: I
  },
  instances: {
    enumerable: Qt,
    value: Mn
  },
  overrides: {
    enumerable: Qt,
    value: ge
  },
  registry: {
    enumerable: Qt,
    value: Pt
  },
  version: {
    enumerable: Qt,
    value: _p
  },
  getChart: {
    enumerable: Qt,
    value: Pl
  },
  register: {
    enumerable: Qt,
    value: (...i) => {
      Pt.add(...i), Ta();
    }
  },
  unregister: {
    enumerable: Qt,
    value: (...i) => {
      Pt.remove(...i), Ta();
    }
  }
});
function Rl(i, t, e) {
  const { startAngle: n, pixelMargin: r, x: s, y: o, outerRadius: a, innerRadius: c } = t;
  let l = r / a;
  i.beginPath(), i.arc(s, o, a, n - l, e + l), c > r ? (l = r / c, i.arc(s, o, c, e + l, n - l, !0)) : i.arc(s, o, r, e + K, n - K), i.closePath(), i.clip();
}
function kp(i) {
  return Is(i, ["outerStart", "outerEnd", "innerStart", "innerEnd"]);
}
function Op(i, t, e, n) {
  const r = kp(i.options.borderRadius), s = (e - t) / 2, o = Math.min(s, n * t / 2), a = (c) => {
    const l = (e - Math.min(s, c)) * n / 2;
    return ft(c, 0, Math.min(s, l));
  };
  return {
    outerStart: a(r.outerStart),
    outerEnd: a(r.outerEnd),
    innerStart: ft(r.innerStart, 0, o),
    innerEnd: ft(r.innerEnd, 0, o)
  };
}
function Ee(i, t, e, n) {
  return {
    x: e + i * Math.cos(t),
    y: n + i * Math.sin(t)
  };
}
function Hr(i, t, e, n, r, s) {
  const { x: o, y: a, startAngle: c, pixelMargin: l, innerRadius: u } = t, h = Math.max(t.outerRadius + n + e - l, 0), f = u > 0 ? u + n + e + l : 0;
  let d = 0;
  const p = r - c;
  if (n) {
    const P = u > 0 ? u - n : 0, G = h > 0 ? h - n : 0, W = (P + G) / 2, et = W !== 0 ? p * W / (W + n) : p;
    d = (p - et) / 2;
  }
  const g = Math.max(1e-3, p * h - e / Z) / h, m = (p - g) / 2, y = c + m + d, b = r - m - d, { outerStart: v, outerEnd: _, innerStart: x, innerEnd: k } = Op(t, f, h, b - y), E = h - v, O = h - _, M = y + v / E, C = b - _ / O, V = f + x, q = f + k, Y = y + x / V, rt = b - k / q;
  if (i.beginPath(), s) {
    if (i.arc(o, a, h, M, C), _ > 0) {
      const W = Ee(O, C, o, a);
      i.arc(W.x, W.y, _, C, b + K);
    }
    const P = Ee(q, b, o, a);
    if (i.lineTo(P.x, P.y), k > 0) {
      const W = Ee(q, rt, o, a);
      i.arc(W.x, W.y, k, b + K, rt + Math.PI);
    }
    if (i.arc(o, a, f, b - k / f, y + x / f, !0), x > 0) {
      const W = Ee(V, Y, o, a);
      i.arc(W.x, W.y, x, Y + Math.PI, y - K);
    }
    const G = Ee(E, y, o, a);
    if (i.lineTo(G.x, G.y), v > 0) {
      const W = Ee(E, M, o, a);
      i.arc(W.x, W.y, v, y - K, M);
    }
  } else {
    i.moveTo(o, a);
    const P = Math.cos(M) * h + o, G = Math.sin(M) * h + a;
    i.lineTo(P, G);
    const W = Math.cos(C) * h + o, et = Math.sin(C) * h + a;
    i.lineTo(W, et);
  }
  i.closePath();
}
function Dp(i, t, e, n, r) {
  const { fullCircles: s, startAngle: o, circumference: a } = t;
  let c = t.endAngle;
  if (s) {
    Hr(i, t, e, n, o + Q, r);
    for (let l = 0; l < s; ++l)
      i.fill();
    isNaN(a) || (c = o + a % Q, a % Q === 0 && (c += Q));
  }
  return Hr(i, t, e, n, c, r), i.fill(), c;
}
function Tp(i, t, e) {
  const { x: n, y: r, startAngle: s, pixelMargin: o, fullCircles: a } = t, c = Math.max(t.outerRadius - o, 0), l = t.innerRadius + o;
  let u;
  for (e && Rl(i, t, s + Q), i.beginPath(), i.arc(n, r, l, s + Q, s, !0), u = 0; u < a; ++u)
    i.stroke();
  for (i.beginPath(), i.arc(n, r, c, s, s + Q), u = 0; u < a; ++u)
    i.stroke();
}
function Mp(i, t, e, n, r, s) {
  const { options: o } = t, { borderWidth: a, borderJoinStyle: c } = o, l = o.borderAlign === "inner";
  !a || (l ? (i.lineWidth = a * 2, i.lineJoin = c || "round") : (i.lineWidth = a, i.lineJoin = c || "bevel"), t.fullCircles && Tp(i, t, l), l && Rl(i, t, r), Hr(i, t, e, n, r, s), i.stroke());
}
class Qn extends $t {
  constructor(t) {
    super(), this.options = void 0, this.circumference = void 0, this.startAngle = void 0, this.endAngle = void 0, this.innerRadius = void 0, this.outerRadius = void 0, this.pixelMargin = 0, this.fullCircles = 0, t && Object.assign(this, t);
  }
  inRange(t, e, n) {
    const r = this.getProps(["x", "y"], n), { angle: s, distance: o } = Gc(r, { x: t, y: e }), { startAngle: a, endAngle: c, innerRadius: l, outerRadius: u, circumference: h } = this.getProps([
      "startAngle",
      "endAngle",
      "innerRadius",
      "outerRadius",
      "circumference"
    ], n), f = this.options.spacing / 2, p = F(h, c - a) >= Q || Di(s, a, c), g = wn(o, l + f, u + f);
    return p && g;
  }
  getCenterPoint(t) {
    const { x: e, y: n, startAngle: r, endAngle: s, innerRadius: o, outerRadius: a } = this.getProps([
      "x",
      "y",
      "startAngle",
      "endAngle",
      "innerRadius",
      "outerRadius",
      "circumference"
    ], t), { offset: c, spacing: l } = this.options, u = (r + s) / 2, h = (o + a + l + c) / 2;
    return {
      x: e + Math.cos(u) * h,
      y: n + Math.sin(u) * h
    };
  }
  tooltipPosition(t) {
    return this.getCenterPoint(t);
  }
  draw(t) {
    const { options: e, circumference: n } = this, r = (e.offset || 0) / 2, s = (e.spacing || 0) / 2, o = e.circular;
    if (this.pixelMargin = e.borderAlign === "inner" ? 0.33 : 0, this.fullCircles = n > Q ? Math.floor(n / Q) : 0, n === 0 || this.innerRadius < 0 || this.outerRadius < 0)
      return;
    t.save();
    let a = 0;
    if (r) {
      a = r / 2;
      const l = (this.startAngle + this.endAngle) / 2;
      t.translate(Math.cos(l) * a, Math.sin(l) * a), this.circumference >= Z && (a = r);
    }
    t.fillStyle = e.backgroundColor, t.strokeStyle = e.borderColor;
    const c = Dp(t, this, a, s, o);
    Mp(t, this, a, s, c, o), t.restore();
  }
}
Qn.id = "arc";
Qn.defaults = {
  borderAlign: "center",
  borderColor: "#fff",
  borderJoinStyle: void 0,
  borderRadius: 0,
  borderWidth: 2,
  offset: 0,
  spacing: 0,
  angle: void 0,
  circular: !0
};
Qn.defaultRoutes = {
  backgroundColor: "backgroundColor"
};
function Il(i, t, e = t) {
  i.lineCap = F(e.borderCapStyle, t.borderCapStyle), i.setLineDash(F(e.borderDash, t.borderDash)), i.lineDashOffset = F(e.borderDashOffset, t.borderDashOffset), i.lineJoin = F(e.borderJoinStyle, t.borderJoinStyle), i.lineWidth = F(e.borderWidth, t.borderWidth), i.strokeStyle = F(e.borderColor, t.borderColor);
}
function Ap(i, t, e) {
  i.lineTo(e.x, e.y);
}
function Cp(i) {
  return i.stepped ? Yh : i.tension || i.cubicInterpolationMode === "monotone" ? Gh : Ap;
}
function Fl(i, t, e = {}) {
  const n = i.length, { start: r = 0, end: s = n - 1 } = e, { start: o, end: a } = t, c = Math.max(r, o), l = Math.min(s, a), u = r < o && s < o || r > a && s > a;
  return {
    count: n,
    start: c,
    loop: t.loop,
    ilen: l < c && !u ? n + l - c : l - c
  };
}
function Pp(i, t, e, n) {
  const { points: r, options: s } = t, { count: o, start: a, loop: c, ilen: l } = Fl(r, e, n), u = Cp(s);
  let { move: h = !0, reverse: f } = n || {}, d, p, g;
  for (d = 0; d <= l; ++d)
    p = r[(a + (f ? l - d : d)) % o], !p.skip && (h ? (i.moveTo(p.x, p.y), h = !1) : u(i, g, p, f, s.stepped), g = p);
  return c && (p = r[(a + (f ? l : 0)) % o], u(i, g, p, f, s.stepped)), !!c;
}
function Rp(i, t, e, n) {
  const r = t.points, { count: s, start: o, ilen: a } = Fl(r, e, n), { move: c = !0, reverse: l } = n || {};
  let u = 0, h = 0, f, d, p, g, m, y;
  const b = (_) => (o + (l ? a - _ : _)) % s, v = () => {
    g !== m && (i.lineTo(u, m), i.lineTo(u, g), i.lineTo(u, y));
  };
  for (c && (d = r[b(0)], i.moveTo(d.x, d.y)), f = 0; f <= a; ++f) {
    if (d = r[b(f)], d.skip)
      continue;
    const _ = d.x, x = d.y, k = _ | 0;
    k === p ? (x < g ? g = x : x > m && (m = x), u = (h * u + _) / ++h) : (v(), i.lineTo(_, x), p = k, h = 0, g = m = x), y = x;
  }
  v();
}
function Yr(i) {
  const t = i.options, e = t.borderDash && t.borderDash.length;
  return !i._decimated && !i._loop && !t.tension && t.cubicInterpolationMode !== "monotone" && !t.stepped && !e ? Rp : Pp;
}
function Ip(i) {
  return i.stepped ? Df : i.tension || i.cubicInterpolationMode === "monotone" ? Tf : le;
}
function Fp(i, t, e, n) {
  let r = t._path;
  r || (r = t._path = new Path2D(), t.path(r, e, n) && r.closePath()), Il(i, t.options), i.stroke(r);
}
function Lp(i, t, e, n) {
  const { segments: r, options: s } = t, o = Yr(t);
  for (const a of r)
    Il(i, s, a.style), i.beginPath(), o(i, t, a, { start: e, end: e + n - 1 }) && i.closePath(), i.stroke();
}
const Np = typeof Path2D == "function";
function Vp(i, t, e, n) {
  Np && !t.options.segment ? Fp(i, t, e, n) : Lp(i, t, e, n);
}
class $i extends $t {
  constructor(t) {
    super(), this.animated = !0, this.options = void 0, this._chart = void 0, this._loop = void 0, this._fullLoop = void 0, this._path = void 0, this._points = void 0, this._segments = void 0, this._decimated = !1, this._pointsUpdated = !1, this._datasetIndex = void 0, t && Object.assign(this, t);
  }
  updateControlPoints(t, e) {
    const n = this.options;
    if ((n.tension || n.cubicInterpolationMode === "monotone") && !n.stepped && !this._pointsUpdated) {
      const r = n.spanGaps ? this._loop : this._fullLoop;
      bf(this._points, n, t, r, e), this._pointsUpdated = !0;
    }
  }
  set points(t) {
    this._points = t, delete this._segments, delete this._path, this._pointsUpdated = !1;
  }
  get points() {
    return this._points;
  }
  get segments() {
    return this._segments || (this._segments = jf(this, this.options.segment));
  }
  first() {
    const t = this.segments, e = this.points;
    return t.length && e[t[0].start];
  }
  last() {
    const t = this.segments, e = this.points, n = t.length;
    return n && e[t[n - 1].end];
  }
  interpolate(t, e) {
    const n = this.options, r = t[e], s = this.points, o = Lf(this, { property: e, start: r, end: r });
    if (!o.length)
      return;
    const a = [], c = Ip(n);
    let l, u;
    for (l = 0, u = o.length; l < u; ++l) {
      const { start: h, end: f } = o[l], d = s[h], p = s[f];
      if (d === p) {
        a.push(d);
        continue;
      }
      const g = Math.abs((r - d[e]) / (p[e] - d[e])), m = c(d, p, g, n.stepped);
      m[e] = t[e], a.push(m);
    }
    return a.length === 1 ? a[0] : a;
  }
  pathSegment(t, e, n) {
    return Yr(this)(t, this, e, n);
  }
  path(t, e, n) {
    const r = this.segments, s = Yr(this);
    let o = this._loop;
    e = e || 0, n = n || this.points.length - e;
    for (const a of r)
      o &= s(t, this, a, { start: e, end: e + n - 1 });
    return !!o;
  }
  draw(t, e, n, r) {
    const s = this.options || {};
    (this.points || []).length && s.borderWidth && (t.save(), Vp(t, this, n, r), t.restore()), this.animated && (this._pointsUpdated = !1, this._path = void 0);
  }
}
$i.id = "line";
$i.defaults = {
  borderCapStyle: "butt",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: "miter",
  borderWidth: 3,
  capBezierPoints: !0,
  cubicInterpolationMode: "default",
  fill: !1,
  spanGaps: !1,
  stepped: !1,
  tension: 0
};
$i.defaultRoutes = {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
};
$i.descriptors = {
  _scriptable: !0,
  _indexable: (i) => i !== "borderDash" && i !== "fill"
};
function Ma(i, t, e, n) {
  const r = i.options, { [e]: s } = i.getProps([e], n);
  return Math.abs(t - s) < r.radius + r.hitRadius;
}
class Qs extends $t {
  constructor(t) {
    super(), this.options = void 0, this.parsed = void 0, this.skip = void 0, this.stop = void 0, t && Object.assign(this, t);
  }
  inRange(t, e, n) {
    const r = this.options, { x: s, y: o } = this.getProps(["x", "y"], n);
    return Math.pow(t - s, 2) + Math.pow(e - o, 2) < Math.pow(r.hitRadius + r.radius, 2);
  }
  inXRange(t, e) {
    return Ma(this, t, "x", e);
  }
  inYRange(t, e) {
    return Ma(this, t, "y", e);
  }
  getCenterPoint(t) {
    const { x: e, y: n } = this.getProps(["x", "y"], t);
    return { x: e, y: n };
  }
  size(t) {
    t = t || this.options || {};
    let e = t.radius || 0;
    e = Math.max(e, e && t.hoverRadius || 0);
    const n = e && t.borderWidth || 0;
    return (e + n) * 2;
  }
  draw(t, e) {
    const n = this.options;
    this.skip || n.radius < 0.1 || !Ti(this, e, this.size(n) / 2) || (t.strokeStyle = n.borderColor, t.lineWidth = n.borderWidth, t.fillStyle = n.backgroundColor, qr(t, n, this.x, this.y));
  }
  getRange() {
    const t = this.options || {};
    return t.radius + t.hitRadius;
  }
}
Qs.id = "point";
Qs.defaults = {
  borderWidth: 1,
  hitRadius: 1,
  hoverBorderWidth: 1,
  hoverRadius: 4,
  pointStyle: "circle",
  radius: 3,
  rotation: 0
};
Qs.defaultRoutes = {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
};
function Ll(i, t) {
  const { x: e, y: n, base: r, width: s, height: o } = i.getProps(["x", "y", "base", "width", "height"], t);
  let a, c, l, u, h;
  return i.horizontal ? (h = o / 2, a = Math.min(e, r), c = Math.max(e, r), l = n - h, u = n + h) : (h = s / 2, a = e - h, c = e + h, l = Math.min(n, r), u = Math.max(n, r)), { left: a, top: l, right: c, bottom: u };
}
function Jt(i, t, e, n) {
  return i ? 0 : ft(t, e, n);
}
function jp(i, t, e) {
  const n = i.options.borderWidth, r = i.borderSkipped, s = ll(n);
  return {
    t: Jt(r.top, s.top, 0, e),
    r: Jt(r.right, s.right, 0, t),
    b: Jt(r.bottom, s.bottom, 0, e),
    l: Jt(r.left, s.left, 0, t)
  };
}
function Bp(i, t, e) {
  const { enableBorderRadius: n } = i.getProps(["enableBorderRadius"]), r = i.options.borderRadius, s = Pe(r), o = Math.min(t, e), a = i.borderSkipped, c = n || L(r);
  return {
    topLeft: Jt(!c || a.top || a.left, s.topLeft, 0, o),
    topRight: Jt(!c || a.top || a.right, s.topRight, 0, o),
    bottomLeft: Jt(!c || a.bottom || a.left, s.bottomLeft, 0, o),
    bottomRight: Jt(!c || a.bottom || a.right, s.bottomRight, 0, o)
  };
}
function $p(i) {
  const t = Ll(i), e = t.right - t.left, n = t.bottom - t.top, r = jp(i, e / 2, n / 2), s = Bp(i, e / 2, n / 2);
  return {
    outer: {
      x: t.left,
      y: t.top,
      w: e,
      h: n,
      radius: s
    },
    inner: {
      x: t.left + r.l,
      y: t.top + r.t,
      w: e - r.l - r.r,
      h: n - r.t - r.b,
      radius: {
        topLeft: Math.max(0, s.topLeft - Math.max(r.t, r.l)),
        topRight: Math.max(0, s.topRight - Math.max(r.t, r.r)),
        bottomLeft: Math.max(0, s.bottomLeft - Math.max(r.b, r.l)),
        bottomRight: Math.max(0, s.bottomRight - Math.max(r.b, r.r))
      }
    }
  };
}
function xr(i, t, e, n) {
  const r = t === null, s = e === null, a = i && !(r && s) && Ll(i, n);
  return a && (r || wn(t, a.left, a.right)) && (s || wn(e, a.top, a.bottom));
}
function zp(i) {
  return i.topLeft || i.topRight || i.bottomLeft || i.bottomRight;
}
function qp(i, t) {
  i.rect(t.x, t.y, t.w, t.h);
}
function wr(i, t, e = {}) {
  const n = i.x !== e.x ? -t : 0, r = i.y !== e.y ? -t : 0, s = (i.x + i.w !== e.x + e.w ? t : 0) - n, o = (i.y + i.h !== e.y + e.h ? t : 0) - r;
  return {
    x: i.x + n,
    y: i.y + r,
    w: i.w + s,
    h: i.h + o,
    radius: i.radius
  };
}
class Us extends $t {
  constructor(t) {
    super(), this.options = void 0, this.horizontal = void 0, this.base = void 0, this.width = void 0, this.height = void 0, this.inflateAmount = void 0, t && Object.assign(this, t);
  }
  draw(t) {
    const { inflateAmount: e, options: { borderColor: n, backgroundColor: r } } = this, { inner: s, outer: o } = $p(this), a = zp(o.radius) ? On : qp;
    t.save(), (o.w !== s.w || o.h !== s.h) && (t.beginPath(), a(t, wr(o, e, s)), t.clip(), a(t, wr(s, -e, o)), t.fillStyle = n, t.fill("evenodd")), t.beginPath(), a(t, wr(s, e)), t.fillStyle = r, t.fill(), t.restore();
  }
  inRange(t, e, n) {
    return xr(this, t, e, n);
  }
  inXRange(t, e) {
    return xr(this, t, null, e);
  }
  inYRange(t, e) {
    return xr(this, null, t, e);
  }
  getCenterPoint(t) {
    const { x: e, y: n, base: r, horizontal: s } = this.getProps(["x", "y", "base", "horizontal"], t);
    return {
      x: s ? (e + r) / 2 : e,
      y: s ? n : (n + r) / 2
    };
  }
  getRange(t) {
    return t === "x" ? this.width / 2 : this.height / 2;
  }
}
Us.id = "bar";
Us.defaults = {
  borderSkipped: "start",
  borderWidth: 0,
  borderRadius: 0,
  inflateAmount: "auto",
  pointStyle: void 0
};
Us.defaultRoutes = {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
};
const ln = {
  average(i) {
    if (!i.length)
      return !1;
    let t, e, n = 0, r = 0, s = 0;
    for (t = 0, e = i.length; t < e; ++t) {
      const o = i[t].element;
      if (o && o.hasValue()) {
        const a = o.tooltipPosition();
        n += a.x, r += a.y, ++s;
      }
    }
    return {
      x: n / s,
      y: r / s
    };
  },
  nearest(i, t) {
    if (!i.length)
      return !1;
    let e = t.x, n = t.y, r = Number.POSITIVE_INFINITY, s, o, a;
    for (s = 0, o = i.length; s < o; ++s) {
      const c = i[s].element;
      if (c && c.hasValue()) {
        const l = c.getCenterPoint(), u = Br(t, l);
        u < r && (r = u, a = c);
      }
    }
    if (a) {
      const c = a.tooltipPosition();
      e = c.x, n = c.y;
    }
    return {
      x: e,
      y: n
    };
  }
};
function Ct(i, t) {
  return t && (H(t) ? Array.prototype.push.apply(i, t) : i.push(t)), i;
}
function Vt(i) {
  return (typeof i == "string" || i instanceof String) && i.indexOf(`
`) > -1 ? i.split(`
`) : i;
}
function Qp(i, t) {
  const { element: e, datasetIndex: n, index: r } = t, s = i.getDatasetMeta(n).controller, { label: o, value: a } = s.getLabelAndValue(r);
  return {
    chart: i,
    label: o,
    parsed: s.getParsed(r),
    raw: i.data.datasets[n].data[r],
    formattedValue: a,
    dataset: s.getDataset(),
    dataIndex: r,
    datasetIndex: n,
    element: e
  };
}
function Aa(i, t) {
  const e = i.chart.ctx, { body: n, footer: r, title: s } = i, { boxWidth: o, boxHeight: a } = t, c = gt(t.bodyFont), l = gt(t.titleFont), u = gt(t.footerFont), h = s.length, f = r.length, d = n.length, p = xt(t.padding);
  let g = p.height, m = 0, y = n.reduce((_, x) => _ + x.before.length + x.lines.length + x.after.length, 0);
  if (y += i.beforeBody.length + i.afterBody.length, h && (g += h * l.lineHeight + (h - 1) * t.titleSpacing + t.titleMarginBottom), y) {
    const _ = t.displayColors ? Math.max(a, c.lineHeight) : c.lineHeight;
    g += d * _ + (y - d) * c.lineHeight + (y - 1) * t.bodySpacing;
  }
  f && (g += t.footerMarginTop + f * u.lineHeight + (f - 1) * t.footerSpacing);
  let b = 0;
  const v = function(_) {
    m = Math.max(m, e.measureText(_).width + b);
  };
  return e.save(), e.font = l.string, j(i.title, v), e.font = c.string, j(i.beforeBody.concat(i.afterBody), v), b = t.displayColors ? o + 2 + t.boxPadding : 0, j(n, (_) => {
    j(_.before, v), j(_.lines, v), j(_.after, v);
  }), b = 0, e.font = u.string, j(i.footer, v), e.restore(), m += p.width, { width: m, height: g };
}
function Up(i, t) {
  const { y: e, height: n } = t;
  return e < n / 2 ? "top" : e > i.height - n / 2 ? "bottom" : "center";
}
function Wp(i, t, e, n) {
  const { x: r, width: s } = n, o = e.caretSize + e.caretPadding;
  if (i === "left" && r + s + o > t.width || i === "right" && r - s - o < 0)
    return !0;
}
function Hp(i, t, e, n) {
  const { x: r, width: s } = e, { width: o, chartArea: { left: a, right: c } } = i;
  let l = "center";
  return n === "center" ? l = r <= (a + c) / 2 ? "left" : "right" : r <= s / 2 ? l = "left" : r >= o - s / 2 && (l = "right"), Wp(l, i, t, e) && (l = "center"), l;
}
function Ca(i, t, e) {
  const n = e.yAlign || t.yAlign || Up(i, e);
  return {
    xAlign: e.xAlign || t.xAlign || Hp(i, t, e, n),
    yAlign: n
  };
}
function Yp(i, t) {
  let { x: e, width: n } = i;
  return t === "right" ? e -= n : t === "center" && (e -= n / 2), e;
}
function Gp(i, t, e) {
  let { y: n, height: r } = i;
  return t === "top" ? n += e : t === "bottom" ? n -= r + e : n -= r / 2, n;
}
function Pa(i, t, e, n) {
  const { caretSize: r, caretPadding: s, cornerRadius: o } = i, { xAlign: a, yAlign: c } = e, l = r + s, { topLeft: u, topRight: h, bottomLeft: f, bottomRight: d } = Pe(o);
  let p = Yp(t, a);
  const g = Gp(t, c, l);
  return c === "center" ? a === "left" ? p += l : a === "right" && (p -= l) : a === "left" ? p -= Math.max(u, f) + r : a === "right" && (p += Math.max(h, d) + r), {
    x: ft(p, 0, n.width - t.width),
    y: ft(g, 0, n.height - t.height)
  };
}
function en(i, t, e) {
  const n = xt(e.padding);
  return t === "center" ? i.x + i.width / 2 : t === "right" ? i.x + i.width - n.right : i.x + n.left;
}
function Ra(i) {
  return Ct([], Vt(i));
}
function Xp(i, t, e) {
  return re(i, {
    tooltip: t,
    tooltipItems: e,
    type: "tooltip"
  });
}
function Ia(i, t) {
  const e = t && t.dataset && t.dataset.tooltip && t.dataset.tooltip.callbacks;
  return e ? i.override(e) : i;
}
class Kp extends $t {
  constructor(t) {
    super(), this.opacity = 0, this._active = [], this._eventPosition = void 0, this._size = void 0, this._cachedAnimations = void 0, this._tooltipItems = [], this.$animations = void 0, this.$context = void 0, this.chart = t.chart || t._chart, this._chart = this.chart, this.options = t.options, this.dataPoints = void 0, this.title = void 0, this.beforeBody = void 0, this.body = void 0, this.afterBody = void 0, this.footer = void 0, this.xAlign = void 0, this.yAlign = void 0, this.x = void 0, this.y = void 0, this.height = void 0, this.width = void 0, this.caretX = void 0, this.caretY = void 0, this.labelColors = void 0, this.labelPointStyles = void 0, this.labelTextColors = void 0;
  }
  initialize(t) {
    this.options = t, this._cachedAnimations = void 0, this.$context = void 0;
  }
  _resolveAnimations() {
    const t = this._cachedAnimations;
    if (t)
      return t;
    const e = this.chart, n = this.options.setContext(this.getContext()), r = n.enabled && e.options.animation && n.animations, s = new vl(this.chart, r);
    return r._cacheable && (this._cachedAnimations = Object.freeze(s)), s;
  }
  getContext() {
    return this.$context || (this.$context = Xp(this.chart.getContext(), this, this._tooltipItems));
  }
  getTitle(t, e) {
    const { callbacks: n } = e, r = n.beforeTitle.apply(this, [t]), s = n.title.apply(this, [t]), o = n.afterTitle.apply(this, [t]);
    let a = [];
    return a = Ct(a, Vt(r)), a = Ct(a, Vt(s)), a = Ct(a, Vt(o)), a;
  }
  getBeforeBody(t, e) {
    return Ra(e.callbacks.beforeBody.apply(this, [t]));
  }
  getBody(t, e) {
    const { callbacks: n } = e, r = [];
    return j(t, (s) => {
      const o = {
        before: [],
        lines: [],
        after: []
      }, a = Ia(n, s);
      Ct(o.before, Vt(a.beforeLabel.call(this, s))), Ct(o.lines, a.label.call(this, s)), Ct(o.after, Vt(a.afterLabel.call(this, s))), r.push(o);
    }), r;
  }
  getAfterBody(t, e) {
    return Ra(e.callbacks.afterBody.apply(this, [t]));
  }
  getFooter(t, e) {
    const { callbacks: n } = e, r = n.beforeFooter.apply(this, [t]), s = n.footer.apply(this, [t]), o = n.afterFooter.apply(this, [t]);
    let a = [];
    return a = Ct(a, Vt(r)), a = Ct(a, Vt(s)), a = Ct(a, Vt(o)), a;
  }
  _createItems(t) {
    const e = this._active, n = this.chart.data, r = [], s = [], o = [];
    let a = [], c, l;
    for (c = 0, l = e.length; c < l; ++c)
      a.push(Qp(this.chart, e[c]));
    return t.filter && (a = a.filter((u, h, f) => t.filter(u, h, f, n))), t.itemSort && (a = a.sort((u, h) => t.itemSort(u, h, n))), j(a, (u) => {
      const h = Ia(t.callbacks, u);
      r.push(h.labelColor.call(this, u)), s.push(h.labelPointStyle.call(this, u)), o.push(h.labelTextColor.call(this, u));
    }), this.labelColors = r, this.labelPointStyles = s, this.labelTextColors = o, this.dataPoints = a, a;
  }
  update(t, e) {
    const n = this.options.setContext(this.getContext()), r = this._active;
    let s, o = [];
    if (!r.length)
      this.opacity !== 0 && (s = {
        opacity: 0
      });
    else {
      const a = ln[n.position].call(this, r, this._eventPosition);
      o = this._createItems(n), this.title = this.getTitle(o, n), this.beforeBody = this.getBeforeBody(o, n), this.body = this.getBody(o, n), this.afterBody = this.getAfterBody(o, n), this.footer = this.getFooter(o, n);
      const c = this._size = Aa(this, n), l = Object.assign({}, a, c), u = Ca(this.chart, n, l), h = Pa(n, l, u, this.chart);
      this.xAlign = u.xAlign, this.yAlign = u.yAlign, s = {
        opacity: 1,
        x: h.x,
        y: h.y,
        width: c.width,
        height: c.height,
        caretX: a.x,
        caretY: a.y
      };
    }
    this._tooltipItems = o, this.$context = void 0, s && this._resolveAnimations().update(this, s), t && n.external && n.external.call(this, { chart: this.chart, tooltip: this, replay: e });
  }
  drawCaret(t, e, n, r) {
    const s = this.getCaretPosition(t, n, r);
    e.lineTo(s.x1, s.y1), e.lineTo(s.x2, s.y2), e.lineTo(s.x3, s.y3);
  }
  getCaretPosition(t, e, n) {
    const { xAlign: r, yAlign: s } = this, { caretSize: o, cornerRadius: a } = n, { topLeft: c, topRight: l, bottomLeft: u, bottomRight: h } = Pe(a), { x: f, y: d } = t, { width: p, height: g } = e;
    let m, y, b, v, _, x;
    return s === "center" ? (_ = d + g / 2, r === "left" ? (m = f, y = m - o, v = _ + o, x = _ - o) : (m = f + p, y = m + o, v = _ - o, x = _ + o), b = m) : (r === "left" ? y = f + Math.max(c, u) + o : r === "right" ? y = f + p - Math.max(l, h) - o : y = this.caretX, s === "top" ? (v = d, _ = v - o, m = y - o, b = y + o) : (v = d + g, _ = v + o, m = y + o, b = y - o), x = v), { x1: m, x2: y, x3: b, y1: v, y2: _, y3: x };
  }
  drawTitle(t, e, n) {
    const r = this.title, s = r.length;
    let o, a, c;
    if (s) {
      const l = pr(n.rtl, this.x, this.width);
      for (t.x = en(this, n.titleAlign, n), e.textAlign = l.textAlign(n.titleAlign), e.textBaseline = "middle", o = gt(n.titleFont), a = n.titleSpacing, e.fillStyle = n.titleColor, e.font = o.string, c = 0; c < s; ++c)
        e.fillText(r[c], l.x(t.x), t.y + o.lineHeight / 2), t.y += o.lineHeight + a, c + 1 === s && (t.y += n.titleMarginBottom - a);
    }
  }
  _drawColorBox(t, e, n, r, s) {
    const o = this.labelColors[n], a = this.labelPointStyles[n], { boxHeight: c, boxWidth: l, boxPadding: u } = s, h = gt(s.bodyFont), f = en(this, "left", s), d = r.x(f), p = c < h.lineHeight ? (h.lineHeight - c) / 2 : 0, g = e.y + p;
    if (s.usePointStyle) {
      const m = {
        radius: Math.min(l, c) / 2,
        pointStyle: a.pointStyle,
        rotation: a.rotation,
        borderWidth: 1
      }, y = r.leftForLtr(d, l) + l / 2, b = g + c / 2;
      t.strokeStyle = s.multiKeyBackground, t.fillStyle = s.multiKeyBackground, qr(t, m, y, b), t.strokeStyle = o.borderColor, t.fillStyle = o.backgroundColor, qr(t, m, y, b);
    } else {
      t.lineWidth = L(o.borderWidth) ? Math.max(...Object.values(o.borderWidth)) : o.borderWidth || 1, t.strokeStyle = o.borderColor, t.setLineDash(o.borderDash || []), t.lineDashOffset = o.borderDashOffset || 0;
      const m = r.leftForLtr(d, l - u), y = r.leftForLtr(r.xPlus(d, 1), l - u - 2), b = Pe(o.borderRadius);
      Object.values(b).some((v) => v !== 0) ? (t.beginPath(), t.fillStyle = s.multiKeyBackground, On(t, {
        x: m,
        y: g,
        w: l,
        h: c,
        radius: b
      }), t.fill(), t.stroke(), t.fillStyle = o.backgroundColor, t.beginPath(), On(t, {
        x: y,
        y: g + 1,
        w: l - 2,
        h: c - 2,
        radius: b
      }), t.fill()) : (t.fillStyle = s.multiKeyBackground, t.fillRect(m, g, l, c), t.strokeRect(m, g, l, c), t.fillStyle = o.backgroundColor, t.fillRect(y, g + 1, l - 2, c - 2));
    }
    t.fillStyle = this.labelTextColors[n];
  }
  drawBody(t, e, n) {
    const { body: r } = this, { bodySpacing: s, bodyAlign: o, displayColors: a, boxHeight: c, boxWidth: l, boxPadding: u } = n, h = gt(n.bodyFont);
    let f = h.lineHeight, d = 0;
    const p = pr(n.rtl, this.x, this.width), g = function(O) {
      e.fillText(O, p.x(t.x + d), t.y + f / 2), t.y += f + s;
    }, m = p.textAlign(o);
    let y, b, v, _, x, k, E;
    for (e.textAlign = o, e.textBaseline = "middle", e.font = h.string, t.x = en(this, m, n), e.fillStyle = n.bodyColor, j(this.beforeBody, g), d = a && m !== "right" ? o === "center" ? l / 2 + u : l + 2 + u : 0, _ = 0, k = r.length; _ < k; ++_) {
      for (y = r[_], b = this.labelTextColors[_], e.fillStyle = b, j(y.before, g), v = y.lines, a && v.length && (this._drawColorBox(e, t, _, p, n), f = Math.max(h.lineHeight, c)), x = 0, E = v.length; x < E; ++x)
        g(v[x]), f = h.lineHeight;
      j(y.after, g);
    }
    d = 0, f = h.lineHeight, j(this.afterBody, g), t.y -= s;
  }
  drawFooter(t, e, n) {
    const r = this.footer, s = r.length;
    let o, a;
    if (s) {
      const c = pr(n.rtl, this.x, this.width);
      for (t.x = en(this, n.footerAlign, n), t.y += n.footerMarginTop, e.textAlign = c.textAlign(n.footerAlign), e.textBaseline = "middle", o = gt(n.footerFont), e.fillStyle = n.footerColor, e.font = o.string, a = 0; a < s; ++a)
        e.fillText(r[a], c.x(t.x), t.y + o.lineHeight / 2), t.y += o.lineHeight + n.footerSpacing;
    }
  }
  drawBackground(t, e, n, r) {
    const { xAlign: s, yAlign: o } = this, { x: a, y: c } = t, { width: l, height: u } = n, { topLeft: h, topRight: f, bottomLeft: d, bottomRight: p } = Pe(r.cornerRadius);
    e.fillStyle = r.backgroundColor, e.strokeStyle = r.borderColor, e.lineWidth = r.borderWidth, e.beginPath(), e.moveTo(a + h, c), o === "top" && this.drawCaret(t, e, n, r), e.lineTo(a + l - f, c), e.quadraticCurveTo(a + l, c, a + l, c + f), o === "center" && s === "right" && this.drawCaret(t, e, n, r), e.lineTo(a + l, c + u - p), e.quadraticCurveTo(a + l, c + u, a + l - p, c + u), o === "bottom" && this.drawCaret(t, e, n, r), e.lineTo(a + d, c + u), e.quadraticCurveTo(a, c + u, a, c + u - d), o === "center" && s === "left" && this.drawCaret(t, e, n, r), e.lineTo(a, c + h), e.quadraticCurveTo(a, c, a + h, c), e.closePath(), e.fill(), r.borderWidth > 0 && e.stroke();
  }
  _updateAnimationTarget(t) {
    const e = this.chart, n = this.$animations, r = n && n.x, s = n && n.y;
    if (r || s) {
      const o = ln[t.position].call(this, this._active, this._eventPosition);
      if (!o)
        return;
      const a = this._size = Aa(this, t), c = Object.assign({}, o, this._size), l = Ca(e, t, c), u = Pa(t, c, l, e);
      (r._to !== u.x || s._to !== u.y) && (this.xAlign = l.xAlign, this.yAlign = l.yAlign, this.width = a.width, this.height = a.height, this.caretX = o.x, this.caretY = o.y, this._resolveAnimations().update(this, u));
    }
  }
  _willRender() {
    return !!this.opacity;
  }
  draw(t) {
    const e = this.options.setContext(this.getContext());
    let n = this.opacity;
    if (!n)
      return;
    this._updateAnimationTarget(e);
    const r = {
      width: this.width,
      height: this.height
    }, s = {
      x: this.x,
      y: this.y
    };
    n = Math.abs(n) < 1e-3 ? 0 : n;
    const o = xt(e.padding), a = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
    e.enabled && a && (t.save(), t.globalAlpha = n, this.drawBackground(s, t, r, e), Pf(t, e.textDirection), s.y += o.top, this.drawTitle(s, t, e), this.drawBody(s, t, e), this.drawFooter(s, t, e), Rf(t, e.textDirection), t.restore());
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(t, e) {
    const n = this._active, r = t.map(({ datasetIndex: a, index: c }) => {
      const l = this.chart.getDatasetMeta(a);
      if (!l)
        throw new Error("Cannot find a dataset at index " + a);
      return {
        datasetIndex: a,
        element: l.data[c],
        index: c
      };
    }), s = !bn(n, r), o = this._positionChanged(r, e);
    (s || o) && (this._active = r, this._eventPosition = e, this._ignoreReplayEvents = !0, this.update(!0));
  }
  handleEvent(t, e, n = !0) {
    if (e && this._ignoreReplayEvents)
      return !1;
    this._ignoreReplayEvents = !1;
    const r = this.options, s = this._active || [], o = this._getActiveElements(t, s, e, n), a = this._positionChanged(o, t), c = e || !bn(o, s) || a;
    return c && (this._active = o, (r.enabled || r.external) && (this._eventPosition = {
      x: t.x,
      y: t.y
    }, this.update(!0, e))), c;
  }
  _getActiveElements(t, e, n, r) {
    const s = this.options;
    if (t.type === "mouseout")
      return [];
    if (!r)
      return e;
    const o = this.chart.getElementsAtEventForMode(t, s.mode, s, n);
    return s.reverse && o.reverse(), o;
  }
  _positionChanged(t, e) {
    const { caretX: n, caretY: r, options: s } = this, o = ln[s.position].call(this, t, e);
    return o !== !1 && (n !== o.x || r !== o.y);
  }
}
Kp.positioners = ln;
const Jp = (i, t, e, n) => (typeof t == "string" ? (e = i.push(t) - 1, n.unshift({ index: e, label: t })) : isNaN(t) && (e = null), e);
function Zp(i, t, e, n) {
  const r = i.indexOf(t);
  if (r === -1)
    return Jp(i, t, e, n);
  const s = i.lastIndexOf(t);
  return r !== s ? e : r;
}
const tg = (i, t) => i === null ? null : ft(Math.round(i), 0, t);
class Gr extends be {
  constructor(t) {
    super(t), this._startValue = void 0, this._valueRange = 0, this._addedLabels = [];
  }
  init(t) {
    const e = this._addedLabels;
    if (e.length) {
      const n = this.getLabels();
      for (const { index: r, label: s } of e)
        n[r] === s && n.splice(r, 1);
      this._addedLabels = [];
    }
    super.init(t);
  }
  parse(t, e) {
    if ($(t))
      return null;
    const n = this.getLabels();
    return e = isFinite(e) && n[e] === t ? e : Zp(n, t, F(e, t), this._addedLabels), tg(e, n.length - 1);
  }
  determineDataLimits() {
    const { minDefined: t, maxDefined: e } = this.getUserBounds();
    let { min: n, max: r } = this.getMinMax(!0);
    this.options.bounds === "ticks" && (t || (n = 0), e || (r = this.getLabels().length - 1)), this.min = n, this.max = r;
  }
  buildTicks() {
    const t = this.min, e = this.max, n = this.options.offset, r = [];
    let s = this.getLabels();
    s = t === 0 && e === s.length - 1 ? s : s.slice(t, e + 1), this._valueRange = Math.max(s.length - (n ? 0 : 1), 1), this._startValue = this.min - (n ? 0.5 : 0);
    for (let o = t; o <= e; o++)
      r.push({ value: o });
    return r;
  }
  getLabelForValue(t) {
    const e = this.getLabels();
    return t >= 0 && t < e.length ? e[t] : t;
  }
  configure() {
    super.configure(), this.isHorizontal() || (this._reversePixels = !this._reversePixels);
  }
  getPixelForValue(t) {
    return typeof t != "number" && (t = this.parse(t)), t === null ? NaN : this.getPixelForDecimal((t - this._startValue) / this._valueRange);
  }
  getPixelForTick(t) {
    const e = this.ticks;
    return t < 0 || t > e.length - 1 ? null : this.getPixelForValue(e[t].value);
  }
  getValueForPixel(t) {
    return Math.round(this._startValue + this.getDecimalForPixel(t) * this._valueRange);
  }
  getBasePixel() {
    return this.bottom;
  }
}
Gr.id = "category";
Gr.defaults = {
  ticks: {
    callback: Gr.prototype.getLabelForValue
  }
};
function eg(i, t) {
  const e = [], { bounds: r, step: s, min: o, max: a, precision: c, count: l, maxTicks: u, maxDigits: h, includeBounds: f } = i, d = s || 1, p = u - 1, { min: g, max: m } = t, y = !$(o), b = !$(a), v = !$(l), _ = (m - g) / (h + 1);
  let x = Vo((m - g) / p / d) * d, k, E, O, M;
  if (x < 1e-14 && !y && !b)
    return [{ value: g }, { value: m }];
  M = Math.ceil(m / x) - Math.floor(g / x), M > p && (x = Vo(M * x / p / d) * d), $(c) || (k = Math.pow(10, c), x = Math.ceil(x * k) / k), r === "ticks" ? (E = Math.floor(g / x) * x, O = Math.ceil(m / x) * x) : (E = g, O = m), y && b && s && ph((a - o) / s, x / 1e3) ? (M = Math.round(Math.min((a - o) / x, u)), x = (a - o) / M, E = o, O = a) : v ? (E = y ? o : E, O = b ? a : O, M = l - 1, x = (O - E) / M) : (M = (O - E) / x, mi(M, Math.round(M), x / 1e3) ? M = Math.round(M) : M = Math.ceil(M));
  const C = Math.max(
    jo(x),
    jo(E)
  );
  k = Math.pow(10, $(c) ? C : c), E = Math.round(E * k) / k, O = Math.round(O * k) / k;
  let V = 0;
  for (y && (f && E !== o ? (e.push({ value: o }), E < o && V++, mi(Math.round((E + V * x) * k) / k, o, Fa(o, _, i)) && V++) : E < o && V++); V < M; ++V)
    e.push({ value: Math.round((E + V * x) * k) / k });
  return b && f && O !== a ? e.length && mi(e[e.length - 1].value, a, Fa(a, _, i)) ? e[e.length - 1].value = a : e.push({ value: a }) : (!b || O === a) && e.push({ value: O }), e;
}
function Fa(i, t, { horizontal: e, minRotation: n }) {
  const r = kt(n), s = (e ? Math.sin(r) : Math.cos(r)) || 1e-3, o = 0.75 * t * ("" + i).length;
  return Math.min(t / s, o);
}
class Cn extends be {
  constructor(t) {
    super(t), this.start = void 0, this.end = void 0, this._startValue = void 0, this._endValue = void 0, this._valueRange = 0;
  }
  parse(t, e) {
    return $(t) || (typeof t == "number" || t instanceof Number) && !isFinite(+t) ? null : +t;
  }
  handleTickRangeOptions() {
    const { beginAtZero: t } = this.options, { minDefined: e, maxDefined: n } = this.getUserBounds();
    let { min: r, max: s } = this;
    const o = (c) => r = e ? r : c, a = (c) => s = n ? s : c;
    if (t) {
      const c = Rt(r), l = Rt(s);
      c < 0 && l < 0 ? a(0) : c > 0 && l > 0 && o(0);
    }
    if (r === s) {
      let c = 1;
      (s >= Number.MAX_SAFE_INTEGER || r <= Number.MIN_SAFE_INTEGER) && (c = Math.abs(s * 0.05)), a(s + c), t || o(r - c);
    }
    this.min = r, this.max = s;
  }
  getTickLimit() {
    const t = this.options.ticks;
    let { maxTicksLimit: e, stepSize: n } = t, r;
    return n ? (r = Math.ceil(this.max / n) - Math.floor(this.min / n) + 1, r > 1e3 && (console.warn(`scales.${this.id}.ticks.stepSize: ${n} would result generating up to ${r} ticks. Limiting to 1000.`), r = 1e3)) : (r = this.computeTickLimit(), e = e || 11), e && (r = Math.min(e, r)), r;
  }
  computeTickLimit() {
    return Number.POSITIVE_INFINITY;
  }
  buildTicks() {
    const t = this.options, e = t.ticks;
    let n = this.getTickLimit();
    n = Math.max(2, n);
    const r = {
      maxTicks: n,
      bounds: t.bounds,
      min: t.min,
      max: t.max,
      precision: e.precision,
      step: e.stepSize,
      count: e.count,
      maxDigits: this._maxDigits(),
      horizontal: this.isHorizontal(),
      minRotation: e.minRotation || 0,
      includeBounds: e.includeBounds !== !1
    }, s = this._range || this, o = eg(r, s);
    return t.bounds === "ticks" && Yc(o, this, "value"), t.reverse ? (o.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), o;
  }
  configure() {
    const t = this.ticks;
    let e = this.min, n = this.max;
    if (super.configure(), this.options.offset && t.length) {
      const r = (n - e) / Math.max(t.length - 1, 1) / 2;
      e -= r, n += r;
    }
    this._startValue = e, this._endValue = n, this._valueRange = n - e;
  }
  getLabelForValue(t) {
    return ji(t, this.chart.options.locale, this.options.ticks.format);
  }
}
class Nl extends Cn {
  determineDataLimits() {
    const { min: t, max: e } = this.getMinMax(!0);
    this.min = ut(t) ? t : 0, this.max = ut(e) ? e : 1, this.handleTickRangeOptions();
  }
  computeTickLimit() {
    const t = this.isHorizontal(), e = t ? this.width : this.height, n = kt(this.options.ticks.minRotation), r = (t ? Math.sin(n) : Math.cos(n)) || 1e-3, s = this._resolveTickFontOptions(0);
    return Math.ceil(e / Math.min(40, s.lineHeight / r));
  }
  getPixelForValue(t) {
    return t === null ? NaN : this.getPixelForDecimal((t - this._startValue) / this._valueRange);
  }
  getValueForPixel(t) {
    return this._startValue + this.getDecimalForPixel(t) * this._valueRange;
  }
}
Nl.id = "linear";
Nl.defaults = {
  ticks: {
    callback: qn.formatters.numeric
  }
};
function La(i) {
  return i / Math.pow(10, Math.floor(bt(i))) === 1;
}
function ig(i, t) {
  const e = Math.floor(bt(t.max)), n = Math.ceil(t.max / Math.pow(10, e)), r = [];
  let s = yt(i.min, Math.pow(10, Math.floor(bt(t.min)))), o = Math.floor(bt(s)), a = Math.floor(s / Math.pow(10, o)), c = o < 0 ? Math.pow(10, Math.abs(o)) : 1;
  do
    r.push({ value: s, major: La(s) }), ++a, a === 10 && (a = 1, ++o, c = o >= 0 ? 1 : c), s = Math.round(a * Math.pow(10, o) * c) / c;
  while (o < e || o === e && a < n);
  const l = yt(i.max, s);
  return r.push({ value: l, major: La(s) }), r;
}
class Vl extends be {
  constructor(t) {
    super(t), this.start = void 0, this.end = void 0, this._startValue = void 0, this._valueRange = 0;
  }
  parse(t, e) {
    const n = Cn.prototype.parse.apply(this, [t, e]);
    if (n === 0) {
      this._zero = !0;
      return;
    }
    return ut(n) && n > 0 ? n : null;
  }
  determineDataLimits() {
    const { min: t, max: e } = this.getMinMax(!0);
    this.min = ut(t) ? Math.max(0, t) : null, this.max = ut(e) ? Math.max(0, e) : null, this.options.beginAtZero && (this._zero = !0), this.handleTickRangeOptions();
  }
  handleTickRangeOptions() {
    const { minDefined: t, maxDefined: e } = this.getUserBounds();
    let n = this.min, r = this.max;
    const s = (c) => n = t ? n : c, o = (c) => r = e ? r : c, a = (c, l) => Math.pow(10, Math.floor(bt(c)) + l);
    n === r && (n <= 0 ? (s(1), o(10)) : (s(a(n, -1)), o(a(r, 1)))), n <= 0 && s(a(r, -1)), r <= 0 && o(a(n, 1)), this._zero && this.min !== this._suggestedMin && n === a(this.min, 0) && s(a(n, -1)), this.min = n, this.max = r;
  }
  buildTicks() {
    const t = this.options, e = {
      min: this._userMin,
      max: this._userMax
    }, n = ig(e, this);
    return t.bounds === "ticks" && Yc(n, this, "value"), t.reverse ? (n.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), n;
  }
  getLabelForValue(t) {
    return t === void 0 ? "0" : ji(t, this.chart.options.locale, this.options.ticks.format);
  }
  configure() {
    const t = this.min;
    super.configure(), this._startValue = bt(t), this._valueRange = bt(this.max) - bt(t);
  }
  getPixelForValue(t) {
    return (t === void 0 || t === 0) && (t = this.min), t === null || isNaN(t) ? NaN : this.getPixelForDecimal(t === this.min ? 0 : (bt(t) - this._startValue) / this._valueRange);
  }
  getValueForPixel(t) {
    const e = this.getDecimalForPixel(t);
    return Math.pow(10, this._startValue + e * this._valueRange);
  }
}
Vl.id = "logarithmic";
Vl.defaults = {
  ticks: {
    callback: qn.formatters.logarithmic,
    major: {
      enabled: !0
    }
  }
};
function Xr(i) {
  const t = i.ticks;
  if (t.display && i.display) {
    const e = xt(t.backdropPadding);
    return F(t.font && t.font.size, I.font.size) + e.height;
  }
  return 0;
}
function ng(i, t, e) {
  return e = H(e) ? e : [e], {
    w: Wh(i, t.string, e),
    h: e.length * t.lineHeight
  };
}
function Na(i, t, e, n, r) {
  return i === n || i === r ? {
    start: t - e / 2,
    end: t + e / 2
  } : i < n || i > r ? {
    start: t - e,
    end: t
  } : {
    start: t,
    end: t + e
  };
}
function rg(i) {
  const t = {
    l: i.left + i._padding.left,
    r: i.right - i._padding.right,
    t: i.top + i._padding.top,
    b: i.bottom - i._padding.bottom
  }, e = Object.assign({}, t), n = [], r = [], s = i._pointLabels.length, o = i.options.pointLabels, a = o.centerPointLabels ? Z / s : 0;
  for (let c = 0; c < s; c++) {
    const l = o.setContext(i.getPointLabelContext(c));
    r[c] = l.padding;
    const u = i.getPointPosition(c, i.drawingArea + r[c], a), h = gt(l.font), f = ng(i.ctx, h, i._pointLabels[c]);
    n[c] = f;
    const d = Et(i.getIndexAngle(c) + a), p = Math.round(Ms(d)), g = Na(p, u.x, f.w, 0, 180), m = Na(p, u.y, f.h, 90, 270);
    sg(e, t, d, g, m);
  }
  i.setCenterPoint(
    t.l - e.l,
    e.r - t.r,
    t.t - e.t,
    e.b - t.b
  ), i._pointLabelItems = og(i, n, r);
}
function sg(i, t, e, n, r) {
  const s = Math.abs(Math.sin(e)), o = Math.abs(Math.cos(e));
  let a = 0, c = 0;
  n.start < t.l ? (a = (t.l - n.start) / s, i.l = Math.min(i.l, t.l - a)) : n.end > t.r && (a = (n.end - t.r) / s, i.r = Math.max(i.r, t.r + a)), r.start < t.t ? (c = (t.t - r.start) / o, i.t = Math.min(i.t, t.t - c)) : r.end > t.b && (c = (r.end - t.b) / o, i.b = Math.max(i.b, t.b + c));
}
function og(i, t, e) {
  const n = [], r = i._pointLabels.length, s = i.options, o = Xr(s) / 2, a = i.drawingArea, c = s.pointLabels.centerPointLabels ? Z / r : 0;
  for (let l = 0; l < r; l++) {
    const u = i.getPointPosition(l, a + o + e[l], c), h = Math.round(Ms(Et(u.angle + K))), f = t[l], d = lg(u.y, f.h, h), p = ag(h), g = cg(u.x, f.w, p);
    n.push({
      x: u.x,
      y: d,
      textAlign: p,
      left: g,
      top: d,
      right: g + f.w,
      bottom: d + f.h
    });
  }
  return n;
}
function ag(i) {
  return i === 0 || i === 180 ? "center" : i < 180 ? "left" : "right";
}
function cg(i, t, e) {
  return e === "right" ? i -= t : e === "center" && (i -= t / 2), i;
}
function lg(i, t, e) {
  return e === 90 || e === 270 ? i -= t / 2 : (e > 270 || e < 90) && (i -= t), i;
}
function ug(i, t) {
  const { ctx: e, options: { pointLabels: n } } = i;
  for (let r = t - 1; r >= 0; r--) {
    const s = n.setContext(i.getPointLabelContext(r)), o = gt(s.font), { x: a, y: c, textAlign: l, left: u, top: h, right: f, bottom: d } = i._pointLabelItems[r], { backdropColor: p } = s;
    if (!$(p)) {
      const g = Pe(s.borderRadius), m = xt(s.backdropPadding);
      e.fillStyle = p;
      const y = u - m.left, b = h - m.top, v = f - u + m.width, _ = d - h + m.height;
      Object.values(g).some((x) => x !== 0) ? (e.beginPath(), On(e, {
        x: y,
        y: b,
        w: v,
        h: _,
        radius: g
      }), e.fill()) : e.fillRect(y, b, v, _);
    }
    kn(
      e,
      i._pointLabels[r],
      a,
      c + o.lineHeight / 2,
      o,
      {
        color: s.color,
        textAlign: l,
        textBaseline: "middle"
      }
    );
  }
}
function jl(i, t, e, n) {
  const { ctx: r } = i;
  if (e)
    r.arc(i.xCenter, i.yCenter, t, 0, Q);
  else {
    let s = i.getPointPosition(0, t);
    r.moveTo(s.x, s.y);
    for (let o = 1; o < n; o++)
      s = i.getPointPosition(o, t), r.lineTo(s.x, s.y);
  }
}
function hg(i, t, e, n) {
  const r = i.ctx, s = t.circular, { color: o, lineWidth: a } = t;
  !s && !n || !o || !a || e < 0 || (r.save(), r.strokeStyle = o, r.lineWidth = a, r.setLineDash(t.borderDash), r.lineDashOffset = t.borderDashOffset, r.beginPath(), jl(i, e, s, n), r.closePath(), r.stroke(), r.restore());
}
function fg(i, t, e) {
  return re(i, {
    label: e,
    index: t,
    type: "pointLabel"
  });
}
class Un extends Cn {
  constructor(t) {
    super(t), this.xCenter = void 0, this.yCenter = void 0, this.drawingArea = void 0, this._pointLabels = [], this._pointLabelItems = [];
  }
  setDimensions() {
    const t = this._padding = xt(Xr(this.options) / 2), e = this.width = this.maxWidth - t.width, n = this.height = this.maxHeight - t.height;
    this.xCenter = Math.floor(this.left + e / 2 + t.left), this.yCenter = Math.floor(this.top + n / 2 + t.top), this.drawingArea = Math.floor(Math.min(e, n) / 2);
  }
  determineDataLimits() {
    const { min: t, max: e } = this.getMinMax(!1);
    this.min = ut(t) && !isNaN(t) ? t : 0, this.max = ut(e) && !isNaN(e) ? e : 0, this.handleTickRangeOptions();
  }
  computeTickLimit() {
    return Math.ceil(this.drawingArea / Xr(this.options));
  }
  generateTickLabels(t) {
    Cn.prototype.generateTickLabels.call(this, t), this._pointLabels = this.getLabels().map((e, n) => {
      const r = X(this.options.pointLabels.callback, [e, n], this);
      return r || r === 0 ? r : "";
    }).filter((e, n) => this.chart.getDataVisibility(n));
  }
  fit() {
    const t = this.options;
    t.display && t.pointLabels.display ? rg(this) : this.setCenterPoint(0, 0, 0, 0);
  }
  setCenterPoint(t, e, n, r) {
    this.xCenter += Math.floor((t - e) / 2), this.yCenter += Math.floor((n - r) / 2), this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(t, e, n, r));
  }
  getIndexAngle(t) {
    const e = Q / (this._pointLabels.length || 1), n = this.options.startAngle || 0;
    return Et(t * e + kt(n));
  }
  getDistanceFromCenterForValue(t) {
    if ($(t))
      return NaN;
    const e = this.drawingArea / (this.max - this.min);
    return this.options.reverse ? (this.max - t) * e : (t - this.min) * e;
  }
  getValueForDistanceFromCenter(t) {
    if ($(t))
      return NaN;
    const e = t / (this.drawingArea / (this.max - this.min));
    return this.options.reverse ? this.max - e : this.min + e;
  }
  getPointLabelContext(t) {
    const e = this._pointLabels || [];
    if (t >= 0 && t < e.length) {
      const n = e[t];
      return fg(this.getContext(), t, n);
    }
  }
  getPointPosition(t, e, n = 0) {
    const r = this.getIndexAngle(t) - K + n;
    return {
      x: Math.cos(r) * e + this.xCenter,
      y: Math.sin(r) * e + this.yCenter,
      angle: r
    };
  }
  getPointPositionForValue(t, e) {
    return this.getPointPosition(t, this.getDistanceFromCenterForValue(e));
  }
  getBasePosition(t) {
    return this.getPointPositionForValue(t || 0, this.getBaseValue());
  }
  getPointLabelPosition(t) {
    const { left: e, top: n, right: r, bottom: s } = this._pointLabelItems[t];
    return {
      left: e,
      top: n,
      right: r,
      bottom: s
    };
  }
  drawBackground() {
    const { backgroundColor: t, grid: { circular: e } } = this.options;
    if (t) {
      const n = this.ctx;
      n.save(), n.beginPath(), jl(this, this.getDistanceFromCenterForValue(this._endValue), e, this._pointLabels.length), n.closePath(), n.fillStyle = t, n.fill(), n.restore();
    }
  }
  drawGrid() {
    const t = this.ctx, e = this.options, { angleLines: n, grid: r } = e, s = this._pointLabels.length;
    let o, a, c;
    if (e.pointLabels.display && ug(this, s), r.display && this.ticks.forEach((l, u) => {
      if (u !== 0) {
        a = this.getDistanceFromCenterForValue(l.value);
        const h = r.setContext(this.getContext(u - 1));
        hg(this, h, a, s);
      }
    }), n.display) {
      for (t.save(), o = s - 1; o >= 0; o--) {
        const l = n.setContext(this.getPointLabelContext(o)), { color: u, lineWidth: h } = l;
        !h || !u || (t.lineWidth = h, t.strokeStyle = u, t.setLineDash(l.borderDash), t.lineDashOffset = l.borderDashOffset, a = this.getDistanceFromCenterForValue(e.ticks.reverse ? this.min : this.max), c = this.getPointPosition(o, a), t.beginPath(), t.moveTo(this.xCenter, this.yCenter), t.lineTo(c.x, c.y), t.stroke());
      }
      t.restore();
    }
  }
  drawBorder() {
  }
  drawLabels() {
    const t = this.ctx, e = this.options, n = e.ticks;
    if (!n.display)
      return;
    const r = this.getIndexAngle(0);
    let s, o;
    t.save(), t.translate(this.xCenter, this.yCenter), t.rotate(r), t.textAlign = "center", t.textBaseline = "middle", this.ticks.forEach((a, c) => {
      if (c === 0 && !e.reverse)
        return;
      const l = n.setContext(this.getContext(c)), u = gt(l.font);
      if (s = this.getDistanceFromCenterForValue(this.ticks[c].value), l.showLabelBackdrop) {
        t.font = u.string, o = t.measureText(a.label).width, t.fillStyle = l.backdropColor;
        const h = xt(l.backdropPadding);
        t.fillRect(
          -o / 2 - h.left,
          -s - u.size / 2 - h.top,
          o + h.width,
          u.size + h.height
        );
      }
      kn(t, a.label, 0, -s, u, {
        color: l.color
      });
    }), t.restore();
  }
  drawTitle() {
  }
}
Un.id = "radialLinear";
Un.defaults = {
  display: !0,
  animate: !0,
  position: "chartArea",
  angleLines: {
    display: !0,
    lineWidth: 1,
    borderDash: [],
    borderDashOffset: 0
  },
  grid: {
    circular: !1
  },
  startAngle: 0,
  ticks: {
    showLabelBackdrop: !0,
    callback: qn.formatters.numeric
  },
  pointLabels: {
    backdropColor: void 0,
    backdropPadding: 2,
    display: !0,
    font: {
      size: 10
    },
    callback(i) {
      return i;
    },
    padding: 5,
    centerPointLabels: !1
  }
};
Un.defaultRoutes = {
  "angleLines.color": "borderColor",
  "pointLabels.color": "color",
  "ticks.color": "color"
};
Un.descriptors = {
  angleLines: {
    _fallback: "grid"
  }
};
const Wn = {
  millisecond: { common: !0, size: 1, steps: 1e3 },
  second: { common: !0, size: 1e3, steps: 60 },
  minute: { common: !0, size: 6e4, steps: 60 },
  hour: { common: !0, size: 36e5, steps: 24 },
  day: { common: !0, size: 864e5, steps: 30 },
  week: { common: !1, size: 6048e5, steps: 4 },
  month: { common: !0, size: 2628e6, steps: 12 },
  quarter: { common: !1, size: 7884e6, steps: 4 },
  year: { common: !0, size: 3154e7 }
}, pt = Object.keys(Wn);
function dg(i, t) {
  return i - t;
}
function Va(i, t) {
  if ($(t))
    return null;
  const e = i._adapter, { parser: n, round: r, isoWeekday: s } = i._parseOpts;
  let o = t;
  return typeof n == "function" && (o = n(o)), ut(o) || (o = typeof n == "string" ? e.parse(o, n) : e.parse(o)), o === null ? null : (r && (o = r === "week" && ($e(s) || s === !0) ? e.startOf(o, "isoWeek", s) : e.startOf(o, r)), +o);
}
function ja(i, t, e, n) {
  const r = pt.length;
  for (let s = pt.indexOf(i); s < r - 1; ++s) {
    const o = Wn[pt[s]], a = o.steps ? o.steps : Number.MAX_SAFE_INTEGER;
    if (o.common && Math.ceil((e - t) / (a * o.size)) <= n)
      return pt[s];
  }
  return pt[r - 1];
}
function pg(i, t, e, n, r) {
  for (let s = pt.length - 1; s >= pt.indexOf(e); s--) {
    const o = pt[s];
    if (Wn[o].common && i._adapter.diff(r, n, o) >= t - 1)
      return o;
  }
  return pt[e ? pt.indexOf(e) : 0];
}
function gg(i) {
  for (let t = pt.indexOf(i) + 1, e = pt.length; t < e; ++t)
    if (Wn[pt[t]].common)
      return pt[t];
}
function Ba(i, t, e) {
  if (!e)
    i[t] = !0;
  else if (e.length) {
    const { lo: n, hi: r } = As(e, t), s = e[n] >= t ? e[n] : e[r];
    i[s] = !0;
  }
}
function mg(i, t, e, n) {
  const r = i._adapter, s = +r.startOf(t[0].value, n), o = t[t.length - 1].value;
  let a, c;
  for (a = s; a <= o; a = +r.add(a, 1, n))
    c = e[a], c >= 0 && (t[c].major = !0);
  return t;
}
function $a(i, t, e) {
  const n = [], r = {}, s = t.length;
  let o, a;
  for (o = 0; o < s; ++o)
    a = t[o], r[a] = o, n.push({
      value: a,
      major: !1
    });
  return s === 0 || !e ? n : mg(i, n, r, e);
}
class Hn extends be {
  constructor(t) {
    super(t), this._cache = {
      data: [],
      labels: [],
      all: []
    }, this._unit = "day", this._majorUnit = void 0, this._offsets = {}, this._normalized = !1, this._parseOpts = void 0;
  }
  init(t, e) {
    const n = t.time || (t.time = {}), r = this._adapter = new Id._date(t.adapters.date);
    r.init(e), gi(n.displayFormats, r.formats()), this._parseOpts = {
      parser: n.parser,
      round: n.round,
      isoWeekday: n.isoWeekday
    }, super.init(t), this._normalized = e.normalized;
  }
  parse(t, e) {
    return t === void 0 ? null : Va(this, t);
  }
  beforeLayout() {
    super.beforeLayout(), this._cache = {
      data: [],
      labels: [],
      all: []
    };
  }
  determineDataLimits() {
    const t = this.options, e = this._adapter, n = t.time.unit || "day";
    let { min: r, max: s, minDefined: o, maxDefined: a } = this.getUserBounds();
    function c(l) {
      !o && !isNaN(l.min) && (r = Math.min(r, l.min)), !a && !isNaN(l.max) && (s = Math.max(s, l.max));
    }
    (!o || !a) && (c(this._getLabelBounds()), (t.bounds !== "ticks" || t.ticks.source !== "labels") && c(this.getMinMax(!1))), r = ut(r) && !isNaN(r) ? r : +e.startOf(Date.now(), n), s = ut(s) && !isNaN(s) ? s : +e.endOf(Date.now(), n) + 1, this.min = Math.min(r, s - 1), this.max = Math.max(r + 1, s);
  }
  _getLabelBounds() {
    const t = this.getLabelTimestamps();
    let e = Number.POSITIVE_INFINITY, n = Number.NEGATIVE_INFINITY;
    return t.length && (e = t[0], n = t[t.length - 1]), { min: e, max: n };
  }
  buildTicks() {
    const t = this.options, e = t.time, n = t.ticks, r = n.source === "labels" ? this.getLabelTimestamps() : this._generate();
    t.bounds === "ticks" && r.length && (this.min = this._userMin || r[0], this.max = this._userMax || r[r.length - 1]);
    const s = this.min, o = this.max, a = vh(r, s, o);
    return this._unit = e.unit || (n.autoSkip ? ja(e.minUnit, this.min, this.max, this._getLabelCapacity(s)) : pg(this, a.length, e.minUnit, this.min, this.max)), this._majorUnit = !n.major.enabled || this._unit === "year" ? void 0 : gg(this._unit), this.initOffsets(r), t.reverse && a.reverse(), $a(this, a, this._majorUnit);
  }
  afterAutoSkip() {
    this.options.offsetAfterAutoskip && this.initOffsets(this.ticks.map((t) => +t.value));
  }
  initOffsets(t) {
    let e = 0, n = 0, r, s;
    this.options.offset && t.length && (r = this.getDecimalForValue(t[0]), t.length === 1 ? e = 1 - r : e = (this.getDecimalForValue(t[1]) - r) / 2, s = this.getDecimalForValue(t[t.length - 1]), t.length === 1 ? n = s : n = (s - this.getDecimalForValue(t[t.length - 2])) / 2);
    const o = t.length < 3 ? 0.5 : 0.25;
    e = ft(e, 0, o), n = ft(n, 0, o), this._offsets = { start: e, end: n, factor: 1 / (e + 1 + n) };
  }
  _generate() {
    const t = this._adapter, e = this.min, n = this.max, r = this.options, s = r.time, o = s.unit || ja(s.minUnit, e, n, this._getLabelCapacity(e)), a = F(s.stepSize, 1), c = o === "week" ? s.isoWeekday : !1, l = $e(c) || c === !0, u = {};
    let h = e, f, d;
    if (l && (h = +t.startOf(h, "isoWeek", c)), h = +t.startOf(h, l ? "day" : o), t.diff(n, e, o) > 1e5 * a)
      throw new Error(e + " and " + n + " are too far apart with stepSize of " + a + " " + o);
    const p = r.ticks.source === "data" && this.getDataTimestamps();
    for (f = h, d = 0; f < n; f = +t.add(f, a, o), d++)
      Ba(u, f, p);
    return (f === n || r.bounds === "ticks" || d === 1) && Ba(u, f, p), Object.keys(u).sort((g, m) => g - m).map((g) => +g);
  }
  getLabelForValue(t) {
    const e = this._adapter, n = this.options.time;
    return n.tooltipFormat ? e.format(t, n.tooltipFormat) : e.format(t, n.displayFormats.datetime);
  }
  _tickFormatFunction(t, e, n, r) {
    const s = this.options, o = s.time.displayFormats, a = this._unit, c = this._majorUnit, l = a && o[a], u = c && o[c], h = n[e], f = c && u && h && h.major, d = this._adapter.format(t, r || (f ? u : l)), p = s.ticks.callback;
    return p ? X(p, [d, e, n], this) : d;
  }
  generateTickLabels(t) {
    let e, n, r;
    for (e = 0, n = t.length; e < n; ++e)
      r = t[e], r.label = this._tickFormatFunction(r.value, e, t);
  }
  getDecimalForValue(t) {
    return t === null ? NaN : (t - this.min) / (this.max - this.min);
  }
  getPixelForValue(t) {
    const e = this._offsets, n = this.getDecimalForValue(t);
    return this.getPixelForDecimal((e.start + n) * e.factor);
  }
  getValueForPixel(t) {
    const e = this._offsets, n = this.getDecimalForPixel(t) / e.factor - e.end;
    return this.min + n * (this.max - this.min);
  }
  _getLabelSize(t) {
    const e = this.options.ticks, n = this.ctx.measureText(t).width, r = kt(this.isHorizontal() ? e.maxRotation : e.minRotation), s = Math.cos(r), o = Math.sin(r), a = this._resolveTickFontOptions(0).size;
    return {
      w: n * s + a * o,
      h: n * o + a * s
    };
  }
  _getLabelCapacity(t) {
    const e = this.options.time, n = e.displayFormats, r = n[e.unit] || n.millisecond, s = this._tickFormatFunction(t, 0, $a(this, [t], this._majorUnit), r), o = this._getLabelSize(s), a = Math.floor(this.isHorizontal() ? this.width / o.w : this.height / o.h) - 1;
    return a > 0 ? a : 1;
  }
  getDataTimestamps() {
    let t = this._cache.data || [], e, n;
    if (t.length)
      return t;
    const r = this.getMatchingVisibleMetas();
    if (this._normalized && r.length)
      return this._cache.data = r[0].controller.getAllParsedValues(this);
    for (e = 0, n = r.length; e < n; ++e)
      t = t.concat(r[e].controller.getAllParsedValues(this));
    return this._cache.data = this.normalize(t);
  }
  getLabelTimestamps() {
    const t = this._cache.labels || [];
    let e, n;
    if (t.length)
      return t;
    const r = this.getLabels();
    for (e = 0, n = r.length; e < n; ++e)
      t.push(Va(this, r[e]));
    return this._cache.labels = this._normalized ? t : this.normalize(t);
  }
  normalize(t) {
    return Kc(t.sort(dg));
  }
}
Hn.id = "time";
Hn.defaults = {
  bounds: "data",
  adapters: {},
  time: {
    parser: !1,
    unit: !1,
    round: !1,
    isoWeekday: !1,
    minUnit: "millisecond",
    displayFormats: {}
  },
  ticks: {
    source: "auto",
    major: {
      enabled: !1
    }
  }
};
function nn(i, t, e) {
  let n = 0, r = i.length - 1, s, o, a, c;
  e ? (t >= i[n].pos && t <= i[r].pos && ({ lo: n, hi: r } = ue(i, "pos", t)), { pos: s, time: a } = i[n], { pos: o, time: c } = i[r]) : (t >= i[n].time && t <= i[r].time && ({ lo: n, hi: r } = ue(i, "time", t)), { time: s, pos: a } = i[n], { time: o, pos: c } = i[r]);
  const l = o - s;
  return l ? a + (c - a) * (t - s) / l : a;
}
class Bl extends Hn {
  constructor(t) {
    super(t), this._table = [], this._minPos = void 0, this._tableRange = void 0;
  }
  initOffsets() {
    const t = this._getTimestampsForTable(), e = this._table = this.buildLookupTable(t);
    this._minPos = nn(e, this.min), this._tableRange = nn(e, this.max) - this._minPos, super.initOffsets(t);
  }
  buildLookupTable(t) {
    const { min: e, max: n } = this, r = [], s = [];
    let o, a, c, l, u;
    for (o = 0, a = t.length; o < a; ++o)
      l = t[o], l >= e && l <= n && r.push(l);
    if (r.length < 2)
      return [
        { time: e, pos: 0 },
        { time: n, pos: 1 }
      ];
    for (o = 0, a = r.length; o < a; ++o)
      u = r[o + 1], c = r[o - 1], l = r[o], Math.round((u + c) / 2) !== l && s.push({ time: l, pos: o / (a - 1) });
    return s;
  }
  _getTimestampsForTable() {
    let t = this._cache.all || [];
    if (t.length)
      return t;
    const e = this.getDataTimestamps(), n = this.getLabelTimestamps();
    return e.length && n.length ? t = this.normalize(e.concat(n)) : t = e.length ? e : n, t = this._cache.all = t, t;
  }
  getDecimalForValue(t) {
    return (nn(this._table, t) - this._minPos) / this._tableRange;
  }
  getValueForPixel(t) {
    const e = this._offsets, n = this.getDecimalForPixel(t) / e.factor - e.end;
    return nn(this._table, n * this._tableRange + this._minPos, !0);
  }
}
Bl.id = "timeseries";
Bl.defaults = Hn.defaults;
const yg = 3.7, vg = (i) => ({
  datasets: [
    {
      label: "Pressure Level",
      data: [i, yg - i],
      value: 1,
      minValue: 0,
      maxValue: 100,
      backgroundColor: ["#A98ED3", "#D4C7E9"],
      borderWidth: 0
    }
  ]
}), bg = {
  id: "chartText",
  afterDatasetsDraw(i, t, e) {
    const { ctx: n, data: r, chartArea: { top: s, bottom: o, left: a, right: c, width: l, height: u }, scales: { r: h } } = i;
    n.save();
    const f = i.getDatasetMeta(0).data[0].x, d = i.getDatasetMeta(0).data[0].y, p = r.datasets[0].data[0];
    n.font = "4em sans-serif", n.textAlign = "center", n.fillStyle = "black", n.fillText(`${p} V`, f, d);
  }
}, _g = (i) => ({
  type: "doughnut",
  data: vg(i),
  options: {
    rotation: 270,
    circumference: 180,
    cutout: "90%",
    responsive: !0,
    legend: {
      display: !1
    },
    title: {
      display: !1
    },
    tooltip: {
      enabled: !1
    },
    layout: {
      padding: {}
    }
  },
  plugins: [bg]
});
var Kr = function(i, t) {
  return Kr = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, n) {
    e.__proto__ = n;
  } || function(e, n) {
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
  }, Kr(i, t);
};
function Dt(i, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  Kr(i, t);
  function e() {
    this.constructor = i;
  }
  i.prototype = t === null ? Object.create(t) : (e.prototype = t.prototype, new e());
}
var w = function() {
  return w = Object.assign || function(t) {
    for (var e, n = 1, r = arguments.length; n < r; n++) {
      e = arguments[n];
      for (var s in e)
        Object.prototype.hasOwnProperty.call(e, s) && (t[s] = e[s]);
    }
    return t;
  }, w.apply(this, arguments);
};
function Qe(i, t) {
  var e = {};
  for (var n in i)
    Object.prototype.hasOwnProperty.call(i, n) && t.indexOf(n) < 0 && (e[n] = i[n]);
  if (i != null && typeof Object.getOwnPropertySymbols == "function")
    for (var r = 0, n = Object.getOwnPropertySymbols(i); r < n.length; r++)
      t.indexOf(n[r]) < 0 && Object.prototype.propertyIsEnumerable.call(i, n[r]) && (e[n[r]] = i[n[r]]);
  return e;
}
function wt(i, t, e, n) {
  var r = arguments.length, s = r < 3 ? t : n === null ? n = Object.getOwnPropertyDescriptor(t, e) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    s = Reflect.decorate(i, t, e, n);
  else
    for (var a = i.length - 1; a >= 0; a--)
      (o = i[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(t, e, s) : o(t, e)) || s);
  return r > 3 && s && Object.defineProperty(t, e, s), s;
}
function Wt(i, t, e, n) {
  function r(s) {
    return s instanceof e ? s : new e(function(o) {
      o(s);
    });
  }
  return new (e || (e = Promise))(function(s, o) {
    function a(u) {
      try {
        l(n.next(u));
      } catch (h) {
        o(h);
      }
    }
    function c(u) {
      try {
        l(n.throw(u));
      } catch (h) {
        o(h);
      }
    }
    function l(u) {
      u.done ? s(u.value) : r(u.value).then(a, c);
    }
    l((n = n.apply(i, t || [])).next());
  });
}
function Ht(i, t) {
  var e = { label: 0, sent: function() {
    if (s[0] & 1)
      throw s[1];
    return s[1];
  }, trys: [], ops: [] }, n, r, s, o;
  return o = { next: a(0), throw: a(1), return: a(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function a(l) {
    return function(u) {
      return c([l, u]);
    };
  }
  function c(l) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, l[0] && (e = 0)), e; )
      try {
        if (n = 1, r && (s = l[0] & 2 ? r.return : l[0] ? r.throw || ((s = r.return) && s.call(r), 0) : r.next) && !(s = s.call(r, l[1])).done)
          return s;
        switch (r = 0, s && (l = [l[0] & 2, s.value]), l[0]) {
          case 0:
          case 1:
            s = l;
            break;
          case 4:
            return e.label++, { value: l[1], done: !1 };
          case 5:
            e.label++, r = l[1], l = [0];
            continue;
          case 7:
            l = e.ops.pop(), e.trys.pop();
            continue;
          default:
            if (s = e.trys, !(s = s.length > 0 && s[s.length - 1]) && (l[0] === 6 || l[0] === 2)) {
              e = 0;
              continue;
            }
            if (l[0] === 3 && (!s || l[1] > s[0] && l[1] < s[3])) {
              e.label = l[1];
              break;
            }
            if (l[0] === 6 && e.label < s[1]) {
              e.label = s[1], s = l;
              break;
            }
            if (s && e.label < s[2]) {
              e.label = s[2], e.ops.push(l);
              break;
            }
            s[2] && e.ops.pop(), e.trys.pop();
            continue;
        }
        l = t.call(i, e);
      } catch (u) {
        l = [6, u], r = 0;
      } finally {
        n = s = 0;
      }
    if (l[0] & 5)
      throw l[1];
    return { value: l[0] ? l[1] : void 0, done: !0 };
  }
}
function Pn(i, t, e) {
  if (e || arguments.length === 2)
    for (var n = 0, r = t.length, s; n < r; n++)
      (s || !(n in t)) && (s || (s = Array.prototype.slice.call(t, 0, n)), s[n] = t[n]);
  return i.concat(s || Array.prototype.slice.call(t));
}
var Sr = "Invariant Violation", za = Object.setPrototypeOf, xg = za === void 0 ? function(i, t) {
  return i.__proto__ = t, i;
} : za, N = function(i) {
  Dt(t, i);
  function t(e) {
    e === void 0 && (e = Sr);
    var n = i.call(this, typeof e == "number" ? Sr + ": " + e + " (see https://github.com/apollographql/invariant-packages)" : e) || this;
    return n.framesToPop = 1, n.name = Sr, xg(n, t.prototype), n;
  }
  return t;
}(Error);
function D(i, t) {
  if (!i)
    throw new N(t);
}
var $l = ["debug", "log", "warn", "error", "silent"], wg = $l.indexOf("log");
function rn(i) {
  return function() {
    if ($l.indexOf(i) >= wg) {
      var t = console[i] || console.log;
      return t.apply(console, arguments);
    }
  };
}
(function(i) {
  i.debug = rn("debug"), i.log = rn("log"), i.warn = rn("warn"), i.error = rn("error");
})(D || (D = {}));
function vt(i) {
  try {
    return i();
  } catch {
  }
}
const qa = vt(function() {
  return globalThis;
}) || vt(function() {
  return window;
}) || vt(function() {
  return self;
}) || vt(function() {
  return global;
}) || vt(function() {
  return vt.constructor("return this")();
});
var Qa = "__", Ua = [Qa, Qa].join("DEV");
function Sg() {
  try {
    return Boolean(__DEV__);
  } catch {
    return Object.defineProperty(qa, Ua, {
      value: vt(function() {
        return process.env.NODE_ENV;
      }) !== "production",
      enumerable: !1,
      configurable: !0,
      writable: !0
    }), qa[Ua];
  }
}
const Er = Sg();
function Yt(i) {
  try {
    return i();
  } catch {
  }
}
var Jr = Yt(function() {
  return globalThis;
}) || Yt(function() {
  return window;
}) || Yt(function() {
  return self;
}) || Yt(function() {
  return global;
}) || Yt(function() {
  return Yt.constructor("return this")();
}), Zr = !1;
function Eg() {
  Jr && !Yt(function() {
    return process.env.NODE_ENV;
  }) && !Yt(function() {
    return process;
  }) && (Object.defineProperty(Jr, "process", {
    value: {
      env: {
        NODE_ENV: "production"
      }
    },
    configurable: !0,
    enumerable: !1,
    writable: !0
  }), Zr = !0);
}
Eg();
function Wa() {
  Zr && (delete Jr.process, Zr = !1);
}
function un(i, t) {
  if (!Boolean(i))
    throw new Error(t);
}
function kg(i) {
  return typeof i == "object" && i !== null;
}
function Og(i, t) {
  if (!Boolean(i))
    throw new Error(
      t != null ? t : "Unexpected invariant triggered."
    );
}
const Dg = /\r\n|[\n\r]/g;
function ts(i, t) {
  let e = 0, n = 1;
  for (const r of i.body.matchAll(Dg)) {
    if (typeof r.index == "number" || Og(!1), r.index >= t)
      break;
    e = r.index + r[0].length, n += 1;
  }
  return {
    line: n,
    column: t + 1 - e
  };
}
function Tg(i) {
  return zl(
    i.source,
    ts(i.source, i.start)
  );
}
function zl(i, t) {
  const e = i.locationOffset.column - 1, n = "".padStart(e) + i.body, r = t.line - 1, s = i.locationOffset.line - 1, o = t.line + s, a = t.line === 1 ? e : 0, c = t.column + a, l = `${i.name}:${o}:${c}
`, u = n.split(/\r\n|[\n\r]/g), h = u[r];
  if (h.length > 120) {
    const f = Math.floor(c / 80), d = c % 80, p = [];
    for (let g = 0; g < h.length; g += 80)
      p.push(h.slice(g, g + 80));
    return l + Ha([
      [`${o} |`, p[0]],
      ...p.slice(1, f + 1).map((g) => ["|", g]),
      ["|", "^".padStart(d)],
      ["|", p[f + 1]]
    ]);
  }
  return l + Ha([
    [`${o - 1} |`, u[r - 1]],
    [`${o} |`, h],
    ["|", "^".padStart(c)],
    [`${o + 1} |`, u[r + 1]]
  ]);
}
function Ha(i) {
  const t = i.filter(([n, r]) => r !== void 0), e = Math.max(...t.map(([n]) => n.length));
  return t.map(([n, r]) => n.padStart(e) + (r ? " " + r : "")).join(`
`);
}
function Mg(i) {
  const t = i[0];
  return t == null || "kind" in t || "length" in t ? {
    nodes: t,
    source: i[1],
    positions: i[2],
    path: i[3],
    originalError: i[4],
    extensions: i[5]
  } : t;
}
class Ws extends Error {
  constructor(t, ...e) {
    var n, r, s;
    const { nodes: o, source: a, positions: c, path: l, originalError: u, extensions: h } = Mg(e);
    super(t), this.name = "GraphQLError", this.path = l != null ? l : void 0, this.originalError = u != null ? u : void 0, this.nodes = Ya(
      Array.isArray(o) ? o : o ? [o] : void 0
    );
    const f = Ya(
      (n = this.nodes) === null || n === void 0 ? void 0 : n.map((p) => p.loc).filter((p) => p != null)
    );
    this.source = a != null ? a : f == null || (r = f[0]) === null || r === void 0 ? void 0 : r.source, this.positions = c != null ? c : f == null ? void 0 : f.map((p) => p.start), this.locations = c && a ? c.map((p) => ts(a, p)) : f == null ? void 0 : f.map((p) => ts(p.source, p.start));
    const d = kg(
      u == null ? void 0 : u.extensions
    ) ? u == null ? void 0 : u.extensions : void 0;
    this.extensions = (s = h != null ? h : d) !== null && s !== void 0 ? s : /* @__PURE__ */ Object.create(null), Object.defineProperties(this, {
      message: {
        writable: !0,
        enumerable: !0
      },
      name: {
        enumerable: !1
      },
      nodes: {
        enumerable: !1
      },
      source: {
        enumerable: !1
      },
      positions: {
        enumerable: !1
      },
      originalError: {
        enumerable: !1
      }
    }), u != null && u.stack ? Object.defineProperty(this, "stack", {
      value: u.stack,
      writable: !0,
      configurable: !0
    }) : Error.captureStackTrace ? Error.captureStackTrace(this, Ws) : Object.defineProperty(this, "stack", {
      value: Error().stack,
      writable: !0,
      configurable: !0
    });
  }
  get [Symbol.toStringTag]() {
    return "GraphQLError";
  }
  toString() {
    let t = this.message;
    if (this.nodes)
      for (const e of this.nodes)
        e.loc && (t += `

` + Tg(e.loc));
    else if (this.source && this.locations)
      for (const e of this.locations)
        t += `

` + zl(this.source, e);
    return t;
  }
  toJSON() {
    const t = {
      message: this.message
    };
    return this.locations != null && (t.locations = this.locations), this.path != null && (t.path = this.path), this.extensions != null && Object.keys(this.extensions).length > 0 && (t.extensions = this.extensions), t;
  }
}
function Ya(i) {
  return i === void 0 || i.length === 0 ? void 0 : i;
}
function ot(i, t, e) {
  return new Ws(`Syntax Error: ${e}`, {
    source: i,
    positions: [t]
  });
}
class Ag {
  constructor(t, e, n) {
    this.start = t.start, this.end = e.end, this.startToken = t, this.endToken = e, this.source = n;
  }
  get [Symbol.toStringTag]() {
    return "Location";
  }
  toJSON() {
    return {
      start: this.start,
      end: this.end
    };
  }
}
class ql {
  constructor(t, e, n, r, s, o) {
    this.kind = t, this.start = e, this.end = n, this.line = r, this.column = s, this.value = o, this.prev = null, this.next = null;
  }
  get [Symbol.toStringTag]() {
    return "Token";
  }
  toJSON() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column
    };
  }
}
const Ql = {
  Name: [],
  Document: ["definitions"],
  OperationDefinition: [
    "name",
    "variableDefinitions",
    "directives",
    "selectionSet"
  ],
  VariableDefinition: ["variable", "type", "defaultValue", "directives"],
  Variable: ["name"],
  SelectionSet: ["selections"],
  Field: ["alias", "name", "arguments", "directives", "selectionSet"],
  Argument: ["name", "value"],
  FragmentSpread: ["name", "directives"],
  InlineFragment: ["typeCondition", "directives", "selectionSet"],
  FragmentDefinition: [
    "name",
    "variableDefinitions",
    "typeCondition",
    "directives",
    "selectionSet"
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ["values"],
  ObjectValue: ["fields"],
  ObjectField: ["name", "value"],
  Directive: ["name", "arguments"],
  NamedType: ["name"],
  ListType: ["type"],
  NonNullType: ["type"],
  SchemaDefinition: ["description", "directives", "operationTypes"],
  OperationTypeDefinition: ["type"],
  ScalarTypeDefinition: ["description", "name", "directives"],
  ObjectTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  FieldDefinition: ["description", "name", "arguments", "type", "directives"],
  InputValueDefinition: [
    "description",
    "name",
    "type",
    "defaultValue",
    "directives"
  ],
  InterfaceTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  UnionTypeDefinition: ["description", "name", "directives", "types"],
  EnumTypeDefinition: ["description", "name", "directives", "values"],
  EnumValueDefinition: ["description", "name", "directives"],
  InputObjectTypeDefinition: ["description", "name", "directives", "fields"],
  DirectiveDefinition: ["description", "name", "arguments", "locations"],
  SchemaExtension: ["directives", "operationTypes"],
  ScalarTypeExtension: ["name", "directives"],
  ObjectTypeExtension: ["name", "interfaces", "directives", "fields"],
  InterfaceTypeExtension: ["name", "interfaces", "directives", "fields"],
  UnionTypeExtension: ["name", "directives", "types"],
  EnumTypeExtension: ["name", "directives", "values"],
  InputObjectTypeExtension: ["name", "directives", "fields"]
}, Cg = new Set(Object.keys(Ql));
function Ga(i) {
  const t = i == null ? void 0 : i.kind;
  return typeof t == "string" && Cg.has(t);
}
var Te;
(function(i) {
  i.QUERY = "query", i.MUTATION = "mutation", i.SUBSCRIPTION = "subscription";
})(Te || (Te = {}));
var es;
(function(i) {
  i.QUERY = "QUERY", i.MUTATION = "MUTATION", i.SUBSCRIPTION = "SUBSCRIPTION", i.FIELD = "FIELD", i.FRAGMENT_DEFINITION = "FRAGMENT_DEFINITION", i.FRAGMENT_SPREAD = "FRAGMENT_SPREAD", i.INLINE_FRAGMENT = "INLINE_FRAGMENT", i.VARIABLE_DEFINITION = "VARIABLE_DEFINITION", i.SCHEMA = "SCHEMA", i.SCALAR = "SCALAR", i.OBJECT = "OBJECT", i.FIELD_DEFINITION = "FIELD_DEFINITION", i.ARGUMENT_DEFINITION = "ARGUMENT_DEFINITION", i.INTERFACE = "INTERFACE", i.UNION = "UNION", i.ENUM = "ENUM", i.ENUM_VALUE = "ENUM_VALUE", i.INPUT_OBJECT = "INPUT_OBJECT", i.INPUT_FIELD_DEFINITION = "INPUT_FIELD_DEFINITION";
})(es || (es = {}));
var A;
(function(i) {
  i.NAME = "Name", i.DOCUMENT = "Document", i.OPERATION_DEFINITION = "OperationDefinition", i.VARIABLE_DEFINITION = "VariableDefinition", i.SELECTION_SET = "SelectionSet", i.FIELD = "Field", i.ARGUMENT = "Argument", i.FRAGMENT_SPREAD = "FragmentSpread", i.INLINE_FRAGMENT = "InlineFragment", i.FRAGMENT_DEFINITION = "FragmentDefinition", i.VARIABLE = "Variable", i.INT = "IntValue", i.FLOAT = "FloatValue", i.STRING = "StringValue", i.BOOLEAN = "BooleanValue", i.NULL = "NullValue", i.ENUM = "EnumValue", i.LIST = "ListValue", i.OBJECT = "ObjectValue", i.OBJECT_FIELD = "ObjectField", i.DIRECTIVE = "Directive", i.NAMED_TYPE = "NamedType", i.LIST_TYPE = "ListType", i.NON_NULL_TYPE = "NonNullType", i.SCHEMA_DEFINITION = "SchemaDefinition", i.OPERATION_TYPE_DEFINITION = "OperationTypeDefinition", i.SCALAR_TYPE_DEFINITION = "ScalarTypeDefinition", i.OBJECT_TYPE_DEFINITION = "ObjectTypeDefinition", i.FIELD_DEFINITION = "FieldDefinition", i.INPUT_VALUE_DEFINITION = "InputValueDefinition", i.INTERFACE_TYPE_DEFINITION = "InterfaceTypeDefinition", i.UNION_TYPE_DEFINITION = "UnionTypeDefinition", i.ENUM_TYPE_DEFINITION = "EnumTypeDefinition", i.ENUM_VALUE_DEFINITION = "EnumValueDefinition", i.INPUT_OBJECT_TYPE_DEFINITION = "InputObjectTypeDefinition", i.DIRECTIVE_DEFINITION = "DirectiveDefinition", i.SCHEMA_EXTENSION = "SchemaExtension", i.SCALAR_TYPE_EXTENSION = "ScalarTypeExtension", i.OBJECT_TYPE_EXTENSION = "ObjectTypeExtension", i.INTERFACE_TYPE_EXTENSION = "InterfaceTypeExtension", i.UNION_TYPE_EXTENSION = "UnionTypeExtension", i.ENUM_TYPE_EXTENSION = "EnumTypeExtension", i.INPUT_OBJECT_TYPE_EXTENSION = "InputObjectTypeExtension";
})(A || (A = {}));
function is(i) {
  return i === 9 || i === 32;
}
function Ai(i) {
  return i >= 48 && i <= 57;
}
function Ul(i) {
  return i >= 97 && i <= 122 || i >= 65 && i <= 90;
}
function Wl(i) {
  return Ul(i) || i === 95;
}
function Pg(i) {
  return Ul(i) || Ai(i) || i === 95;
}
function Rg(i) {
  var t;
  let e = Number.MAX_SAFE_INTEGER, n = null, r = -1;
  for (let o = 0; o < i.length; ++o) {
    var s;
    const a = i[o], c = Ig(a);
    c !== a.length && (n = (s = n) !== null && s !== void 0 ? s : o, r = o, o !== 0 && c < e && (e = c));
  }
  return i.map((o, a) => a === 0 ? o : o.slice(e)).slice(
    (t = n) !== null && t !== void 0 ? t : 0,
    r + 1
  );
}
function Ig(i) {
  let t = 0;
  for (; t < i.length && is(i.charCodeAt(t)); )
    ++t;
  return t;
}
function Fg(i, t) {
  const e = i.replace(/"""/g, '\\"""'), n = e.split(/\r\n|[\n\r]/g), r = n.length === 1, s = n.length > 1 && n.slice(1).every((d) => d.length === 0 || is(d.charCodeAt(0))), o = e.endsWith('\\"""'), a = i.endsWith('"') && !o, c = i.endsWith("\\"), l = a || c, u = !(t != null && t.minimize) && (!r || i.length > 70 || l || s || o);
  let h = "";
  const f = r && is(i.charCodeAt(0));
  return (u && !f || s) && (h += `
`), h += e, (u || l) && (h += `
`), '"""' + h + '"""';
}
var S;
(function(i) {
  i.SOF = "<SOF>", i.EOF = "<EOF>", i.BANG = "!", i.DOLLAR = "$", i.AMP = "&", i.PAREN_L = "(", i.PAREN_R = ")", i.SPREAD = "...", i.COLON = ":", i.EQUALS = "=", i.AT = "@", i.BRACKET_L = "[", i.BRACKET_R = "]", i.BRACE_L = "{", i.PIPE = "|", i.BRACE_R = "}", i.NAME = "Name", i.INT = "Int", i.FLOAT = "Float", i.STRING = "String", i.BLOCK_STRING = "BlockString", i.COMMENT = "Comment";
})(S || (S = {}));
class Lg {
  constructor(t) {
    const e = new ql(S.SOF, 0, 0, 0, 0);
    this.source = t, this.lastToken = e, this.token = e, this.line = 1, this.lineStart = 0;
  }
  get [Symbol.toStringTag]() {
    return "Lexer";
  }
  advance() {
    return this.lastToken = this.token, this.token = this.lookahead();
  }
  lookahead() {
    let t = this.token;
    if (t.kind !== S.EOF)
      do
        if (t.next)
          t = t.next;
        else {
          const e = Vg(this, t.end);
          t.next = e, e.prev = t, t = e;
        }
      while (t.kind === S.COMMENT);
    return t;
  }
}
function Ng(i) {
  return i === S.BANG || i === S.DOLLAR || i === S.AMP || i === S.PAREN_L || i === S.PAREN_R || i === S.SPREAD || i === S.COLON || i === S.EQUALS || i === S.AT || i === S.BRACKET_L || i === S.BRACKET_R || i === S.BRACE_L || i === S.PIPE || i === S.BRACE_R;
}
function Xe(i) {
  return i >= 0 && i <= 55295 || i >= 57344 && i <= 1114111;
}
function Yn(i, t) {
  return Hl(i.charCodeAt(t)) && Yl(i.charCodeAt(t + 1));
}
function Hl(i) {
  return i >= 55296 && i <= 56319;
}
function Yl(i) {
  return i >= 56320 && i <= 57343;
}
function me(i, t) {
  const e = i.source.body.codePointAt(t);
  if (e === void 0)
    return S.EOF;
  if (e >= 32 && e <= 126) {
    const n = String.fromCodePoint(e);
    return n === '"' ? `'"'` : `"${n}"`;
  }
  return "U+" + e.toString(16).toUpperCase().padStart(4, "0");
}
function it(i, t, e, n, r) {
  const s = i.line, o = 1 + e - i.lineStart;
  return new ql(t, e, n, s, o, r);
}
function Vg(i, t) {
  const e = i.source.body, n = e.length;
  let r = t;
  for (; r < n; ) {
    const s = e.charCodeAt(r);
    switch (s) {
      case 65279:
      case 9:
      case 32:
      case 44:
        ++r;
        continue;
      case 10:
        ++r, ++i.line, i.lineStart = r;
        continue;
      case 13:
        e.charCodeAt(r + 1) === 10 ? r += 2 : ++r, ++i.line, i.lineStart = r;
        continue;
      case 35:
        return jg(i, r);
      case 33:
        return it(i, S.BANG, r, r + 1);
      case 36:
        return it(i, S.DOLLAR, r, r + 1);
      case 38:
        return it(i, S.AMP, r, r + 1);
      case 40:
        return it(i, S.PAREN_L, r, r + 1);
      case 41:
        return it(i, S.PAREN_R, r, r + 1);
      case 46:
        if (e.charCodeAt(r + 1) === 46 && e.charCodeAt(r + 2) === 46)
          return it(i, S.SPREAD, r, r + 3);
        break;
      case 58:
        return it(i, S.COLON, r, r + 1);
      case 61:
        return it(i, S.EQUALS, r, r + 1);
      case 64:
        return it(i, S.AT, r, r + 1);
      case 91:
        return it(i, S.BRACKET_L, r, r + 1);
      case 93:
        return it(i, S.BRACKET_R, r, r + 1);
      case 123:
        return it(i, S.BRACE_L, r, r + 1);
      case 124:
        return it(i, S.PIPE, r, r + 1);
      case 125:
        return it(i, S.BRACE_R, r, r + 1);
      case 34:
        return e.charCodeAt(r + 1) === 34 && e.charCodeAt(r + 2) === 34 ? Ug(i, r) : $g(i, r);
    }
    if (Ai(s) || s === 45)
      return Bg(i, r, s);
    if (Wl(s))
      return Wg(i, r);
    throw ot(
      i.source,
      r,
      s === 39 ? `Unexpected single quote character ('), did you mean to use a double quote (")?` : Xe(s) || Yn(e, r) ? `Unexpected character: ${me(i, r)}.` : `Invalid character: ${me(i, r)}.`
    );
  }
  return it(i, S.EOF, n, n);
}
function jg(i, t) {
  const e = i.source.body, n = e.length;
  let r = t + 1;
  for (; r < n; ) {
    const s = e.charCodeAt(r);
    if (s === 10 || s === 13)
      break;
    if (Xe(s))
      ++r;
    else if (Yn(e, r))
      r += 2;
    else
      break;
  }
  return it(
    i,
    S.COMMENT,
    t,
    r,
    e.slice(t + 1, r)
  );
}
function Bg(i, t, e) {
  const n = i.source.body;
  let r = t, s = e, o = !1;
  if (s === 45 && (s = n.charCodeAt(++r)), s === 48) {
    if (s = n.charCodeAt(++r), Ai(s))
      throw ot(
        i.source,
        r,
        `Invalid number, unexpected digit after 0: ${me(
          i,
          r
        )}.`
      );
  } else
    r = kr(i, r, s), s = n.charCodeAt(r);
  if (s === 46 && (o = !0, s = n.charCodeAt(++r), r = kr(i, r, s), s = n.charCodeAt(r)), (s === 69 || s === 101) && (o = !0, s = n.charCodeAt(++r), (s === 43 || s === 45) && (s = n.charCodeAt(++r)), r = kr(i, r, s), s = n.charCodeAt(r)), s === 46 || Wl(s))
    throw ot(
      i.source,
      r,
      `Invalid number, expected digit but got: ${me(
        i,
        r
      )}.`
    );
  return it(
    i,
    o ? S.FLOAT : S.INT,
    t,
    r,
    n.slice(t, r)
  );
}
function kr(i, t, e) {
  if (!Ai(e))
    throw ot(
      i.source,
      t,
      `Invalid number, expected digit but got: ${me(
        i,
        t
      )}.`
    );
  const n = i.source.body;
  let r = t + 1;
  for (; Ai(n.charCodeAt(r)); )
    ++r;
  return r;
}
function $g(i, t) {
  const e = i.source.body, n = e.length;
  let r = t + 1, s = r, o = "";
  for (; r < n; ) {
    const a = e.charCodeAt(r);
    if (a === 34)
      return o += e.slice(s, r), it(i, S.STRING, t, r + 1, o);
    if (a === 92) {
      o += e.slice(s, r);
      const c = e.charCodeAt(r + 1) === 117 ? e.charCodeAt(r + 2) === 123 ? zg(i, r) : qg(i, r) : Qg(i, r);
      o += c.value, r += c.size, s = r;
      continue;
    }
    if (a === 10 || a === 13)
      break;
    if (Xe(a))
      ++r;
    else if (Yn(e, r))
      r += 2;
    else
      throw ot(
        i.source,
        r,
        `Invalid character within String: ${me(
          i,
          r
        )}.`
      );
  }
  throw ot(i.source, r, "Unterminated string.");
}
function zg(i, t) {
  const e = i.source.body;
  let n = 0, r = 3;
  for (; r < 12; ) {
    const s = e.charCodeAt(t + r++);
    if (s === 125) {
      if (r < 5 || !Xe(n))
        break;
      return {
        value: String.fromCodePoint(n),
        size: r
      };
    }
    if (n = n << 4 | fi(s), n < 0)
      break;
  }
  throw ot(
    i.source,
    t,
    `Invalid Unicode escape sequence: "${e.slice(
      t,
      t + r
    )}".`
  );
}
function qg(i, t) {
  const e = i.source.body, n = Xa(e, t + 2);
  if (Xe(n))
    return {
      value: String.fromCodePoint(n),
      size: 6
    };
  if (Hl(n) && e.charCodeAt(t + 6) === 92 && e.charCodeAt(t + 7) === 117) {
    const r = Xa(e, t + 8);
    if (Yl(r))
      return {
        value: String.fromCodePoint(n, r),
        size: 12
      };
  }
  throw ot(
    i.source,
    t,
    `Invalid Unicode escape sequence: "${e.slice(t, t + 6)}".`
  );
}
function Xa(i, t) {
  return fi(i.charCodeAt(t)) << 12 | fi(i.charCodeAt(t + 1)) << 8 | fi(i.charCodeAt(t + 2)) << 4 | fi(i.charCodeAt(t + 3));
}
function fi(i) {
  return i >= 48 && i <= 57 ? i - 48 : i >= 65 && i <= 70 ? i - 55 : i >= 97 && i <= 102 ? i - 87 : -1;
}
function Qg(i, t) {
  const e = i.source.body;
  switch (e.charCodeAt(t + 1)) {
    case 34:
      return {
        value: '"',
        size: 2
      };
    case 92:
      return {
        value: "\\",
        size: 2
      };
    case 47:
      return {
        value: "/",
        size: 2
      };
    case 98:
      return {
        value: "\b",
        size: 2
      };
    case 102:
      return {
        value: "\f",
        size: 2
      };
    case 110:
      return {
        value: `
`,
        size: 2
      };
    case 114:
      return {
        value: "\r",
        size: 2
      };
    case 116:
      return {
        value: "	",
        size: 2
      };
  }
  throw ot(
    i.source,
    t,
    `Invalid character escape sequence: "${e.slice(
      t,
      t + 2
    )}".`
  );
}
function Ug(i, t) {
  const e = i.source.body, n = e.length;
  let r = i.lineStart, s = t + 3, o = s, a = "";
  const c = [];
  for (; s < n; ) {
    const l = e.charCodeAt(s);
    if (l === 34 && e.charCodeAt(s + 1) === 34 && e.charCodeAt(s + 2) === 34) {
      a += e.slice(o, s), c.push(a);
      const u = it(
        i,
        S.BLOCK_STRING,
        t,
        s + 3,
        Rg(c).join(`
`)
      );
      return i.line += c.length - 1, i.lineStart = r, u;
    }
    if (l === 92 && e.charCodeAt(s + 1) === 34 && e.charCodeAt(s + 2) === 34 && e.charCodeAt(s + 3) === 34) {
      a += e.slice(o, s), o = s + 1, s += 4;
      continue;
    }
    if (l === 10 || l === 13) {
      a += e.slice(o, s), c.push(a), l === 13 && e.charCodeAt(s + 1) === 10 ? s += 2 : ++s, a = "", o = s, r = s;
      continue;
    }
    if (Xe(l))
      ++s;
    else if (Yn(e, s))
      s += 2;
    else
      throw ot(
        i.source,
        s,
        `Invalid character within String: ${me(
          i,
          s
        )}.`
      );
  }
  throw ot(i.source, s, "Unterminated string.");
}
function Wg(i, t) {
  const e = i.source.body, n = e.length;
  let r = t + 1;
  for (; r < n; ) {
    const s = e.charCodeAt(r);
    if (Pg(s))
      ++r;
    else
      break;
  }
  return it(
    i,
    S.NAME,
    t,
    r,
    e.slice(t, r)
  );
}
const Hg = 10, Gl = 2;
function Hs(i) {
  return Gn(i, []);
}
function Gn(i, t) {
  switch (typeof i) {
    case "string":
      return JSON.stringify(i);
    case "function":
      return i.name ? `[function ${i.name}]` : "[function]";
    case "object":
      return Yg(i, t);
    default:
      return String(i);
  }
}
function Yg(i, t) {
  if (i === null)
    return "null";
  if (t.includes(i))
    return "[Circular]";
  const e = [...t, i];
  if (Gg(i)) {
    const n = i.toJSON();
    if (n !== i)
      return typeof n == "string" ? n : Gn(n, e);
  } else if (Array.isArray(i))
    return Kg(i, e);
  return Xg(i, e);
}
function Gg(i) {
  return typeof i.toJSON == "function";
}
function Xg(i, t) {
  const e = Object.entries(i);
  return e.length === 0 ? "{}" : t.length > Gl ? "[" + Jg(i) + "]" : "{ " + e.map(
    ([r, s]) => r + ": " + Gn(s, t)
  ).join(", ") + " }";
}
function Kg(i, t) {
  if (i.length === 0)
    return "[]";
  if (t.length > Gl)
    return "[Array]";
  const e = Math.min(Hg, i.length), n = i.length - e, r = [];
  for (let s = 0; s < e; ++s)
    r.push(Gn(i[s], t));
  return n === 1 ? r.push("... 1 more item") : n > 1 && r.push(`... ${n} more items`), "[" + r.join(", ") + "]";
}
function Jg(i) {
  const t = Object.prototype.toString.call(i).replace(/^\[object /, "").replace(/]$/, "");
  if (t === "Object" && typeof i.constructor == "function") {
    const e = i.constructor.name;
    if (typeof e == "string" && e !== "")
      return e;
  }
  return t;
}
const Zg = process.env.NODE_ENV === "production" ? function(t, e) {
  return t instanceof e;
} : function(t, e) {
  if (t instanceof e)
    return !0;
  if (typeof t == "object" && t !== null) {
    var n;
    const r = e.prototype[Symbol.toStringTag], s = Symbol.toStringTag in t ? t[Symbol.toStringTag] : (n = t.constructor) === null || n === void 0 ? void 0 : n.name;
    if (r === s) {
      const o = Hs(t);
      throw new Error(`Cannot use ${r} "${o}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
    }
  }
  return !1;
};
class Ys {
  constructor(t, e = "GraphQL request", n = {
    line: 1,
    column: 1
  }) {
    typeof t == "string" || un(!1, `Body must be a string. Received: ${Hs(t)}.`), this.body = t, this.name = e, this.locationOffset = n, this.locationOffset.line > 0 || un(
      !1,
      "line in locationOffset is 1-indexed and must be positive."
    ), this.locationOffset.column > 0 || un(
      !1,
      "column in locationOffset is 1-indexed and must be positive."
    );
  }
  get [Symbol.toStringTag]() {
    return "Source";
  }
}
function tm(i) {
  return Zg(i, Ys);
}
function em(i, t) {
  return new im(i, t).parseDocument();
}
class im {
  constructor(t, e = {}) {
    const n = tm(t) ? t : new Ys(t);
    this._lexer = new Lg(n), this._options = e, this._tokenCounter = 0;
  }
  parseName() {
    const t = this.expectToken(S.NAME);
    return this.node(t, {
      kind: A.NAME,
      value: t.value
    });
  }
  parseDocument() {
    return this.node(this._lexer.token, {
      kind: A.DOCUMENT,
      definitions: this.many(
        S.SOF,
        this.parseDefinition,
        S.EOF
      )
    });
  }
  parseDefinition() {
    if (this.peek(S.BRACE_L))
      return this.parseOperationDefinition();
    const t = this.peekDescription(), e = t ? this._lexer.lookahead() : this._lexer.token;
    if (e.kind === S.NAME) {
      switch (e.value) {
        case "schema":
          return this.parseSchemaDefinition();
        case "scalar":
          return this.parseScalarTypeDefinition();
        case "type":
          return this.parseObjectTypeDefinition();
        case "interface":
          return this.parseInterfaceTypeDefinition();
        case "union":
          return this.parseUnionTypeDefinition();
        case "enum":
          return this.parseEnumTypeDefinition();
        case "input":
          return this.parseInputObjectTypeDefinition();
        case "directive":
          return this.parseDirectiveDefinition();
      }
      if (t)
        throw ot(
          this._lexer.source,
          this._lexer.token.start,
          "Unexpected description, descriptions are supported only on type definitions."
        );
      switch (e.value) {
        case "query":
        case "mutation":
        case "subscription":
          return this.parseOperationDefinition();
        case "fragment":
          return this.parseFragmentDefinition();
        case "extend":
          return this.parseTypeSystemExtension();
      }
    }
    throw this.unexpected(e);
  }
  parseOperationDefinition() {
    const t = this._lexer.token;
    if (this.peek(S.BRACE_L))
      return this.node(t, {
        kind: A.OPERATION_DEFINITION,
        operation: Te.QUERY,
        name: void 0,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet()
      });
    const e = this.parseOperationType();
    let n;
    return this.peek(S.NAME) && (n = this.parseName()), this.node(t, {
      kind: A.OPERATION_DEFINITION,
      operation: e,
      name: n,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  parseOperationType() {
    const t = this.expectToken(S.NAME);
    switch (t.value) {
      case "query":
        return Te.QUERY;
      case "mutation":
        return Te.MUTATION;
      case "subscription":
        return Te.SUBSCRIPTION;
    }
    throw this.unexpected(t);
  }
  parseVariableDefinitions() {
    return this.optionalMany(
      S.PAREN_L,
      this.parseVariableDefinition,
      S.PAREN_R
    );
  }
  parseVariableDefinition() {
    return this.node(this._lexer.token, {
      kind: A.VARIABLE_DEFINITION,
      variable: this.parseVariable(),
      type: (this.expectToken(S.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(S.EQUALS) ? this.parseConstValueLiteral() : void 0,
      directives: this.parseConstDirectives()
    });
  }
  parseVariable() {
    const t = this._lexer.token;
    return this.expectToken(S.DOLLAR), this.node(t, {
      kind: A.VARIABLE,
      name: this.parseName()
    });
  }
  parseSelectionSet() {
    return this.node(this._lexer.token, {
      kind: A.SELECTION_SET,
      selections: this.many(
        S.BRACE_L,
        this.parseSelection,
        S.BRACE_R
      )
    });
  }
  parseSelection() {
    return this.peek(S.SPREAD) ? this.parseFragment() : this.parseField();
  }
  parseField() {
    const t = this._lexer.token, e = this.parseName();
    let n, r;
    return this.expectOptionalToken(S.COLON) ? (n = e, r = this.parseName()) : r = e, this.node(t, {
      kind: A.FIELD,
      alias: n,
      name: r,
      arguments: this.parseArguments(!1),
      directives: this.parseDirectives(!1),
      selectionSet: this.peek(S.BRACE_L) ? this.parseSelectionSet() : void 0
    });
  }
  parseArguments(t) {
    const e = t ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(S.PAREN_L, e, S.PAREN_R);
  }
  parseArgument(t = !1) {
    const e = this._lexer.token, n = this.parseName();
    return this.expectToken(S.COLON), this.node(e, {
      kind: A.ARGUMENT,
      name: n,
      value: this.parseValueLiteral(t)
    });
  }
  parseConstArgument() {
    return this.parseArgument(!0);
  }
  parseFragment() {
    const t = this._lexer.token;
    this.expectToken(S.SPREAD);
    const e = this.expectOptionalKeyword("on");
    return !e && this.peek(S.NAME) ? this.node(t, {
      kind: A.FRAGMENT_SPREAD,
      name: this.parseFragmentName(),
      directives: this.parseDirectives(!1)
    }) : this.node(t, {
      kind: A.INLINE_FRAGMENT,
      typeCondition: e ? this.parseNamedType() : void 0,
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  parseFragmentDefinition() {
    const t = this._lexer.token;
    return this.expectKeyword("fragment"), this._options.allowLegacyFragmentVariables === !0 ? this.node(t, {
      kind: A.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      variableDefinitions: this.parseVariableDefinitions(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    }) : this.node(t, {
      kind: A.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  parseFragmentName() {
    if (this._lexer.token.value === "on")
      throw this.unexpected();
    return this.parseName();
  }
  parseValueLiteral(t) {
    const e = this._lexer.token;
    switch (e.kind) {
      case S.BRACKET_L:
        return this.parseList(t);
      case S.BRACE_L:
        return this.parseObject(t);
      case S.INT:
        return this.advanceLexer(), this.node(e, {
          kind: A.INT,
          value: e.value
        });
      case S.FLOAT:
        return this.advanceLexer(), this.node(e, {
          kind: A.FLOAT,
          value: e.value
        });
      case S.STRING:
      case S.BLOCK_STRING:
        return this.parseStringLiteral();
      case S.NAME:
        switch (this.advanceLexer(), e.value) {
          case "true":
            return this.node(e, {
              kind: A.BOOLEAN,
              value: !0
            });
          case "false":
            return this.node(e, {
              kind: A.BOOLEAN,
              value: !1
            });
          case "null":
            return this.node(e, {
              kind: A.NULL
            });
          default:
            return this.node(e, {
              kind: A.ENUM,
              value: e.value
            });
        }
      case S.DOLLAR:
        if (t)
          if (this.expectToken(S.DOLLAR), this._lexer.token.kind === S.NAME) {
            const n = this._lexer.token.value;
            throw ot(
              this._lexer.source,
              e.start,
              `Unexpected variable "$${n}" in constant value.`
            );
          } else
            throw this.unexpected(e);
        return this.parseVariable();
      default:
        throw this.unexpected();
    }
  }
  parseConstValueLiteral() {
    return this.parseValueLiteral(!0);
  }
  parseStringLiteral() {
    const t = this._lexer.token;
    return this.advanceLexer(), this.node(t, {
      kind: A.STRING,
      value: t.value,
      block: t.kind === S.BLOCK_STRING
    });
  }
  parseList(t) {
    const e = () => this.parseValueLiteral(t);
    return this.node(this._lexer.token, {
      kind: A.LIST,
      values: this.any(S.BRACKET_L, e, S.BRACKET_R)
    });
  }
  parseObject(t) {
    const e = () => this.parseObjectField(t);
    return this.node(this._lexer.token, {
      kind: A.OBJECT,
      fields: this.any(S.BRACE_L, e, S.BRACE_R)
    });
  }
  parseObjectField(t) {
    const e = this._lexer.token, n = this.parseName();
    return this.expectToken(S.COLON), this.node(e, {
      kind: A.OBJECT_FIELD,
      name: n,
      value: this.parseValueLiteral(t)
    });
  }
  parseDirectives(t) {
    const e = [];
    for (; this.peek(S.AT); )
      e.push(this.parseDirective(t));
    return e;
  }
  parseConstDirectives() {
    return this.parseDirectives(!0);
  }
  parseDirective(t) {
    const e = this._lexer.token;
    return this.expectToken(S.AT), this.node(e, {
      kind: A.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(t)
    });
  }
  parseTypeReference() {
    const t = this._lexer.token;
    let e;
    if (this.expectOptionalToken(S.BRACKET_L)) {
      const n = this.parseTypeReference();
      this.expectToken(S.BRACKET_R), e = this.node(t, {
        kind: A.LIST_TYPE,
        type: n
      });
    } else
      e = this.parseNamedType();
    return this.expectOptionalToken(S.BANG) ? this.node(t, {
      kind: A.NON_NULL_TYPE,
      type: e
    }) : e;
  }
  parseNamedType() {
    return this.node(this._lexer.token, {
      kind: A.NAMED_TYPE,
      name: this.parseName()
    });
  }
  peekDescription() {
    return this.peek(S.STRING) || this.peek(S.BLOCK_STRING);
  }
  parseDescription() {
    if (this.peekDescription())
      return this.parseStringLiteral();
  }
  parseSchemaDefinition() {
    const t = this._lexer.token, e = this.parseDescription();
    this.expectKeyword("schema");
    const n = this.parseConstDirectives(), r = this.many(
      S.BRACE_L,
      this.parseOperationTypeDefinition,
      S.BRACE_R
    );
    return this.node(t, {
      kind: A.SCHEMA_DEFINITION,
      description: e,
      directives: n,
      operationTypes: r
    });
  }
  parseOperationTypeDefinition() {
    const t = this._lexer.token, e = this.parseOperationType();
    this.expectToken(S.COLON);
    const n = this.parseNamedType();
    return this.node(t, {
      kind: A.OPERATION_TYPE_DEFINITION,
      operation: e,
      type: n
    });
  }
  parseScalarTypeDefinition() {
    const t = this._lexer.token, e = this.parseDescription();
    this.expectKeyword("scalar");
    const n = this.parseName(), r = this.parseConstDirectives();
    return this.node(t, {
      kind: A.SCALAR_TYPE_DEFINITION,
      description: e,
      name: n,
      directives: r
    });
  }
  parseObjectTypeDefinition() {
    const t = this._lexer.token, e = this.parseDescription();
    this.expectKeyword("type");
    const n = this.parseName(), r = this.parseImplementsInterfaces(), s = this.parseConstDirectives(), o = this.parseFieldsDefinition();
    return this.node(t, {
      kind: A.OBJECT_TYPE_DEFINITION,
      description: e,
      name: n,
      interfaces: r,
      directives: s,
      fields: o
    });
  }
  parseImplementsInterfaces() {
    return this.expectOptionalKeyword("implements") ? this.delimitedMany(S.AMP, this.parseNamedType) : [];
  }
  parseFieldsDefinition() {
    return this.optionalMany(
      S.BRACE_L,
      this.parseFieldDefinition,
      S.BRACE_R
    );
  }
  parseFieldDefinition() {
    const t = this._lexer.token, e = this.parseDescription(), n = this.parseName(), r = this.parseArgumentDefs();
    this.expectToken(S.COLON);
    const s = this.parseTypeReference(), o = this.parseConstDirectives();
    return this.node(t, {
      kind: A.FIELD_DEFINITION,
      description: e,
      name: n,
      arguments: r,
      type: s,
      directives: o
    });
  }
  parseArgumentDefs() {
    return this.optionalMany(
      S.PAREN_L,
      this.parseInputValueDef,
      S.PAREN_R
    );
  }
  parseInputValueDef() {
    const t = this._lexer.token, e = this.parseDescription(), n = this.parseName();
    this.expectToken(S.COLON);
    const r = this.parseTypeReference();
    let s;
    this.expectOptionalToken(S.EQUALS) && (s = this.parseConstValueLiteral());
    const o = this.parseConstDirectives();
    return this.node(t, {
      kind: A.INPUT_VALUE_DEFINITION,
      description: e,
      name: n,
      type: r,
      defaultValue: s,
      directives: o
    });
  }
  parseInterfaceTypeDefinition() {
    const t = this._lexer.token, e = this.parseDescription();
    this.expectKeyword("interface");
    const n = this.parseName(), r = this.parseImplementsInterfaces(), s = this.parseConstDirectives(), o = this.parseFieldsDefinition();
    return this.node(t, {
      kind: A.INTERFACE_TYPE_DEFINITION,
      description: e,
      name: n,
      interfaces: r,
      directives: s,
      fields: o
    });
  }
  parseUnionTypeDefinition() {
    const t = this._lexer.token, e = this.parseDescription();
    this.expectKeyword("union");
    const n = this.parseName(), r = this.parseConstDirectives(), s = this.parseUnionMemberTypes();
    return this.node(t, {
      kind: A.UNION_TYPE_DEFINITION,
      description: e,
      name: n,
      directives: r,
      types: s
    });
  }
  parseUnionMemberTypes() {
    return this.expectOptionalToken(S.EQUALS) ? this.delimitedMany(S.PIPE, this.parseNamedType) : [];
  }
  parseEnumTypeDefinition() {
    const t = this._lexer.token, e = this.parseDescription();
    this.expectKeyword("enum");
    const n = this.parseName(), r = this.parseConstDirectives(), s = this.parseEnumValuesDefinition();
    return this.node(t, {
      kind: A.ENUM_TYPE_DEFINITION,
      description: e,
      name: n,
      directives: r,
      values: s
    });
  }
  parseEnumValuesDefinition() {
    return this.optionalMany(
      S.BRACE_L,
      this.parseEnumValueDefinition,
      S.BRACE_R
    );
  }
  parseEnumValueDefinition() {
    const t = this._lexer.token, e = this.parseDescription(), n = this.parseEnumValueName(), r = this.parseConstDirectives();
    return this.node(t, {
      kind: A.ENUM_VALUE_DEFINITION,
      description: e,
      name: n,
      directives: r
    });
  }
  parseEnumValueName() {
    if (this._lexer.token.value === "true" || this._lexer.token.value === "false" || this._lexer.token.value === "null")
      throw ot(
        this._lexer.source,
        this._lexer.token.start,
        `${sn(
          this._lexer.token
        )} is reserved and cannot be used for an enum value.`
      );
    return this.parseName();
  }
  parseInputObjectTypeDefinition() {
    const t = this._lexer.token, e = this.parseDescription();
    this.expectKeyword("input");
    const n = this.parseName(), r = this.parseConstDirectives(), s = this.parseInputFieldsDefinition();
    return this.node(t, {
      kind: A.INPUT_OBJECT_TYPE_DEFINITION,
      description: e,
      name: n,
      directives: r,
      fields: s
    });
  }
  parseInputFieldsDefinition() {
    return this.optionalMany(
      S.BRACE_L,
      this.parseInputValueDef,
      S.BRACE_R
    );
  }
  parseTypeSystemExtension() {
    const t = this._lexer.lookahead();
    if (t.kind === S.NAME)
      switch (t.value) {
        case "schema":
          return this.parseSchemaExtension();
        case "scalar":
          return this.parseScalarTypeExtension();
        case "type":
          return this.parseObjectTypeExtension();
        case "interface":
          return this.parseInterfaceTypeExtension();
        case "union":
          return this.parseUnionTypeExtension();
        case "enum":
          return this.parseEnumTypeExtension();
        case "input":
          return this.parseInputObjectTypeExtension();
      }
    throw this.unexpected(t);
  }
  parseSchemaExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("schema");
    const e = this.parseConstDirectives(), n = this.optionalMany(
      S.BRACE_L,
      this.parseOperationTypeDefinition,
      S.BRACE_R
    );
    if (e.length === 0 && n.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: A.SCHEMA_EXTENSION,
      directives: e,
      operationTypes: n
    });
  }
  parseScalarTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("scalar");
    const e = this.parseName(), n = this.parseConstDirectives();
    if (n.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: A.SCALAR_TYPE_EXTENSION,
      name: e,
      directives: n
    });
  }
  parseObjectTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("type");
    const e = this.parseName(), n = this.parseImplementsInterfaces(), r = this.parseConstDirectives(), s = this.parseFieldsDefinition();
    if (n.length === 0 && r.length === 0 && s.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: A.OBJECT_TYPE_EXTENSION,
      name: e,
      interfaces: n,
      directives: r,
      fields: s
    });
  }
  parseInterfaceTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("interface");
    const e = this.parseName(), n = this.parseImplementsInterfaces(), r = this.parseConstDirectives(), s = this.parseFieldsDefinition();
    if (n.length === 0 && r.length === 0 && s.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: A.INTERFACE_TYPE_EXTENSION,
      name: e,
      interfaces: n,
      directives: r,
      fields: s
    });
  }
  parseUnionTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("union");
    const e = this.parseName(), n = this.parseConstDirectives(), r = this.parseUnionMemberTypes();
    if (n.length === 0 && r.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: A.UNION_TYPE_EXTENSION,
      name: e,
      directives: n,
      types: r
    });
  }
  parseEnumTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("enum");
    const e = this.parseName(), n = this.parseConstDirectives(), r = this.parseEnumValuesDefinition();
    if (n.length === 0 && r.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: A.ENUM_TYPE_EXTENSION,
      name: e,
      directives: n,
      values: r
    });
  }
  parseInputObjectTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("input");
    const e = this.parseName(), n = this.parseConstDirectives(), r = this.parseInputFieldsDefinition();
    if (n.length === 0 && r.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: A.INPUT_OBJECT_TYPE_EXTENSION,
      name: e,
      directives: n,
      fields: r
    });
  }
  parseDirectiveDefinition() {
    const t = this._lexer.token, e = this.parseDescription();
    this.expectKeyword("directive"), this.expectToken(S.AT);
    const n = this.parseName(), r = this.parseArgumentDefs(), s = this.expectOptionalKeyword("repeatable");
    this.expectKeyword("on");
    const o = this.parseDirectiveLocations();
    return this.node(t, {
      kind: A.DIRECTIVE_DEFINITION,
      description: e,
      name: n,
      arguments: r,
      repeatable: s,
      locations: o
    });
  }
  parseDirectiveLocations() {
    return this.delimitedMany(S.PIPE, this.parseDirectiveLocation);
  }
  parseDirectiveLocation() {
    const t = this._lexer.token, e = this.parseName();
    if (Object.prototype.hasOwnProperty.call(es, e.value))
      return e;
    throw this.unexpected(t);
  }
  node(t, e) {
    return this._options.noLocation !== !0 && (e.loc = new Ag(
      t,
      this._lexer.lastToken,
      this._lexer.source
    )), e;
  }
  peek(t) {
    return this._lexer.token.kind === t;
  }
  expectToken(t) {
    const e = this._lexer.token;
    if (e.kind === t)
      return this.advanceLexer(), e;
    throw ot(
      this._lexer.source,
      e.start,
      `Expected ${Xl(t)}, found ${sn(e)}.`
    );
  }
  expectOptionalToken(t) {
    return this._lexer.token.kind === t ? (this.advanceLexer(), !0) : !1;
  }
  expectKeyword(t) {
    const e = this._lexer.token;
    if (e.kind === S.NAME && e.value === t)
      this.advanceLexer();
    else
      throw ot(
        this._lexer.source,
        e.start,
        `Expected "${t}", found ${sn(e)}.`
      );
  }
  expectOptionalKeyword(t) {
    const e = this._lexer.token;
    return e.kind === S.NAME && e.value === t ? (this.advanceLexer(), !0) : !1;
  }
  unexpected(t) {
    const e = t != null ? t : this._lexer.token;
    return ot(
      this._lexer.source,
      e.start,
      `Unexpected ${sn(e)}.`
    );
  }
  any(t, e, n) {
    this.expectToken(t);
    const r = [];
    for (; !this.expectOptionalToken(n); )
      r.push(e.call(this));
    return r;
  }
  optionalMany(t, e, n) {
    if (this.expectOptionalToken(t)) {
      const r = [];
      do
        r.push(e.call(this));
      while (!this.expectOptionalToken(n));
      return r;
    }
    return [];
  }
  many(t, e, n) {
    this.expectToken(t);
    const r = [];
    do
      r.push(e.call(this));
    while (!this.expectOptionalToken(n));
    return r;
  }
  delimitedMany(t, e) {
    this.expectOptionalToken(t);
    const n = [];
    do
      n.push(e.call(this));
    while (this.expectOptionalToken(t));
    return n;
  }
  advanceLexer() {
    const { maxTokens: t } = this._options, e = this._lexer.advance();
    if (t !== void 0 && e.kind !== S.EOF && (++this._tokenCounter, this._tokenCounter > t))
      throw ot(
        this._lexer.source,
        e.start,
        `Document contains more that ${t} tokens. Parsing aborted.`
      );
  }
}
function sn(i) {
  const t = i.value;
  return Xl(i.kind) + (t != null ? ` "${t}"` : "");
}
function Xl(i) {
  return Ng(i) ? `"${i}"` : i;
}
function nm(i) {
  return `"${i.replace(rm, sm)}"`;
}
const rm = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function sm(i) {
  return om[i.charCodeAt(0)];
}
const om = [
  "\\u0000",
  "\\u0001",
  "\\u0002",
  "\\u0003",
  "\\u0004",
  "\\u0005",
  "\\u0006",
  "\\u0007",
  "\\b",
  "\\t",
  "\\n",
  "\\u000B",
  "\\f",
  "\\r",
  "\\u000E",
  "\\u000F",
  "\\u0010",
  "\\u0011",
  "\\u0012",
  "\\u0013",
  "\\u0014",
  "\\u0015",
  "\\u0016",
  "\\u0017",
  "\\u0018",
  "\\u0019",
  "\\u001A",
  "\\u001B",
  "\\u001C",
  "\\u001D",
  "\\u001E",
  "\\u001F",
  "",
  "",
  '\\"',
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "\\\\",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "\\u007F",
  "\\u0080",
  "\\u0081",
  "\\u0082",
  "\\u0083",
  "\\u0084",
  "\\u0085",
  "\\u0086",
  "\\u0087",
  "\\u0088",
  "\\u0089",
  "\\u008A",
  "\\u008B",
  "\\u008C",
  "\\u008D",
  "\\u008E",
  "\\u008F",
  "\\u0090",
  "\\u0091",
  "\\u0092",
  "\\u0093",
  "\\u0094",
  "\\u0095",
  "\\u0096",
  "\\u0097",
  "\\u0098",
  "\\u0099",
  "\\u009A",
  "\\u009B",
  "\\u009C",
  "\\u009D",
  "\\u009E",
  "\\u009F"
], Gs = Object.freeze({});
function Ft(i, t, e = Ql) {
  const n = /* @__PURE__ */ new Map();
  for (const y of Object.values(A))
    n.set(y, am(t, y));
  let r, s = Array.isArray(i), o = [i], a = -1, c = [], l = i, u, h;
  const f = [], d = [];
  do {
    a++;
    const y = a === o.length, b = y && c.length !== 0;
    if (y) {
      if (u = d.length === 0 ? void 0 : f[f.length - 1], l = h, h = d.pop(), b)
        if (s) {
          l = l.slice();
          let _ = 0;
          for (const [x, k] of c) {
            const E = x - _;
            k === null ? (l.splice(E, 1), _++) : l[E] = k;
          }
        } else {
          l = Object.defineProperties(
            {},
            Object.getOwnPropertyDescriptors(l)
          );
          for (const [_, x] of c)
            l[_] = x;
        }
      a = r.index, o = r.keys, c = r.edits, s = r.inArray, r = r.prev;
    } else if (h) {
      if (u = s ? a : o[a], l = h[u], l == null)
        continue;
      f.push(u);
    }
    let v;
    if (!Array.isArray(l)) {
      var p, g;
      Ga(l) || un(!1, `Invalid AST Node: ${Hs(l)}.`);
      const _ = y ? (p = n.get(l.kind)) === null || p === void 0 ? void 0 : p.leave : (g = n.get(l.kind)) === null || g === void 0 ? void 0 : g.enter;
      if (v = _ == null ? void 0 : _.call(t, l, u, h, f, d), v === Gs)
        break;
      if (v === !1) {
        if (!y) {
          f.pop();
          continue;
        }
      } else if (v !== void 0 && (c.push([u, v]), !y))
        if (Ga(v))
          l = v;
        else {
          f.pop();
          continue;
        }
    }
    if (v === void 0 && b && c.push([u, l]), y)
      f.pop();
    else {
      var m;
      r = {
        inArray: s,
        index: a,
        keys: o,
        edits: c,
        prev: r
      }, s = Array.isArray(l), o = s ? l : (m = e[l.kind]) !== null && m !== void 0 ? m : [], a = -1, c = [], h && d.push(h), h = l;
    }
  } while (r !== void 0);
  return c.length !== 0 ? c[c.length - 1][1] : i;
}
function am(i, t) {
  const e = i[t];
  return typeof e == "object" ? e : typeof e == "function" ? {
    enter: e,
    leave: void 0
  } : {
    enter: i.enter,
    leave: i.leave
  };
}
function cm(i) {
  return Ft(i, um);
}
const lm = 80, um = {
  Name: {
    leave: (i) => i.value
  },
  Variable: {
    leave: (i) => "$" + i.name
  },
  Document: {
    leave: (i) => T(i.definitions, `

`)
  },
  OperationDefinition: {
    leave(i) {
      const t = R("(", T(i.variableDefinitions, ", "), ")"), e = T(
        [
          i.operation,
          T([i.name, t]),
          T(i.directives, " ")
        ],
        " "
      );
      return (e === "query" ? "" : e + " ") + i.selectionSet;
    }
  },
  VariableDefinition: {
    leave: ({ variable: i, type: t, defaultValue: e, directives: n }) => i + ": " + t + R(" = ", e) + R(" ", T(n, " "))
  },
  SelectionSet: {
    leave: ({ selections: i }) => St(i)
  },
  Field: {
    leave({ alias: i, name: t, arguments: e, directives: n, selectionSet: r }) {
      const s = R("", i, ": ") + t;
      let o = s + R("(", T(e, ", "), ")");
      return o.length > lm && (o = s + R(`(
`, hn(T(e, `
`)), `
)`)), T([o, T(n, " "), r], " ");
    }
  },
  Argument: {
    leave: ({ name: i, value: t }) => i + ": " + t
  },
  FragmentSpread: {
    leave: ({ name: i, directives: t }) => "..." + i + R(" ", T(t, " "))
  },
  InlineFragment: {
    leave: ({ typeCondition: i, directives: t, selectionSet: e }) => T(
      [
        "...",
        R("on ", i),
        T(t, " "),
        e
      ],
      " "
    )
  },
  FragmentDefinition: {
    leave: ({ name: i, typeCondition: t, variableDefinitions: e, directives: n, selectionSet: r }) => `fragment ${i}${R("(", T(e, ", "), ")")} on ${t} ${R("", T(n, " "), " ")}` + r
  },
  IntValue: {
    leave: ({ value: i }) => i
  },
  FloatValue: {
    leave: ({ value: i }) => i
  },
  StringValue: {
    leave: ({ value: i, block: t }) => t ? Fg(i) : nm(i)
  },
  BooleanValue: {
    leave: ({ value: i }) => i ? "true" : "false"
  },
  NullValue: {
    leave: () => "null"
  },
  EnumValue: {
    leave: ({ value: i }) => i
  },
  ListValue: {
    leave: ({ values: i }) => "[" + T(i, ", ") + "]"
  },
  ObjectValue: {
    leave: ({ fields: i }) => "{" + T(i, ", ") + "}"
  },
  ObjectField: {
    leave: ({ name: i, value: t }) => i + ": " + t
  },
  Directive: {
    leave: ({ name: i, arguments: t }) => "@" + i + R("(", T(t, ", "), ")")
  },
  NamedType: {
    leave: ({ name: i }) => i
  },
  ListType: {
    leave: ({ type: i }) => "[" + i + "]"
  },
  NonNullType: {
    leave: ({ type: i }) => i + "!"
  },
  SchemaDefinition: {
    leave: ({ description: i, directives: t, operationTypes: e }) => R("", i, `
`) + T(["schema", T(t, " "), St(e)], " ")
  },
  OperationTypeDefinition: {
    leave: ({ operation: i, type: t }) => i + ": " + t
  },
  ScalarTypeDefinition: {
    leave: ({ description: i, name: t, directives: e }) => R("", i, `
`) + T(["scalar", t, T(e, " ")], " ")
  },
  ObjectTypeDefinition: {
    leave: ({ description: i, name: t, interfaces: e, directives: n, fields: r }) => R("", i, `
`) + T(
      [
        "type",
        t,
        R("implements ", T(e, " & ")),
        T(n, " "),
        St(r)
      ],
      " "
    )
  },
  FieldDefinition: {
    leave: ({ description: i, name: t, arguments: e, type: n, directives: r }) => R("", i, `
`) + t + (Ka(e) ? R(`(
`, hn(T(e, `
`)), `
)`) : R("(", T(e, ", "), ")")) + ": " + n + R(" ", T(r, " "))
  },
  InputValueDefinition: {
    leave: ({ description: i, name: t, type: e, defaultValue: n, directives: r }) => R("", i, `
`) + T(
      [t + ": " + e, R("= ", n), T(r, " ")],
      " "
    )
  },
  InterfaceTypeDefinition: {
    leave: ({ description: i, name: t, interfaces: e, directives: n, fields: r }) => R("", i, `
`) + T(
      [
        "interface",
        t,
        R("implements ", T(e, " & ")),
        T(n, " "),
        St(r)
      ],
      " "
    )
  },
  UnionTypeDefinition: {
    leave: ({ description: i, name: t, directives: e, types: n }) => R("", i, `
`) + T(
      ["union", t, T(e, " "), R("= ", T(n, " | "))],
      " "
    )
  },
  EnumTypeDefinition: {
    leave: ({ description: i, name: t, directives: e, values: n }) => R("", i, `
`) + T(["enum", t, T(e, " "), St(n)], " ")
  },
  EnumValueDefinition: {
    leave: ({ description: i, name: t, directives: e }) => R("", i, `
`) + T([t, T(e, " ")], " ")
  },
  InputObjectTypeDefinition: {
    leave: ({ description: i, name: t, directives: e, fields: n }) => R("", i, `
`) + T(["input", t, T(e, " "), St(n)], " ")
  },
  DirectiveDefinition: {
    leave: ({ description: i, name: t, arguments: e, repeatable: n, locations: r }) => R("", i, `
`) + "directive @" + t + (Ka(e) ? R(`(
`, hn(T(e, `
`)), `
)`) : R("(", T(e, ", "), ")")) + (n ? " repeatable" : "") + " on " + T(r, " | ")
  },
  SchemaExtension: {
    leave: ({ directives: i, operationTypes: t }) => T(
      ["extend schema", T(i, " "), St(t)],
      " "
    )
  },
  ScalarTypeExtension: {
    leave: ({ name: i, directives: t }) => T(["extend scalar", i, T(t, " ")], " ")
  },
  ObjectTypeExtension: {
    leave: ({ name: i, interfaces: t, directives: e, fields: n }) => T(
      [
        "extend type",
        i,
        R("implements ", T(t, " & ")),
        T(e, " "),
        St(n)
      ],
      " "
    )
  },
  InterfaceTypeExtension: {
    leave: ({ name: i, interfaces: t, directives: e, fields: n }) => T(
      [
        "extend interface",
        i,
        R("implements ", T(t, " & ")),
        T(e, " "),
        St(n)
      ],
      " "
    )
  },
  UnionTypeExtension: {
    leave: ({ name: i, directives: t, types: e }) => T(
      [
        "extend union",
        i,
        T(t, " "),
        R("= ", T(e, " | "))
      ],
      " "
    )
  },
  EnumTypeExtension: {
    leave: ({ name: i, directives: t, values: e }) => T(["extend enum", i, T(t, " "), St(e)], " ")
  },
  InputObjectTypeExtension: {
    leave: ({ name: i, directives: t, fields: e }) => T(["extend input", i, T(t, " "), St(e)], " ")
  }
};
function T(i, t = "") {
  var e;
  return (e = i == null ? void 0 : i.filter((n) => n).join(t)) !== null && e !== void 0 ? e : "";
}
function St(i) {
  return R(`{
`, hn(T(i, `
`)), `
}`);
}
function R(i, t, e = "") {
  return t != null && t !== "" ? i + t + e : "";
}
function hn(i) {
  return R("  ", i.replace(/\n/g, `
  `));
}
function Ka(i) {
  var t;
  return (t = i == null ? void 0 : i.some((e) => e.includes(`
`))) !== null && t !== void 0 ? t : !1;
}
function hm() {
  return Wa();
}
function fm() {
  __DEV__ ? D(typeof Er == "boolean", Er) : D(typeof Er == "boolean", 38);
}
hm();
fm();
function Xn(i, t) {
  var e = i.directives;
  return !e || !e.length ? !0 : gm(e).every(function(n) {
    var r = n.directive, s = n.ifArgument, o = !1;
    return s.value.kind === "Variable" ? (o = t && t[s.value.name.value], __DEV__ ? D(o !== void 0, "Invalid variable referenced in @".concat(r.name.value, " directive.")) : D(o !== void 0, 39)) : o = s.value.value, r.name.value === "skip" ? !o : o;
  });
}
function Xs(i, t, e) {
  var n = new Set(i), r = n.size;
  return Ft(t, {
    Directive: function(s) {
      if (n.delete(s.name.value) && (!e || !n.size))
        return Gs;
    }
  }), e ? !n.size : n.size < r;
}
function dm(i) {
  return i && Xs(["client", "export"], i, !0);
}
function pm(i) {
  var t = i.name.value;
  return t === "skip" || t === "include";
}
function gm(i) {
  var t = [];
  return i && i.length && i.forEach(function(e) {
    if (!!pm(e)) {
      var n = e.arguments, r = e.name.value;
      __DEV__ ? D(n && n.length === 1, "Incorrect number of arguments for the @".concat(r, " directive.")) : D(n && n.length === 1, 40);
      var s = n[0];
      __DEV__ ? D(s.name && s.name.value === "if", "Invalid argument for the @".concat(r, " directive.")) : D(s.name && s.name.value === "if", 41);
      var o = s.value;
      __DEV__ ? D(o && (o.kind === "Variable" || o.kind === "BooleanValue"), "Argument for the @".concat(r, " directive must be a variable or a boolean value.")) : D(o && (o.kind === "Variable" || o.kind === "BooleanValue"), 42), t.push({ directive: e, ifArgument: s });
    }
  }), t;
}
function mm(i, t) {
  var e = t, n = [];
  i.definitions.forEach(function(s) {
    if (s.kind === "OperationDefinition")
      throw __DEV__ ? new N("Found a ".concat(s.operation, " operation").concat(s.name ? " named '".concat(s.name.value, "'") : "", ". ") + "No operations are allowed when using a fragment as a query. Only fragments are allowed.") : new N(43);
    s.kind === "FragmentDefinition" && n.push(s);
  }), typeof e > "u" && (__DEV__ ? D(n.length === 1, "Found ".concat(n.length, " fragments. `fragmentName` must be provided when there is not exactly 1 fragment.")) : D(n.length === 1, 44), e = n[0].name.value);
  var r = w(w({}, i), { definitions: Pn([
    {
      kind: "OperationDefinition",
      operation: "query",
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: e
            }
          }
        ]
      }
    }
  ], i.definitions, !0) });
  return r;
}
function Ks(i) {
  i === void 0 && (i = []);
  var t = {};
  return i.forEach(function(e) {
    t[e.name.value] = e;
  }), t;
}
function Js(i, t) {
  switch (i.kind) {
    case "InlineFragment":
      return i;
    case "FragmentSpread": {
      var e = i.name.value;
      if (typeof t == "function")
        return t(e);
      var n = t && t[e];
      return __DEV__ ? D(n, "No fragment named ".concat(e)) : D(n, 45), n || null;
    }
    default:
      return null;
  }
}
function J(i) {
  return i !== null && typeof i == "object";
}
function Re(i) {
  return { __ref: String(i) };
}
function B(i) {
  return Boolean(i && typeof i == "object" && typeof i.__ref == "string");
}
function ym(i) {
  return J(i) && i.kind === "Document" && Array.isArray(i.definitions);
}
function vm(i) {
  return i.kind === "StringValue";
}
function bm(i) {
  return i.kind === "BooleanValue";
}
function _m(i) {
  return i.kind === "IntValue";
}
function xm(i) {
  return i.kind === "FloatValue";
}
function wm(i) {
  return i.kind === "Variable";
}
function Sm(i) {
  return i.kind === "ObjectValue";
}
function Em(i) {
  return i.kind === "ListValue";
}
function km(i) {
  return i.kind === "EnumValue";
}
function Om(i) {
  return i.kind === "NullValue";
}
function Ue(i, t, e, n) {
  if (_m(e) || xm(e))
    i[t.value] = Number(e.value);
  else if (bm(e) || vm(e))
    i[t.value] = e.value;
  else if (Sm(e)) {
    var r = {};
    e.fields.map(function(o) {
      return Ue(r, o.name, o.value, n);
    }), i[t.value] = r;
  } else if (wm(e)) {
    var s = (n || {})[e.name.value];
    i[t.value] = s;
  } else if (Em(e))
    i[t.value] = e.values.map(function(o) {
      var a = {};
      return Ue(a, t, o, n), a[t.value];
    });
  else if (km(e))
    i[t.value] = e.value;
  else if (Om(e))
    i[t.value] = null;
  else
    throw __DEV__ ? new N('The inline argument "'.concat(t.value, '" of kind "').concat(e.kind, '"') + "is not supported. Use variables instead of inline arguments to overcome this limitation.") : new N(54);
}
function Dm(i, t) {
  var e = null;
  i.directives && (e = {}, i.directives.forEach(function(r) {
    e[r.name.value] = {}, r.arguments && r.arguments.forEach(function(s) {
      var o = s.name, a = s.value;
      return Ue(e[r.name.value], o, a, t);
    });
  }));
  var n = null;
  return i.arguments && i.arguments.length && (n = {}, i.arguments.forEach(function(r) {
    var s = r.name, o = r.value;
    return Ue(n, s, o, t);
  })), Zs(i.name.value, n, e);
}
var Tm = [
  "connection",
  "include",
  "skip",
  "client",
  "rest",
  "export"
], Zs = Object.assign(function(i, t, e) {
  if (t && e && e.connection && e.connection.key)
    if (e.connection.filter && e.connection.filter.length > 0) {
      var n = e.connection.filter ? e.connection.filter : [];
      n.sort();
      var r = {};
      return n.forEach(function(a) {
        r[a] = t[a];
      }), "".concat(e.connection.key, "(").concat(si(r), ")");
    } else
      return e.connection.key;
  var s = i;
  if (t) {
    var o = si(t);
    s += "(".concat(o, ")");
  }
  return e && Object.keys(e).forEach(function(a) {
    Tm.indexOf(a) === -1 && (e[a] && Object.keys(e[a]).length ? s += "@".concat(a, "(").concat(si(e[a]), ")") : s += "@".concat(a));
  }), s;
}, {
  setStringify: function(i) {
    var t = si;
    return si = i, t;
  }
}), si = function(t) {
  return JSON.stringify(t, Mm);
};
function Mm(i, t) {
  return J(t) && !Array.isArray(t) && (t = Object.keys(t).sort().reduce(function(e, n) {
    return e[n] = t[n], e;
  }, {})), t;
}
function Kn(i, t) {
  if (i.arguments && i.arguments.length) {
    var e = {};
    return i.arguments.forEach(function(n) {
      var r = n.name, s = n.value;
      return Ue(e, r, s, t);
    }), e;
  }
  return null;
}
function ye(i) {
  return i.alias ? i.alias.value : i.name.value;
}
function ns(i, t, e) {
  if (typeof i.__typename == "string")
    return i.__typename;
  for (var n = 0, r = t.selections; n < r.length; n++) {
    var s = r[n];
    if (Bt(s)) {
      if (s.name.value === "__typename")
        return i[ye(s)];
    } else {
      var o = ns(i, Js(s, e).selectionSet, e);
      if (typeof o == "string")
        return o;
    }
  }
}
function Bt(i) {
  return i.kind === "Field";
}
function Kl(i) {
  return i.kind === "InlineFragment";
}
function Jn(i) {
  __DEV__ ? D(i && i.kind === "Document", 'Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a "gql" tag? http://docs.apollostack.com/apollo-client/core.html#gql') : D(i && i.kind === "Document", 46);
  var t = i.definitions.filter(function(e) {
    return e.kind !== "FragmentDefinition";
  }).map(function(e) {
    if (e.kind !== "OperationDefinition")
      throw __DEV__ ? new N('Schema type definitions not allowed in queries. Found: "'.concat(e.kind, '"')) : new N(47);
    return e;
  });
  return __DEV__ ? D(t.length <= 1, "Ambiguous GraphQL document: contains ".concat(t.length, " operations")) : D(t.length <= 1, 48), i;
}
function zi(i) {
  return Jn(i), i.definitions.filter(function(t) {
    return t.kind === "OperationDefinition";
  })[0];
}
function rs(i) {
  return i.definitions.filter(function(t) {
    return t.kind === "OperationDefinition" && t.name;
  }).map(function(t) {
    return t.name.value;
  })[0] || null;
}
function to(i) {
  return i.definitions.filter(function(t) {
    return t.kind === "FragmentDefinition";
  });
}
function Jl(i) {
  var t = zi(i);
  return __DEV__ ? D(t && t.operation === "query", "Must contain a query definition.") : D(t && t.operation === "query", 49), t;
}
function Am(i) {
  __DEV__ ? D(i.kind === "Document", 'Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a "gql" tag? http://docs.apollostack.com/apollo-client/core.html#gql') : D(i.kind === "Document", 50), __DEV__ ? D(i.definitions.length <= 1, "Fragment must have exactly one definition.") : D(i.definitions.length <= 1, 51);
  var t = i.definitions[0];
  return __DEV__ ? D(t.kind === "FragmentDefinition", "Must be a fragment definition.") : D(t.kind === "FragmentDefinition", 52), t;
}
function eo(i) {
  Jn(i);
  for (var t, e = 0, n = i.definitions; e < n.length; e++) {
    var r = n[e];
    if (r.kind === "OperationDefinition") {
      var s = r.operation;
      if (s === "query" || s === "mutation" || s === "subscription")
        return r;
    }
    r.kind === "FragmentDefinition" && !t && (t = r);
  }
  if (t)
    return t;
  throw __DEV__ ? new N("Expected a parsed GraphQL query with a query, mutation, subscription, or a fragment.") : new N(53);
}
function io(i) {
  var t = /* @__PURE__ */ Object.create(null), e = i && i.variableDefinitions;
  return e && e.length && e.forEach(function(n) {
    n.defaultValue && Ue(t, n.variable.name, n.defaultValue);
  }), t;
}
function Ja(i, t, e) {
  var n = 0;
  return i.forEach(function(r, s) {
    t.call(this, r, s, i) && (i[n++] = r);
  }, e), i.length = n, i;
}
var Za = {
  kind: "Field",
  name: {
    kind: "Name",
    value: "__typename"
  }
};
function Zl(i, t) {
  return !i || i.selectionSet.selections.every(function(e) {
    return e.kind === "FragmentSpread" && Zl(t[e.name.value], t);
  });
}
function no(i) {
  return Zl(zi(i) || Am(i), Ks(to(i))) ? null : i;
}
function tc(i) {
  return function(e) {
    return i.some(function(n) {
      return n.name && n.name === e.name.value || n.test && n.test(e);
    });
  };
}
function tu(i, t) {
  var e = /* @__PURE__ */ Object.create(null), n = [], r = /* @__PURE__ */ Object.create(null), s = [], o = no(Ft(t, {
    Variable: {
      enter: function(a, c, l) {
        l.kind !== "VariableDefinition" && (e[a.name.value] = !0);
      }
    },
    Field: {
      enter: function(a) {
        if (i && a.directives) {
          var c = i.some(function(l) {
            return l.remove;
          });
          if (c && a.directives && a.directives.some(tc(i)))
            return a.arguments && a.arguments.forEach(function(l) {
              l.value.kind === "Variable" && n.push({
                name: l.value.name.value
              });
            }), a.selectionSet && eu(a.selectionSet).forEach(function(l) {
              s.push({
                name: l.name.value
              });
            }), null;
        }
      }
    },
    FragmentSpread: {
      enter: function(a) {
        r[a.name.value] = !0;
      }
    },
    Directive: {
      enter: function(a) {
        if (tc(i)(a))
          return null;
      }
    }
  }));
  return o && Ja(n, function(a) {
    return !!a.name && !e[a.name];
  }).length && (o = Im(n, o)), o && Ja(s, function(a) {
    return !!a.name && !r[a.name];
  }).length && (o = Fm(s, o)), o;
}
var ro = Object.assign(function(i) {
  return Ft(i, {
    SelectionSet: {
      enter: function(t, e, n) {
        if (!(n && n.kind === "OperationDefinition")) {
          var r = t.selections;
          if (!!r) {
            var s = r.some(function(a) {
              return Bt(a) && (a.name.value === "__typename" || a.name.value.lastIndexOf("__", 0) === 0);
            });
            if (!s) {
              var o = n;
              if (!(Bt(o) && o.directives && o.directives.some(function(a) {
                return a.name.value === "export";
              })))
                return w(w({}, t), { selections: Pn(Pn([], r, !0), [Za], !1) });
            }
          }
        }
      }
    }
  });
}, {
  added: function(i) {
    return i === Za;
  }
}), Cm = {
  test: function(i) {
    var t = i.name.value === "connection";
    return t && (!i.arguments || !i.arguments.some(function(e) {
      return e.name.value === "key";
    })) && __DEV__ && D.warn("Removing an @connection directive even though it does not have a key. You may want to use the key parameter to specify a store key."), t;
  }
};
function Pm(i) {
  return tu([Cm], Jn(i));
}
function Rm(i) {
  return function(e) {
    return i.some(function(n) {
      return e.value && e.value.kind === "Variable" && e.value.name && (n.name === e.value.name.value || n.test && n.test(e));
    });
  };
}
function Im(i, t) {
  var e = Rm(i);
  return no(Ft(t, {
    OperationDefinition: {
      enter: function(n) {
        return w(w({}, n), { variableDefinitions: n.variableDefinitions ? n.variableDefinitions.filter(function(r) {
          return !i.some(function(s) {
            return s.name === r.variable.name.value;
          });
        }) : [] });
      }
    },
    Field: {
      enter: function(n) {
        var r = i.some(function(o) {
          return o.remove;
        });
        if (r) {
          var s = 0;
          if (n.arguments && n.arguments.forEach(function(o) {
            e(o) && (s += 1);
          }), s === 1)
            return null;
        }
      }
    },
    Argument: {
      enter: function(n) {
        if (e(n))
          return null;
      }
    }
  }));
}
function Fm(i, t) {
  function e(n) {
    if (i.some(function(r) {
      return r.name === n.name.value;
    }))
      return null;
  }
  return no(Ft(t, {
    FragmentSpread: { enter: e },
    FragmentDefinition: { enter: e }
  }));
}
function eu(i) {
  var t = [];
  return i.selections.forEach(function(e) {
    (Bt(e) || Kl(e)) && e.selectionSet ? eu(e.selectionSet).forEach(function(n) {
      return t.push(n);
    }) : e.kind === "FragmentSpread" && t.push(e);
  }), t;
}
function Lm(i) {
  var t = eo(i), e = t.operation;
  if (e === "query")
    return i;
  var n = Ft(i, {
    OperationDefinition: {
      enter: function(r) {
        return w(w({}, r), { operation: "query" });
      }
    }
  });
  return n;
}
function Nm(i) {
  Jn(i);
  var t = tu([
    {
      test: function(e) {
        return e.name.value === "client";
      },
      remove: !0
    }
  ], i);
  return t && (t = Ft(t, {
    FragmentDefinition: {
      enter: function(e) {
        if (e.selectionSet) {
          var n = e.selectionSet.selections.every(function(r) {
            return Bt(r) && r.name.value === "__typename";
          });
          if (n)
            return null;
        }
      }
    }
  })), t;
}
var Vm = Object.prototype.hasOwnProperty;
function ec() {
  for (var i = [], t = 0; t < arguments.length; t++)
    i[t] = arguments[t];
  return so(i);
}
function so(i) {
  var t = i[0] || {}, e = i.length;
  if (e > 1)
    for (var n = new ve(), r = 1; r < e; ++r)
      t = n.merge(t, i[r]);
  return t;
}
var jm = function(i, t, e) {
  return this.merge(i[e], t[e]);
}, ve = function() {
  function i(t) {
    t === void 0 && (t = jm), this.reconciler = t, this.isObject = J, this.pastCopies = /* @__PURE__ */ new Set();
  }
  return i.prototype.merge = function(t, e) {
    for (var n = this, r = [], s = 2; s < arguments.length; s++)
      r[s - 2] = arguments[s];
    return J(e) && J(t) ? (Object.keys(e).forEach(function(o) {
      if (Vm.call(t, o)) {
        var a = t[o];
        if (e[o] !== a) {
          var c = n.reconciler.apply(n, Pn([t, e, o], r, !1));
          c !== a && (t = n.shallowCopyForMerge(t), t[o] = c);
        }
      } else
        t = n.shallowCopyForMerge(t), t[o] = e[o];
    }), t) : e;
  }, i.prototype.shallowCopyForMerge = function(t) {
    return J(t) && (this.pastCopies.has(t) || (Array.isArray(t) ? t = t.slice(0) : t = w({ __proto__: Object.getPrototypeOf(t) }, t), this.pastCopies.add(t))), t;
  }, i;
}();
function Bm(i, t) {
  var e = typeof Symbol < "u" && i[Symbol.iterator] || i["@@iterator"];
  if (e)
    return (e = e.call(i)).next.bind(e);
  if (Array.isArray(i) || (e = $m(i)) || t && i && typeof i.length == "number") {
    e && (i = e);
    var n = 0;
    return function() {
      return n >= i.length ? { done: !0 } : { done: !1, value: i[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function $m(i, t) {
  if (!!i) {
    if (typeof i == "string")
      return ic(i, t);
    var e = Object.prototype.toString.call(i).slice(8, -1);
    if (e === "Object" && i.constructor && (e = i.constructor.name), e === "Map" || e === "Set")
      return Array.from(i);
    if (e === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e))
      return ic(i, t);
  }
}
function ic(i, t) {
  (t == null || t > i.length) && (t = i.length);
  for (var e = 0, n = new Array(t); e < t; e++)
    n[e] = i[e];
  return n;
}
function nc(i, t) {
  for (var e = 0; e < t.length; e++) {
    var n = t[e];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(i, n.key, n);
  }
}
function oo(i, t, e) {
  return t && nc(i.prototype, t), e && nc(i, e), Object.defineProperty(i, "prototype", { writable: !1 }), i;
}
var ao = function() {
  return typeof Symbol == "function";
}, co = function(i) {
  return ao() && Boolean(Symbol[i]);
}, lo = function(i) {
  return co(i) ? Symbol[i] : "@@" + i;
};
ao() && !co("observable") && (Symbol.observable = Symbol("observable"));
var zm = lo("iterator"), ss = lo("observable"), iu = lo("species");
function Rn(i, t) {
  var e = i[t];
  if (e != null) {
    if (typeof e != "function")
      throw new TypeError(e + " is not a function");
    return e;
  }
}
function oi(i) {
  var t = i.constructor;
  return t !== void 0 && (t = t[iu], t === null && (t = void 0)), t !== void 0 ? t : U;
}
function qm(i) {
  return i instanceof U;
}
function We(i) {
  We.log ? We.log(i) : setTimeout(function() {
    throw i;
  });
}
function fn(i) {
  Promise.resolve().then(function() {
    try {
      i();
    } catch (t) {
      We(t);
    }
  });
}
function nu(i) {
  var t = i._cleanup;
  if (t !== void 0 && (i._cleanup = void 0, !!t))
    try {
      if (typeof t == "function")
        t();
      else {
        var e = Rn(t, "unsubscribe");
        e && e.call(t);
      }
    } catch (n) {
      We(n);
    }
}
function os(i) {
  i._observer = void 0, i._queue = void 0, i._state = "closed";
}
function Qm(i) {
  var t = i._queue;
  if (!!t) {
    i._queue = void 0, i._state = "ready";
    for (var e = 0; e < t.length && (ru(i, t[e].type, t[e].value), i._state !== "closed"); ++e)
      ;
  }
}
function ru(i, t, e) {
  i._state = "running";
  var n = i._observer;
  try {
    var r = Rn(n, t);
    switch (t) {
      case "next":
        r && r.call(n, e);
        break;
      case "error":
        if (os(i), r)
          r.call(n, e);
        else
          throw e;
        break;
      case "complete":
        os(i), r && r.call(n);
        break;
    }
  } catch (s) {
    We(s);
  }
  i._state === "closed" ? nu(i) : i._state === "running" && (i._state = "ready");
}
function Or(i, t, e) {
  if (i._state !== "closed") {
    if (i._state === "buffering") {
      i._queue.push({
        type: t,
        value: e
      });
      return;
    }
    if (i._state !== "ready") {
      i._state = "buffering", i._queue = [{
        type: t,
        value: e
      }], fn(function() {
        return Qm(i);
      });
      return;
    }
    ru(i, t, e);
  }
}
var Um = /* @__PURE__ */ function() {
  function i(e, n) {
    this._cleanup = void 0, this._observer = e, this._queue = void 0, this._state = "initializing";
    var r = new Wm(this);
    try {
      this._cleanup = n.call(void 0, r);
    } catch (s) {
      r.error(s);
    }
    this._state === "initializing" && (this._state = "ready");
  }
  var t = i.prototype;
  return t.unsubscribe = function() {
    this._state !== "closed" && (os(this), nu(this));
  }, oo(i, [{
    key: "closed",
    get: function() {
      return this._state === "closed";
    }
  }]), i;
}(), Wm = /* @__PURE__ */ function() {
  function i(e) {
    this._subscription = e;
  }
  var t = i.prototype;
  return t.next = function(n) {
    Or(this._subscription, "next", n);
  }, t.error = function(n) {
    Or(this._subscription, "error", n);
  }, t.complete = function() {
    Or(this._subscription, "complete");
  }, oo(i, [{
    key: "closed",
    get: function() {
      return this._subscription._state === "closed";
    }
  }]), i;
}(), U = /* @__PURE__ */ function() {
  function i(e) {
    if (!(this instanceof i))
      throw new TypeError("Observable cannot be called as a function");
    if (typeof e != "function")
      throw new TypeError("Observable initializer must be a function");
    this._subscriber = e;
  }
  var t = i.prototype;
  return t.subscribe = function(n) {
    return (typeof n != "object" || n === null) && (n = {
      next: n,
      error: arguments[1],
      complete: arguments[2]
    }), new Um(n, this._subscriber);
  }, t.forEach = function(n) {
    var r = this;
    return new Promise(function(s, o) {
      if (typeof n != "function") {
        o(new TypeError(n + " is not a function"));
        return;
      }
      function a() {
        c.unsubscribe(), s();
      }
      var c = r.subscribe({
        next: function(l) {
          try {
            n(l, a);
          } catch (u) {
            o(u), c.unsubscribe();
          }
        },
        error: o,
        complete: s
      });
    });
  }, t.map = function(n) {
    var r = this;
    if (typeof n != "function")
      throw new TypeError(n + " is not a function");
    var s = oi(this);
    return new s(function(o) {
      return r.subscribe({
        next: function(a) {
          try {
            a = n(a);
          } catch (c) {
            return o.error(c);
          }
          o.next(a);
        },
        error: function(a) {
          o.error(a);
        },
        complete: function() {
          o.complete();
        }
      });
    });
  }, t.filter = function(n) {
    var r = this;
    if (typeof n != "function")
      throw new TypeError(n + " is not a function");
    var s = oi(this);
    return new s(function(o) {
      return r.subscribe({
        next: function(a) {
          try {
            if (!n(a))
              return;
          } catch (c) {
            return o.error(c);
          }
          o.next(a);
        },
        error: function(a) {
          o.error(a);
        },
        complete: function() {
          o.complete();
        }
      });
    });
  }, t.reduce = function(n) {
    var r = this;
    if (typeof n != "function")
      throw new TypeError(n + " is not a function");
    var s = oi(this), o = arguments.length > 1, a = !1, c = arguments[1], l = c;
    return new s(function(u) {
      return r.subscribe({
        next: function(h) {
          var f = !a;
          if (a = !0, !f || o)
            try {
              l = n(l, h);
            } catch (d) {
              return u.error(d);
            }
          else
            l = h;
        },
        error: function(h) {
          u.error(h);
        },
        complete: function() {
          if (!a && !o)
            return u.error(new TypeError("Cannot reduce an empty sequence"));
          u.next(l), u.complete();
        }
      });
    });
  }, t.concat = function() {
    for (var n = this, r = arguments.length, s = new Array(r), o = 0; o < r; o++)
      s[o] = arguments[o];
    var a = oi(this);
    return new a(function(c) {
      var l, u = 0;
      function h(f) {
        l = f.subscribe({
          next: function(d) {
            c.next(d);
          },
          error: function(d) {
            c.error(d);
          },
          complete: function() {
            u === s.length ? (l = void 0, c.complete()) : h(a.from(s[u++]));
          }
        });
      }
      return h(n), function() {
        l && (l.unsubscribe(), l = void 0);
      };
    });
  }, t.flatMap = function(n) {
    var r = this;
    if (typeof n != "function")
      throw new TypeError(n + " is not a function");
    var s = oi(this);
    return new s(function(o) {
      var a = [], c = r.subscribe({
        next: function(u) {
          if (n)
            try {
              u = n(u);
            } catch (f) {
              return o.error(f);
            }
          var h = s.from(u).subscribe({
            next: function(f) {
              o.next(f);
            },
            error: function(f) {
              o.error(f);
            },
            complete: function() {
              var f = a.indexOf(h);
              f >= 0 && a.splice(f, 1), l();
            }
          });
          a.push(h);
        },
        error: function(u) {
          o.error(u);
        },
        complete: function() {
          l();
        }
      });
      function l() {
        c.closed && a.length === 0 && o.complete();
      }
      return function() {
        a.forEach(function(u) {
          return u.unsubscribe();
        }), c.unsubscribe();
      };
    });
  }, t[ss] = function() {
    return this;
  }, i.from = function(n) {
    var r = typeof this == "function" ? this : i;
    if (n == null)
      throw new TypeError(n + " is not an object");
    var s = Rn(n, ss);
    if (s) {
      var o = s.call(n);
      if (Object(o) !== o)
        throw new TypeError(o + " is not an object");
      return qm(o) && o.constructor === r ? o : new r(function(a) {
        return o.subscribe(a);
      });
    }
    if (co("iterator") && (s = Rn(n, zm), s))
      return new r(function(a) {
        fn(function() {
          if (!a.closed) {
            for (var c = Bm(s.call(n)), l; !(l = c()).done; ) {
              var u = l.value;
              if (a.next(u), a.closed)
                return;
            }
            a.complete();
          }
        });
      });
    if (Array.isArray(n))
      return new r(function(a) {
        fn(function() {
          if (!a.closed) {
            for (var c = 0; c < n.length; ++c)
              if (a.next(n[c]), a.closed)
                return;
            a.complete();
          }
        });
      });
    throw new TypeError(n + " is not observable");
  }, i.of = function() {
    for (var n = arguments.length, r = new Array(n), s = 0; s < n; s++)
      r[s] = arguments[s];
    var o = typeof this == "function" ? this : i;
    return new o(function(a) {
      fn(function() {
        if (!a.closed) {
          for (var c = 0; c < r.length; ++c)
            if (a.next(r[c]), a.closed)
              return;
          a.complete();
        }
      });
    });
  }, oo(i, null, [{
    key: iu,
    get: function() {
      return this;
    }
  }]), i;
}();
ao() && Object.defineProperty(U, Symbol("extensions"), {
  value: {
    symbol: ss,
    hostReportError: We
  },
  configurable: !0
});
function Hm(i) {
  var t, e = i.Symbol;
  if (typeof e == "function")
    if (e.observable)
      t = e.observable;
    else {
      typeof e.for == "function" ? t = e.for("https://github.com/benlesh/symbol-observable") : t = e("https://github.com/benlesh/symbol-observable");
      try {
        e.observable = t;
      } catch {
      }
    }
  else
    t = "@@observable";
  return t;
}
var De;
typeof self < "u" ? De = self : typeof window < "u" ? De = window : typeof global < "u" ? De = global : typeof module < "u" ? De = module : De = Function("return this")();
Hm(De);
var rc = U.prototype, sc = "@@observable";
rc[sc] || (rc[sc] = function() {
  return this;
});
var Ym = Object.prototype.toString;
function uo(i) {
  return as(i);
}
function as(i, t) {
  switch (Ym.call(i)) {
    case "[object Array]": {
      if (t = t || /* @__PURE__ */ new Map(), t.has(i))
        return t.get(i);
      var e = i.slice(0);
      return t.set(i, e), e.forEach(function(r, s) {
        e[s] = as(r, t);
      }), e;
    }
    case "[object Object]": {
      if (t = t || /* @__PURE__ */ new Map(), t.has(i))
        return t.get(i);
      var n = Object.create(Object.getPrototypeOf(i));
      return t.set(i, n), Object.keys(i).forEach(function(r) {
        n[r] = as(i[r], t);
      }), n;
    }
    default:
      return i;
  }
}
function Gm(i) {
  var t = /* @__PURE__ */ new Set([i]);
  return t.forEach(function(e) {
    J(e) && Xm(e) === e && Object.getOwnPropertyNames(e).forEach(function(n) {
      J(e[n]) && t.add(e[n]);
    });
  }), i;
}
function Xm(i) {
  if (__DEV__ && !Object.isFrozen(i))
    try {
      Object.freeze(i);
    } catch (t) {
      if (t instanceof TypeError)
        return null;
      throw t;
    }
  return i;
}
function cs(i) {
  return __DEV__ && Gm(i), i;
}
function bi(i, t, e) {
  var n = [];
  i.forEach(function(r) {
    return r[t] && n.push(r);
  }), n.forEach(function(r) {
    return r[t](e);
  });
}
function Dr(i, t, e) {
  return new U(function(n) {
    var r = n.next, s = n.error, o = n.complete, a = 0, c = !1, l = {
      then: function(d) {
        return new Promise(function(p) {
          return p(d());
        });
      }
    };
    function u(d, p) {
      return d ? function(g) {
        ++a;
        var m = function() {
          return d(g);
        };
        l = l.then(m, m).then(function(y) {
          --a, r && r.call(n, y), c && h.complete();
        }, function(y) {
          throw --a, y;
        }).catch(function(y) {
          s && s.call(n, y);
        });
      } : function(g) {
        return p && p.call(n, g);
      };
    }
    var h = {
      next: u(t, r),
      error: u(e, s),
      complete: function() {
        c = !0, a || o && o.call(n);
      }
    }, f = i.subscribe(h);
    return function() {
      return f.unsubscribe();
    };
  });
}
var _e = typeof WeakMap == "function" && vt(function() {
  return navigator.product;
}) !== "ReactNative", Km = typeof WeakSet == "function", su = typeof Symbol == "function" && typeof Symbol.for == "function", Zn = su && Symbol.asyncIterator;
vt(function() {
  return window.document.createElement;
});
vt(function() {
  return navigator.userAgent.indexOf("jsdom") >= 0;
});
function ou(i) {
  function t(e) {
    Object.defineProperty(i, e, { value: U });
  }
  return su && Symbol.species && t(Symbol.species), t("@@species"), i;
}
function oc(i) {
  return i && typeof i.then == "function";
}
var di = function(i) {
  Dt(t, i);
  function t(e) {
    var n = i.call(this, function(r) {
      return n.addObserver(r), function() {
        return n.removeObserver(r);
      };
    }) || this;
    return n.observers = /* @__PURE__ */ new Set(), n.promise = new Promise(function(r, s) {
      n.resolve = r, n.reject = s;
    }), n.handlers = {
      next: function(r) {
        n.sub !== null && (n.latest = ["next", r], n.notify("next", r), bi(n.observers, "next", r));
      },
      error: function(r) {
        var s = n.sub;
        s !== null && (s && setTimeout(function() {
          return s.unsubscribe();
        }), n.sub = null, n.latest = ["error", r], n.reject(r), n.notify("error", r), bi(n.observers, "error", r));
      },
      complete: function() {
        var r = n.sub;
        if (r !== null) {
          var s = n.sources.shift();
          s ? oc(s) ? s.then(function(o) {
            return n.sub = o.subscribe(n.handlers);
          }) : n.sub = s.subscribe(n.handlers) : (r && setTimeout(function() {
            return r.unsubscribe();
          }), n.sub = null, n.latest && n.latest[0] === "next" ? n.resolve(n.latest[1]) : n.resolve(), n.notify("complete"), bi(n.observers, "complete"));
        }
      }
    }, n.nextResultListeners = /* @__PURE__ */ new Set(), n.cancel = function(r) {
      n.reject(r), n.sources = [], n.handlers.complete();
    }, n.promise.catch(function(r) {
    }), typeof e == "function" && (e = [new U(e)]), oc(e) ? e.then(function(r) {
      return n.start(r);
    }, n.handlers.error) : n.start(e), n;
  }
  return t.prototype.start = function(e) {
    this.sub === void 0 && (this.sources = Array.from(e), this.handlers.complete());
  }, t.prototype.deliverLastMessage = function(e) {
    if (this.latest) {
      var n = this.latest[0], r = e[n];
      r && r.call(e, this.latest[1]), this.sub === null && n === "next" && e.complete && e.complete();
    }
  }, t.prototype.addObserver = function(e) {
    this.observers.has(e) || (this.deliverLastMessage(e), this.observers.add(e));
  }, t.prototype.removeObserver = function(e) {
    this.observers.delete(e) && this.observers.size < 1 && this.handlers.complete();
  }, t.prototype.notify = function(e, n) {
    var r = this.nextResultListeners;
    r.size && (this.nextResultListeners = /* @__PURE__ */ new Set(), r.forEach(function(s) {
      return s(e, n);
    }));
  }, t.prototype.beforeNext = function(e) {
    var n = !1;
    this.nextResultListeners.add(function(r, s) {
      n || (n = !0, e(r, s));
    });
  }, t;
}(U);
ou(di);
function It(i) {
  return Array.isArray(i) && i.length > 0;
}
function dn(i) {
  return i.errors && i.errors.length > 0 || !1;
}
function tr() {
  for (var i = [], t = 0; t < arguments.length; t++)
    i[t] = arguments[t];
  var e = /* @__PURE__ */ Object.create(null);
  return i.forEach(function(n) {
    !n || Object.keys(n).forEach(function(r) {
      var s = n[r];
      s !== void 0 && (e[r] = s);
    });
  }), e;
}
var ac = /* @__PURE__ */ new Map();
function ls(i) {
  var t = ac.get(i) || 1;
  return ac.set(i, t + 1), "".concat(i, ":").concat(t, ":").concat(Math.random().toString(36).slice(2));
}
function Jm(i) {
  var t = ls("stringifyForDisplay");
  return JSON.stringify(i, function(e, n) {
    return n === void 0 ? t : n;
  }).split(JSON.stringify(t)).join("<undefined>");
}
function Tr(i, t) {
  return tr(i, t, t.variables && {
    variables: w(w({}, i && i.variables), t.variables)
  });
}
function cc(i) {
  return new U(function(t) {
    t.error(i);
  });
}
var us = function(i, t, e) {
  var n = new Error(e);
  throw n.name = "ServerError", n.response = i, n.statusCode = i.status, n.result = t, n;
};
function Zm(i) {
  for (var t = [
    "query",
    "operationName",
    "variables",
    "extensions",
    "context"
  ], e = 0, n = Object.keys(i); e < n.length; e++) {
    var r = n[e];
    if (t.indexOf(r) < 0)
      throw __DEV__ ? new N("illegal argument: ".concat(r)) : new N(26);
  }
  return i;
}
function ty(i, t) {
  var e = w({}, i), n = function(s) {
    typeof s == "function" ? e = w(w({}, e), s(e)) : e = w(w({}, e), s);
  }, r = function() {
    return w({}, e);
  };
  return Object.defineProperty(t, "setContext", {
    enumerable: !1,
    value: n
  }), Object.defineProperty(t, "getContext", {
    enumerable: !1,
    value: r
  }), t;
}
function ey(i) {
  var t = {
    variables: i.variables || {},
    extensions: i.extensions || {},
    operationName: i.operationName,
    query: i.query
  };
  return t.operationName || (t.operationName = typeof t.query != "string" ? rs(t.query) || void 0 : ""), t;
}
function lc(i, t) {
  return t ? t(i) : U.of();
}
function ai(i) {
  return typeof i == "function" ? new xe(i) : i;
}
function on(i) {
  return i.request.length <= 1;
}
var iy = function(i) {
  Dt(t, i);
  function t(e, n) {
    var r = i.call(this, e) || this;
    return r.link = n, r;
  }
  return t;
}(Error), xe = function() {
  function i(t) {
    t && (this.request = t);
  }
  return i.empty = function() {
    return new i(function() {
      return U.of();
    });
  }, i.from = function(t) {
    return t.length === 0 ? i.empty() : t.map(ai).reduce(function(e, n) {
      return e.concat(n);
    });
  }, i.split = function(t, e, n) {
    var r = ai(e), s = ai(n || new i(lc));
    return on(r) && on(s) ? new i(function(o) {
      return t(o) ? r.request(o) || U.of() : s.request(o) || U.of();
    }) : new i(function(o, a) {
      return t(o) ? r.request(o, a) || U.of() : s.request(o, a) || U.of();
    });
  }, i.execute = function(t, e) {
    return t.request(ty(e.context, ey(Zm(e)))) || U.of();
  }, i.concat = function(t, e) {
    var n = ai(t);
    if (on(n))
      return __DEV__ && D.warn(new iy("You are calling concat on a terminating link, which will have no effect", n)), n;
    var r = ai(e);
    return on(r) ? new i(function(s) {
      return n.request(s, function(o) {
        return r.request(o) || U.of();
      }) || U.of();
    }) : new i(function(s, o) {
      return n.request(s, function(a) {
        return r.request(a, o) || U.of();
      }) || U.of();
    });
  }, i.prototype.split = function(t, e, n) {
    return this.concat(i.split(t, e, n || new i(lc)));
  }, i.prototype.concat = function(t) {
    return i.concat(this, t);
  }, i.prototype.request = function(t, e) {
    throw __DEV__ ? new N("request is not implemented") : new N(21);
  }, i.prototype.onError = function(t, e) {
    if (e && e.error)
      return e.error(t), !1;
    throw t;
  }, i.prototype.setOnError = function(t) {
    return this.onError = t, this;
  }, i;
}(), ny = xe.concat, hs = xe.execute, ry = "3.7.1";
function sy(i) {
  return !!i.body;
}
function oy(i) {
  return !!i.getReader;
}
function ay(i) {
  return !!(Zn && i[Symbol.asyncIterator]);
}
function cy(i) {
  return !!i.stream;
}
function ly(i) {
  return !!i.arrayBuffer;
}
function uy(i) {
  return !!i.pipe;
}
function hy(i) {
  var t, e = i[Symbol.asyncIterator]();
  return t = {
    next: function() {
      return e.next();
    }
  }, t[Symbol.asyncIterator] = function() {
    return this;
  }, t;
}
function fy(i) {
  var t = null, e = null, n = !1, r = [], s = [];
  function o(h) {
    if (!e) {
      if (s.length) {
        var f = s.shift();
        if (Array.isArray(f) && f[0])
          return f[0]({ value: h, done: !1 });
      }
      r.push(h);
    }
  }
  function a(h) {
    e = h;
    var f = s.slice();
    f.forEach(function(d) {
      d[1](h);
    }), !t || t();
  }
  function c() {
    n = !0;
    var h = s.slice();
    h.forEach(function(f) {
      f[0]({ value: void 0, done: !0 });
    }), !t || t();
  }
  t = function() {
    t = null, i.removeListener("data", o), i.removeListener("error", a), i.removeListener("end", c), i.removeListener("finish", c), i.removeListener("close", c);
  }, i.on("data", o), i.on("error", a), i.on("end", c), i.on("finish", c), i.on("close", c);
  function l() {
    return new Promise(function(h, f) {
      if (e)
        return f(e);
      if (r.length)
        return h({ value: r.shift(), done: !1 });
      if (n)
        return h({ value: void 0, done: !0 });
      s.push([h, f]);
    });
  }
  var u = {
    next: function() {
      return l();
    }
  };
  return Zn && (u[Symbol.asyncIterator] = function() {
    return this;
  }), u;
}
function dy(i) {
  var t = !1, e = {
    next: function() {
      return t ? Promise.resolve({
        value: void 0,
        done: !0
      }) : (t = !0, new Promise(function(n, r) {
        i.then(function(s) {
          n({ value: s, done: !1 });
        }).catch(r);
      }));
    }
  };
  return Zn && (e[Symbol.asyncIterator] = function() {
    return this;
  }), e;
}
function uc(i) {
  var t = {
    next: function() {
      return i.read();
    }
  };
  return Zn && (t[Symbol.asyncIterator] = function() {
    return this;
  }), t;
}
function py(i) {
  var t = i;
  if (sy(i) && (t = i.body), ay(t))
    return hy(t);
  if (oy(t))
    return uc(t.getReader());
  if (cy(t))
    return uc(t.stream().getReader());
  if (ly(t))
    return dy(t.arrayBuffer());
  if (uy(t))
    return fy(t);
  throw new Error("Unknown body type for responseIterator. Please pass a streamable response.");
}
var hc = Object.prototype.hasOwnProperty;
function gy(i, t) {
  var e, n, r;
  return Wt(this, void 0, void 0, function() {
    var s, o, a, c, l, u, h, f, d, p, g, m, y, b, v, _, x, k, E, O;
    return Ht(this, function(M) {
      switch (M.label) {
        case 0:
          if (TextDecoder === void 0)
            throw new Error("TextDecoder must be defined in the environment: please import a polyfill.");
          s = new TextDecoder("utf-8"), o = (e = i.headers) === null || e === void 0 ? void 0 : e.get("content-type"), a = "boundary=", c = o != null && o.includes(a) ? o == null ? void 0 : o.substring((o == null ? void 0 : o.indexOf(a)) + a.length).replace(/['"]/g, "").replace(/\;(.*)/gm, "").trim() : "-", l = "--".concat(c), u = "", h = py(i), f = !0, M.label = 1;
        case 1:
          return f ? [4, h.next()] : [3, 3];
        case 2:
          for (d = M.sent(), p = d.value, g = d.done, m = typeof p == "string" ? p : s.decode(p), f = !g, u += m, y = u.indexOf(l); y > -1; ) {
            if (b = void 0, O = [
              u.slice(0, y),
              u.slice(y + l.length)
            ], b = O[0], u = O[1], b.trim()) {
              if (v = b.indexOf(`\r
\r
`), _ = my(b.slice(0, v)), x = _["content-type"], x && x.toLowerCase().indexOf("application/json") === -1)
                throw new Error("Unsupported patch content type: application/json is required.");
              k = b.slice(v);
              try {
                E = au(i, k.replace(`\r
`, "")), (Object.keys(E).length > 1 || "data" in E || "incremental" in E || "errors" in E) && ((n = t.next) === null || n === void 0 || n.call(t, E));
              } catch (C) {
                ho(C, t);
              }
            }
            y = u.indexOf(l);
          }
          return [3, 1];
        case 3:
          return (r = t.complete) === null || r === void 0 || r.call(t), [2];
      }
    });
  });
}
function my(i) {
  var t = {};
  return i.split(`
`).forEach(function(e) {
    var n = e.indexOf(":");
    if (n > -1) {
      var r = e.slice(0, n).trim().toLowerCase(), s = e.slice(n + 1).trim();
      t[r] = s;
    }
  }), t;
}
function au(i, t) {
  if (i.status >= 300) {
    var e = function() {
      try {
        return JSON.parse(t);
      } catch {
        return t;
      }
    };
    us(i, e(), "Response not successful: Received status code ".concat(i.status));
  }
  try {
    return JSON.parse(t);
  } catch (r) {
    var n = r;
    throw n.name = "ServerParseError", n.response = i, n.statusCode = i.status, n.bodyText = t, n;
  }
}
function ho(i, t) {
  var e, n;
  i.name !== "AbortError" && (i.result && i.result.errors && i.result.data && ((e = t.next) === null || e === void 0 || e.call(t, i.result)), (n = t.error) === null || n === void 0 || n.call(t, i));
}
function yy(i, t, e) {
  vy(t)(i).then(function(n) {
    var r, s;
    (r = e.next) === null || r === void 0 || r.call(e, n), (s = e.complete) === null || s === void 0 || s.call(e);
  }).catch(function(n) {
    return ho(n, e);
  });
}
function vy(i) {
  return function(t) {
    return t.text().then(function(e) {
      return au(t, e);
    }).then(function(e) {
      return t.status >= 300 && us(t, e, "Response not successful: Received status code ".concat(t.status)), !Array.isArray(e) && !hc.call(e, "data") && !hc.call(e, "errors") && us(t, e, "Server response was missing for query '".concat(Array.isArray(i) ? i.map(function(n) {
        return n.operationName;
      }) : i.operationName, "'.")), e;
    });
  };
}
var fs = function(i, t) {
  var e;
  try {
    e = JSON.stringify(i);
  } catch (r) {
    var n = __DEV__ ? new N("Network request failed. ".concat(t, " is not serializable: ").concat(r.message)) : new N(23);
    throw n.parseError = r, n;
  }
  return e;
}, by = {
  includeQuery: !0,
  includeExtensions: !1,
  preserveHeaderCase: !1
}, _y = {
  accept: "*/*",
  "content-type": "application/json"
}, xy = {
  method: "POST"
}, wy = {
  http: by,
  headers: _y,
  options: xy
}, Sy = function(i, t) {
  return t(i);
};
function Ey(i, t) {
  for (var e = [], n = 2; n < arguments.length; n++)
    e[n - 2] = arguments[n];
  var r = {}, s = {};
  e.forEach(function(h) {
    r = w(w(w({}, r), h.options), { headers: w(w({}, r.headers), h.headers) }), h.credentials && (r.credentials = h.credentials), s = w(w({}, s), h.http);
  }), r.headers = ky(r.headers, s.preserveHeaderCase);
  var o = i.operationName, a = i.extensions, c = i.variables, l = i.query, u = { operationName: o, variables: c };
  return s.includeExtensions && (u.extensions = a), s.includeQuery && (u.query = t(l, cm)), {
    options: r,
    body: u
  };
}
function ky(i, t) {
  if (!t) {
    var e = /* @__PURE__ */ Object.create(null);
    return Object.keys(Object(i)).forEach(function(s) {
      e[s.toLowerCase()] = i[s];
    }), e;
  }
  var n = /* @__PURE__ */ Object.create(null);
  Object.keys(Object(i)).forEach(function(s) {
    n[s.toLowerCase()] = { originalName: s, value: i[s] };
  });
  var r = /* @__PURE__ */ Object.create(null);
  return Object.keys(n).forEach(function(s) {
    r[n[s].originalName] = n[s].value;
  }), r;
}
var Oy = function(i) {
  if (!i && typeof fetch > "u")
    throw __DEV__ ? new N(`
"fetch" has not been found globally and no fetcher has been configured. To fix this, install a fetch package (like https://www.npmjs.com/package/cross-fetch), instantiate the fetcher, and pass it into your HttpLink constructor. For example:

import fetch from 'cross-fetch';
import { ApolloClient, HttpLink } from '@apollo/client';
const client = new ApolloClient({
  link: new HttpLink({ uri: '/graphql', fetch })
});
    `) : new N(22);
}, Dy = function() {
  if (typeof AbortController > "u")
    return { controller: !1, signal: !1 };
  var i = new AbortController(), t = i.signal;
  return { controller: i, signal: t };
}, Ty = function(i, t) {
  var e = i.getContext(), n = e.uri;
  return n || (typeof t == "function" ? t(i) : t || "/graphql");
};
function My(i, t) {
  var e = [], n = function(h, f) {
    e.push("".concat(h, "=").concat(encodeURIComponent(f)));
  };
  if ("query" in t && n("query", t.query), t.operationName && n("operationName", t.operationName), t.variables) {
    var r = void 0;
    try {
      r = fs(t.variables, "Variables map");
    } catch (h) {
      return { parseError: h };
    }
    n("variables", r);
  }
  if (t.extensions) {
    var s = void 0;
    try {
      s = fs(t.extensions, "Extensions map");
    } catch (h) {
      return { parseError: h };
    }
    n("extensions", s);
  }
  var o = "", a = i, c = i.indexOf("#");
  c !== -1 && (o = i.substr(c), a = i.substr(0, c));
  var l = a.indexOf("?") === -1 ? "?" : "&", u = a + l + e.join("&") + o;
  return { newURI: u };
}
var fc = vt(function() {
  return fetch;
}), Ay = function(i) {
  i === void 0 && (i = {});
  var t = i.uri, e = t === void 0 ? "/graphql" : t, n = i.fetch, r = i.print, s = r === void 0 ? Sy : r, o = i.includeExtensions, a = i.preserveHeaderCase, c = i.useGETForQueries, l = i.includeUnusedVariables, u = l === void 0 ? !1 : l, h = Qe(i, ["uri", "fetch", "print", "includeExtensions", "preserveHeaderCase", "useGETForQueries", "includeUnusedVariables"]);
  __DEV__ && Oy(n || fc);
  var f = {
    http: { includeExtensions: o, preserveHeaderCase: a },
    options: h.fetchOptions,
    credentials: h.credentials,
    headers: h.headers
  };
  return new xe(function(d) {
    var p = Ty(d, e), g = d.getContext(), m = {};
    if (g.clientAwareness) {
      var y = g.clientAwareness, b = y.name, v = y.version;
      b && (m["apollographql-client-name"] = b), v && (m["apollographql-client-version"] = v);
    }
    var _ = w(w({}, m), g.headers), x = {
      http: g.http,
      options: g.fetchOptions,
      credentials: g.credentials,
      headers: _
    }, k = Ey(d, s, wy, f, x), E = k.options, O = k.body;
    if (O.variables && !u) {
      var M = new Set(Object.keys(O.variables));
      Ft(d.query, {
        Variable: function(et, we, ht) {
          ht && ht.kind !== "VariableDefinition" && M.delete(et.name.value);
        }
      }), M.size && (O.variables = w({}, O.variables), M.forEach(function(et) {
        delete O.variables[et];
      }));
    }
    var C;
    if (!E.signal) {
      var V = Dy(), q = V.controller, Y = V.signal;
      C = q, C && (E.signal = Y);
    }
    var rt = function(et) {
      return et.kind === "OperationDefinition" && et.operation === "mutation";
    };
    if (c && !d.query.definitions.some(rt) && (E.method = "GET"), Xs(["defer"], d.query) && (E.headers.accept = "multipart/mixed; deferSpec=20220824, application/json"), E.method === "GET") {
      var P = My(p, O), G = P.newURI, W = P.parseError;
      if (W)
        return cc(W);
      p = G;
    } else
      try {
        E.body = fs(O, "Payload");
      } catch (et) {
        return cc(et);
      }
    return new U(function(et) {
      var we = n || vt(function() {
        return fetch;
      }) || fc;
      return we(p, E).then(function(ht) {
        var qt;
        d.setContext({ response: ht });
        var Lt = (qt = ht.headers) === null || qt === void 0 ? void 0 : qt.get("content-type");
        return Lt !== null && /^multipart\/mixed/i.test(Lt) ? gy(ht, et) : yy(ht, d, et);
      }).catch(function(ht) {
        return ho(ht, et);
      }), function() {
        C && C.abort();
      };
    });
  });
}, cu = function(i) {
  Dt(t, i);
  function t(e) {
    e === void 0 && (e = {});
    var n = i.call(this, Ay(e).request) || this;
    return n.options = e, n;
  }
  return t;
}(xe), lu = Object.prototype, dc = lu.toString, Cy = lu.hasOwnProperty, pc = Function.prototype.toString, ds = /* @__PURE__ */ new Map();
function nt(i, t) {
  try {
    return ps(i, t);
  } finally {
    ds.clear();
  }
}
function ps(i, t) {
  if (i === t)
    return !0;
  var e = dc.call(i), n = dc.call(t);
  if (e !== n)
    return !1;
  switch (e) {
    case "[object Array]":
      if (i.length !== t.length)
        return !1;
    case "[object Object]": {
      if (mc(i, t))
        return !0;
      var r = gc(i), s = gc(t), o = r.length;
      if (o !== s.length)
        return !1;
      for (var a = 0; a < o; ++a)
        if (!Cy.call(t, r[a]))
          return !1;
      for (var a = 0; a < o; ++a) {
        var c = r[a];
        if (!ps(i[c], t[c]))
          return !1;
      }
      return !0;
    }
    case "[object Error]":
      return i.name === t.name && i.message === t.message;
    case "[object Number]":
      if (i !== i)
        return t !== t;
    case "[object Boolean]":
    case "[object Date]":
      return +i == +t;
    case "[object RegExp]":
    case "[object String]":
      return i == "".concat(t);
    case "[object Map]":
    case "[object Set]": {
      if (i.size !== t.size)
        return !1;
      if (mc(i, t))
        return !0;
      for (var l = i.entries(), u = e === "[object Map]"; ; ) {
        var h = l.next();
        if (h.done)
          break;
        var f = h.value, d = f[0], p = f[1];
        if (!t.has(d) || u && !ps(p, t.get(d)))
          return !1;
      }
      return !0;
    }
    case "[object Uint16Array]":
    case "[object Uint8Array]":
    case "[object Uint32Array]":
    case "[object Int32Array]":
    case "[object Int8Array]":
    case "[object Int16Array]":
    case "[object ArrayBuffer]":
      i = new Uint8Array(i), t = new Uint8Array(t);
    case "[object DataView]": {
      var g = i.byteLength;
      if (g === t.byteLength)
        for (; g-- && i[g] === t[g]; )
          ;
      return g === -1;
    }
    case "[object AsyncFunction]":
    case "[object GeneratorFunction]":
    case "[object AsyncGeneratorFunction]":
    case "[object Function]": {
      var m = pc.call(i);
      return m !== pc.call(t) ? !1 : !Iy(m, Ry);
    }
  }
  return !1;
}
function gc(i) {
  return Object.keys(i).filter(Py, i);
}
function Py(i) {
  return this[i] !== void 0;
}
var Ry = "{ [native code] }";
function Iy(i, t) {
  var e = i.length - t.length;
  return e >= 0 && i.indexOf(t, e) === e;
}
function mc(i, t) {
  var e = ds.get(i);
  if (e) {
    if (e.has(t))
      return !0;
  } else
    ds.set(i, e = /* @__PURE__ */ new Set());
  return e.add(t), !1;
}
function Fy(i) {
  return !!i.incremental;
}
var Ly = function() {
  return /* @__PURE__ */ Object.create(null);
}, uu = Array.prototype, Ny = uu.forEach, Vy = uu.slice, qi = function() {
  function i(t, e) {
    t === void 0 && (t = !0), e === void 0 && (e = Ly), this.weakness = t, this.makeData = e;
  }
  return i.prototype.lookup = function() {
    for (var t = [], e = 0; e < arguments.length; e++)
      t[e] = arguments[e];
    return this.lookupArray(t);
  }, i.prototype.lookupArray = function(t) {
    var e = this;
    return Ny.call(t, function(n) {
      return e = e.getChildTrie(n);
    }), e.data || (e.data = this.makeData(Vy.call(t)));
  }, i.prototype.getChildTrie = function(t) {
    var e = this.weakness && jy(t) ? this.weak || (this.weak = /* @__PURE__ */ new WeakMap()) : this.strong || (this.strong = /* @__PURE__ */ new Map()), n = e.get(t);
    return n || e.set(t, n = new i(this.weakness, this.makeData)), n;
  }, i;
}();
function jy(i) {
  switch (typeof i) {
    case "object":
      if (i === null)
        break;
    case "function":
      return !0;
  }
  return !1;
}
var ct = null, yc = {}, By = 1, $y = function() {
  return function() {
    function i() {
      this.id = [
        "slot",
        By++,
        Date.now(),
        Math.random().toString(36).slice(2)
      ].join(":");
    }
    return i.prototype.hasValue = function() {
      for (var t = ct; t; t = t.parent)
        if (this.id in t.slots) {
          var e = t.slots[this.id];
          if (e === yc)
            break;
          return t !== ct && (ct.slots[this.id] = e), !0;
        }
      return ct && (ct.slots[this.id] = yc), !1;
    }, i.prototype.getValue = function() {
      if (this.hasValue())
        return ct.slots[this.id];
    }, i.prototype.withValue = function(t, e, n, r) {
      var s, o = (s = {
        __proto__: null
      }, s[this.id] = t, s), a = ct;
      ct = { parent: a, slots: o };
      try {
        return e.apply(r, n);
      } finally {
        ct = a;
      }
    }, i.bind = function(t) {
      var e = ct;
      return function() {
        var n = ct;
        try {
          return ct = e, t.apply(this, arguments);
        } finally {
          ct = n;
        }
      };
    }, i.noContext = function(t, e, n) {
      if (ct) {
        var r = ct;
        try {
          return ct = null, t.apply(n, e);
        } finally {
          ct = r;
        }
      } else
        return t.apply(n, e);
    }, i;
  }();
}, Mr = "@wry/context:Slot", Ar = Array, fo = Ar[Mr] || function() {
  var i = $y();
  try {
    Object.defineProperty(Ar, Mr, {
      value: Ar[Mr] = i,
      enumerable: !1,
      writable: !1,
      configurable: !1
    });
  } finally {
    return i;
  }
}();
fo.bind;
fo.noContext;
function zy() {
}
var qy = function() {
  function i(t, e) {
    t === void 0 && (t = 1 / 0), e === void 0 && (e = zy), this.max = t, this.dispose = e, this.map = /* @__PURE__ */ new Map(), this.newest = null, this.oldest = null;
  }
  return i.prototype.has = function(t) {
    return this.map.has(t);
  }, i.prototype.get = function(t) {
    var e = this.getNode(t);
    return e && e.value;
  }, i.prototype.getNode = function(t) {
    var e = this.map.get(t);
    if (e && e !== this.newest) {
      var n = e.older, r = e.newer;
      r && (r.older = n), n && (n.newer = r), e.older = this.newest, e.older.newer = e, e.newer = null, this.newest = e, e === this.oldest && (this.oldest = r);
    }
    return e;
  }, i.prototype.set = function(t, e) {
    var n = this.getNode(t);
    return n ? n.value = e : (n = {
      key: t,
      value: e,
      newer: null,
      older: this.newest
    }, this.newest && (this.newest.newer = n), this.newest = n, this.oldest = this.oldest || n, this.map.set(t, n), n.value);
  }, i.prototype.clean = function() {
    for (; this.oldest && this.map.size > this.max; )
      this.delete(this.oldest.key);
  }, i.prototype.delete = function(t) {
    var e = this.map.get(t);
    return e ? (e === this.newest && (this.newest = e.older), e === this.oldest && (this.oldest = e.newer), e.newer && (e.newer.older = e.older), e.older && (e.older.newer = e.newer), this.map.delete(t), this.dispose(e.value, t), !0) : !1;
  }, i;
}(), er = new fo(), Cr, Qy = Object.prototype.hasOwnProperty, po = (Cr = Array.from, Cr === void 0 ? function(i) {
  var t = [];
  return i.forEach(function(e) {
    return t.push(e);
  }), t;
} : Cr);
function In(i) {
  var t = i.unsubscribe;
  typeof t == "function" && (i.unsubscribe = void 0, t());
}
var Ci = [], Uy = 100;
function He(i, t) {
  if (!i)
    throw new Error(t || "assertion failure");
}
function Wy(i, t) {
  var e = i.length;
  return e > 0 && e === t.length && i[e - 1] === t[e - 1];
}
function hu(i) {
  switch (i.length) {
    case 0:
      throw new Error("unknown value");
    case 1:
      return i[0];
    case 2:
      throw i[1];
  }
}
function Hy(i) {
  return i.slice(0);
}
var Yy = function() {
  function i(t) {
    this.fn = t, this.parents = /* @__PURE__ */ new Set(), this.childValues = /* @__PURE__ */ new Map(), this.dirtyChildren = null, this.dirty = !0, this.recomputing = !1, this.value = [], this.deps = null, ++i.count;
  }
  return i.prototype.peek = function() {
    if (this.value.length === 1 && !ie(this))
      return vc(this), this.value[0];
  }, i.prototype.recompute = function(t) {
    return He(!this.recomputing, "already recomputing"), vc(this), ie(this) ? Gy(this, t) : hu(this.value);
  }, i.prototype.setDirty = function() {
    this.dirty || (this.dirty = !0, this.value.length = 0, fu(this), In(this));
  }, i.prototype.dispose = function() {
    var t = this;
    this.setDirty(), yu(this), go(this, function(e, n) {
      e.setDirty(), vu(e, t);
    });
  }, i.prototype.forget = function() {
    this.dispose();
  }, i.prototype.dependOn = function(t) {
    t.add(this), this.deps || (this.deps = Ci.pop() || /* @__PURE__ */ new Set()), this.deps.add(t);
  }, i.prototype.forgetDeps = function() {
    var t = this;
    this.deps && (po(this.deps).forEach(function(e) {
      return e.delete(t);
    }), this.deps.clear(), Ci.push(this.deps), this.deps = null);
  }, i.count = 0, i;
}();
function vc(i) {
  var t = er.getValue();
  if (t)
    return i.parents.add(t), t.childValues.has(i) || t.childValues.set(i, []), ie(i) ? pu(t, i) : gu(t, i), t;
}
function Gy(i, t) {
  return yu(i), er.withValue(i, Xy, [i, t]), Jy(i, t) && Ky(i), hu(i.value);
}
function Xy(i, t) {
  i.recomputing = !0, i.value.length = 0;
  try {
    i.value[0] = i.fn.apply(null, t);
  } catch (e) {
    i.value[1] = e;
  }
  i.recomputing = !1;
}
function ie(i) {
  return i.dirty || !!(i.dirtyChildren && i.dirtyChildren.size);
}
function Ky(i) {
  i.dirty = !1, !ie(i) && du(i);
}
function fu(i) {
  go(i, pu);
}
function du(i) {
  go(i, gu);
}
function go(i, t) {
  var e = i.parents.size;
  if (e)
    for (var n = po(i.parents), r = 0; r < e; ++r)
      t(n[r], i);
}
function pu(i, t) {
  He(i.childValues.has(t)), He(ie(t));
  var e = !ie(i);
  if (!i.dirtyChildren)
    i.dirtyChildren = Ci.pop() || /* @__PURE__ */ new Set();
  else if (i.dirtyChildren.has(t))
    return;
  i.dirtyChildren.add(t), e && fu(i);
}
function gu(i, t) {
  He(i.childValues.has(t)), He(!ie(t));
  var e = i.childValues.get(t);
  e.length === 0 ? i.childValues.set(t, Hy(t.value)) : Wy(e, t.value) || i.setDirty(), mu(i, t), !ie(i) && du(i);
}
function mu(i, t) {
  var e = i.dirtyChildren;
  e && (e.delete(t), e.size === 0 && (Ci.length < Uy && Ci.push(e), i.dirtyChildren = null));
}
function yu(i) {
  i.childValues.size > 0 && i.childValues.forEach(function(t, e) {
    vu(i, e);
  }), i.forgetDeps(), He(i.dirtyChildren === null);
}
function vu(i, t) {
  t.parents.delete(i), i.childValues.delete(t), mu(i, t);
}
function Jy(i, t) {
  if (typeof i.subscribe == "function")
    try {
      In(i), i.unsubscribe = i.subscribe.apply(null, t);
    } catch {
      return i.setDirty(), !1;
    }
  return !0;
}
var Zy = {
  setDirty: !0,
  dispose: !0,
  forget: !0
};
function bu(i) {
  var t = /* @__PURE__ */ new Map(), e = i && i.subscribe;
  function n(r) {
    var s = er.getValue();
    if (s) {
      var o = t.get(r);
      o || t.set(r, o = /* @__PURE__ */ new Set()), s.dependOn(o), typeof e == "function" && (In(o), o.unsubscribe = e(r));
    }
  }
  return n.dirty = function(s, o) {
    var a = t.get(s);
    if (a) {
      var c = o && Qy.call(Zy, o) ? o : "setDirty";
      po(a).forEach(function(l) {
        return l[c]();
      }), t.delete(s), In(a);
    }
  }, n;
}
function _u() {
  var i = new qi(typeof WeakMap == "function");
  return function() {
    return i.lookupArray(arguments);
  };
}
_u();
var Pr = /* @__PURE__ */ new Set();
function Fn(i, t) {
  t === void 0 && (t = /* @__PURE__ */ Object.create(null));
  var e = new qy(t.max || Math.pow(2, 16), function(l) {
    return l.dispose();
  }), n = t.keyArgs, r = t.makeCacheKey || _u(), s = function() {
    var l = r.apply(null, n ? n.apply(null, arguments) : arguments);
    if (l === void 0)
      return i.apply(null, arguments);
    var u = e.get(l);
    u || (e.set(l, u = new Yy(i)), u.subscribe = t.subscribe, u.forget = function() {
      return e.delete(l);
    });
    var h = u.recompute(Array.prototype.slice.call(arguments));
    return e.set(l, u), Pr.add(e), er.hasValue() || (Pr.forEach(function(f) {
      return f.clean();
    }), Pr.clear()), h;
  };
  Object.defineProperty(s, "size", {
    get: function() {
      return e.map.size;
    },
    configurable: !1,
    enumerable: !1
  });
  function o(l) {
    var u = e.get(l);
    u && u.setDirty();
  }
  s.dirtyKey = o, s.dirty = function() {
    o(r.apply(null, arguments));
  };
  function a(l) {
    var u = e.get(l);
    if (u)
      return u.peek();
  }
  s.peekKey = a, s.peek = function() {
    return a(r.apply(null, arguments));
  };
  function c(l) {
    return e.delete(l);
  }
  return s.forgetKey = c, s.forget = function() {
    return c(r.apply(null, arguments));
  }, s.makeCacheKey = r, s.getKey = n ? function() {
    return r.apply(null, n.apply(null, arguments));
  } : r, Object.freeze(s);
}
var tv = function() {
  function i() {
    this.getFragmentDoc = Fn(mm);
  }
  return i.prototype.batch = function(t) {
    var e = this, n = typeof t.optimistic == "string" ? t.optimistic : t.optimistic === !1 ? null : void 0, r;
    return this.performTransaction(function() {
      return r = t.update(e);
    }, n), r;
  }, i.prototype.recordOptimisticTransaction = function(t, e) {
    this.performTransaction(t, e);
  }, i.prototype.transformDocument = function(t) {
    return t;
  }, i.prototype.transformForLink = function(t) {
    return t;
  }, i.prototype.identify = function(t) {
  }, i.prototype.gc = function() {
    return [];
  }, i.prototype.modify = function(t) {
    return !1;
  }, i.prototype.readQuery = function(t, e) {
    return e === void 0 && (e = !!t.optimistic), this.read(w(w({}, t), { rootId: t.id || "ROOT_QUERY", optimistic: e }));
  }, i.prototype.readFragment = function(t, e) {
    return e === void 0 && (e = !!t.optimistic), this.read(w(w({}, t), { query: this.getFragmentDoc(t.fragment, t.fragmentName), rootId: t.id, optimistic: e }));
  }, i.prototype.writeQuery = function(t) {
    var e = t.id, n = t.data, r = Qe(t, ["id", "data"]);
    return this.write(Object.assign(r, {
      dataId: e || "ROOT_QUERY",
      result: n
    }));
  }, i.prototype.writeFragment = function(t) {
    var e = t.id, n = t.data, r = t.fragment, s = t.fragmentName, o = Qe(t, ["id", "data", "fragment", "fragmentName"]);
    return this.write(Object.assign(o, {
      query: this.getFragmentDoc(r, s),
      dataId: e,
      result: n
    }));
  }, i.prototype.updateQuery = function(t, e) {
    return this.batch({
      update: function(n) {
        var r = n.readQuery(t), s = e(r);
        return s == null ? r : (n.writeQuery(w(w({}, t), { data: s })), s);
      }
    });
  }, i.prototype.updateFragment = function(t, e) {
    return this.batch({
      update: function(n) {
        var r = n.readFragment(t), s = e(r);
        return s == null ? r : (n.writeFragment(w(w({}, t), { data: s })), s);
      }
    });
  }, i;
}(), xu = function(i) {
  Dt(t, i);
  function t(e, n, r, s) {
    var o, a = i.call(this, e) || this;
    if (a.message = e, a.path = n, a.query = r, a.variables = s, Array.isArray(a.path)) {
      a.missing = a.message;
      for (var c = a.path.length - 1; c >= 0; --c)
        a.missing = (o = {}, o[a.path[c]] = a.missing, o);
    } else
      a.missing = a.path;
    return a.__proto__ = t.prototype, a;
  }
  return t;
}(Error), st = Object.prototype.hasOwnProperty;
function ci(i) {
  return i == null;
}
var tt = Array.isArray;
function wu(i, t) {
  var e = i.__typename, n = i.id, r = i._id;
  if (typeof e == "string" && (t && (t.keyObject = ci(n) ? ci(r) ? void 0 : { _id: r } : { id: n }), ci(n) && !ci(r) && (n = r), !ci(n)))
    return "".concat(e, ":").concat(typeof n == "number" || typeof n == "string" ? n : JSON.stringify(n));
}
var Su = {
  dataIdFromObject: wu,
  addTypename: !0,
  resultCaching: !0,
  canonizeResults: !1
};
function ev(i) {
  return tr(Su, i);
}
function Eu(i) {
  var t = i.canonizeResults;
  return t === void 0 ? Su.canonizeResults : t;
}
function iv(i, t) {
  return B(t) ? i.get(t.__ref, "__typename") : t && t.__typename;
}
var ku = /^[_a-z][_0-9a-z]*/i;
function ne(i) {
  var t = i.match(ku);
  return t ? t[0] : i;
}
function gs(i, t, e) {
  return J(t) ? tt(t) ? t.every(function(n) {
    return gs(i, n, e);
  }) : i.selections.every(function(n) {
    if (Bt(n) && Xn(n, e)) {
      var r = ye(n);
      return st.call(t, r) && (!n.selectionSet || gs(n.selectionSet, t[r], e));
    }
    return !0;
  }) : !1;
}
function Me(i) {
  return J(i) && !B(i) && !tt(i);
}
function nv() {
  return new ve();
}
function Ou(i, t) {
  var e = Ks(to(i));
  return {
    fragmentMap: e,
    lookupFragment: function(n) {
      var r = e[n];
      return !r && t && (r = t.lookup(n)), r || null;
    }
  };
}
var pn = /* @__PURE__ */ Object.create(null), Rr = function() {
  return pn;
}, bc = /* @__PURE__ */ Object.create(null), Pi = function() {
  function i(t, e) {
    var n = this;
    this.policies = t, this.group = e, this.data = /* @__PURE__ */ Object.create(null), this.rootIds = /* @__PURE__ */ Object.create(null), this.refs = /* @__PURE__ */ Object.create(null), this.getFieldValue = function(r, s) {
      return cs(B(r) ? n.get(r.__ref, s) : r && r[s]);
    }, this.canRead = function(r) {
      return B(r) ? n.has(r.__ref) : typeof r == "object";
    }, this.toReference = function(r, s) {
      if (typeof r == "string")
        return Re(r);
      if (B(r))
        return r;
      var o = n.policies.identify(r)[0];
      if (o) {
        var a = Re(o);
        return s && n.merge(o, r), a;
      }
    };
  }
  return i.prototype.toObject = function() {
    return w({}, this.data);
  }, i.prototype.has = function(t) {
    return this.lookup(t, !0) !== void 0;
  }, i.prototype.get = function(t, e) {
    if (this.group.depend(t, e), st.call(this.data, t)) {
      var n = this.data[t];
      if (n && st.call(n, e))
        return n[e];
    }
    if (e === "__typename" && st.call(this.policies.rootTypenamesById, t))
      return this.policies.rootTypenamesById[t];
    if (this instanceof Ut)
      return this.parent.get(t, e);
  }, i.prototype.lookup = function(t, e) {
    if (e && this.group.depend(t, "__exists"), st.call(this.data, t))
      return this.data[t];
    if (this instanceof Ut)
      return this.parent.lookup(t, e);
    if (this.policies.rootTypenamesById[t])
      return /* @__PURE__ */ Object.create(null);
  }, i.prototype.merge = function(t, e) {
    var n = this, r;
    B(t) && (t = t.__ref), B(e) && (e = e.__ref);
    var s = typeof t == "string" ? this.lookup(r = t) : t, o = typeof e == "string" ? this.lookup(r = e) : e;
    if (!!o) {
      __DEV__ ? D(typeof r == "string", "store.merge expects a string ID") : D(typeof r == "string", 1);
      var a = new ve(sv).merge(s, o);
      if (this.data[r] = a, a !== s && (delete this.refs[r], this.group.caching)) {
        var c = /* @__PURE__ */ Object.create(null);
        s || (c.__exists = 1), Object.keys(o).forEach(function(l) {
          if (!s || s[l] !== a[l]) {
            c[l] = 1;
            var u = ne(l);
            u !== l && !n.policies.hasKeyArgs(a.__typename, u) && (c[u] = 1), a[l] === void 0 && !(n instanceof Ut) && delete a[l];
          }
        }), c.__typename && !(s && s.__typename) && this.policies.rootTypenamesById[r] === a.__typename && delete c.__typename, Object.keys(c).forEach(function(l) {
          return n.group.dirty(r, l);
        });
      }
    }
  }, i.prototype.modify = function(t, e) {
    var n = this, r = this.lookup(t);
    if (r) {
      var s = /* @__PURE__ */ Object.create(null), o = !1, a = !0, c = {
        DELETE: pn,
        INVALIDATE: bc,
        isReference: B,
        toReference: this.toReference,
        canRead: this.canRead,
        readField: function(l, u) {
          return n.policies.readField(typeof l == "string" ? {
            fieldName: l,
            from: u || Re(t)
          } : l, { store: n });
        }
      };
      if (Object.keys(r).forEach(function(l) {
        var u = ne(l), h = r[l];
        if (h !== void 0) {
          var f = typeof e == "function" ? e : e[l] || e[u];
          if (f) {
            var d = f === Rr ? pn : f(cs(h), w(w({}, c), { fieldName: u, storeFieldName: l, storage: n.getStorage(t, l) }));
            d === bc ? n.group.dirty(t, l) : (d === pn && (d = void 0), d !== h && (s[l] = d, o = !0, h = d));
          }
          h !== void 0 && (a = !1);
        }
      }), o)
        return this.merge(t, s), a && (this instanceof Ut ? this.data[t] = void 0 : delete this.data[t], this.group.dirty(t, "__exists")), !0;
    }
    return !1;
  }, i.prototype.delete = function(t, e, n) {
    var r, s = this.lookup(t);
    if (s) {
      var o = this.getFieldValue(s, "__typename"), a = e && n ? this.policies.getStoreFieldName({ typename: o, fieldName: e, args: n }) : e;
      return this.modify(t, a ? (r = {}, r[a] = Rr, r) : Rr);
    }
    return !1;
  }, i.prototype.evict = function(t, e) {
    var n = !1;
    return t.id && (st.call(this.data, t.id) && (n = this.delete(t.id, t.fieldName, t.args)), this instanceof Ut && this !== e && (n = this.parent.evict(t, e) || n), (t.fieldName || n) && this.group.dirty(t.id, t.fieldName || "__exists")), n;
  }, i.prototype.clear = function() {
    this.replace(null);
  }, i.prototype.extract = function() {
    var t = this, e = this.toObject(), n = [];
    return this.getRootIdSet().forEach(function(r) {
      st.call(t.policies.rootTypenamesById, r) || n.push(r);
    }), n.length && (e.__META = { extraRootIds: n.sort() }), e;
  }, i.prototype.replace = function(t) {
    var e = this;
    if (Object.keys(this.data).forEach(function(s) {
      t && st.call(t, s) || e.delete(s);
    }), t) {
      var n = t.__META, r = Qe(t, ["__META"]);
      Object.keys(r).forEach(function(s) {
        e.merge(s, r[s]);
      }), n && n.extraRootIds.forEach(this.retain, this);
    }
  }, i.prototype.retain = function(t) {
    return this.rootIds[t] = (this.rootIds[t] || 0) + 1;
  }, i.prototype.release = function(t) {
    if (this.rootIds[t] > 0) {
      var e = --this.rootIds[t];
      return e || delete this.rootIds[t], e;
    }
    return 0;
  }, i.prototype.getRootIdSet = function(t) {
    return t === void 0 && (t = /* @__PURE__ */ new Set()), Object.keys(this.rootIds).forEach(t.add, t), this instanceof Ut ? this.parent.getRootIdSet(t) : Object.keys(this.policies.rootTypenamesById).forEach(t.add, t), t;
  }, i.prototype.gc = function() {
    var t = this, e = this.getRootIdSet(), n = this.toObject();
    e.forEach(function(o) {
      st.call(n, o) && (Object.keys(t.findChildRefIds(o)).forEach(e.add, e), delete n[o]);
    });
    var r = Object.keys(n);
    if (r.length) {
      for (var s = this; s instanceof Ut; )
        s = s.parent;
      r.forEach(function(o) {
        return s.delete(o);
      });
    }
    return r;
  }, i.prototype.findChildRefIds = function(t) {
    if (!st.call(this.refs, t)) {
      var e = this.refs[t] = /* @__PURE__ */ Object.create(null), n = this.data[t];
      if (!n)
        return e;
      var r = /* @__PURE__ */ new Set([n]);
      r.forEach(function(s) {
        B(s) && (e[s.__ref] = !0), J(s) && Object.keys(s).forEach(function(o) {
          var a = s[o];
          J(a) && r.add(a);
        });
      });
    }
    return this.refs[t];
  }, i.prototype.makeCacheKey = function() {
    return this.group.keyMaker.lookupArray(arguments);
  }, i;
}(), Du = function() {
  function i(t, e) {
    e === void 0 && (e = null), this.caching = t, this.parent = e, this.d = null, this.resetCaching();
  }
  return i.prototype.resetCaching = function() {
    this.d = this.caching ? bu() : null, this.keyMaker = new qi(_e);
  }, i.prototype.depend = function(t, e) {
    if (this.d) {
      this.d(Ir(t, e));
      var n = ne(e);
      n !== e && this.d(Ir(t, n)), this.parent && this.parent.depend(t, e);
    }
  }, i.prototype.dirty = function(t, e) {
    this.d && this.d.dirty(Ir(t, e), e === "__exists" ? "forget" : "setDirty");
  }, i;
}();
function Ir(i, t) {
  return t + "#" + i;
}
function _c(i, t) {
  _i(i) && i.group.depend(t, "__exists");
}
(function(i) {
  var t = function(e) {
    Dt(n, e);
    function n(r) {
      var s = r.policies, o = r.resultCaching, a = o === void 0 ? !0 : o, c = r.seed, l = e.call(this, s, new Du(a)) || this;
      return l.stump = new rv(l), l.storageTrie = new qi(_e), c && l.replace(c), l;
    }
    return n.prototype.addLayer = function(r, s) {
      return this.stump.addLayer(r, s);
    }, n.prototype.removeLayer = function() {
      return this;
    }, n.prototype.getStorage = function() {
      return this.storageTrie.lookupArray(arguments);
    }, n;
  }(i);
  i.Root = t;
})(Pi || (Pi = {}));
var Ut = function(i) {
  Dt(t, i);
  function t(e, n, r, s) {
    var o = i.call(this, n.policies, s) || this;
    return o.id = e, o.parent = n, o.replay = r, o.group = s, r(o), o;
  }
  return t.prototype.addLayer = function(e, n) {
    return new t(e, this, n, this.group);
  }, t.prototype.removeLayer = function(e) {
    var n = this, r = this.parent.removeLayer(e);
    return e === this.id ? (this.group.caching && Object.keys(this.data).forEach(function(s) {
      var o = n.data[s], a = r.lookup(s);
      a ? o ? o !== a && Object.keys(o).forEach(function(c) {
        nt(o[c], a[c]) || n.group.dirty(s, c);
      }) : (n.group.dirty(s, "__exists"), Object.keys(a).forEach(function(c) {
        n.group.dirty(s, c);
      })) : n.delete(s);
    }), r) : r === this.parent ? this : r.addLayer(this.id, this.replay);
  }, t.prototype.toObject = function() {
    return w(w({}, this.parent.toObject()), this.data);
  }, t.prototype.findChildRefIds = function(e) {
    var n = this.parent.findChildRefIds(e);
    return st.call(this.data, e) ? w(w({}, n), i.prototype.findChildRefIds.call(this, e)) : n;
  }, t.prototype.getStorage = function() {
    for (var e = this.parent; e.parent; )
      e = e.parent;
    return e.getStorage.apply(e, arguments);
  }, t;
}(Pi), rv = function(i) {
  Dt(t, i);
  function t(e) {
    return i.call(this, "EntityStore.Stump", e, function() {
    }, new Du(e.group.caching, e.group)) || this;
  }
  return t.prototype.removeLayer = function() {
    return this;
  }, t.prototype.merge = function() {
    return this.parent.merge.apply(this.parent, arguments);
  }, t;
}(Ut);
function sv(i, t, e) {
  var n = i[e], r = t[e];
  return nt(n, r) ? n : r;
}
function _i(i) {
  return !!(i instanceof Pi && i.group.caching);
}
function ov(i) {
  return J(i) ? tt(i) ? i.slice(0) : w({ __proto__: Object.getPrototypeOf(i) }, i) : i;
}
var ms = function() {
  function i() {
    this.known = new (Km ? WeakSet : Set)(), this.pool = new qi(_e), this.passes = /* @__PURE__ */ new WeakMap(), this.keysByJSON = /* @__PURE__ */ new Map(), this.empty = this.admit({});
  }
  return i.prototype.isKnown = function(t) {
    return J(t) && this.known.has(t);
  }, i.prototype.pass = function(t) {
    if (J(t)) {
      var e = ov(t);
      return this.passes.set(e, t), e;
    }
    return t;
  }, i.prototype.admit = function(t) {
    var e = this;
    if (J(t)) {
      var n = this.passes.get(t);
      if (n)
        return n;
      var r = Object.getPrototypeOf(t);
      switch (r) {
        case Array.prototype: {
          if (this.known.has(t))
            return t;
          var s = t.map(this.admit, this), o = this.pool.lookupArray(s);
          return o.array || (this.known.add(o.array = s), __DEV__ && Object.freeze(s)), o.array;
        }
        case null:
        case Object.prototype: {
          if (this.known.has(t))
            return t;
          var a = Object.getPrototypeOf(t), c = [a], l = this.sortedKeys(t);
          c.push(l.json);
          var u = c.length;
          l.sorted.forEach(function(d) {
            c.push(e.admit(t[d]));
          });
          var o = this.pool.lookupArray(c);
          if (!o.object) {
            var h = o.object = Object.create(a);
            this.known.add(h), l.sorted.forEach(function(d, p) {
              h[d] = c[u + p];
            }), __DEV__ && Object.freeze(h);
          }
          return o.object;
        }
      }
    }
    return t;
  }, i.prototype.sortedKeys = function(t) {
    var e = Object.keys(t), n = this.pool.lookupArray(e);
    if (!n.keys) {
      e.sort();
      var r = JSON.stringify(e);
      (n.keys = this.keysByJSON.get(r)) || this.keysByJSON.set(r, n.keys = { sorted: e, json: r });
    }
    return n.keys;
  }, i;
}(), pe = Object.assign(function(i) {
  if (J(i)) {
    ys === void 0 && xc();
    var t = ys.admit(i), e = vs.get(t);
    return e === void 0 && vs.set(t, e = JSON.stringify(t)), e;
  }
  return JSON.stringify(i);
}, {
  reset: xc
}), ys, vs;
function xc() {
  ys = new ms(), vs = new (_e ? WeakMap : Map)();
}
function wc(i) {
  return [
    i.selectionSet,
    i.objectOrReference,
    i.context,
    i.context.canonizeResults
  ];
}
var av = function() {
  function i(t) {
    var e = this;
    this.knownResults = new (_e ? WeakMap : Map)(), this.config = tr(t, {
      addTypename: t.addTypename !== !1,
      canonizeResults: Eu(t)
    }), this.canon = t.canon || new ms(), this.executeSelectionSet = Fn(function(n) {
      var r, s = n.context.canonizeResults, o = wc(n);
      o[3] = !s;
      var a = (r = e.executeSelectionSet).peek.apply(r, o);
      return a ? s ? w(w({}, a), { result: e.canon.admit(a.result) }) : a : (_c(n.context.store, n.enclosingRef.__ref), e.execSelectionSetImpl(n));
    }, {
      max: this.config.resultCacheMaxSize,
      keyArgs: wc,
      makeCacheKey: function(n, r, s, o) {
        if (_i(s.store))
          return s.store.makeCacheKey(n, B(r) ? r.__ref : r, s.varString, o);
      }
    }), this.executeSubSelectedArray = Fn(function(n) {
      return _c(n.context.store, n.enclosingRef.__ref), e.execSubSelectedArrayImpl(n);
    }, {
      max: this.config.resultCacheMaxSize,
      makeCacheKey: function(n) {
        var r = n.field, s = n.array, o = n.context;
        if (_i(o.store))
          return o.store.makeCacheKey(r, s, o.varString);
      }
    });
  }
  return i.prototype.resetCanon = function() {
    this.canon = new ms();
  }, i.prototype.diffQueryAgainstStore = function(t) {
    var e = t.store, n = t.query, r = t.rootId, s = r === void 0 ? "ROOT_QUERY" : r, o = t.variables, a = t.returnPartialData, c = a === void 0 ? !0 : a, l = t.canonizeResults, u = l === void 0 ? this.config.canonizeResults : l, h = this.config.cache.policies;
    o = w(w({}, io(Jl(n))), o);
    var f = Re(s), d = this.executeSelectionSet({
      selectionSet: eo(n).selectionSet,
      objectOrReference: f,
      enclosingRef: f,
      context: w({ store: e, query: n, policies: h, variables: o, varString: pe(o), canonizeResults: u }, Ou(n, this.config.fragments))
    }), p;
    if (d.missing && (p = [new xu(cv(d.missing), d.missing, n, o)], !c))
      throw p[0];
    return {
      result: d.result,
      complete: !p,
      missing: p
    };
  }, i.prototype.isFresh = function(t, e, n, r) {
    if (_i(r.store) && this.knownResults.get(t) === n) {
      var s = this.executeSelectionSet.peek(n, e, r, this.canon.isKnown(t));
      if (s && t === s.result)
        return !0;
    }
    return !1;
  }, i.prototype.execSelectionSetImpl = function(t) {
    var e = this, n = t.selectionSet, r = t.objectOrReference, s = t.enclosingRef, o = t.context;
    if (B(r) && !o.policies.rootTypenamesById[r.__ref] && !o.store.has(r.__ref))
      return {
        result: this.canon.empty,
        missing: "Dangling reference to missing ".concat(r.__ref, " object")
      };
    var a = o.variables, c = o.policies, l = o.store, u = l.getFieldValue(r, "__typename"), h = [], f, d = new ve();
    this.config.addTypename && typeof u == "string" && !c.rootIdsByTypename[u] && h.push({ __typename: u });
    function p(v, _) {
      var x;
      return v.missing && (f = d.merge(f, (x = {}, x[_] = v.missing, x))), v.result;
    }
    var g = new Set(n.selections);
    g.forEach(function(v) {
      var _, x;
      if (!!Xn(v, a))
        if (Bt(v)) {
          var k = c.readField({
            fieldName: v.name.value,
            field: v,
            variables: o.variables,
            from: r
          }, o), E = ye(v);
          k === void 0 ? ro.added(v) || (f = d.merge(f, (_ = {}, _[E] = "Can't find field '".concat(v.name.value, "' on ").concat(B(r) ? r.__ref + " object" : "object " + JSON.stringify(r, null, 2)), _))) : tt(k) ? k = p(e.executeSubSelectedArray({
            field: v,
            array: k,
            enclosingRef: s,
            context: o
          }), E) : v.selectionSet ? k != null && (k = p(e.executeSelectionSet({
            selectionSet: v.selectionSet,
            objectOrReference: k,
            enclosingRef: B(k) ? k : s,
            context: o
          }), E)) : o.canonizeResults && (k = e.canon.pass(k)), k !== void 0 && h.push((x = {}, x[E] = k, x));
        } else {
          var O = Js(v, o.lookupFragment);
          if (!O && v.kind === A.FRAGMENT_SPREAD)
            throw __DEV__ ? new N("No fragment named ".concat(v.name.value)) : new N(5);
          O && c.fragmentMatches(O, u) && O.selectionSet.selections.forEach(g.add, g);
        }
    });
    var m = so(h), y = { result: m, missing: f }, b = o.canonizeResults ? this.canon.admit(y) : cs(y);
    return b.result && this.knownResults.set(b.result, n), b;
  }, i.prototype.execSubSelectedArrayImpl = function(t) {
    var e = this, n = t.field, r = t.array, s = t.enclosingRef, o = t.context, a, c = new ve();
    function l(u, h) {
      var f;
      return u.missing && (a = c.merge(a, (f = {}, f[h] = u.missing, f))), u.result;
    }
    return n.selectionSet && (r = r.filter(o.store.canRead)), r = r.map(function(u, h) {
      return u === null ? null : tt(u) ? l(e.executeSubSelectedArray({
        field: n,
        array: u,
        enclosingRef: s,
        context: o
      }), h) : n.selectionSet ? l(e.executeSelectionSet({
        selectionSet: n.selectionSet,
        objectOrReference: u,
        enclosingRef: B(u) ? u : s,
        context: o
      }), h) : (__DEV__ && lv(o.store, n, u), u);
    }), {
      result: o.canonizeResults ? this.canon.admit(r) : r,
      missing: a
    };
  }, i;
}();
function cv(i) {
  try {
    JSON.stringify(i, function(t, e) {
      if (typeof e == "string")
        throw e;
      return e;
    });
  } catch (t) {
    return t;
  }
}
function lv(i, t, e) {
  if (!t.selectionSet) {
    var n = /* @__PURE__ */ new Set([e]);
    n.forEach(function(r) {
      J(r) && (__DEV__ ? D(!B(r), "Missing selection set for object of type ".concat(iv(i, r), " returned for query field ").concat(t.name.value)) : D(!B(r), 6), Object.values(r).forEach(n.add, n));
    });
  }
}
var lt = null, Sc = {}, uv = 1, hv = function() {
  return function() {
    function i() {
      this.id = [
        "slot",
        uv++,
        Date.now(),
        Math.random().toString(36).slice(2)
      ].join(":");
    }
    return i.prototype.hasValue = function() {
      for (var t = lt; t; t = t.parent)
        if (this.id in t.slots) {
          var e = t.slots[this.id];
          if (e === Sc)
            break;
          return t !== lt && (lt.slots[this.id] = e), !0;
        }
      return lt && (lt.slots[this.id] = Sc), !1;
    }, i.prototype.getValue = function() {
      if (this.hasValue())
        return lt.slots[this.id];
    }, i.prototype.withValue = function(t, e, n, r) {
      var s, o = (s = {
        __proto__: null
      }, s[this.id] = t, s), a = lt;
      lt = { parent: a, slots: o };
      try {
        return e.apply(r, n);
      } finally {
        lt = a;
      }
    }, i.bind = function(t) {
      var e = lt;
      return function() {
        var n = lt;
        try {
          return lt = e, t.apply(this, arguments);
        } finally {
          lt = n;
        }
      };
    }, i.noContext = function(t, e, n) {
      if (lt) {
        var r = lt;
        try {
          return lt = null, t.apply(n, e);
        } finally {
          lt = r;
        }
      } else
        return t.apply(n, e);
    }, i;
  }();
};
function Ec(i) {
  try {
    return i();
  } catch {
  }
}
var Fr = "@wry/context:Slot", fv = Ec(function() {
  return globalThis;
}) || Ec(function() {
  return global;
}) || /* @__PURE__ */ Object.create(null), kc = fv, mo = kc[Fr] || Array[Fr] || function(i) {
  try {
    Object.defineProperty(kc, Fr, {
      value: i,
      enumerable: !1,
      writable: !1,
      configurable: !0
    });
  } finally {
    return i;
  }
}(hv());
mo.bind;
mo.noContext;
var yo = new mo(), Oc = /* @__PURE__ */ new WeakMap();
function xi(i) {
  var t = Oc.get(i);
  return t || Oc.set(i, t = {
    vars: /* @__PURE__ */ new Set(),
    dep: bu()
  }), t;
}
function Dc(i) {
  xi(i).vars.forEach(function(t) {
    return t.forgetCache(i);
  });
}
function dv(i) {
  xi(i).vars.forEach(function(t) {
    return t.attachCache(i);
  });
}
function pv(i) {
  var t = /* @__PURE__ */ new Set(), e = /* @__PURE__ */ new Set(), n = function(s) {
    if (arguments.length > 0) {
      if (i !== s) {
        i = s, t.forEach(function(c) {
          xi(c).dep.dirty(n), gv(c);
        });
        var o = Array.from(e);
        e.clear(), o.forEach(function(c) {
          return c(i);
        });
      }
    } else {
      var a = yo.getValue();
      a && (r(a), xi(a).dep(n));
    }
    return i;
  };
  n.onNextChange = function(s) {
    return e.add(s), function() {
      e.delete(s);
    };
  };
  var r = n.attachCache = function(s) {
    return t.add(s), xi(s).vars.add(n), n;
  };
  return n.forgetCache = function(s) {
    return t.delete(s);
  }, n;
}
function gv(i) {
  i.broadcastWatches && i.broadcastWatches();
}
var Tc = /* @__PURE__ */ Object.create(null);
function vo(i) {
  var t = JSON.stringify(i);
  return Tc[t] || (Tc[t] = /* @__PURE__ */ Object.create(null));
}
function Mc(i) {
  var t = vo(i);
  return t.keyFieldsFn || (t.keyFieldsFn = function(e, n) {
    var r = function(o, a) {
      return n.readField(a, o);
    }, s = n.keyObject = bo(i, function(o) {
      var a = Ie(n.storeObject, o, r);
      return a === void 0 && e !== n.storeObject && st.call(e, o[0]) && (a = Ie(e, o, Mu)), __DEV__ ? D(a !== void 0, "Missing field '".concat(o.join("."), "' while extracting keyFields from ").concat(JSON.stringify(e))) : D(a !== void 0, 2), a;
    });
    return "".concat(n.typename, ":").concat(JSON.stringify(s));
  });
}
function Ac(i) {
  var t = vo(i);
  return t.keyArgsFn || (t.keyArgsFn = function(e, n) {
    var r = n.field, s = n.variables, o = n.fieldName, a = bo(i, function(l) {
      var u = l[0], h = u.charAt(0);
      if (h === "@") {
        if (r && It(r.directives)) {
          var f = u.slice(1), d = r.directives.find(function(y) {
            return y.name.value === f;
          }), p = d && Kn(d, s);
          return p && Ie(p, l.slice(1));
        }
        return;
      }
      if (h === "$") {
        var g = u.slice(1);
        if (s && st.call(s, g)) {
          var m = l.slice(0);
          return m[0] = g, Ie(s, m);
        }
        return;
      }
      if (e)
        return Ie(e, l);
    }), c = JSON.stringify(a);
    return (e || c !== "{}") && (o += ":" + c), o;
  });
}
function bo(i, t) {
  var e = new ve();
  return Tu(i).reduce(function(n, r) {
    var s, o = t(r);
    if (o !== void 0) {
      for (var a = r.length - 1; a >= 0; --a)
        o = (s = {}, s[r[a]] = o, s);
      n = e.merge(n, o);
    }
    return n;
  }, /* @__PURE__ */ Object.create(null));
}
function Tu(i) {
  var t = vo(i);
  if (!t.paths) {
    var e = t.paths = [], n = [];
    i.forEach(function(r, s) {
      tt(r) ? (Tu(r).forEach(function(o) {
        return e.push(n.concat(o));
      }), n.length = 0) : (n.push(r), tt(i[s + 1]) || (e.push(n.slice(0)), n.length = 0));
    });
  }
  return t.paths;
}
function Mu(i, t) {
  return i[t];
}
function Ie(i, t, e) {
  return e = e || Mu, Au(t.reduce(function n(r, s) {
    return tt(r) ? r.map(function(o) {
      return n(o, s);
    }) : r && e(r, s);
  }, i));
}
function Au(i) {
  return J(i) ? tt(i) ? i.map(Au) : bo(Object.keys(i).sort(), function(t) {
    return Ie(i, t);
  }) : i;
}
Zs.setStringify(pe);
function bs(i) {
  return i.args !== void 0 ? i.args : i.field ? Kn(i.field, i.variables) : null;
}
var mv = function() {
}, Cc = function(i, t) {
  return t.fieldName;
}, Pc = function(i, t, e) {
  var n = e.mergeObjects;
  return n(i, t);
}, Rc = function(i, t) {
  return t;
}, yv = function() {
  function i(t) {
    this.config = t, this.typePolicies = /* @__PURE__ */ Object.create(null), this.toBeAdded = /* @__PURE__ */ Object.create(null), this.supertypeMap = /* @__PURE__ */ new Map(), this.fuzzySubtypes = /* @__PURE__ */ new Map(), this.rootIdsByTypename = /* @__PURE__ */ Object.create(null), this.rootTypenamesById = /* @__PURE__ */ Object.create(null), this.usingPossibleTypes = !1, this.config = w({ dataIdFromObject: wu }, t), this.cache = this.config.cache, this.setRootTypename("Query"), this.setRootTypename("Mutation"), this.setRootTypename("Subscription"), t.possibleTypes && this.addPossibleTypes(t.possibleTypes), t.typePolicies && this.addTypePolicies(t.typePolicies);
  }
  return i.prototype.identify = function(t, e) {
    var n, r = this, s = e && (e.typename || ((n = e.storeObject) === null || n === void 0 ? void 0 : n.__typename)) || t.__typename;
    if (s === this.rootTypenamesById.ROOT_QUERY)
      return ["ROOT_QUERY"];
    for (var o = e && e.storeObject || t, a = w(w({}, e), { typename: s, storeObject: o, readField: e && e.readField || function() {
      var f = _o(arguments, o);
      return r.readField(f, {
        store: r.cache.data,
        variables: f.variables
      });
    } }), c, l = s && this.getTypePolicy(s), u = l && l.keyFn || this.config.dataIdFromObject; u; ) {
      var h = u(t, a);
      if (tt(h))
        u = Mc(h);
      else {
        c = h;
        break;
      }
    }
    return c = c ? String(c) : void 0, a.keyObject ? [c, a.keyObject] : [c];
  }, i.prototype.addTypePolicies = function(t) {
    var e = this;
    Object.keys(t).forEach(function(n) {
      var r = t[n], s = r.queryType, o = r.mutationType, a = r.subscriptionType, c = Qe(r, ["queryType", "mutationType", "subscriptionType"]);
      s && e.setRootTypename("Query", n), o && e.setRootTypename("Mutation", n), a && e.setRootTypename("Subscription", n), st.call(e.toBeAdded, n) ? e.toBeAdded[n].push(c) : e.toBeAdded[n] = [c];
    });
  }, i.prototype.updateTypePolicy = function(t, e) {
    var n = this, r = this.getTypePolicy(t), s = e.keyFields, o = e.fields;
    function a(c, l) {
      c.merge = typeof l == "function" ? l : l === !0 ? Pc : l === !1 ? Rc : c.merge;
    }
    a(r, e.merge), r.keyFn = s === !1 ? mv : tt(s) ? Mc(s) : typeof s == "function" ? s : r.keyFn, o && Object.keys(o).forEach(function(c) {
      var l = n.getFieldPolicy(t, c, !0), u = o[c];
      if (typeof u == "function")
        l.read = u;
      else {
        var h = u.keyArgs, f = u.read, d = u.merge;
        l.keyFn = h === !1 ? Cc : tt(h) ? Ac(h) : typeof h == "function" ? h : l.keyFn, typeof f == "function" && (l.read = f), a(l, d);
      }
      l.read && l.merge && (l.keyFn = l.keyFn || Cc);
    });
  }, i.prototype.setRootTypename = function(t, e) {
    e === void 0 && (e = t);
    var n = "ROOT_" + t.toUpperCase(), r = this.rootTypenamesById[n];
    e !== r && (__DEV__ ? D(!r || r === t, "Cannot change root ".concat(t, " __typename more than once")) : D(!r || r === t, 3), r && delete this.rootIdsByTypename[r], this.rootIdsByTypename[e] = n, this.rootTypenamesById[n] = e);
  }, i.prototype.addPossibleTypes = function(t) {
    var e = this;
    this.usingPossibleTypes = !0, Object.keys(t).forEach(function(n) {
      e.getSupertypeSet(n, !0), t[n].forEach(function(r) {
        e.getSupertypeSet(r, !0).add(n);
        var s = r.match(ku);
        (!s || s[0] !== r) && e.fuzzySubtypes.set(r, new RegExp(r));
      });
    });
  }, i.prototype.getTypePolicy = function(t) {
    var e = this;
    if (!st.call(this.typePolicies, t)) {
      var n = this.typePolicies[t] = /* @__PURE__ */ Object.create(null);
      n.fields = /* @__PURE__ */ Object.create(null);
      var r = this.supertypeMap.get(t);
      r && r.size && r.forEach(function(o) {
        var a = e.getTypePolicy(o), c = a.fields, l = Qe(a, ["fields"]);
        Object.assign(n, l), Object.assign(n.fields, c);
      });
    }
    var s = this.toBeAdded[t];
    return s && s.length && s.splice(0).forEach(function(o) {
      e.updateTypePolicy(t, o);
    }), this.typePolicies[t];
  }, i.prototype.getFieldPolicy = function(t, e, n) {
    if (t) {
      var r = this.getTypePolicy(t).fields;
      return r[e] || n && (r[e] = /* @__PURE__ */ Object.create(null));
    }
  }, i.prototype.getSupertypeSet = function(t, e) {
    var n = this.supertypeMap.get(t);
    return !n && e && this.supertypeMap.set(t, n = /* @__PURE__ */ new Set()), n;
  }, i.prototype.fragmentMatches = function(t, e, n, r) {
    var s = this;
    if (!t.typeCondition)
      return !0;
    if (!e)
      return !1;
    var o = t.typeCondition.name.value;
    if (e === o)
      return !0;
    if (this.usingPossibleTypes && this.supertypeMap.has(o))
      for (var a = this.getSupertypeSet(e, !0), c = [a], l = function(p) {
        var g = s.getSupertypeSet(p, !1);
        g && g.size && c.indexOf(g) < 0 && c.push(g);
      }, u = !!(n && this.fuzzySubtypes.size), h = !1, f = 0; f < c.length; ++f) {
        var d = c[f];
        if (d.has(o))
          return a.has(o) || (h && __DEV__ && D.warn("Inferring subtype ".concat(e, " of supertype ").concat(o)), a.add(o)), !0;
        d.forEach(l), u && f === c.length - 1 && gs(t.selectionSet, n, r) && (u = !1, h = !0, this.fuzzySubtypes.forEach(function(p, g) {
          var m = e.match(p);
          m && m[0] === e && l(g);
        }));
      }
    return !1;
  }, i.prototype.hasKeyArgs = function(t, e) {
    var n = this.getFieldPolicy(t, e, !1);
    return !!(n && n.keyFn);
  }, i.prototype.getStoreFieldName = function(t) {
    var e = t.typename, n = t.fieldName, r = this.getFieldPolicy(e, n, !1), s, o = r && r.keyFn;
    if (o && e)
      for (var a = {
        typename: e,
        fieldName: n,
        field: t.field || null,
        variables: t.variables
      }, c = bs(t); o; ) {
        var l = o(c, a);
        if (tt(l))
          o = Ac(l);
        else {
          s = l || n;
          break;
        }
      }
    return s === void 0 && (s = t.field ? Dm(t.field, t.variables) : Zs(n, bs(t))), s === !1 ? n : n === ne(s) ? s : n + ":" + s;
  }, i.prototype.readField = function(t, e) {
    var n = t.from;
    if (!!n) {
      var r = t.field || t.fieldName;
      if (!!r) {
        if (t.typename === void 0) {
          var s = e.store.getFieldValue(n, "__typename");
          s && (t.typename = s);
        }
        var o = this.getStoreFieldName(t), a = ne(o), c = e.store.getFieldValue(n, o), l = this.getFieldPolicy(t.typename, a, !1), u = l && l.read;
        if (u) {
          var h = Ic(this, n, t, e, e.store.getStorage(B(n) ? n.__ref : n, o));
          return yo.withValue(this.cache, u, [c, h]);
        }
        return c;
      }
    }
  }, i.prototype.getReadFunction = function(t, e) {
    var n = this.getFieldPolicy(t, e, !1);
    return n && n.read;
  }, i.prototype.getMergeFunction = function(t, e, n) {
    var r = this.getFieldPolicy(t, e, !1), s = r && r.merge;
    return !s && n && (r = this.getTypePolicy(n), s = r && r.merge), s;
  }, i.prototype.runMergeFunction = function(t, e, n, r, s) {
    var o = n.field, a = n.typename, c = n.merge;
    return c === Pc ? Cu(r.store)(t, e) : c === Rc ? e : (r.overwrite && (t = void 0), c(t, e, Ic(this, void 0, { typename: a, fieldName: o.name.value, field: o, variables: r.variables }, r, s || /* @__PURE__ */ Object.create(null))));
  }, i;
}();
function Ic(i, t, e, n, r) {
  var s = i.getStoreFieldName(e), o = ne(s), a = e.variables || n.variables, c = n.store, l = c.toReference, u = c.canRead;
  return {
    args: bs(e),
    field: e.field || null,
    fieldName: o,
    storeFieldName: s,
    variables: a,
    isReference: B,
    toReference: l,
    storage: r,
    cache: i.cache,
    canRead: u,
    readField: function() {
      return i.readField(_o(arguments, t, a), n);
    },
    mergeObjects: Cu(n.store)
  };
}
function _o(i, t, e) {
  var n = i[0], r = i[1], s = i.length, o;
  return typeof n == "string" ? o = {
    fieldName: n,
    from: s > 1 ? r : t
  } : (o = w({}, n), st.call(o, "from") || (o.from = t)), __DEV__ && o.from === void 0 && __DEV__ && D.warn("Undefined 'from' passed to readField with arguments ".concat(Jm(Array.from(i)))), o.variables === void 0 && (o.variables = e), o;
}
function Cu(i) {
  return function(e, n) {
    if (tt(e) || tt(n))
      throw __DEV__ ? new N("Cannot automatically merge arrays") : new N(4);
    if (J(e) && J(n)) {
      var r = i.getFieldValue(e, "__typename"), s = i.getFieldValue(n, "__typename"), o = r && s && r !== s;
      if (o)
        return n;
      if (B(e) && Me(n))
        return i.merge(e.__ref, n), e;
      if (Me(e) && B(n))
        return i.merge(e, n.__ref), n;
      if (Me(e) && Me(n))
        return w(w({}, e), n);
    }
    return n;
  };
}
function Lr(i, t, e) {
  var n = "".concat(t).concat(e), r = i.flavors.get(n);
  return r || i.flavors.set(n, r = i.clientOnly === t && i.deferred === e ? i : w(w({}, i), { clientOnly: t, deferred: e })), r;
}
var vv = function() {
  function i(t, e, n) {
    this.cache = t, this.reader = e, this.fragments = n;
  }
  return i.prototype.writeToStore = function(t, e) {
    var n = this, r = e.query, s = e.result, o = e.dataId, a = e.variables, c = e.overwrite, l = zi(r), u = nv();
    a = w(w({}, io(l)), a);
    var h = w(w({ store: t, written: /* @__PURE__ */ Object.create(null), merge: function(d, p) {
      return u.merge(d, p);
    }, variables: a, varString: pe(a) }, Ou(r, this.fragments)), { overwrite: !!c, incomingById: /* @__PURE__ */ new Map(), clientOnly: !1, deferred: !1, flavors: /* @__PURE__ */ new Map() }), f = this.processSelectionSet({
      result: s || /* @__PURE__ */ Object.create(null),
      dataId: o,
      selectionSet: l.selectionSet,
      mergeTree: { map: /* @__PURE__ */ new Map() },
      context: h
    });
    if (!B(f))
      throw __DEV__ ? new N("Could not identify object ".concat(JSON.stringify(s))) : new N(7);
    return h.incomingById.forEach(function(d, p) {
      var g = d.storeObject, m = d.mergeTree, y = d.fieldNodeSet, b = Re(p);
      if (m && m.map.size) {
        var v = n.applyMerges(m, b, g, h);
        if (B(v))
          return;
        g = v;
      }
      if (__DEV__ && !h.overwrite) {
        var _ = /* @__PURE__ */ Object.create(null);
        y.forEach(function(E) {
          E.selectionSet && (_[E.name.value] = !0);
        });
        var x = function(E) {
          return _[ne(E)] === !0;
        }, k = function(E) {
          var O = m && m.map.get(E);
          return Boolean(O && O.info && O.info.merge);
        };
        Object.keys(g).forEach(function(E) {
          x(E) && !k(E) && bv(b, g, E, h.store);
        });
      }
      t.merge(p, g);
    }), t.retain(f.__ref), f;
  }, i.prototype.processSelectionSet = function(t) {
    var e = this, n = t.dataId, r = t.result, s = t.selectionSet, o = t.context, a = t.mergeTree, c = this.cache.policies, l = /* @__PURE__ */ Object.create(null), u = n && c.rootTypenamesById[n] || ns(r, s, o.fragmentMap) || n && o.store.get(n, "__typename");
    typeof u == "string" && (l.__typename = u);
    var h = function() {
      var v = _o(arguments, l, o.variables);
      if (B(v.from)) {
        var _ = o.incomingById.get(v.from.__ref);
        if (_) {
          var x = c.readField(w(w({}, v), { from: _.storeObject }), o);
          if (x !== void 0)
            return x;
        }
      }
      return c.readField(v, o);
    }, f = /* @__PURE__ */ new Set();
    this.flattenFields(s, r, o, u).forEach(function(v, _) {
      var x, k = ye(_), E = r[k];
      if (f.add(_), E !== void 0) {
        var O = c.getStoreFieldName({
          typename: u,
          fieldName: _.name.value,
          field: _,
          variables: v.variables
        }), M = Fc(a, O), C = e.processFieldValue(E, _, _.selectionSet ? Lr(v, !1, !1) : v, M), V = void 0;
        _.selectionSet && (B(C) || Me(C)) && (V = h("__typename", C));
        var q = c.getMergeFunction(u, _.name.value, V);
        q ? M.info = {
          field: _,
          typename: u,
          merge: q
        } : Lc(a, O), l = v.merge(l, (x = {}, x[O] = C, x));
      } else
        __DEV__ && !v.clientOnly && !v.deferred && !ro.added(_) && !c.getReadFunction(u, _.name.value) && __DEV__ && D.error("Missing field '".concat(ye(_), "' while writing result ").concat(JSON.stringify(r, null, 2)).substring(0, 1e3));
    });
    try {
      var d = c.identify(r, {
        typename: u,
        selectionSet: s,
        fragmentMap: o.fragmentMap,
        storeObject: l,
        readField: h
      }), p = d[0], g = d[1];
      n = n || p, g && (l = o.merge(l, g));
    } catch (v) {
      if (!n)
        throw v;
    }
    if (typeof n == "string") {
      var m = Re(n), y = o.written[n] || (o.written[n] = []);
      if (y.indexOf(s) >= 0 || (y.push(s), this.reader && this.reader.isFresh(r, m, s, o)))
        return m;
      var b = o.incomingById.get(n);
      return b ? (b.storeObject = o.merge(b.storeObject, l), b.mergeTree = _s(b.mergeTree, a), f.forEach(function(v) {
        return b.fieldNodeSet.add(v);
      })) : o.incomingById.set(n, {
        storeObject: l,
        mergeTree: Ln(a) ? void 0 : a,
        fieldNodeSet: f
      }), m;
    }
    return l;
  }, i.prototype.processFieldValue = function(t, e, n, r) {
    var s = this;
    return !e.selectionSet || t === null ? __DEV__ ? uo(t) : t : tt(t) ? t.map(function(o, a) {
      var c = s.processFieldValue(o, e, n, Fc(r, a));
      return Lc(r, a), c;
    }) : this.processSelectionSet({
      result: t,
      selectionSet: e.selectionSet,
      context: n,
      mergeTree: r
    });
  }, i.prototype.flattenFields = function(t, e, n, r) {
    r === void 0 && (r = ns(e, t, n.fragmentMap));
    var s = /* @__PURE__ */ new Map(), o = this.cache.policies, a = new qi(!1);
    return function c(l, u) {
      var h = a.lookup(l, u.clientOnly, u.deferred);
      h.visited || (h.visited = !0, l.selections.forEach(function(f) {
        if (!!Xn(f, n.variables)) {
          var d = u.clientOnly, p = u.deferred;
          if (!(d && p) && It(f.directives) && f.directives.forEach(function(y) {
            var b = y.name.value;
            if (b === "client" && (d = !0), b === "defer") {
              var v = Kn(y, n.variables);
              (!v || v.if !== !1) && (p = !0);
            }
          }), Bt(f)) {
            var g = s.get(f);
            g && (d = d && g.clientOnly, p = p && g.deferred), s.set(f, Lr(n, d, p));
          } else {
            var m = Js(f, n.lookupFragment);
            if (!m && f.kind === A.FRAGMENT_SPREAD)
              throw __DEV__ ? new N("No fragment named ".concat(f.name.value)) : new N(8);
            m && o.fragmentMatches(m, r, e, n.variables) && c(m.selectionSet, Lr(n, d, p));
          }
        }
      }));
    }(t, n), s;
  }, i.prototype.applyMerges = function(t, e, n, r, s) {
    var o, a = this;
    if (t.map.size && !B(n)) {
      var c = !tt(n) && (B(e) || Me(e)) ? e : void 0, l = n;
      c && !s && (s = [B(c) ? c.__ref : c]);
      var u, h = function(f, d) {
        return tt(f) ? typeof d == "number" ? f[d] : void 0 : r.store.getFieldValue(f, String(d));
      };
      t.map.forEach(function(f, d) {
        var p = h(c, d), g = h(l, d);
        if (g !== void 0) {
          s && s.push(d);
          var m = a.applyMerges(f, p, g, r, s);
          m !== g && (u = u || /* @__PURE__ */ new Map(), u.set(d, m)), s && D(s.pop() === d);
        }
      }), u && (n = tt(l) ? l.slice(0) : w({}, l), u.forEach(function(f, d) {
        n[d] = f;
      }));
    }
    return t.info ? this.cache.policies.runMergeFunction(e, n, t.info, r, s && (o = r.store).getStorage.apply(o, s)) : n;
  }, i;
}(), Pu = [];
function Fc(i, t) {
  var e = i.map;
  return e.has(t) || e.set(t, Pu.pop() || { map: /* @__PURE__ */ new Map() }), e.get(t);
}
function _s(i, t) {
  if (i === t || !t || Ln(t))
    return i;
  if (!i || Ln(i))
    return t;
  var e = i.info && t.info ? w(w({}, i.info), t.info) : i.info || t.info, n = i.map.size && t.map.size, r = n ? /* @__PURE__ */ new Map() : i.map.size ? i.map : t.map, s = { info: e, map: r };
  if (n) {
    var o = new Set(t.map.keys());
    i.map.forEach(function(a, c) {
      s.map.set(c, _s(a, t.map.get(c))), o.delete(c);
    }), o.forEach(function(a) {
      s.map.set(a, _s(t.map.get(a), i.map.get(a)));
    });
  }
  return s;
}
function Ln(i) {
  return !i || !(i.info || i.map.size);
}
function Lc(i, t) {
  var e = i.map, n = e.get(t);
  n && Ln(n) && (Pu.push(n), e.delete(t));
}
var Nc = /* @__PURE__ */ new Set();
function bv(i, t, e, n) {
  var r = function(h) {
    var f = n.getFieldValue(h, e);
    return typeof f == "object" && f;
  }, s = r(i);
  if (!!s) {
    var o = r(t);
    if (!!o && !B(s) && !nt(s, o) && !Object.keys(s).every(function(h) {
      return n.getFieldValue(o, h) !== void 0;
    })) {
      var a = n.getFieldValue(i, "__typename") || n.getFieldValue(t, "__typename"), c = ne(e), l = "".concat(a, ".").concat(c);
      if (!Nc.has(l)) {
        Nc.add(l);
        var u = [];
        !tt(s) && !tt(o) && [s, o].forEach(function(h) {
          var f = n.getFieldValue(h, "__typename");
          typeof f == "string" && !u.includes(f) && u.push(f);
        }), __DEV__ && D.warn("Cache data may be lost when replacing the ".concat(c, " field of a ").concat(a, ` object.

To address this problem (which is not a bug in Apollo Client), `).concat(u.length ? "either ensure all objects of type " + u.join(" and ") + " have an ID or a custom merge function, or " : "", "define a custom merge function for the ").concat(l, ` field, so InMemoryCache can safely merge these objects:

  existing: `).concat(JSON.stringify(s).slice(0, 1e3), `
  incoming: `).concat(JSON.stringify(o).slice(0, 1e3), `

For more information about these options, please refer to the documentation:

  * Ensuring entity objects have IDs: https://go.apollo.dev/c/generating-unique-identifiers
  * Defining custom merge functions: https://go.apollo.dev/c/merging-non-normalized-objects
`));
      }
    }
  }
}
var _v = function(i) {
  Dt(t, i);
  function t(e) {
    e === void 0 && (e = {});
    var n = i.call(this) || this;
    return n.watches = /* @__PURE__ */ new Set(), n.typenameDocumentCache = /* @__PURE__ */ new Map(), n.makeVar = pv, n.txCount = 0, n.config = ev(e), n.addTypename = !!n.config.addTypename, n.policies = new yv({
      cache: n,
      dataIdFromObject: n.config.dataIdFromObject,
      possibleTypes: n.config.possibleTypes,
      typePolicies: n.config.typePolicies
    }), n.init(), n;
  }
  return t.prototype.init = function() {
    var e = this.data = new Pi.Root({
      policies: this.policies,
      resultCaching: this.config.resultCaching
    });
    this.optimisticData = e.stump, this.resetResultCache();
  }, t.prototype.resetResultCache = function(e) {
    var n = this, r = this.storeReader, s = this.config.fragments;
    this.storeWriter = new vv(this, this.storeReader = new av({
      cache: this,
      addTypename: this.addTypename,
      resultCacheMaxSize: this.config.resultCacheMaxSize,
      canonizeResults: Eu(this.config),
      canon: e ? void 0 : r && r.canon,
      fragments: s
    }), s), this.maybeBroadcastWatch = Fn(function(o, a) {
      return n.broadcastWatch(o, a);
    }, {
      max: this.config.resultCacheMaxSize,
      makeCacheKey: function(o) {
        var a = o.optimistic ? n.optimisticData : n.data;
        if (_i(a)) {
          var c = o.optimistic, l = o.id, u = o.variables;
          return a.makeCacheKey(o.query, o.callback, pe({ optimistic: c, id: l, variables: u }));
        }
      }
    }), (/* @__PURE__ */ new Set([
      this.data.group,
      this.optimisticData.group
    ])).forEach(function(o) {
      return o.resetCaching();
    });
  }, t.prototype.restore = function(e) {
    return this.init(), e && this.data.replace(e), this;
  }, t.prototype.extract = function(e) {
    return e === void 0 && (e = !1), (e ? this.optimisticData : this.data).extract();
  }, t.prototype.read = function(e) {
    var n = e.returnPartialData, r = n === void 0 ? !1 : n;
    try {
      return this.storeReader.diffQueryAgainstStore(w(w({}, e), { store: e.optimistic ? this.optimisticData : this.data, config: this.config, returnPartialData: r })).result || null;
    } catch (s) {
      if (s instanceof xu)
        return null;
      throw s;
    }
  }, t.prototype.write = function(e) {
    try {
      return ++this.txCount, this.storeWriter.writeToStore(this.data, e);
    } finally {
      !--this.txCount && e.broadcast !== !1 && this.broadcastWatches();
    }
  }, t.prototype.modify = function(e) {
    if (st.call(e, "id") && !e.id)
      return !1;
    var n = e.optimistic ? this.optimisticData : this.data;
    try {
      return ++this.txCount, n.modify(e.id || "ROOT_QUERY", e.fields);
    } finally {
      !--this.txCount && e.broadcast !== !1 && this.broadcastWatches();
    }
  }, t.prototype.diff = function(e) {
    return this.storeReader.diffQueryAgainstStore(w(w({}, e), { store: e.optimistic ? this.optimisticData : this.data, rootId: e.id || "ROOT_QUERY", config: this.config }));
  }, t.prototype.watch = function(e) {
    var n = this;
    return this.watches.size || dv(this), this.watches.add(e), e.immediate && this.maybeBroadcastWatch(e), function() {
      n.watches.delete(e) && !n.watches.size && Dc(n), n.maybeBroadcastWatch.forget(e);
    };
  }, t.prototype.gc = function(e) {
    pe.reset();
    var n = this.optimisticData.gc();
    return e && !this.txCount && (e.resetResultCache ? this.resetResultCache(e.resetResultIdentities) : e.resetResultIdentities && this.storeReader.resetCanon()), n;
  }, t.prototype.retain = function(e, n) {
    return (n ? this.optimisticData : this.data).retain(e);
  }, t.prototype.release = function(e, n) {
    return (n ? this.optimisticData : this.data).release(e);
  }, t.prototype.identify = function(e) {
    if (B(e))
      return e.__ref;
    try {
      return this.policies.identify(e)[0];
    } catch (n) {
      __DEV__ && D.warn(n);
    }
  }, t.prototype.evict = function(e) {
    if (!e.id) {
      if (st.call(e, "id"))
        return !1;
      e = w(w({}, e), { id: "ROOT_QUERY" });
    }
    try {
      return ++this.txCount, this.optimisticData.evict(e, this.data);
    } finally {
      !--this.txCount && e.broadcast !== !1 && this.broadcastWatches();
    }
  }, t.prototype.reset = function(e) {
    var n = this;
    return this.init(), pe.reset(), e && e.discardWatches ? (this.watches.forEach(function(r) {
      return n.maybeBroadcastWatch.forget(r);
    }), this.watches.clear(), Dc(this)) : this.broadcastWatches(), Promise.resolve();
  }, t.prototype.removeOptimistic = function(e) {
    var n = this.optimisticData.removeLayer(e);
    n !== this.optimisticData && (this.optimisticData = n, this.broadcastWatches());
  }, t.prototype.batch = function(e) {
    var n = this, r = e.update, s = e.optimistic, o = s === void 0 ? !0 : s, a = e.removeOptimistic, c = e.onWatchUpdated, l, u = function(f) {
      var d = n, p = d.data, g = d.optimisticData;
      ++n.txCount, f && (n.data = n.optimisticData = f);
      try {
        return l = r(n);
      } finally {
        --n.txCount, n.data = p, n.optimisticData = g;
      }
    }, h = /* @__PURE__ */ new Set();
    return c && !this.txCount && this.broadcastWatches(w(w({}, e), { onWatchUpdated: function(f) {
      return h.add(f), !1;
    } })), typeof o == "string" ? this.optimisticData = this.optimisticData.addLayer(o, u) : o === !1 ? u(this.data) : u(), typeof a == "string" && (this.optimisticData = this.optimisticData.removeLayer(a)), c && h.size ? (this.broadcastWatches(w(w({}, e), { onWatchUpdated: function(f, d) {
      var p = c.call(this, f, d);
      return p !== !1 && h.delete(f), p;
    } })), h.size && h.forEach(function(f) {
      return n.maybeBroadcastWatch.dirty(f);
    })) : this.broadcastWatches(e), l;
  }, t.prototype.performTransaction = function(e, n) {
    return this.batch({
      update: e,
      optimistic: n || n !== null
    });
  }, t.prototype.transformDocument = function(e) {
    if (this.addTypename) {
      var n = this.typenameDocumentCache.get(e);
      return n || (n = ro(e), this.typenameDocumentCache.set(e, n), this.typenameDocumentCache.set(n, n)), n;
    }
    return e;
  }, t.prototype.transformForLink = function(e) {
    var n = this.config.fragments;
    return n ? n.transform(e) : e;
  }, t.prototype.broadcastWatches = function(e) {
    var n = this;
    this.txCount || this.watches.forEach(function(r) {
      return n.maybeBroadcastWatch(r, e);
    });
  }, t.prototype.broadcastWatch = function(e, n) {
    var r = e.lastDiff, s = this.diff(e);
    n && (e.optimistic && typeof n.optimistic == "string" && (s.fromOptimisticTransaction = !0), n.onWatchUpdated && n.onWatchUpdated.call(this, e, s, r) === !1) || (!r || !nt(r.result, s.result)) && e.callback(e.lastDiff = s, r);
  }, t;
}(tv);
function xv(i) {
  return i.hasOwnProperty("graphQLErrors");
}
var wv = function(i) {
  var t = "";
  if (It(i.graphQLErrors) || It(i.clientErrors)) {
    var e = (i.graphQLErrors || []).concat(i.clientErrors || []);
    e.forEach(function(n) {
      var r = n ? n.message : "Error message not found.";
      t += "".concat(r, `
`);
    });
  }
  return i.networkError && (t += "".concat(i.networkError.message, `
`)), t = t.replace(/\n$/, ""), t;
}, ke = function(i) {
  Dt(t, i);
  function t(e) {
    var n = e.graphQLErrors, r = e.clientErrors, s = e.networkError, o = e.errorMessage, a = e.extraInfo, c = i.call(this, o) || this;
    return c.graphQLErrors = n || [], c.clientErrors = r || [], c.networkError = s || null, c.message = o || wv(c), c.extraInfo = a, c.__proto__ = t.prototype, c;
  }
  return t;
}(Error), z;
(function(i) {
  i[i.loading = 1] = "loading", i[i.setVariables = 2] = "setVariables", i[i.fetchMore = 3] = "fetchMore", i[i.refetch = 4] = "refetch", i[i.poll = 6] = "poll", i[i.ready = 7] = "ready", i[i.error = 8] = "error";
})(z || (z = {}));
function Ri(i) {
  return i ? i < 7 : !1;
}
var Sv = Object.assign, Ev = Object.hasOwnProperty, xs = function(i) {
  Dt(t, i);
  function t(e) {
    var n = e.queryManager, r = e.queryInfo, s = e.options, o = i.call(this, function(m) {
      try {
        var y = m._subscription._observer;
        y && !y.error && (y.error = kv);
      } catch {
      }
      var b = !o.observers.size;
      o.observers.add(m);
      var v = o.last;
      return v && v.error ? m.error && m.error(v.error) : v && v.result && m.next && m.next(v.result), b && o.reobserve().catch(function() {
      }), function() {
        o.observers.delete(m) && !o.observers.size && o.tearDownQuery();
      };
    }) || this;
    o.observers = /* @__PURE__ */ new Set(), o.subscriptions = /* @__PURE__ */ new Set(), o.queryInfo = r, o.queryManager = n, o.isTornDown = !1;
    var a = n.defaultOptions.watchQuery, c = a === void 0 ? {} : a, l = c.fetchPolicy, u = l === void 0 ? "cache-first" : l, h = s.fetchPolicy, f = h === void 0 ? u : h, d = s.initialFetchPolicy, p = d === void 0 ? f === "standby" ? u : f : d;
    o.options = w(w({}, s), { initialFetchPolicy: p, fetchPolicy: f }), o.queryId = r.queryId || n.generateQueryId();
    var g = zi(o.query);
    return o.queryName = g && g.name && g.name.value, o;
  }
  return Object.defineProperty(t.prototype, "query", {
    get: function() {
      return this.queryManager.transform(this.options.query).document;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "variables", {
    get: function() {
      return this.options.variables;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.result = function() {
    var e = this;
    return new Promise(function(n, r) {
      var s = {
        next: function(a) {
          n(a), e.observers.delete(s), e.observers.size || e.queryManager.removeQuery(e.queryId), setTimeout(function() {
            o.unsubscribe();
          }, 0);
        },
        error: r
      }, o = e.subscribe(s);
    });
  }, t.prototype.getCurrentResult = function(e) {
    e === void 0 && (e = !0);
    var n = this.getLastResult(!0), r = this.queryInfo.networkStatus || n && n.networkStatus || z.ready, s = w(w({}, n), { loading: Ri(r), networkStatus: r }), o = this.options.fetchPolicy, a = o === void 0 ? "cache-first" : o;
    if (!(a === "network-only" || a === "no-cache" || a === "standby" || this.queryManager.transform(this.options.query).hasForcedResolvers)) {
      var c = this.queryInfo.getDiff();
      (c.complete || this.options.returnPartialData) && (s.data = c.result), nt(s.data, {}) && (s.data = void 0), c.complete ? (delete s.partial, c.complete && s.networkStatus === z.loading && (a === "cache-first" || a === "cache-only") && (s.networkStatus = z.ready, s.loading = !1)) : s.partial = !0, __DEV__ && !c.complete && !this.options.partialRefetch && !s.loading && !s.data && !s.error && Iu(c.missing);
    }
    return e && this.updateLastResult(s), s;
  }, t.prototype.isDifferentFromLastResult = function(e, n) {
    return !this.last || !nt(this.last.result, e) || n && !nt(this.last.variables, n);
  }, t.prototype.getLast = function(e, n) {
    var r = this.last;
    if (r && r[e] && (!n || nt(r.variables, this.variables)))
      return r[e];
  }, t.prototype.getLastResult = function(e) {
    return this.getLast("result", e);
  }, t.prototype.getLastError = function(e) {
    return this.getLast("error", e);
  }, t.prototype.resetLastResults = function() {
    delete this.last, this.isTornDown = !1;
  }, t.prototype.resetQueryStoreErrors = function() {
    this.queryManager.resetErrors(this.queryId);
  }, t.prototype.refetch = function(e) {
    var n, r = {
      pollInterval: 0
    }, s = this.options.fetchPolicy;
    if (s === "cache-and-network" ? r.fetchPolicy = s : s === "no-cache" ? r.fetchPolicy = "no-cache" : r.fetchPolicy = "network-only", __DEV__ && e && Ev.call(e, "variables")) {
      var o = Jl(this.query), a = o.variableDefinitions;
      (!a || !a.some(function(c) {
        return c.variable.name.value === "variables";
      })) && __DEV__ && D.warn("Called refetch(".concat(JSON.stringify(e), ") for query ").concat(((n = o.name) === null || n === void 0 ? void 0 : n.value) || JSON.stringify(o), `, which does not declare a $variables variable.
Did you mean to call refetch(variables) instead of refetch({ variables })?`));
    }
    return e && !nt(this.options.variables, e) && (r.variables = this.options.variables = w(w({}, this.options.variables), e)), this.queryInfo.resetLastWrite(), this.reobserve(r, z.refetch);
  }, t.prototype.fetchMore = function(e) {
    var n = this, r = w(w({}, e.query ? e : w(w(w(w({}, this.options), { query: this.query }), e), { variables: w(w({}, this.options.variables), e.variables) })), { fetchPolicy: "no-cache" }), s = this.queryManager.generateQueryId(), o = this.queryInfo, a = o.networkStatus;
    o.networkStatus = z.fetchMore, r.notifyOnNetworkStatusChange && this.observe();
    var c = /* @__PURE__ */ new Set();
    return this.queryManager.fetchQuery(s, r, z.fetchMore).then(function(l) {
      return n.queryManager.removeQuery(s), o.networkStatus === z.fetchMore && (o.networkStatus = a), n.queryManager.cache.batch({
        update: function(u) {
          var h = e.updateQuery;
          h ? u.updateQuery({
            query: n.query,
            variables: n.variables,
            returnPartialData: !0,
            optimistic: !1
          }, function(f) {
            return h(f, {
              fetchMoreResult: l.data,
              variables: r.variables
            });
          }) : u.writeQuery({
            query: r.query,
            variables: r.variables,
            data: l.data
          });
        },
        onWatchUpdated: function(u) {
          c.add(u.query);
        }
      }), l;
    }).finally(function() {
      c.has(n.query) || Ru(n);
    });
  }, t.prototype.subscribeToMore = function(e) {
    var n = this, r = this.queryManager.startGraphQLSubscription({
      query: e.document,
      variables: e.variables,
      context: e.context
    }).subscribe({
      next: function(s) {
        var o = e.updateQuery;
        o && n.updateQuery(function(a, c) {
          var l = c.variables;
          return o(a, {
            subscriptionData: s,
            variables: l
          });
        });
      },
      error: function(s) {
        if (e.onError) {
          e.onError(s);
          return;
        }
        __DEV__ && D.error("Unhandled GraphQL subscription error", s);
      }
    });
    return this.subscriptions.add(r), function() {
      n.subscriptions.delete(r) && r.unsubscribe();
    };
  }, t.prototype.setOptions = function(e) {
    return this.reobserve(e);
  }, t.prototype.setVariables = function(e) {
    return nt(this.variables, e) ? this.observers.size ? this.result() : Promise.resolve() : (this.options.variables = e, this.observers.size ? this.reobserve({
      fetchPolicy: this.options.initialFetchPolicy,
      variables: e
    }, z.setVariables) : Promise.resolve());
  }, t.prototype.updateQuery = function(e) {
    var n = this.queryManager, r = n.cache.diff({
      query: this.options.query,
      variables: this.variables,
      returnPartialData: !0,
      optimistic: !1
    }).result, s = e(r, {
      variables: this.variables
    });
    s && (n.cache.writeQuery({
      query: this.options.query,
      data: s,
      variables: this.variables
    }), n.broadcastQueries());
  }, t.prototype.startPolling = function(e) {
    this.options.pollInterval = e, this.updatePolling();
  }, t.prototype.stopPolling = function() {
    this.options.pollInterval = 0, this.updatePolling();
  }, t.prototype.applyNextFetchPolicy = function(e, n) {
    if (n.nextFetchPolicy) {
      var r = n.fetchPolicy, s = r === void 0 ? "cache-first" : r, o = n.initialFetchPolicy, a = o === void 0 ? s : o;
      s === "standby" || (typeof n.nextFetchPolicy == "function" ? n.fetchPolicy = n.nextFetchPolicy(s, {
        reason: e,
        options: n,
        observable: this,
        initialFetchPolicy: a
      }) : e === "variables-changed" ? n.fetchPolicy = a : n.fetchPolicy = n.nextFetchPolicy);
    }
    return n.fetchPolicy;
  }, t.prototype.fetch = function(e, n) {
    return this.queryManager.setObservableQuery(this), this.queryManager.fetchQueryObservable(this.queryId, e, n);
  }, t.prototype.updatePolling = function() {
    var e = this;
    if (!this.queryManager.ssrMode) {
      var n = this, r = n.pollingInfo, s = n.options.pollInterval;
      if (!s) {
        r && (clearTimeout(r.timeout), delete this.pollingInfo);
        return;
      }
      if (!(r && r.interval === s)) {
        __DEV__ ? D(s, "Attempted to start a polling query without a polling interval.") : D(s, 12);
        var o = r || (this.pollingInfo = {});
        o.interval = s;
        var a = function() {
          e.pollingInfo && (Ri(e.queryInfo.networkStatus) ? c() : e.reobserve({
            fetchPolicy: e.options.initialFetchPolicy === "no-cache" ? "no-cache" : "network-only"
          }, z.poll).then(c, c));
        }, c = function() {
          var l = e.pollingInfo;
          l && (clearTimeout(l.timeout), l.timeout = setTimeout(a, l.interval));
        };
        c();
      }
    }
  }, t.prototype.updateLastResult = function(e, n) {
    return n === void 0 && (n = this.variables), this.last = w(w({}, this.last), { result: this.queryManager.assumeImmutableResults ? e : uo(e), variables: n }), It(e.errors) || delete this.last.error, this.last;
  }, t.prototype.reobserve = function(e, n) {
    var r = this;
    this.isTornDown = !1;
    var s = n === z.refetch || n === z.fetchMore || n === z.poll, o = this.options.variables, a = this.options.fetchPolicy, c = tr(this.options, e || {}), l = s ? c : Sv(this.options, c);
    s || (this.updatePolling(), e && e.variables && !nt(e.variables, o) && l.fetchPolicy !== "standby" && l.fetchPolicy === a && (this.applyNextFetchPolicy("variables-changed", l), n === void 0 && (n = z.setVariables)));
    var u = l.variables && w({}, l.variables), h = this.fetch(l, n), f = {
      next: function(d) {
        r.reportResult(d, u);
      },
      error: function(d) {
        r.reportError(d, u);
      }
    };
    return s || (this.concast && this.observer && this.concast.removeObserver(this.observer), this.concast = h, this.observer = f), h.addObserver(f), h.promise;
  }, t.prototype.observe = function() {
    this.reportResult(this.getCurrentResult(!1), this.variables);
  }, t.prototype.reportResult = function(e, n) {
    var r = this.getLastError();
    (r || this.isDifferentFromLastResult(e, n)) && ((r || !e.partial || this.options.returnPartialData) && this.updateLastResult(e, n), bi(this.observers, "next", e));
  }, t.prototype.reportError = function(e, n) {
    var r = w(w({}, this.getLastResult()), { error: e, errors: e.graphQLErrors, networkStatus: z.error, loading: !1 });
    this.updateLastResult(r, n), bi(this.observers, "error", this.last.error = e);
  }, t.prototype.hasObservers = function() {
    return this.observers.size > 0;
  }, t.prototype.tearDownQuery = function() {
    this.isTornDown || (this.concast && this.observer && (this.concast.removeObserver(this.observer), delete this.concast, delete this.observer), this.stopPolling(), this.subscriptions.forEach(function(e) {
      return e.unsubscribe();
    }), this.subscriptions.clear(), this.queryManager.stopQuery(this.queryId), this.observers.clear(), this.isTornDown = !0);
  }, t;
}(U);
ou(xs);
function Ru(i) {
  var t = i.options, e = t.fetchPolicy, n = t.nextFetchPolicy;
  return e === "cache-and-network" || e === "network-only" ? i.reobserve({
    fetchPolicy: "cache-first",
    nextFetchPolicy: function() {
      return this.nextFetchPolicy = n, typeof n == "function" ? n.apply(this, arguments) : e;
    }
  }) : i.reobserve();
}
function kv(i) {
  __DEV__ && D.error("Unhandled error", i.message, i.stack);
}
function Iu(i) {
  __DEV__ && i && __DEV__ && D.debug("Missing cache result fields: ".concat(JSON.stringify(i)), i);
}
var Fu = function() {
  function i(t) {
    var e = t.cache, n = t.client, r = t.resolvers, s = t.fragmentMatcher;
    this.cache = e, n && (this.client = n), r && this.addResolvers(r), s && this.setFragmentMatcher(s);
  }
  return i.prototype.addResolvers = function(t) {
    var e = this;
    this.resolvers = this.resolvers || {}, Array.isArray(t) ? t.forEach(function(n) {
      e.resolvers = ec(e.resolvers, n);
    }) : this.resolvers = ec(this.resolvers, t);
  }, i.prototype.setResolvers = function(t) {
    this.resolvers = {}, this.addResolvers(t);
  }, i.prototype.getResolvers = function() {
    return this.resolvers || {};
  }, i.prototype.runResolvers = function(t) {
    var e = t.document, n = t.remoteResult, r = t.context, s = t.variables, o = t.onlyRunForcedResolvers, a = o === void 0 ? !1 : o;
    return Wt(this, void 0, void 0, function() {
      return Ht(this, function(c) {
        return e ? [2, this.resolveDocument(e, n.data, r, s, this.fragmentMatcher, a).then(function(l) {
          return w(w({}, n), { data: l.result });
        })] : [2, n];
      });
    });
  }, i.prototype.setFragmentMatcher = function(t) {
    this.fragmentMatcher = t;
  }, i.prototype.getFragmentMatcher = function() {
    return this.fragmentMatcher;
  }, i.prototype.clientQuery = function(t) {
    return Xs(["client"], t) && this.resolvers ? t : null;
  }, i.prototype.serverQuery = function(t) {
    return Nm(t);
  }, i.prototype.prepareContext = function(t) {
    var e = this.cache;
    return w(w({}, t), { cache: e, getCacheKey: function(n) {
      return e.identify(n);
    } });
  }, i.prototype.addExportedVariables = function(t, e, n) {
    return e === void 0 && (e = {}), n === void 0 && (n = {}), Wt(this, void 0, void 0, function() {
      return Ht(this, function(r) {
        return t ? [2, this.resolveDocument(t, this.buildRootValueFromCache(t, e) || {}, this.prepareContext(n), e).then(function(s) {
          return w(w({}, e), s.exportedVariables);
        })] : [2, w({}, e)];
      });
    });
  }, i.prototype.shouldForceResolvers = function(t) {
    var e = !1;
    return Ft(t, {
      Directive: {
        enter: function(n) {
          if (n.name.value === "client" && n.arguments && (e = n.arguments.some(function(r) {
            return r.name.value === "always" && r.value.kind === "BooleanValue" && r.value.value === !0;
          }), e))
            return Gs;
        }
      }
    }), e;
  }, i.prototype.buildRootValueFromCache = function(t, e) {
    return this.cache.diff({
      query: Lm(t),
      variables: e,
      returnPartialData: !0,
      optimistic: !1
    }).result;
  }, i.prototype.resolveDocument = function(t, e, n, r, s, o) {
    return n === void 0 && (n = {}), r === void 0 && (r = {}), s === void 0 && (s = function() {
      return !0;
    }), o === void 0 && (o = !1), Wt(this, void 0, void 0, function() {
      var a, c, l, u, h, f, d, p, g;
      return Ht(this, function(m) {
        return a = eo(t), c = to(t), l = Ks(c), u = a.operation, h = u ? u.charAt(0).toUpperCase() + u.slice(1) : "Query", f = this, d = f.cache, p = f.client, g = {
          fragmentMap: l,
          context: w(w({}, n), { cache: d, client: p }),
          variables: r,
          fragmentMatcher: s,
          defaultOperationType: h,
          exportedVariables: {},
          onlyRunForcedResolvers: o
        }, [2, this.resolveSelectionSet(a.selectionSet, e, g).then(function(y) {
          return {
            result: y,
            exportedVariables: g.exportedVariables
          };
        })];
      });
    });
  }, i.prototype.resolveSelectionSet = function(t, e, n) {
    return Wt(this, void 0, void 0, function() {
      var r, s, o, a, c, l = this;
      return Ht(this, function(u) {
        return r = n.fragmentMap, s = n.context, o = n.variables, a = [e], c = function(h) {
          return Wt(l, void 0, void 0, function() {
            var f, d;
            return Ht(this, function(p) {
              return Xn(h, o) ? Bt(h) ? [2, this.resolveField(h, e, n).then(function(g) {
                var m;
                typeof g < "u" && a.push((m = {}, m[ye(h)] = g, m));
              })] : (Kl(h) ? f = h : (f = r[h.name.value], __DEV__ ? D(f, "No fragment named ".concat(h.name.value)) : D(f, 11)), f && f.typeCondition && (d = f.typeCondition.name.value, n.fragmentMatcher(e, d, s)) ? [2, this.resolveSelectionSet(f.selectionSet, e, n).then(function(g) {
                a.push(g);
              })] : [2]) : [2];
            });
          });
        }, [2, Promise.all(t.selections.map(c)).then(function() {
          return so(a);
        })];
      });
    });
  }, i.prototype.resolveField = function(t, e, n) {
    return Wt(this, void 0, void 0, function() {
      var r, s, o, a, c, l, u, h, f, d = this;
      return Ht(this, function(p) {
        return r = n.variables, s = t.name.value, o = ye(t), a = s !== o, c = e[o] || e[s], l = Promise.resolve(c), (!n.onlyRunForcedResolvers || this.shouldForceResolvers(t)) && (u = e.__typename || n.defaultOperationType, h = this.resolvers && this.resolvers[u], h && (f = h[a ? s : o], f && (l = Promise.resolve(yo.withValue(this.cache, f, [
          e,
          Kn(t, r),
          n.context,
          { field: t, fragmentMap: n.fragmentMap }
        ]))))), [2, l.then(function(g) {
          if (g === void 0 && (g = c), t.directives && t.directives.forEach(function(m) {
            m.name.value === "export" && m.arguments && m.arguments.forEach(function(y) {
              y.name.value === "as" && y.value.kind === "StringValue" && (n.exportedVariables[y.value.value] = g);
            });
          }), !t.selectionSet || g == null)
            return g;
          if (Array.isArray(g))
            return d.resolveSubSelectedArray(t, g, n);
          if (t.selectionSet)
            return d.resolveSelectionSet(t.selectionSet, g, n);
        })];
      });
    });
  }, i.prototype.resolveSubSelectedArray = function(t, e, n) {
    var r = this;
    return Promise.all(e.map(function(s) {
      if (s === null)
        return null;
      if (Array.isArray(s))
        return r.resolveSubSelectedArray(t, s, n);
      if (t.selectionSet)
        return r.resolveSelectionSet(t.selectionSet, s, n);
    }));
  }, i;
}(), Ae = new (_e ? WeakMap : Map)();
function Nr(i, t) {
  var e = i[t];
  typeof e == "function" && (i[t] = function() {
    return Ae.set(i, (Ae.get(i) + 1) % 1e15), e.apply(this, arguments);
  });
}
function Vc(i) {
  i.notifyTimeout && (clearTimeout(i.notifyTimeout), i.notifyTimeout = void 0);
}
var Vr = function() {
  function i(t, e) {
    e === void 0 && (e = t.generateQueryId()), this.queryId = e, this.listeners = /* @__PURE__ */ new Set(), this.document = null, this.lastRequestId = 1, this.subscriptions = /* @__PURE__ */ new Set(), this.stopped = !1, this.dirty = !1, this.observableQuery = null;
    var n = this.cache = t.cache;
    Ae.has(n) || (Ae.set(n, 0), Nr(n, "evict"), Nr(n, "modify"), Nr(n, "reset"));
  }
  return i.prototype.init = function(t) {
    var e = t.networkStatus || z.loading;
    return this.variables && this.networkStatus !== z.loading && !nt(this.variables, t.variables) && (e = z.setVariables), nt(t.variables, this.variables) || (this.lastDiff = void 0), Object.assign(this, {
      document: t.document,
      variables: t.variables,
      networkError: null,
      graphQLErrors: this.graphQLErrors || [],
      networkStatus: e
    }), t.observableQuery && this.setObservableQuery(t.observableQuery), t.lastRequestId && (this.lastRequestId = t.lastRequestId), this;
  }, i.prototype.reset = function() {
    Vc(this), this.dirty = !1;
  }, i.prototype.getDiff = function(t) {
    t === void 0 && (t = this.variables);
    var e = this.getDiffOptions(t);
    if (this.lastDiff && nt(e, this.lastDiff.options))
      return this.lastDiff.diff;
    this.updateWatch(this.variables = t);
    var n = this.observableQuery;
    if (n && n.options.fetchPolicy === "no-cache")
      return { complete: !1 };
    var r = this.cache.diff(e);
    return this.updateLastDiff(r, e), r;
  }, i.prototype.updateLastDiff = function(t, e) {
    this.lastDiff = t ? {
      diff: t,
      options: e || this.getDiffOptions()
    } : void 0;
  }, i.prototype.getDiffOptions = function(t) {
    var e;
    return t === void 0 && (t = this.variables), {
      query: this.document,
      variables: t,
      returnPartialData: !0,
      optimistic: !0,
      canonizeResults: (e = this.observableQuery) === null || e === void 0 ? void 0 : e.options.canonizeResults
    };
  }, i.prototype.setDiff = function(t) {
    var e = this, n = this.lastDiff && this.lastDiff.diff;
    this.updateLastDiff(t), !this.dirty && !nt(n && n.result, t && t.result) && (this.dirty = !0, this.notifyTimeout || (this.notifyTimeout = setTimeout(function() {
      return e.notify();
    }, 0)));
  }, i.prototype.setObservableQuery = function(t) {
    var e = this;
    t !== this.observableQuery && (this.oqListener && this.listeners.delete(this.oqListener), this.observableQuery = t, t ? (t.queryInfo = this, this.listeners.add(this.oqListener = function() {
      var n = e.getDiff();
      n.fromOptimisticTransaction ? t.observe() : Ru(t);
    })) : delete this.oqListener);
  }, i.prototype.notify = function() {
    var t = this;
    Vc(this), this.shouldNotify() && this.listeners.forEach(function(e) {
      return e(t);
    }), this.dirty = !1;
  }, i.prototype.shouldNotify = function() {
    if (!this.dirty || !this.listeners.size)
      return !1;
    if (Ri(this.networkStatus) && this.observableQuery) {
      var t = this.observableQuery.options.fetchPolicy;
      if (t !== "cache-only" && t !== "cache-and-network")
        return !1;
    }
    return !0;
  }, i.prototype.stop = function() {
    if (!this.stopped) {
      this.stopped = !0, this.reset(), this.cancel(), this.cancel = i.prototype.cancel, this.subscriptions.forEach(function(e) {
        return e.unsubscribe();
      });
      var t = this.observableQuery;
      t && t.stopPolling();
    }
  }, i.prototype.cancel = function() {
  }, i.prototype.updateWatch = function(t) {
    var e = this;
    t === void 0 && (t = this.variables);
    var n = this.observableQuery;
    if (!(n && n.options.fetchPolicy === "no-cache")) {
      var r = w(w({}, this.getDiffOptions(t)), { watcher: this, callback: function(s) {
        return e.setDiff(s);
      } });
      (!this.lastWatch || !nt(r, this.lastWatch)) && (this.cancel(), this.cancel = this.cache.watch(this.lastWatch = r));
    }
  }, i.prototype.resetLastWrite = function() {
    this.lastWrite = void 0;
  }, i.prototype.shouldWrite = function(t, e) {
    var n = this.lastWrite;
    return !(n && n.dmCount === Ae.get(this.cache) && nt(e, n.variables) && nt(t.data, n.result.data));
  }, i.prototype.markResult = function(t, e, n, r) {
    var s = this, o = It(t.errors) ? t.errors.slice(0) : [];
    if (this.reset(), "incremental" in t && It(t.incremental)) {
      var a = this.getDiff().result, c = new ve();
      t.incremental.forEach(function(l) {
        for (var u = l.data, h = l.path, f = l.errors, d = h.length - 1; d >= 0; --d) {
          var p = h[d], g = !isNaN(+p), m = g ? [] : {};
          m[p] = u, u = m;
        }
        f && o.push.apply(o, f), a = c.merge(a, u);
      }), t.data = a;
    }
    this.graphQLErrors = o, n.fetchPolicy === "no-cache" ? this.updateLastDiff({ result: t.data, complete: !0 }, this.getDiffOptions(n.variables)) : r !== 0 && (ws(t, n.errorPolicy) ? this.cache.performTransaction(function(l) {
      if (s.shouldWrite(t, n.variables))
        l.writeQuery({
          query: e,
          data: t.data,
          variables: n.variables,
          overwrite: r === 1
        }), s.lastWrite = {
          result: t,
          variables: n.variables,
          dmCount: Ae.get(s.cache)
        };
      else if (s.lastDiff && s.lastDiff.diff.complete) {
        t.data = s.lastDiff.diff.result;
        return;
      }
      var u = s.getDiffOptions(n.variables), h = l.diff(u);
      s.stopped || s.updateWatch(n.variables), s.updateLastDiff(h, u), h.complete && (t.data = h.result);
    }) : this.lastWrite = void 0);
  }, i.prototype.markReady = function() {
    return this.networkError = null, this.networkStatus = z.ready;
  }, i.prototype.markError = function(t) {
    return this.networkStatus = z.error, this.lastWrite = void 0, this.reset(), t.graphQLErrors && (this.graphQLErrors = t.graphQLErrors), t.networkError && (this.networkError = t.networkError), t;
  }, i;
}();
function ws(i, t) {
  t === void 0 && (t = "none");
  var e = t === "ignore" || t === "all", n = !dn(i);
  return !n && e && i.data && (n = !0), n;
}
var Ov = Object.prototype.hasOwnProperty, Dv = function() {
  function i(t) {
    var e = t.cache, n = t.link, r = t.defaultOptions, s = t.queryDeduplication, o = s === void 0 ? !1 : s, a = t.onBroadcast, c = t.ssrMode, l = c === void 0 ? !1 : c, u = t.clientAwareness, h = u === void 0 ? {} : u, f = t.localState, d = t.assumeImmutableResults;
    this.clientAwareness = {}, this.queries = /* @__PURE__ */ new Map(), this.fetchCancelFns = /* @__PURE__ */ new Map(), this.transformCache = new (_e ? WeakMap : Map)(), this.queryIdCounter = 1, this.requestIdCounter = 1, this.mutationIdCounter = 1, this.inFlightLinkObservables = /* @__PURE__ */ new Map(), this.cache = e, this.link = n, this.defaultOptions = r || /* @__PURE__ */ Object.create(null), this.queryDeduplication = o, this.clientAwareness = h, this.localState = f || new Fu({ cache: e }), this.ssrMode = l, this.assumeImmutableResults = !!d, (this.onBroadcast = a) && (this.mutationStore = /* @__PURE__ */ Object.create(null));
  }
  return i.prototype.stop = function() {
    var t = this;
    this.queries.forEach(function(e, n) {
      t.stopQueryNoBroadcast(n);
    }), this.cancelPendingFetches(__DEV__ ? new N("QueryManager stopped while query was in flight") : new N(13));
  }, i.prototype.cancelPendingFetches = function(t) {
    this.fetchCancelFns.forEach(function(e) {
      return e(t);
    }), this.fetchCancelFns.clear();
  }, i.prototype.mutate = function(t) {
    var e, n, r = t.mutation, s = t.variables, o = t.optimisticResponse, a = t.updateQueries, c = t.refetchQueries, l = c === void 0 ? [] : c, u = t.awaitRefetchQueries, h = u === void 0 ? !1 : u, f = t.update, d = t.onQueryUpdated, p = t.fetchPolicy, g = p === void 0 ? ((e = this.defaultOptions.mutate) === null || e === void 0 ? void 0 : e.fetchPolicy) || "network-only" : p, m = t.errorPolicy, y = m === void 0 ? ((n = this.defaultOptions.mutate) === null || n === void 0 ? void 0 : n.errorPolicy) || "none" : m, b = t.keepRootFields, v = t.context;
    return Wt(this, void 0, void 0, function() {
      var _, x, k, E, O, M;
      return Ht(this, function(C) {
        switch (C.label) {
          case 0:
            return __DEV__ ? D(r, "mutation option is required. You must specify your GraphQL document in the mutation option.") : D(r, 14), __DEV__ ? D(g === "network-only" || g === "no-cache", "Mutations support only 'network-only' or 'no-cache' fetchPolicy strings. The default `network-only` behavior automatically writes mutation results to the cache. Passing `no-cache` skips the cache write.") : D(g === "network-only" || g === "no-cache", 15), _ = this.generateMutationId(), x = this.transform(r), k = x.document, E = x.hasClientExports, r = this.cache.transformForLink(k), s = this.getVariables(r, s), E ? [4, this.localState.addExportedVariables(r, s, v)] : [3, 2];
          case 1:
            s = C.sent(), C.label = 2;
          case 2:
            return O = this.mutationStore && (this.mutationStore[_] = {
              mutation: r,
              variables: s,
              loading: !0,
              error: null
            }), o && this.markMutationOptimistic(o, {
              mutationId: _,
              document: r,
              variables: s,
              fetchPolicy: g,
              errorPolicy: y,
              context: v,
              updateQueries: a,
              update: f,
              keepRootFields: b
            }), this.broadcastQueries(), M = this, [2, new Promise(function(V, q) {
              return Dr(M.getObservableFromLink(r, w(w({}, v), { optimisticResponse: o }), s, !1), function(Y) {
                if (dn(Y) && y === "none")
                  throw new ke({
                    graphQLErrors: Y.errors
                  });
                O && (O.loading = !1, O.error = null);
                var rt = w({}, Y);
                return typeof l == "function" && (l = l(rt)), y === "ignore" && dn(rt) && delete rt.errors, M.markMutationResult({
                  mutationId: _,
                  result: rt,
                  document: r,
                  variables: s,
                  fetchPolicy: g,
                  errorPolicy: y,
                  context: v,
                  update: f,
                  updateQueries: a,
                  awaitRefetchQueries: h,
                  refetchQueries: l,
                  removeOptimistic: o ? _ : void 0,
                  onQueryUpdated: d,
                  keepRootFields: b
                });
              }).subscribe({
                next: function(Y) {
                  M.broadcastQueries(), V(Y);
                },
                error: function(Y) {
                  O && (O.loading = !1, O.error = Y), o && M.cache.removeOptimistic(_), M.broadcastQueries(), q(Y instanceof ke ? Y : new ke({
                    networkError: Y
                  }));
                }
              });
            })];
        }
      });
    });
  }, i.prototype.markMutationResult = function(t, e) {
    var n = this;
    e === void 0 && (e = this.cache);
    var r = t.result, s = [], o = t.fetchPolicy === "no-cache";
    if (!o && ws(r, t.errorPolicy)) {
      s.push({
        result: r.data,
        dataId: "ROOT_MUTATION",
        query: t.document,
        variables: t.variables
      });
      var a = t.updateQueries;
      a && this.queries.forEach(function(l, u) {
        var h = l.observableQuery, f = h && h.queryName;
        if (!(!f || !Ov.call(a, f))) {
          var d = a[f], p = n.queries.get(u), g = p.document, m = p.variables, y = e.diff({
            query: g,
            variables: m,
            returnPartialData: !0,
            optimistic: !1
          }), b = y.result, v = y.complete;
          if (v && b) {
            var _ = d(b, {
              mutationResult: r,
              queryName: g && rs(g) || void 0,
              queryVariables: m
            });
            _ && s.push({
              result: _,
              dataId: "ROOT_QUERY",
              query: g,
              variables: m
            });
          }
        }
      });
    }
    if (s.length > 0 || t.refetchQueries || t.update || t.onQueryUpdated || t.removeOptimistic) {
      var c = [];
      if (this.refetchQueries({
        updateCache: function(l) {
          o || s.forEach(function(f) {
            return l.write(f);
          });
          var u = t.update;
          if (u) {
            if (!o) {
              var h = l.diff({
                id: "ROOT_MUTATION",
                query: n.transform(t.document).asQuery,
                variables: t.variables,
                optimistic: !1,
                returnPartialData: !0
              });
              h.complete && !Fy(r) && (r = w(w({}, r), { data: h.result }));
            }
            u(l, r, {
              context: t.context,
              variables: t.variables
            });
          }
          !o && !t.keepRootFields && l.modify({
            id: "ROOT_MUTATION",
            fields: function(f, d) {
              var p = d.fieldName, g = d.DELETE;
              return p === "__typename" ? f : g;
            }
          });
        },
        include: t.refetchQueries,
        optimistic: !1,
        removeOptimistic: t.removeOptimistic,
        onQueryUpdated: t.onQueryUpdated || null
      }).forEach(function(l) {
        return c.push(l);
      }), t.awaitRefetchQueries || t.onQueryUpdated)
        return Promise.all(c).then(function() {
          return r;
        });
    }
    return Promise.resolve(r);
  }, i.prototype.markMutationOptimistic = function(t, e) {
    var n = this, r = typeof t == "function" ? t(e.variables) : t;
    return this.cache.recordOptimisticTransaction(function(s) {
      try {
        n.markMutationResult(w(w({}, e), { result: { data: r } }), s);
      } catch (o) {
        __DEV__ && D.error(o);
      }
    }, e.mutationId);
  }, i.prototype.fetchQuery = function(t, e, n) {
    return this.fetchQueryObservable(t, e, n).promise;
  }, i.prototype.getQueryStore = function() {
    var t = /* @__PURE__ */ Object.create(null);
    return this.queries.forEach(function(e, n) {
      t[n] = {
        variables: e.variables,
        networkStatus: e.networkStatus,
        networkError: e.networkError,
        graphQLErrors: e.graphQLErrors
      };
    }), t;
  }, i.prototype.resetErrors = function(t) {
    var e = this.queries.get(t);
    e && (e.networkError = void 0, e.graphQLErrors = []);
  }, i.prototype.transform = function(t) {
    var e = this.transformCache;
    if (!e.has(t)) {
      var n = this.cache.transformDocument(t), r = Pm(n), s = this.localState.clientQuery(n), o = r && this.localState.serverQuery(r), a = {
        document: n,
        hasClientExports: dm(n),
        hasForcedResolvers: this.localState.shouldForceResolvers(n),
        clientQuery: s,
        serverQuery: o,
        defaultVars: io(zi(n)),
        asQuery: w(w({}, n), { definitions: n.definitions.map(function(l) {
          return l.kind === "OperationDefinition" && l.operation !== "query" ? w(w({}, l), { operation: "query" }) : l;
        }) })
      }, c = function(l) {
        l && !e.has(l) && e.set(l, a);
      };
      c(t), c(n), c(s), c(o);
    }
    return e.get(t);
  }, i.prototype.getVariables = function(t, e) {
    return w(w({}, this.transform(t).defaultVars), e);
  }, i.prototype.watchQuery = function(t) {
    t = w(w({}, t), { variables: this.getVariables(t.query, t.variables) }), typeof t.notifyOnNetworkStatusChange > "u" && (t.notifyOnNetworkStatusChange = !1);
    var e = new Vr(this), n = new xs({
      queryManager: this,
      queryInfo: e,
      options: t
    });
    return this.queries.set(n.queryId, e), e.init({
      document: n.query,
      observableQuery: n,
      variables: n.variables
    }), n;
  }, i.prototype.query = function(t, e) {
    var n = this;
    return e === void 0 && (e = this.generateQueryId()), __DEV__ ? D(t.query, "query option is required. You must specify your GraphQL document in the query option.") : D(t.query, 16), __DEV__ ? D(t.query.kind === "Document", 'You must wrap the query string in a "gql" tag.') : D(t.query.kind === "Document", 17), __DEV__ ? D(!t.returnPartialData, "returnPartialData option only supported on watchQuery.") : D(!t.returnPartialData, 18), __DEV__ ? D(!t.pollInterval, "pollInterval option only supported on watchQuery.") : D(!t.pollInterval, 19), this.fetchQuery(e, t).finally(function() {
      return n.stopQuery(e);
    });
  }, i.prototype.generateQueryId = function() {
    return String(this.queryIdCounter++);
  }, i.prototype.generateRequestId = function() {
    return this.requestIdCounter++;
  }, i.prototype.generateMutationId = function() {
    return String(this.mutationIdCounter++);
  }, i.prototype.stopQueryInStore = function(t) {
    this.stopQueryInStoreNoBroadcast(t), this.broadcastQueries();
  }, i.prototype.stopQueryInStoreNoBroadcast = function(t) {
    var e = this.queries.get(t);
    e && e.stop();
  }, i.prototype.clearStore = function(t) {
    return t === void 0 && (t = {
      discardWatches: !0
    }), this.cancelPendingFetches(__DEV__ ? new N("Store reset while query was in flight (not completed in link chain)") : new N(20)), this.queries.forEach(function(e) {
      e.observableQuery ? e.networkStatus = z.loading : e.stop();
    }), this.mutationStore && (this.mutationStore = /* @__PURE__ */ Object.create(null)), this.cache.reset(t);
  }, i.prototype.getObservableQueries = function(t) {
    var e = this;
    t === void 0 && (t = "active");
    var n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map(), s = /* @__PURE__ */ new Set();
    return Array.isArray(t) && t.forEach(function(o) {
      typeof o == "string" ? r.set(o, !1) : ym(o) ? r.set(e.transform(o).document, !1) : J(o) && o.query && s.add(o);
    }), this.queries.forEach(function(o, a) {
      var c = o.observableQuery, l = o.document;
      if (c) {
        if (t === "all") {
          n.set(a, c);
          return;
        }
        var u = c.queryName, h = c.options.fetchPolicy;
        if (h === "standby" || t === "active" && !c.hasObservers())
          return;
        (t === "active" || u && r.has(u) || l && r.has(l)) && (n.set(a, c), u && r.set(u, !0), l && r.set(l, !0));
      }
    }), s.size && s.forEach(function(o) {
      var a = ls("legacyOneTimeQuery"), c = e.getQuery(a).init({
        document: o.query,
        variables: o.variables
      }), l = new xs({
        queryManager: e,
        queryInfo: c,
        options: w(w({}, o), { fetchPolicy: "network-only" })
      });
      D(l.queryId === a), c.setObservableQuery(l), n.set(a, l);
    }), __DEV__ && r.size && r.forEach(function(o, a) {
      o || __DEV__ && D.warn("Unknown query ".concat(typeof a == "string" ? "named " : "").concat(JSON.stringify(a, null, 2), " requested in refetchQueries options.include array"));
    }), n;
  }, i.prototype.reFetchObservableQueries = function(t) {
    var e = this;
    t === void 0 && (t = !1);
    var n = [];
    return this.getObservableQueries(t ? "all" : "active").forEach(function(r, s) {
      var o = r.options.fetchPolicy;
      r.resetLastResults(), (t || o !== "standby" && o !== "cache-only") && n.push(r.refetch()), e.getQuery(s).setDiff(null);
    }), this.broadcastQueries(), Promise.all(n);
  }, i.prototype.setObservableQuery = function(t) {
    this.getQuery(t.queryId).setObservableQuery(t);
  }, i.prototype.startGraphQLSubscription = function(t) {
    var e = this, n = t.query, r = t.fetchPolicy, s = t.errorPolicy, o = t.variables, a = t.context, c = a === void 0 ? {} : a;
    n = this.transform(n).document, o = this.getVariables(n, o);
    var l = function(h) {
      return e.getObservableFromLink(n, c, h).map(function(f) {
        if (r !== "no-cache" && (ws(f, s) && e.cache.write({
          query: n,
          result: f.data,
          dataId: "ROOT_SUBSCRIPTION",
          variables: h
        }), e.broadcastQueries()), dn(f))
          throw new ke({
            graphQLErrors: f.errors
          });
        return f;
      });
    };
    if (this.transform(n).hasClientExports) {
      var u = this.localState.addExportedVariables(n, o, c).then(l);
      return new U(function(h) {
        var f = null;
        return u.then(function(d) {
          return f = d.subscribe(h);
        }, h.error), function() {
          return f && f.unsubscribe();
        };
      });
    }
    return l(o);
  }, i.prototype.stopQuery = function(t) {
    this.stopQueryNoBroadcast(t), this.broadcastQueries();
  }, i.prototype.stopQueryNoBroadcast = function(t) {
    this.stopQueryInStoreNoBroadcast(t), this.removeQuery(t);
  }, i.prototype.removeQuery = function(t) {
    this.fetchCancelFns.delete(t), this.queries.has(t) && (this.getQuery(t).stop(), this.queries.delete(t));
  }, i.prototype.broadcastQueries = function() {
    this.onBroadcast && this.onBroadcast(), this.queries.forEach(function(t) {
      return t.notify();
    });
  }, i.prototype.getLocalState = function() {
    return this.localState;
  }, i.prototype.getObservableFromLink = function(t, e, n, r) {
    var s = this, o;
    r === void 0 && (r = (o = e == null ? void 0 : e.queryDeduplication) !== null && o !== void 0 ? o : this.queryDeduplication);
    var a, c = this.transform(t).serverQuery;
    if (c) {
      var l = this, u = l.inFlightLinkObservables, h = l.link, f = {
        query: c,
        variables: n,
        operationName: rs(c) || void 0,
        context: this.prepareContext(w(w({}, e), { forceFetch: !r }))
      };
      if (e = f.context, r) {
        var d = u.get(c) || /* @__PURE__ */ new Map();
        u.set(c, d);
        var p = pe(n);
        if (a = d.get(p), !a) {
          var g = new di([
            hs(h, f)
          ]);
          d.set(p, a = g), g.beforeNext(function() {
            d.delete(p) && d.size < 1 && u.delete(c);
          });
        }
      } else
        a = new di([
          hs(h, f)
        ]);
    } else
      a = new di([
        U.of({ data: {} })
      ]), e = this.prepareContext(e);
    var m = this.transform(t).clientQuery;
    return m && (a = Dr(a, function(y) {
      return s.localState.runResolvers({
        document: m,
        remoteResult: y,
        context: e,
        variables: n
      });
    })), a;
  }, i.prototype.getResultsFromLink = function(t, e, n) {
    var r = t.lastRequestId = this.generateRequestId();
    n = uo(n);
    var s = this.cache.transformForLink(this.transform(t.document).document);
    return Dr(this.getObservableFromLink(s, n.context, n.variables), function(o) {
      var a = It(o.errors) ? o.errors.slice(0) : [];
      "incremental" in o && It(o.incremental) && o.incremental.forEach(function(u) {
        u.errors && a.push.apply(a, u.errors);
      });
      var c = It(a);
      if (r >= t.lastRequestId) {
        if (c && n.errorPolicy === "none")
          throw t.markError(new ke({
            graphQLErrors: a
          }));
        t.markResult(o, s, n, e), t.markReady();
      }
      var l = {
        data: o.data,
        loading: !1,
        networkStatus: z.ready
      };
      return c && n.errorPolicy !== "ignore" && (l.errors = a, l.networkStatus = z.error), l;
    }, function(o) {
      var a = xv(o) ? o : new ke({ networkError: o });
      throw r >= t.lastRequestId && t.markError(a), a;
    });
  }, i.prototype.fetchQueryObservable = function(t, e, n) {
    var r = this;
    n === void 0 && (n = z.loading);
    var s = this.transform(e.query).document, o = this.getVariables(s, e.variables), a = this.getQuery(t), c = this.defaultOptions.watchQuery, l = e.fetchPolicy, u = l === void 0 ? c && c.fetchPolicy || "cache-first" : l, h = e.errorPolicy, f = h === void 0 ? c && c.errorPolicy || "none" : h, d = e.returnPartialData, p = d === void 0 ? !1 : d, g = e.notifyOnNetworkStatusChange, m = g === void 0 ? !1 : g, y = e.context, b = y === void 0 ? {} : y, v = Object.assign({}, e, {
      query: s,
      variables: o,
      fetchPolicy: u,
      errorPolicy: f,
      returnPartialData: p,
      notifyOnNetworkStatusChange: m,
      context: b
    }), _ = function(E) {
      v.variables = E;
      var O = r.fetchQueryByPolicy(a, v, n);
      return v.fetchPolicy !== "standby" && O.length > 0 && a.observableQuery && a.observableQuery.applyNextFetchPolicy("after-fetch", e), O;
    }, x = function() {
      return r.fetchCancelFns.delete(t);
    };
    this.fetchCancelFns.set(t, function(E) {
      x(), setTimeout(function() {
        return k.cancel(E);
      });
    });
    var k = new di(this.transform(v.query).hasClientExports ? this.localState.addExportedVariables(v.query, v.variables, v.context).then(_) : _(v.variables));
    return k.promise.then(x, x), k;
  }, i.prototype.refetchQueries = function(t) {
    var e = this, n = t.updateCache, r = t.include, s = t.optimistic, o = s === void 0 ? !1 : s, a = t.removeOptimistic, c = a === void 0 ? o ? ls("refetchQueries") : void 0 : a, l = t.onQueryUpdated, u = /* @__PURE__ */ new Map();
    r && this.getObservableQueries(r).forEach(function(f, d) {
      u.set(d, {
        oq: f,
        lastDiff: e.getQuery(d).getDiff()
      });
    });
    var h = /* @__PURE__ */ new Map();
    return n && this.cache.batch({
      update: n,
      optimistic: o && c || !1,
      removeOptimistic: c,
      onWatchUpdated: function(f, d, p) {
        var g = f.watcher instanceof Vr && f.watcher.observableQuery;
        if (g) {
          if (l) {
            u.delete(g.queryId);
            var m = l(g, d, p);
            return m === !0 && (m = g.refetch()), m !== !1 && h.set(g, m), m;
          }
          l !== null && u.set(g.queryId, { oq: g, lastDiff: p, diff: d });
        }
      }
    }), u.size && u.forEach(function(f, d) {
      var p = f.oq, g = f.lastDiff, m = f.diff, y;
      if (l) {
        if (!m) {
          var b = p.queryInfo;
          b.reset(), m = b.getDiff();
        }
        y = l(p, m, g);
      }
      (!l || y === !0) && (y = p.refetch()), y !== !1 && h.set(p, y), d.indexOf("legacyOneTimeQuery") >= 0 && e.stopQueryNoBroadcast(d);
    }), c && this.cache.removeOptimistic(c), h;
  }, i.prototype.fetchQueryByPolicy = function(t, e, n) {
    var r = this, s = e.query, o = e.variables, a = e.fetchPolicy, c = e.refetchWritePolicy, l = e.errorPolicy, u = e.returnPartialData, h = e.context, f = e.notifyOnNetworkStatusChange, d = t.networkStatus;
    t.init({
      document: this.transform(s).document,
      variables: o,
      networkStatus: n
    });
    var p = function() {
      return t.getDiff(o);
    }, g = function(_, x) {
      x === void 0 && (x = t.networkStatus || z.loading);
      var k = _.result;
      __DEV__ && !u && !nt(k, {}) && Iu(_.missing);
      var E = function(O) {
        return U.of(w({ data: O, loading: Ri(x), networkStatus: x }, _.complete ? null : { partial: !0 }));
      };
      return k && r.transform(s).hasForcedResolvers ? r.localState.runResolvers({
        document: s,
        remoteResult: { data: k },
        context: h,
        variables: o,
        onlyRunForcedResolvers: !0
      }).then(function(O) {
        return E(O.data || void 0);
      }) : E(k);
    }, m = a === "no-cache" ? 0 : n === z.refetch && c !== "merge" ? 1 : 2, y = function() {
      return r.getResultsFromLink(t, m, {
        variables: o,
        context: h,
        fetchPolicy: a,
        errorPolicy: l
      });
    }, b = f && typeof d == "number" && d !== n && Ri(n);
    switch (a) {
      default:
      case "cache-first": {
        var v = p();
        return v.complete ? [
          g(v, t.markReady())
        ] : u || b ? [
          g(v),
          y()
        ] : [
          y()
        ];
      }
      case "cache-and-network": {
        var v = p();
        return v.complete || u || b ? [
          g(v),
          y()
        ] : [
          y()
        ];
      }
      case "cache-only":
        return [
          g(p(), t.markReady())
        ];
      case "network-only":
        return b ? [
          g(p()),
          y()
        ] : [y()];
      case "no-cache":
        return b ? [
          g(t.getDiff()),
          y()
        ] : [y()];
      case "standby":
        return [];
    }
  }, i.prototype.getQuery = function(t) {
    return t && !this.queries.has(t) && this.queries.set(t, new Vr(this, t)), this.queries.get(t);
  }, i.prototype.prepareContext = function(t) {
    t === void 0 && (t = {});
    var e = this.localState.prepareContext(t);
    return w(w({}, e), { clientAwareness: this.clientAwareness });
  }, i;
}(), jc = !1, Tv = function() {
  function i(t) {
    var e = this;
    this.resetStoreCallbacks = [], this.clearStoreCallbacks = [];
    var n = t.uri, r = t.credentials, s = t.headers, o = t.cache, a = t.ssrMode, c = a === void 0 ? !1 : a, l = t.ssrForceFetchDelay, u = l === void 0 ? 0 : l, h = t.connectToDevTools, f = h === void 0 ? typeof window == "object" && !window.__APOLLO_CLIENT__ && __DEV__ : h, d = t.queryDeduplication, p = d === void 0 ? !0 : d, g = t.defaultOptions, m = t.assumeImmutableResults, y = m === void 0 ? !1 : m, b = t.resolvers, v = t.typeDefs, _ = t.fragmentMatcher, x = t.name, k = t.version, E = t.link;
    if (E || (E = n ? new cu({ uri: n, credentials: r, headers: s }) : xe.empty()), !o)
      throw __DEV__ ? new N(`To initialize Apollo Client, you must specify a 'cache' property in the options object. 
For more information, please visit: https://go.apollo.dev/c/docs`) : new N(9);
    if (this.link = E, this.cache = o, this.disableNetworkFetches = c || u > 0, this.queryDeduplication = p, this.defaultOptions = g || /* @__PURE__ */ Object.create(null), this.typeDefs = v, u && setTimeout(function() {
      return e.disableNetworkFetches = !1;
    }, u), this.watchQuery = this.watchQuery.bind(this), this.query = this.query.bind(this), this.mutate = this.mutate.bind(this), this.resetStore = this.resetStore.bind(this), this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this), f && typeof window == "object" && (window.__APOLLO_CLIENT__ = this), !jc && __DEV__ && (jc = !0, typeof window < "u" && window.document && window.top === window.self && !window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__)) {
      var O = window.navigator, M = O && O.userAgent, C = void 0;
      typeof M == "string" && (M.indexOf("Chrome/") > -1 ? C = "https://chrome.google.com/webstore/detail/apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm" : M.indexOf("Firefox/") > -1 && (C = "https://addons.mozilla.org/en-US/firefox/addon/apollo-developer-tools/")), C && __DEV__ && D.log("Download the Apollo DevTools for a better development experience: " + C);
    }
    this.version = ry, this.localState = new Fu({
      cache: o,
      client: this,
      resolvers: b,
      fragmentMatcher: _
    }), this.queryManager = new Dv({
      cache: this.cache,
      link: this.link,
      defaultOptions: this.defaultOptions,
      queryDeduplication: p,
      ssrMode: c,
      clientAwareness: {
        name: x,
        version: k
      },
      localState: this.localState,
      assumeImmutableResults: y,
      onBroadcast: f ? function() {
        e.devToolsHookCb && e.devToolsHookCb({
          action: {},
          state: {
            queries: e.queryManager.getQueryStore(),
            mutations: e.queryManager.mutationStore || {}
          },
          dataWithOptimisticResults: e.cache.extract(!0)
        });
      } : void 0
    });
  }
  return i.prototype.stop = function() {
    this.queryManager.stop();
  }, i.prototype.watchQuery = function(t) {
    return this.defaultOptions.watchQuery && (t = Tr(this.defaultOptions.watchQuery, t)), this.disableNetworkFetches && (t.fetchPolicy === "network-only" || t.fetchPolicy === "cache-and-network") && (t = w(w({}, t), { fetchPolicy: "cache-first" })), this.queryManager.watchQuery(t);
  }, i.prototype.query = function(t) {
    return this.defaultOptions.query && (t = Tr(this.defaultOptions.query, t)), __DEV__ ? D(t.fetchPolicy !== "cache-and-network", "The cache-and-network fetchPolicy does not work with client.query, because client.query can only return a single result. Please use client.watchQuery to receive multiple results from the cache and the network, or consider using a different fetchPolicy, such as cache-first or network-only.") : D(t.fetchPolicy !== "cache-and-network", 10), this.disableNetworkFetches && t.fetchPolicy === "network-only" && (t = w(w({}, t), { fetchPolicy: "cache-first" })), this.queryManager.query(t);
  }, i.prototype.mutate = function(t) {
    return this.defaultOptions.mutate && (t = Tr(this.defaultOptions.mutate, t)), this.queryManager.mutate(t);
  }, i.prototype.subscribe = function(t) {
    return this.queryManager.startGraphQLSubscription(t);
  }, i.prototype.readQuery = function(t, e) {
    return e === void 0 && (e = !1), this.cache.readQuery(t, e);
  }, i.prototype.readFragment = function(t, e) {
    return e === void 0 && (e = !1), this.cache.readFragment(t, e);
  }, i.prototype.writeQuery = function(t) {
    this.cache.writeQuery(t), this.queryManager.broadcastQueries();
  }, i.prototype.writeFragment = function(t) {
    this.cache.writeFragment(t), this.queryManager.broadcastQueries();
  }, i.prototype.__actionHookForDevTools = function(t) {
    this.devToolsHookCb = t;
  }, i.prototype.__requestRaw = function(t) {
    return hs(this.link, t);
  }, i.prototype.resetStore = function() {
    var t = this;
    return Promise.resolve().then(function() {
      return t.queryManager.clearStore({
        discardWatches: !1
      });
    }).then(function() {
      return Promise.all(t.resetStoreCallbacks.map(function(e) {
        return e();
      }));
    }).then(function() {
      return t.reFetchObservableQueries();
    });
  }, i.prototype.clearStore = function() {
    var t = this;
    return Promise.resolve().then(function() {
      return t.queryManager.clearStore({
        discardWatches: !0
      });
    }).then(function() {
      return Promise.all(t.clearStoreCallbacks.map(function(e) {
        return e();
      }));
    });
  }, i.prototype.onResetStore = function(t) {
    var e = this;
    return this.resetStoreCallbacks.push(t), function() {
      e.resetStoreCallbacks = e.resetStoreCallbacks.filter(function(n) {
        return n !== t;
      });
    };
  }, i.prototype.onClearStore = function(t) {
    var e = this;
    return this.clearStoreCallbacks.push(t), function() {
      e.clearStoreCallbacks = e.clearStoreCallbacks.filter(function(n) {
        return n !== t;
      });
    };
  }, i.prototype.reFetchObservableQueries = function(t) {
    return this.queryManager.reFetchObservableQueries(t);
  }, i.prototype.refetchQueries = function(t) {
    var e = this.queryManager.refetchQueries(t), n = [], r = [];
    e.forEach(function(o, a) {
      n.push(a), r.push(o);
    });
    var s = Promise.all(r);
    return s.queries = n, s.results = r, s.catch(function(o) {
      __DEV__ && D.debug("In client.refetchQueries, Promise.all promise rejected with error ".concat(o));
    }), s;
  }, i.prototype.getObservableQueries = function(t) {
    return t === void 0 && (t = "active"), this.queryManager.getObservableQueries(t);
  }, i.prototype.extract = function(t) {
    return this.cache.extract(t);
  }, i.prototype.restore = function(t) {
    return this.cache.restore(t);
  }, i.prototype.addResolvers = function(t) {
    this.localState.addResolvers(t);
  }, i.prototype.setResolvers = function(t) {
    this.localState.setResolvers(t);
  }, i.prototype.getResolvers = function() {
    return this.localState.getResolvers();
  }, i.prototype.setLocalStateFragmentMatcher = function(t) {
    this.localState.setFragmentMatcher(t);
  }, i.prototype.setLink = function(t) {
    this.link = this.queryManager.link = t;
  }, i;
}(), gn = /* @__PURE__ */ new Map(), Ss = /* @__PURE__ */ new Map(), Lu = !0, Nn = !1;
function Nu(i) {
  return i.replace(/[\s,]+/g, " ").trim();
}
function Mv(i) {
  return Nu(i.source.body.substring(i.start, i.end));
}
function Av(i) {
  var t = /* @__PURE__ */ new Set(), e = [];
  return i.definitions.forEach(function(n) {
    if (n.kind === "FragmentDefinition") {
      var r = n.name.value, s = Mv(n.loc), o = Ss.get(r);
      o && !o.has(s) ? Lu && console.warn("Warning: fragment with name " + r + ` already exists.
graphql-tag enforces all fragment names across your application to be unique; read more about
this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names`) : o || Ss.set(r, o = /* @__PURE__ */ new Set()), o.add(s), t.has(s) || (t.add(s), e.push(n));
    } else
      e.push(n);
  }), w(w({}, i), { definitions: e });
}
function Cv(i) {
  var t = new Set(i.definitions);
  t.forEach(function(n) {
    n.loc && delete n.loc, Object.keys(n).forEach(function(r) {
      var s = n[r];
      s && typeof s == "object" && t.add(s);
    });
  });
  var e = i.loc;
  return e && (delete e.startToken, delete e.endToken), i;
}
function Pv(i) {
  var t = Nu(i);
  if (!gn.has(t)) {
    var e = em(i, {
      experimentalFragmentVariables: Nn,
      allowLegacyFragmentVariables: Nn
    });
    if (!e || e.kind !== "Document")
      throw new Error("Not a valid GraphQL document.");
    gn.set(t, Cv(Av(e)));
  }
  return gn.get(t);
}
function Ye(i) {
  for (var t = [], e = 1; e < arguments.length; e++)
    t[e - 1] = arguments[e];
  typeof i == "string" && (i = [i]);
  var n = i[0];
  return t.forEach(function(r, s) {
    r && r.kind === "Document" ? n += r.loc.source.body : n += r, n += i[s + 1];
  }), Pv(n);
}
function Rv() {
  gn.clear(), Ss.clear();
}
function Iv() {
  Lu = !1;
}
function Fv() {
  Nn = !0;
}
function Lv() {
  Nn = !1;
}
var li = {
  gql: Ye,
  resetCaches: Rv,
  disableFragmentWarnings: Iv,
  enableExperimentalFragmentVariables: Fv,
  disableExperimentalFragmentVariables: Lv
};
(function(i) {
  i.gql = li.gql, i.resetCaches = li.resetCaches, i.disableFragmentWarnings = li.disableFragmentWarnings, i.enableExperimentalFragmentVariables = li.enableExperimentalFragmentVariables, i.disableExperimentalFragmentVariables = li.disableExperimentalFragmentVariables;
})(Ye || (Ye = {}));
Ye.default = Ye;
const Nv = Ye`
    query getVoltage($pointId: String!, $type: String!){
        
        signals(paginate: {first: 1}, sort: {field: "createdAt", order: DESC},where:{pointId: {_EQ: $pointId}, _AND: {type: {_EQ: $type}}}) {
            nodes {
                pointId
                type
                createdAt
                data {
                    numericValue
                    rawValue
                }
            }
        }
    }
`;
function Vv(i) {
  return !!(i && typeof i == "object" && "kind" in i && "definitions" in i);
}
class jv extends CustomEvent {
  constructor(t, e) {
    super(t, {
      ...e,
      bubbles: !0,
      composed: !0
    });
  }
}
class Vu extends jv {
  constructor(t) {
    super(t);
  }
}
var Es;
const Vn = class extends Vu {
  constructor(t) {
    super(Vn.type), this.controller = t;
  }
};
let mn = Vn;
Es = new WeakMap(), At(mn, Es, Vn.type = "apollo-controller-connected");
var ks;
const jn = class extends Vu {
  constructor(t) {
    super(jn.type), this.controller = t;
  }
};
let wi = jn;
ks = new WeakMap(), At(wi, ks, jn.type = "apollo-controller-disconnected");
var Fe, he, Xt;
class Ii {
  constructor(t, e) {
    At(this, Fe, void 0);
    At(this, he, void 0);
    At(this, Xt, void 0);
    var n, r, s;
    this.host = t, dt(this, Fe, {}), dt(this, he, null), dt(this, Xt, null), this.called = !0, this.data = null, this.error = null, this.errors = [], this.loading = !1, t instanceof EventTarget ? this.emitter = t : (e == null ? void 0 : e.hostElement) instanceof EventTarget ? this.emitter = e.hostElement : this.emitter = new EventTarget(), this.options = e != null ? e : {}, this.client = (r = (n = this.options.client) != null ? n : window.__APOLLO_CLIENT__) != null ? r : null, (s = t.addController) == null || s.call(t, this);
  }
  static o(t, e) {
    Object.defineProperty(t, "options", {
      get() {
        return Mt(this, Fe);
      },
      set(n) {
        var r;
        dt(this, Fe, n), (r = this.optionsChanged) == null || r.call(this, n);
      }
    });
  }
  get client() {
    return Mt(this, he);
  }
  set client(t) {
    var n;
    const e = Mt(this, he);
    dt(this, he, t), (n = this.clientChanged) == null || n.call(this, t), this.notify({
      client: e
    });
  }
  get document() {
    return Mt(this, Xt);
  }
  set document(t) {
    var e;
    if (t !== Mt(this, Xt))
      if (!t)
        dt(this, Xt, null);
      else if (Vv(t))
        dt(this, Xt, t), this.notify({
          document: t
        }), (e = this.documentChanged) == null || e.call(this, t);
      else {
        const n = this.constructor.name.replace(/Apollo(\w+)(Controller|Behavior)/, "$1");
        throw new TypeError(`${n} must be a parsed GraphQL document.`);
      }
  }
  get variables() {
    var t, e;
    return (e = (t = this.options) == null ? void 0 : t.variables) != null ? e : null;
  }
  set variables(t) {
    var e;
    if (!t)
      delete this.options.variables;
    else {
      if (t === this.options.variables)
        return;
      this.options.variables = t;
    }
    this.notify({
      variables: t
    }), (e = this.variablesChanged) == null || e.call(this, t);
  }
  notify(t) {
    if (t && this.host.requestUpdate.length > 0)
      for (const [e, n] of Object.entries(t))
        this.host.requestUpdate(e, n);
    else
      this.host.requestUpdate();
  }
  init(t) {
    var e, n;
    (n = this.variables) != null || (this.variables = (e = this.options.variables) != null ? e : null), this.document = t;
  }
  hostConnected() {
    this.emitter.dispatchEvent(new mn(this));
  }
  hostDisconnected() {
    this.emitter.dispatchEvent(new wi(this)), window.dispatchEvent(new wi(this));
  }
}
Fe = new WeakMap(), he = new WeakMap(), Xt = new WeakMap();
wt([Ii.o], Ii.prototype, "options", void 0);
const Bc = !0;
function Tt(i, t, e) {
  if (typeof (e == null ? void 0 : e.value) != "function")
    throw new TypeError(`Only methods can be decorated with @bound. <${t != null ? t : i.name}> is not a method!`);
  return {
    configurable: Bc,
    get() {
      const n = e.value.bind(this);
      return Object.defineProperty(this, t, {
        value: n,
        configurable: Bc,
        writable: !0
      }), n;
    }
  };
}
class Bv extends Ii {
  constructor(t, e, n) {
    super(t, n), this.mostRecentMutationId = 0, this.called = !1, this.init(e != null ? e : null);
  }
  get mutation() {
    return this.document;
  }
  set mutation(t) {
    this.document = t;
  }
  async mutate(t) {
    var c, l;
    if (!this.client)
      throw new TypeError("No Apollo client. See https://apolloelements.dev/guides/getting-started/apollo-client/");
    const e = this.generateMutationId(), {
      called: n = !1,
      data: r,
      error: s,
      errors: o,
      loading: a
    } = this;
    return this.loading = !0, this.called = !0, this.error = null, this.errors = [], this.data = null, this.notify({
      called: n,
      data: r,
      error: s,
      errors: o,
      loading: a
    }), this.client.mutate({
      mutation: this.mutation,
      awaitRefetchQueries: this.options.awaitRefetchQueries,
      context: this.options.context,
      errorPolicy: this.options.errorPolicy,
      fetchPolicy: this.options.fetchPolicy,
      optimisticResponse: this.options.optimisticResponse,
      refetchQueries: (c = this.options.refetchQueries) != null ? c : void 0,
      update: this.options.update,
      variables: (l = this.variables) != null ? l : void 0,
      ...t
    }).then(this.onCompletedMutation.bind(this, e)).catch(this.onMutationError.bind(this, e));
  }
  generateMutationId() {
    return this.mostRecentMutationId += 1, this.mostRecentMutationId;
  }
  isMostRecentMutation(t) {
    return this.mostRecentMutationId === t;
  }
  onCompletedMutation(t, e) {
    var a, c, l, u;
    const {
      data: n,
      error: r,
      errors: s,
      loading: o
    } = this;
    return this.emitter.dispatchEvent(new CustomEvent("apollo-mutation-result", {
      detail: e
    })), this.isMostRecentMutation(t) && (this.loading = !1, this.options.ignoreResults || (this.error = null, this.data = (a = e.data) != null ? a : null, this.errors = (c = e.errors) != null ? c : [], (u = (l = this.options).onCompleted) == null || u.call(l, this.data)), this.notify({
      data: n,
      error: r,
      errors: s,
      loading: o
    })), e;
  }
  onMutationError(t, e) {
    var o, a;
    this.emitter.dispatchEvent(new CustomEvent("apollo-error", {
      detail: e
    }));
    const {
      data: n,
      error: r,
      loading: s
    } = this;
    throw this.isMostRecentMutation(t) && (this.loading = !1, this.data = null, this.error = e), (a = (o = this.options).onError) == null || a.call(o, e), this.notify({
      data: n,
      error: r,
      loading: s
    }), e;
  }
}
wt([Tt], Bv.prototype, "mutate", null);
var fe, Fi;
class zt extends Ii {
  constructor(e, n, r) {
    super(e, r);
    At(this, fe, void 0);
    At(this, Fi, void 0);
    this.networkStatus = z.ready, this.partial = !1, dt(this, fe, !1), this.init(n != null ? n : null);
  }
  get query() {
    return this.document;
  }
  set query(e) {
    this.document = e;
  }
  get canAutoSubscribe() {
    return !!this.client && !!this.document && !this.options.noAutoSubscribe && this.shouldSubscribe();
  }
  hostConnected() {
    super.hostConnected(), Mt(this, fe) && this.observableQuery ? (this.observableQuery.reobserve(), dt(this, fe, !1)) : this.documentChanged(this.query);
  }
  hostDisconnected() {
    dt(this, fe, !0), super.hostDisconnected();
  }
  shouldSubscribe(e) {
    var n, r, s;
    return (s = (r = (n = this.options).shouldSubscribe) == null ? void 0 : r.call(n, e)) != null ? s : !0;
  }
  canSubscribe(e) {
    var n, r;
    return !((n = this.options.noAutoSubscribe) != null && n) && !!this.client && !!((r = e == null ? void 0 : e.query) != null ? r : this.document);
  }
  watchQuery(e) {
    var n;
    if (!this.client)
      throw new TypeError("No Apollo client. See https://apolloelements.dev/guides/getting-started/apollo-client/");
    return this.client.watchQuery({
      query: this.query,
      variables: (n = this.variables) != null ? n : void 0,
      context: this.options.context,
      errorPolicy: this.options.errorPolicy,
      fetchPolicy: this.options.fetchPolicy,
      notifyOnNetworkStatusChange: this.options.notifyOnNetworkStatusChange,
      partialRefetch: this.options.partialRefetch,
      pollInterval: this.options.pollInterval,
      returnPartialData: this.options.returnPartialData,
      nextFetchPolicy: this.options.nextFetchPolicy,
      ...e
    });
  }
  nextData(e) {
    var l, u, h, f, d, p;
    this.emitter.dispatchEvent(new CustomEvent("apollo-query-result", {
      detail: e
    }));
    const {
      data: n,
      error: r,
      errors: s,
      loading: o,
      networkStatus: a,
      partial: c
    } = this;
    this.data = e.data, this.error = (l = e.error) != null ? l : null, this.errors = (u = e.errors) != null ? u : [], this.loading = (h = e.loading) != null ? h : !1, this.networkStatus = e.networkStatus, this.partial = (f = e.partial) != null ? f : !1, (p = (d = this.options).onData) == null || p.call(d, e.data), this.notify({
      data: n,
      error: r,
      errors: s,
      loading: o,
      networkStatus: a,
      partial: c
    });
  }
  nextError(e) {
    var s, o;
    const {
      error: n,
      loading: r
    } = this;
    this.emitter.dispatchEvent(new CustomEvent("apollo-error", {
      detail: e
    })), this.error = e, this.loading = !1, (o = (s = this.options).onError) == null || o.call(s, e), this.notify({
      error: n,
      loading: r
    });
  }
  clientChanged() {
    this.canSubscribe() && this.shouldSubscribe() && this.subscribe();
  }
  documentChanged(e) {
    const n = e != null ? e : void 0;
    e !== Mt(this, Fi) && this.canSubscribe({
      query: n
    }) && this.shouldSubscribe({
      query: n
    }) && this.subscribe({
      query: n
    });
  }
  variablesChanged(e) {
    this.observableQuery ? this.refetch(e) : this.canSubscribe({
      variables: e
    }) && this.shouldSubscribe({
      variables: e
    }) && this.subscribe({
      variables: e
    });
  }
  optionsChanged(e) {
    var n, r;
    (r = (n = this.observableQuery) == null ? void 0 : n.setOptions) == null || r.call(n, e);
  }
  async refetch(e) {
    if (!this.observableQuery)
      throw new Error("Cannot refetch without an ObservableQuery");
    return this.observableQuery.refetch(e);
  }
  subscribe(e) {
    var r, s, o, a;
    this.observableQuery && this.observableQuery.stopPolling(), this.observableQuery = this.watchQuery({
      query: this.query,
      variables: (r = this.variables) != null ? r : void 0,
      context: this.options.context,
      errorPolicy: this.options.errorPolicy,
      fetchPolicy: this.options.fetchPolicy,
      notifyOnNetworkStatusChange: this.options.notifyOnNetworkStatusChange,
      partialRefetch: this.options.partialRefetch,
      pollInterval: this.options.pollInterval,
      refetchWritePolicy: this.options.refetchWritePolicy,
      returnPartialData: this.options.returnPartialData,
      ...e
    }), dt(this, Fi, (o = (s = e == null ? void 0 : e.query) != null ? s : this.query) != null ? o : void 0);
    const {
      loading: n
    } = this;
    return this.loading = !0, this.notify({
      loading: n
    }), (a = this.observableQuery) == null ? void 0 : a.subscribe({
      next: this.nextData.bind(this),
      error: this.nextError.bind(this)
    });
  }
  subscribeToMore(e) {
    var n;
    return (n = this.observableQuery) == null ? void 0 : n.subscribeToMore(e);
  }
  async executeQuery(e) {
    try {
      if (!this.client)
        throw new TypeError("No Apollo client. See https://apolloelements.dev/guides/getting-started/apollo-client/");
      const {
        loading: n
      } = this;
      this.loading = !0, this.notify({
        loading: n
      });
      const r = await this.client.query({
        query: this.query,
        variables: this.variables,
        context: this.options.context,
        errorPolicy: this.options.errorPolicy,
        fetchPolicy: this.options.fetchPolicy === "cache-and-network" ? void 0 : this.options.fetchPolicy,
        notifyOnNetworkStatusChange: this.options.notifyOnNetworkStatusChange,
        partialRefetch: this.options.partialRefetch,
        returnPartialData: this.options.returnPartialData,
        ...e
      });
      return r && this.nextData(r), r;
    } catch (n) {
      throw this.nextError(n), n;
    }
  }
  async fetchMore(e) {
    var s, o, a;
    const {
      loading: n
    } = this;
    this.loading = !0, this.notify({
      loading: n
    });
    const r = {
      query: this.query,
      context: this.options.context,
      variables: (s = this.variables) != null ? s : void 0,
      ...e
    };
    return (o = r.variables) != null || (r.variables = void 0), (a = this.observableQuery) != null || (this.observableQuery = this.watchQuery(r)), this.observableQuery.fetchMore(r).then((c) => {
      const {
        loading: l
      } = this;
      return this.loading = !1, this.notify({
        loading: l
      }), c;
    });
  }
  startPolling(e) {
    this.pollingInterval = window.setInterval(() => {
      this.refetch();
    }, e);
  }
  stopPolling() {
    clearInterval(this.pollingInterval);
  }
}
fe = new WeakMap(), Fi = new WeakMap();
wt([Tt], zt.prototype, "watchQuery", null);
wt([Tt], zt.prototype, "refetch", null);
wt([Tt], zt.prototype, "subscribe", null);
wt([Tt], zt.prototype, "subscribeToMore", null);
wt([Tt], zt.prototype, "executeQuery", null);
wt([Tt], zt.prototype, "fetchMore", null);
wt([Tt], zt.prototype, "startPolling", null);
wt([Tt], zt.prototype, "stopPolling", null);
var Le, Li;
class ju extends Ii {
  constructor(e, n, r) {
    super(e, r);
    At(this, Le, void 0);
    At(this, Li, void 0);
    dt(this, Le, !1), this.init(n != null ? n : null);
  }
  get subscription() {
    return this.document;
  }
  set subscription(e) {
    this.document = e;
  }
  get canAutoSubscribe() {
    return !!this.client && !this.options.noAutoSubscribe && this.shouldSubscribe();
  }
  hostConnected() {
    super.hostConnected(), Mt(this, Le) && this.observableSubscription ? this.subscribe() : this.documentChanged(this.subscription);
  }
  hostDisconnected() {
    this.endSubscription(), dt(this, Le, !0), super.hostDisconnected();
  }
  canSubscribe(e) {
    var n;
    return !this.options.noAutoSubscribe && !!this.client && (!this.observable || !!this.options.shouldResubscribe) && !!((n = e == null ? void 0 : e.query) != null ? n : this.subscription);
  }
  initObservable(e) {
    var c;
    const {
      shouldResubscribe: n = this.options.shouldResubscribe,
      client: r = this.client,
      skip: s = this.options.skip,
      ...o
    } = e != null ? e : {};
    if (!r)
      throw new TypeError("No Apollo client. See https://apolloelements.dev/guides/getting-started/apollo-client/");
    if (this.observable && !n || s)
      return;
    const a = (c = e == null ? void 0 : e.subscription) != null ? c : this.subscription;
    dt(this, Li, a), this.observable = r.subscribe({
      variables: this.variables,
      context: this.options.context,
      errorPolicy: this.options.errorPolicy,
      fetchPolicy: this.options.fetchPolicy,
      ...o,
      query: a
    });
  }
  nextData(e) {
    var u, h, f, d, p;
    const {
      data: n,
      error: r,
      errors: s,
      loading: o
    } = this, a = this.client, c = {
      data: (u = e == null ? void 0 : e.data) != null ? u : null,
      loading: !1,
      error: null
    }, l = {
      client: a,
      subscriptionData: c
    };
    this.emitter.dispatchEvent(new CustomEvent("apollo-subscription-result", {
      detail: l
    })), this.data = (h = e == null ? void 0 : e.data) != null ? h : null, this.error = null, this.errors = (f = e == null ? void 0 : e.errors) != null ? f : [], this.loading = !1, (p = (d = this.options).onData) == null || p.call(d, l), this.notify({
      data: n,
      error: r,
      errors: s,
      loading: o
    });
  }
  nextError(e) {
    var s, o;
    const {
      error: n,
      loading: r
    } = this;
    this.emitter.dispatchEvent(new CustomEvent("apollo-error", {
      detail: e
    })), this.error = e, this.loading = !1, (o = (s = this.options).onError) == null || o.call(s, e), this.notify({
      error: n,
      loading: r
    });
  }
  onComplete() {
    var s, o;
    const {
      data: e,
      error: n,
      loading: r
    } = this;
    (o = (s = this.options).onComplete) == null || o.call(s), this.endSubscription(), this.notify({
      data: e,
      error: n,
      loading: r
    });
  }
  endSubscription() {
    this.observableSubscription && this.observableSubscription.unsubscribe();
  }
  shouldSubscribe(e) {
    var n, r, s;
    return (s = (r = (n = this.options).shouldSubscribe) == null ? void 0 : r.call(n, e)) != null ? s : !0;
  }
  clientChanged() {
    this.canSubscribe() && this.shouldSubscribe() && this.subscribe();
  }
  documentChanged(e) {
    const n = e != null ? e : void 0;
    e !== Mt(this, Li) && (this.cancel(), this.canSubscribe({
      query: n
    }) && this.shouldSubscribe({
      query: n
    }) && this.subscribe());
  }
  variablesChanged(e) {
    this.cancel(), this.canSubscribe({
      variables: e
    }) && this.shouldSubscribe({
      variables: e
    }) && this.subscribe();
  }
  subscribe(e) {
    var s, o;
    this.initObservable(e);
    const n = (s = e == null ? void 0 : e.shouldResubscribe) != null ? s : this.options.shouldResubscribe;
    if (this.observableSubscription && !n)
      return;
    const {
      loading: r
    } = this;
    this.loading = !0, this.notify({
      loading: r
    }), this.observableSubscription = (o = this.observable) == null ? void 0 : o.subscribe({
      next: this.nextData.bind(this),
      error: this.nextError.bind(this),
      complete: this.onComplete.bind(this)
    });
  }
  cancel() {
    this.endSubscription(), this.observableSubscription = void 0, this.observable = void 0;
  }
}
Le = new WeakMap(), Li = new WeakMap();
wt([Tt], ju.prototype, "subscribe", null);
wt([Tt], ju.prototype, "cancel", null);
const $v = "https://iot.dimensionfour.io/graph";
function zv(i = $v, t, e) {
  const n = new cu({ uri: i, credentials: "include" }), r = new xe((o, a) => (o.setContext(({ headers: c = {} }) => ({
    headers: {
      ...c,
      "x-tenant-id": t,
      "x-tenant-key": e
    }
  })), a(o)));
  return new Tv({
    uri: i,
    cache: new _v(),
    link: ny(r, n)
  });
}
class qv extends pi {
  constructor() {
    super();
    xo(this, "query", new zt(this, Nv));
  }
  static get properties() {
    return {
      api_endpoint: { type: String },
      tenant_id: { type: String },
      tenant_key: { type: String },
      type: { type: String },
      point_id: { type: String },
      _volts: { state: !0 }
    };
  }
  async firstUpdated() {
    const { data: e } = await this.getData(), n = e.signals.nodes[0].data.numericValue;
    this._volts = n, this.drawChart(n);
  }
  getData() {
    return this.query.variables = {
      pointId: this.point_id,
      type: this.type
    }, this.query.client = zv(this.api_endpoint, this.tenant_id, this.tenant_key), this.query.executeQuery();
  }
  drawChart(e = this._volts) {
    const n = this.shadowRoot.getElementById("charty").getContext("2d");
    An.register(
      Qn,
      $i,
      zn,
      Ge
    );
    const r = _g(e);
    new An(n, r);
  }
  render() {
    return Gu`
                <div class="container">
                    <div class="title">Current Voltage</div>
                    <div class="canvas-container">
                        <canvas id="charty" width="100%"></canvas>
                    </div>
                </div>
            `;
  }
  static get styles() {
    return qu`
                :host {
                  width: 100%;
                }
              
                .container {
                    padding: 45px;
                    border-radius: 9px;
                    background-color: white;
                    box-shadow: 3px 4px 25px rgba(30, 26, 44, 0.02);
                    min-height: 380px;
                }

                .canvas-container {
                    width: 320px;
                    margin: 0 auto;
                }

                .title {
                    font-size: 40px;
                    color: black;
                }
            `;
  }
}
window.customElements.define("d4-analogue-sensor", qv);
export {
  qv as default
};
